module.exports = [
  {iata: "AAB", airport: "Arrabury Airport"},
  {iata: "AAC", airport: "Al Arish Airport"},
  {iata: "AAD", airport: "Ad-Dabbah Airport"},
  {iata: "AAE", airport: "Les Salines Airport"},
  {iata: "AAF", airport: "Apalachicola Municipal Airport"},
  {iata: "AAG", airport: "Arapoti Airport"},
  {iata: "AAH", airport: "Aachen/Merzbruck Airport"},
  {iata: "AAI", airport: "Arraias Airport"},
  {iata: "AAJ", airport: "Cayana Airstrip"},
  {iata: "AAK", airport: "Aranuka Airport"},
  {iata: "AAL", airport: "Aalborg Airport"},
  {iata: "AAM", airport: "Mala Mala Airport"},
  {iata: "AAN", airport: "Al Ain Airport"},
  {iata: "AAO", airport: "Anaco Airport"},
  {iata: "AAP", airport: "Andrau Airpark"},
  {iata: "AAQ", airport: "Anapa Airport"},
  {iata: "AAR", airport: "Tirstrup Airport"},
  {iata: "AAS", airport: "Apalapsili Airport"},
  {iata: "AAT", airport: "Altay Airport"},
  {iata: "AAU", airport: "Asau Airport"},
  {iata: "AAV", airport: "Alah Airport"},
  {iata: "AAW", airport: "Abbottabad Airport"},
  {iata: "AAX", airport: "Araxa Airport"},
  {iata: "AAY", airport: "Al Ghaydah Airport"},
  {iata: "ABA", airport: "Abakan Airport"},
  {iata: "ABB", airport: "Royal Air Force Station"},
  {iata: "ABC", airport: "Los Llanos Airport"},
  {iata: "ABD", airport: "Abadan Airport"},
  {iata: "ABE", airport: "Lehigh Valley International Airport"},
  {iata: "ABF", airport: "Abaiang Airport"},
  {iata: "ABG", airport: "Abingdon Airport"},
  {iata: "ABH", airport: "Alpha Airport"},
  {iata: "ABI", airport: "Abilene Municipal Airport"},
  {iata: "ABK", airport: "Kabri Dar Airport"},
  {iata: "ABL", airport: "Ambler Airport"},
  {iata: "ABM", airport: "Bamaga Airport"},
  {iata: "ABN", airport: "Albina Airport"},
  {iata: "ABP", airport: "Atkamba Airport"},
  {iata: "ABQ", airport: "Albuquerque International Airport"},
  {iata: "ABR", airport: "Aberdeen Municipal Airport"},
  {iata: "ABS", airport: "Abu Simbel Airport"},
  {iata: "ABT", airport: "Al-Aqiq Airport"},
  {iata: "ABU", airport: "Atambua Airport"},
  {iata: "ABV", airport: "International Airport"},
  {iata: "ABW", airport: "Abau Airport"},
  {iata: "ABX", airport: "Albury Airport"},
  {iata: "ABY", airport: "Dougherty County Airport"},
  {iata: "ABZ", airport: "Dyce Airport"},
  {iata: "ACA", airport: "Alvarez International Airport"},
  {iata: "ACB", airport: "Antrim County Airport"},
  {iata: "ACC", airport: "Airport"},
  {iata: "ACD", airport: "Acandi Airport"},
  {iata: "ACE", airport: "Lanzarote Airport"},
  {iata: "ACH", airport: "Altenrhein Airport"},
  {iata: "ACI", airport: "The Blaye Airport"},
  {iata: "ACJ", airport: "Anuradhapura Airport"},
  {iata: "ACK", airport: "Nantucket Memorial Airport"},
  {iata: "ACL", airport: "Aguaclara Airport"},
  {iata: "ACM", airport: "Arica Airport"},
  {iata: "ACN", airport: "Ciudad Acuna International Airport"},
  {iata: "ACO", airport: "Ascona Airport"},
  {iata: "ACP", airport: "Sahand Airport"},
  {iata: "ACR", airport: "Araracuara Airport"},
  {iata: "ACS", airport: "Achinsk Airport"},
  {iata: "ACT", airport: "Waco Municipal Airport"},
  {iata: "ACU", airport: "Achutupo Airport"},
  {iata: "ACV", airport: "Arcata Airport"},
  {iata: "ACX", airport: "Xingyi Airport"},
  {iata: "ACY", airport: "Atlantic City International Airport"},
  {iata: "ACZ", airport: "Zabol Airport"},
  {iata: "ADA", airport: "Adana Airport"},
  {iata: "ADB", airport: "Adnan Menderes Airport"},
  {iata: "ADC", airport: "Andakombe Airport"},
  {iata: "ADD", airport: "Airport"},
  {iata: "ADE", airport: "Aden International Airport"},
  {iata: "ADF", airport: "Adiyaman Airport"},
  {iata: "ADG", airport: "Lenawee County Airport"},
  {iata: "ADH", airport: "Aldan Airport"},
  {iata: "ADI", airport: "Arandis Airport"},
  {iata: "ADJ", airport: "Civil - Marka Airport"},
  {iata: "ADK", airport: "Adak Island Naval Station"},
  {iata: "ADL", airport: "Adelaide Airport"},
  {iata: "ADM", airport: "Ardmore Municipal Airport"},
  {iata: "ADN", airport: "Andes Airport"},
  {iata: "ADO", airport: "Andamooka Airport"},
  {iata: "ADP", airport: "Ampara Airport"},
  {iata: "ADQ", airport: "Kodiak Airport"},
  {iata: "ADR", airport: "Andrews Airport"},
  {iata: "ADS", airport: "Addison Airport"},
  {iata: "ADT", airport: "Ada Airport"},
  {iata: "ADU", airport: "Ardabil Airport"},
  {iata: "ADV", airport: "Andover Airport"},
  {iata: "ADW", airport: "Andrews Air Force Base"},
  {iata: "ADX", airport: "Leuchars Airport"},
  {iata: "ADY", airport: "Alldays Airport"},
  {iata: "ADZ", airport: "San Andres Island Airport"},
  {iata: "AEA", airport: "Abemama Atoll Airport"},
  {iata: "AED", airport: "Aleneva Airport"},
  {iata: "AEG", airport: "Aek Godang Airport"},
  {iata: "AEH", airport: "Abecher Airport"},
  {iata: "AEI", airport: "Algeciras Airport"},
  {iata: "AEK", airport: "Aseki Airport"},
  {iata: "AEL", airport: "Albert Lea Airport"},
  {iata: "AEO", airport: "Aioun El Atrouss Airport"},
  {iata: "AEP", airport: "Jorge Newbery Airport"},
  {iata: "AER", airport: "Adler/Sochi Airport"},
  {iata: "AES", airport: "Vigra Airport"},
  {iata: "AET", airport: "Allakaket Airport"},
  {iata: "AEU", airport: "Abu Musa Airport"},
  {iata: "AEX", airport: "Alexandria International Airport"},
  {iata: "AEY", airport: "Akureyri Airport"},
  {iata: "AFA", airport: "San Rafael Airport"},
  {iata: "AFD", airport: "Port Alfred Airport"},
  {iata: "AFF", airport: "United States Air Force Academy Airport"},
  {iata: "AFI", airport: "Amalfi Airport"},
  {iata: "AFL", airport: "Alta Floresta Airport"},
  {iata: "AFN", airport: "Jaffrey Municipal Airport"},
  {iata: "AFO", airport: "Afton Municipal Airport"},
  {iata: "AFR", airport: "Afore Airport"},
  {iata: "AFS", airport: "Zarafshan Airport"},
  {iata: "AFT", airport: "Afutara Aerodrome"},
  {iata: "AFW", airport: "Fort Worth Alliance Airport"},
  {iata: "AFY", airport: "Afyon Airport"},
  {iata: "AFZ", airport: "Sabzevar Airport"},
  {iata: "AGA", airport: "Agadir Almassira Airport"},
  {iata: "AGB", airport: "Augsburg - Muehlhausen Airport"},
  {iata: "AGC", airport: "Allegheny County Airport"},
  {iata: "AGD", airport: "Anggi Airport"},
  {iata: "AGE", airport: "Flugplatz Airport"},
  {iata: "AGF", airport: "La Garenne Airport"},
  {iata: "AGG", airport: "Angoram Airport"},
  {iata: "AGH", airport: "Angelholm Airport"},
  {iata: "AGI", airport: "Wageningen Airport"},
  {iata: "AGJ", airport: "Aguni Airport"},
  {iata: "AGK", airport: "Kagua Airport"},
  {iata: "AGL", airport: "Wanigela Airport"},
  {iata: "AGM", airport: "Tasiilaq Airport"},
  {iata: "AGN", airport: "Angoon Airport"},
  {iata: "AGO", airport: "Magnolia Municipal Airport"},
  {iata: "AGP", airport: "Malaga Airport"},
  {iata: "AGQ", airport: "Agrinion Airport"},
  {iata: "AGR", airport: "Kheria Airport"},
  {iata: "AGS", airport: "Bush Field"},
  {iata: "AGT", airport: "Alejo Garcia Airport"},
  {iata: "AGU", airport: "Aguascalients Airport"},
  {iata: "AGV", airport: "Acarigua Airport"},
  {iata: "AGW", airport: "Agnew Airport"},
  {iata: "AGX", airport: "Agatti Island Airport"},
  {iata: "AGY", airport: "Argyle Downs Airport"},
  {iata: "AGZ", airport: "Aggeneys Airport"},
  {iata: "AHA", airport: "Naha Air Force Base"},
  {iata: "AHB", airport: "Abha Airport"},
  {iata: "AHC", airport: "Amedee Army Air Field"},
  {iata: "AHD", airport: "Ardmore Downtown Airport"},
  {iata: "AHE", airport: "Ahe Airport"},
  {iata: "AHF", airport: "Arapahoe Municipal Airport"},
  {iata: "AHH", airport: "Amery Municipal Airport"},
  {iata: "AHI", airport: "Amahai Airport"},
  {iata: "AHL", airport: "Aishalton Airport"},
  {iata: "AHN", airport: "Athens Airport"},
  {iata: "AHO", airport: "Fertilia Airport"},
  {iata: "AHS", airport: "Ahuas Airport"},
  {iata: "AHU", airport: "Charif Al Idrissi Airport"},
  {iata: "AHY", airport: "Ambatolahy Airport"},
  {iata: "AHZ", airport: "Alpe D Huez Airport"},
  {iata: "AIA", airport: "Alliance Airport"},
  {iata: "AID", airport: "Anderson Municipal Airport"},
  {iata: "AIE", airport: "Aiome Airport"},
  {iata: "AIF", airport: "Assis Airport"},
  {iata: "AIG", airport: "Yalinga Airport"},
  {iata: "AIH", airport: "Aiambak Airport"},
  {iata: "AII", airport: "Ali-Sabieh Airport"},
  {iata: "AIK", airport: "Aiken Municipal Airport"},
  {iata: "AIL", airport: "Ailigandi Airport"},
  {iata: "AIN", airport: "Wainwright Airport"},
  {iata: "AIO", airport: "Atlantic Municipal Airport"},
  {iata: "AIP", airport: "Ailinglapalap Island Airport"},
  {iata: "AIR", airport: "Aripuana Airport"},
  {iata: "AIS", airport: "Arorae Island Airport"},
  {iata: "AIT", airport: "Aitutaki Airport"},
  {iata: "AIU", airport: "Atiu Island Airport"},
  {iata: "AIV", airport: "George Downer Airport"},
  {iata: "AIW", airport: "Ai-Ais Airport"},
  {iata: "AIY", airport: "Bader Field"},
  {iata: "AIZ", airport: "Lee C Fine Memorial Airport"},
  {iata: "AJA", airport: "Campo Dell Oro Airport"},
  {iata: "AJF", airport: "Jouf Airport"},
  {iata: "AJI", airport: "Agri Airport"},
  {iata: "AJJ", airport: "Akjoujt Airport"},
  {iata: "AJK", airport: "Araak Airport"},
  {iata: "AJL", airport: "Aizawl Airport"},
  {iata: "AJN", airport: "Ouani Airport"},
  {iata: "AJO", airport: "Aljouf Airport"},
  {iata: "AJR", airport: "Arvidsjaur Airport"},
  {iata: "AJS", airport: "Abreojos Airport"},
  {iata: "AJU", airport: "Aracaju Airport"},
  {iata: "AJY", airport: "Agades Airport"},
  {iata: "AKA", airport: "Ankang Airport"},
  {iata: "AKB", airport: "Atka Airport"},
  {iata: "AKC", airport: "Fulton International Airport"},
  {iata: "AKD", airport: "Akola Airport"},
  {iata: "AKF", airport: "Kufrah Airport"},
  {iata: "AKG", airport: "Anguganak Airport"},
  {iata: "AKH", airport: "Prince Sultan Air Base"},
  {iata: "AKI", airport: "Akiak Airport"},
  {iata: "AKJ", airport: "Asahikawa Airport"},
  {iata: "AKK", airport: "Akhiok Sea Plane Base"},
  {iata: "AKL", airport: "Auckland International Airport"},
  {iata: "AKM", airport: "Zakouma Airport"},
  {iata: "AKN", airport: "King Salmon Airport"},
  {iata: "AKO", airport: "Washington County Airport"},
  {iata: "AKP", airport: "Anaktuvuk Airport"},
  {iata: "AKQ", airport: "Gunung Batin Airport"},
  {iata: "AKR", airport: "Akure Airport"},
  {iata: "AKT", airport: "Akrotiri Royal Air Force"},
  {iata: "AKU", airport: "Aksu Airport"},
  {iata: "AKV", airport: "Akulivik Airport"},
  {iata: "AKW", airport: "Aghajari Airport"},
  {iata: "AKX", airport: "Aktyubinsk Airport"},
  {iata: "AKY", airport: "Civil Airport"},
  {iata: "ALA", airport: "Almaty Airport"},
  {iata: "ALB", airport: "Albany International Airport"},
  {iata: "ALC", airport: "Alicante Airport"},
  {iata: "ALD", airport: "Alerta Airport"},
  {iata: "ALE", airport: "Alpine Airport"},
  {iata: "ALF", airport: "Alta Airport"},
  {iata: "ALG", airport: "Houari Boumediene Airport"},
  {iata: "ALH", airport: "Albany Airport"},
  {iata: "ALI", airport: "Alice International Airport"},
  {iata: "ALJ", airport: "Kortdoorn Airport"},
  {iata: "ALK", airport: "Asela Airport"},
  {iata: "ALL", airport: "Albenga Airport"},
  {iata: "ALM", airport: "Alamogordo Municipal Airport"},
  {iata: "ALN", airport: "Alton Airport"},
  {iata: "ALO", airport: "Waterloo Airport"},
  {iata: "ALP", airport: "Aleppo International Airport"},
  {iata: "ALQ", airport: "Federal Airport"},
  {iata: "ALR", airport: "Alexandra Airport"},
  {iata: "ALS", airport: "Alamosa Municipal Airport"},
  {iata: "ALT", airport: "Alenquer Airport"},
  {iata: "ALU", airport: "Alula Airport"},
  {iata: "ALV", airport: "Andorra La Vella Heliport"},
  {iata: "ALW", airport: "Walla Walla Airport"},
  {iata: "ALX", airport: "Thomas C Russell Field"},
  {iata: "ALY", airport: "El Nohza Airport"},
  {iata: "ALZ", airport: "Alitak Sea Plane Base"},
  {iata: "AMA", airport: "Amarillo International Airport"},
  {iata: "AMB", airport: "Ambilobe Airport"},
  {iata: "AMC", airport: "Am Timan Airport"},
  {iata: "AMD", airport: "Ahmedabad Airport"},
  {iata: "AME", airport: "Alto Molocue Airport"},
  {iata: "AMF", airport: "Ama Airport"},
  {iata: "AMG", airport: "Amboin Airport"},
  {iata: "AMH", airport: "Arba Mintch Airport"},
  {iata: "AMI", airport: "Selaparang Airport"},
  {iata: "AMJ", airport: "Almenara Airport"},
  {iata: "AMK", airport: "Animas Airpark"},
  {iata: "AML", airport: "Puerto Armuelles Airport"},
  {iata: "AMM", airport: "Queen Alia International Airport"},
  {iata: "AMN", airport: "Gratiot Community Airport"},
  {iata: "AMO", airport: "Mao Airport"},
  {iata: "AMP", airport: "Ampanihy Airport"},
  {iata: "AMQ", airport: "Pattimura Airport"},
  {iata: "AMR", airport: "Arno Airport"},
  {iata: "AMS", airport: "Amsterdam-Schiphol Airport"},
  {iata: "AMT", airport: "Amata Airport"},
  {iata: "AMU", airport: "Amanab Airport"},
  {iata: "AMV", airport: "Amderma Airport"},
  {iata: "AMW", airport: "Ames Airport"},
  {iata: "AMX", airport: "Ammaroo Airport"},
  {iata: "AMY", airport: "Ambatomainty Airport"},
  {iata: "AMZ", airport: "Ardmore Airport"},
  {iata: "ANA", airport: "Anaheim Airport"},
  {iata: "ANB", airport: "County Airport"},
  {iata: "ANC", airport: "Anchorage International Airport"},
  {iata: "AND", airport: "Anderson Airport"},
  {iata: "ANE", airport: "Arville Airport"},
  {iata: "ANF", airport: "Cerro Moreno Airport"},
  {iata: "ANG", airport: "Brie-Champniers Airport"},
  {iata: "ANH", airport: "Anuha Island Resort Airport"},
  {iata: "ANI", airport: "Aniak Airport"},
  {iata: "ANJ", airport: "Zanaga Airport"},
  {iata: "ANK", airport: "Etimesgut Airport"},
  {iata: "ANM", airport: "Antsirabato"},
  {iata: "ANO", airport: "Angoche Airport"},
  {iata: "ANP", airport: "Lee Airport"},
  {iata: "ANQ", airport: "Tri-State Steuben County Airport"},
  {iata: "ANR", airport: "Deurne Airport"},
  {iata: "ANS", airport: "Andahuaylas Airport"},
  {iata: "ANT", airport: "St. Anton Airport"},
  {iata: "ANU", airport: "V.C. Bird International Airport"},
  {iata: "ANV", airport: "Anvik Airport"},
  {iata: "ANW", airport: "Ainsworth Airport"},
  {iata: "ANX", airport: "Andenes Airport"},
  {iata: "ANY", airport: "Anthony Airport"},
  {iata: "ANZ", airport: "Angus Downs Airport"},
  {iata: "AOA", airport: "Aroa Airport"},
  {iata: "AOB", airport: "Annanberg Airport"},
  {iata: "AOC", airport: "Altenburg Nobitz Airport"},
  {iata: "AOD", airport: "Abou Deia Airport"},
  {iata: "AOE", airport: "Anadolu University Airport"},
  {iata: "AOG", airport: "Anshan Airport"},
  {iata: "AOH", airport: "Allen County Airport"},
  {iata: "AOI", airport: "Falconara Airport"},
  {iata: "AOJ", airport: "Aomori Airport"},
  {iata: "AOK", airport: "Karpathos Airport"},
  {iata: "AOL", airport: "Paso de los Libres Airport"},
  {iata: "AON", airport: "Arona Airport"},
  {iata: "AOO", airport: "Altoona Airport"},
  {iata: "AOR", airport: "Alor Setar Airport"},
  {iata: "AOS", airport: "Amook Airport"},
  {iata: "AOT", airport: "Corrado Gex Airport"},
  {iata: "AOU", airport: "Attopeu Airport"},
  {iata: "AOY", airport: "Asaloyeh Airport"},
  {iata: "APA", airport: "Arapahoe County Airport"},
  {iata: "APB", airport: "Apolo Airport"},
  {iata: "APC", airport: "Napa County Airport"},
  {iata: "APE", airport: "San Juan Aposento Airport"},
  {iata: "APF", airport: "Naples Airport"},
  {iata: "APG", airport: "Phillips Army Air Field"},
  {iata: "APH", airport: "Camp A P Hill Airport"},
  {iata: "API", airport: "Apiay Airport"},
  {iata: "APK", airport: "Apataki Airport"},
  {iata: "APL", airport: "Nampula Airport"},
  {iata: "APN", airport: "Alpena County Regional Airport"},
  {iata: "APO", airport: "Apartado Airport"},
  {iata: "APP", airport: "Asapa Airport"},
  {iata: "APQ", airport: "Arapiraca Airport"},
  {iata: "APR", airport: "April River Airport"},
  {iata: "APS", airport: "Anapolis Airport"},
  {iata: "APT", airport: "Marion County Airport"},
  {iata: "APU", airport: "Apucarana Airport"},
  {iata: "APV", airport: "Apple Valley Airport"},
  {iata: "APW", airport: "Faleolo Airport"},
  {iata: "APX", airport: "Arapongas Airport"},
  {iata: "APY", airport: "Alto Parnaiba Airport"},
  {iata: "APZ", airport: "Zapala Airport"},
  {iata: "AQA", airport: "Araraquara Airport"},
  {iata: "AQG", airport: "Anqing Airport"},
  {iata: "AQI", airport: "Qaisumah Airport"},
  {iata: "AQJ", airport: "King Hussein International Airport"},
  {iata: "AQM", airport: "Ariquemes Airport"},
  {iata: "AQP", airport: "Rodriguez Ballon Airport"},
  {iata: "AQS", airport: "Saqani Airport"},
  {iata: "ARA", airport: "Acadiana Regional Airport"},
  {iata: "ARB", airport: "Ann Arbor Municipal Airport"},
  {iata: "ARC", airport: "Arctic Village Airport"},
  {iata: "ARD", airport: "Alor Island Airport"},
  {iata: "ARE", airport: "Arecibo Airport"},
  {iata: "ARF", airport: "Acaricuara Airport"},
  {iata: "ARG", airport: "Walnut Ridge Airport"},
  {iata: "ARH", airport: "Arkhangelsk Airport"},
  {iata: "ARI", airport: "Chacalluta Airport"},
  {iata: "ARJ", airport: "Arso Airport"},
  {iata: "ARK", airport: "Arusha Airport"},
  {iata: "ARL", airport: "Arly Airport"},
  {iata: "ARM", airport: "Armidale Airport"},
  {iata: "ARN", airport: "Arlanda Airport"},
  {iata: "ARO", airport: "Arboletas Airport"},
  {iata: "ARP", airport: "Aragip Airport"},
  {iata: "ARQ", airport: "Arauquita Airport"},
  {iata: "ARR", airport: "Alto Rio Senguerr Airport"},
  {iata: "ARS", airport: "Aragarcas Airport"},
  {iata: "ART", airport: "Watertown Airport"},
  {iata: "ARU", airport: "Aracatuba Airport"},
  {iata: "ARV", airport: "Noble F. Lee Airport"},
  {iata: "ARW", airport: "Arad Airport"},
  {iata: "ARX", airport: "Asbury Park Airport"},
  {iata: "ARY", airport: "Ararat Airport"},
  {iata: "ASA", airport: "Assab Airport"},
  {iata: "ASB", airport: "Ashgabat Airport"},
  {iata: "ASC", airport: "Ascension Airport"},
  {iata: "ASD", airport: "Andros Town Airport"},
  {iata: "ASE", airport: "Aspen Airport"},
  {iata: "ASF", airport: "Astrakhan Airport"},
  {iata: "ASG", airport: "Ashburton Airport"},
  {iata: "ASH", airport: "Boire Field"},
  {iata: "ASI", airport: "Wideawake Field"},
  {iata: "ASJ", airport: "Amami O Shima Airport"},
  {iata: "ASL", airport: "Harrison County Airport"},
  {iata: "ASM", airport: "Asmara International Airport"},
  {iata: "ASN", airport: "Talladega Airport"},
  {iata: "ASO", airport: "Asosa Airport"},
  {iata: "ASP", airport: "Alice Springs Airport"},
  {iata: "ASQ", airport: "Austin Airport"},
  {iata: "ASR", airport: "Kayseri Airport"},
  {iata: "AST", airport: "Astoria Airport"},
  {iata: "ASU", airport: "Silvio Pettirossi Airport"},
  {iata: "ASV", airport: "Amboseli Airport"},
  {iata: "ASW", airport: "Aswan Airport"},
  {iata: "ASX", airport: "Ashland Airport"},
  {iata: "ASY", airport: "Ashley Airport"},
  {iata: "ASZ", airport: "Asirim Airport"},
  {iata: "ATA", airport: "Anta Airport"},
  {iata: "ATB", airport: "Atbara Airport"},
  {iata: "ATD", airport: "Atoifi Airport"},
  {iata: "ATE", airport: "Antlers Airport"},
  {iata: "ATF", airport: "Chachoan Airport"},
  {iata: "ATG", airport: "Attock Airport"},
  {iata: "ATH", airport: "Eleftherios Venizelos International Airport"},
  {iata: "ATI", airport: "Artigas Airport"},
  {iata: "ATJ", airport: "Antsirabe Airport"},
  {iata: "ATK", airport: "Atqasuk Airport"},
  {iata: "ATL", airport: "Hartsfield-Jackson Atlanta International Airport"},
  {iata: "ATM", airport: "Altamira Airport"},
  {iata: "ATN", airport: "Namatanai Airport"},
  {iata: "ATO", airport: "Ohio University Airport"},
  {iata: "ATP", airport: "Aitape Airstrip"},
  {iata: "ATQ", airport: "Raja Sansi Airport"},
  {iata: "ATR", airport: "Mouakchott Airport"},
  {iata: "ATS", airport: "Artesia Airport"},
  {iata: "ATT", airport: "Atmautluak Airport"},
  {iata: "ATV", airport: "Ati Airport"},
  {iata: "ATW", airport: "Outagamie County Airport"},
  {iata: "ATX", airport: "Atbasar Airport"},
  {iata: "ATY", airport: "Watertown Airport"},
  {iata: "ATZ", airport: "Assiut Airport"},
  {iata: "AUA", airport: "Reina Beatrix Airport"},
  {iata: "AUB", airport: "Itauba Airport"},
  {iata: "AUC", airport: "Arauca Airport"},
  {iata: "AUD", airport: "Augustus Downs Airport"},
  {iata: "AUE", airport: "Abu Rudeis Airport"},
  {iata: "AUF", airport: "Aeroport Auxerre Branches"},
  {iata: "AUG", airport: "Augusta Airport"},
  {iata: "AUH", airport: "Abu Dhabi International Airport"},
  {iata: "AUI", airport: "Aua Island Airport"},
  {iata: "AUJ", airport: "Ambunti Airport"},
  {iata: "AUK", airport: "Alakanuk Airport"},
  {iata: "AUM", airport: "Austin Airport"},
  {iata: "AUN", airport: "Auburn Airport"},
  {iata: "AUO", airport: "Auburn-Opelika Airport"},
  {iata: "AUP", airport: "Agaun Airport"},
  {iata: "AUQ", airport: "Atuona Airport"},
  {iata: "AUR", airport: "Aurillac Airport"},
  {iata: "AUS", airport: "Austin-Bergstrom International Airport"},
  {iata: "AUT", airport: "Atauro Airport"},
  {iata: "AUU", airport: "Aurukun Mission Airport"},
  {iata: "AUV", airport: "Aumo Airport"},
  {iata: "AUW", airport: "Wausau Municipal Airport"},
  {iata: "AUX", airport: "Araguaina Airport"},
  {iata: "AUY", airport: "Aneityum Airport"},
  {iata: "AUZ", airport: "Aurora Municipal Airport"},
  {iata: "AVA", airport: "An Shun/Huang Guo Shu Airport"},
  {iata: "AVB", airport: "Aviano Airport"},
  {iata: "AVF", airport: "Avoriaz Airport"},
  {iata: "AVG", airport: "Auvergne Airport"},
  {iata: "AVI", airport: "Maximo Gomez Airport"},
  {iata: "AVK", airport: "Arvaikheer Airport"},
  {iata: "AVL", airport: "Asheville Regional Airport"},
  {iata: "AVN", airport: "Avignon-Caum Airport"},
  {iata: "AVO", airport: "Avon Park Municipal Airport"},
  {iata: "AVP", airport: "Wilkes-Barre International Airport"},
  {iata: "AVU", airport: "Avu Avu Airport"},
  {iata: "AVV", airport: "Avalon Airport"},
  {iata: "AVW", airport: "Avra Valley Airport"},
  {iata: "AVX", airport: "Avalon Bay Airport"},
  {iata: "AWA", airport: "Awasa Airport"},
  {iata: "AWB", airport: "Awaba Airport"},
  {iata: "AWD", airport: "Aniwa Airport"},
  {iata: "AWE", airport: "Alowe Airport"},
  {iata: "AWH", airport: "Awareh Airport"},
  {iata: "AWK", airport: "Wake Island Airport"},
  {iata: "AWM", airport: "West Memphis Municipal Airport"},
  {iata: "AWN", airport: "Alton Downs Airport"},
  {iata: "AWP", airport: "Austral Downs Airport"},
  {iata: "AWR", airport: "Awar Airport"},
  {iata: "AWZ", airport: "Ahwaz Airport"},
  {iata: "AXA", airport: "Wallblake Airport"},
  {iata: "AXB", airport: "Alexandria Bay Airport"},
  {iata: "AXC", airport: "Aramac Airport"},
  {iata: "AXD", airport: "Demokritos Airport"},
  {iata: "AXE", airport: "Xanxere Airport"},
  {iata: "AXG", airport: "Algona Airport"},
  {iata: "AXK", airport: "Ataq Airport"},
  {iata: "AXL", airport: "Alexandria Airport"},
  {iata: "AXM", airport: "El Eden Airport"},
  {iata: "AXN", airport: "Alexandria Airport"},
  {iata: "AXP", airport: "Springpoint Airport"},
  {iata: "AXR", airport: "Arutua Airport"},
  {iata: "AXS", airport: "Altus Municipal Airport"},
  {iata: "AXT", airport: "Akita Airport"},
  {iata: "AXU", airport: "Axum Airport"},
  {iata: "AXV", airport: "Neil Armstrong Airport"},
  {iata: "AXX", airport: "Angel Fire Airport"},
  {iata: "AYA", airport: "Ayapel Airport"},
  {iata: "AYC", airport: "Ayacucho Airport"},
  {iata: "AYD", airport: "Alroy Downs Airport"},
  {iata: "AYE", airport: "Army Air Field Heliport"},
  {iata: "AYG", airport: "Yaguara Airport"},
  {iata: "AYH", airport: "Royal Air Force Station"},
  {iata: "AYI", airport: "Yari Airport"},
  {iata: "AYK", airport: "Arkalyk Airport"},
  {iata: "AYL", airport: "Anthony Lagoon Airport"},
  {iata: "AYN", airport: "Anyang Airport"},
  {iata: "AYO", airport: "Ayolas Airport"},
  {iata: "AYP", airport: "Yanamilla Airport"},
  {iata: "AYQ", airport: "Connellan Airport"},
  {iata: "AYR", airport: "Ayr Airport"},
  {iata: "AYS", airport: "Ware County Airport"},
  {iata: "AYT", airport: "Antalya Airport"},
  {iata: "AYU", airport: "Aiyura Airport"},
  {iata: "AYW", airport: "Ayawasi Airport"},
  {iata: "AYX", airport: "Arnold Afb"},
  {iata: "AYZ", airport: "Zahns Airport"},
  {iata: "AZA", airport: "Phoenix-Mesa Gateway Airport"},
  {iata: "AZA", airport: "Phoenix-Mesa Gateway Airport"},
  {iata: "AZB", airport: "Amazon Bay Airport"},
  {iata: "AZD", airport: "Yazd Airport"},
  {iata: "AZG", airport: "Apatzingan Airport"},
  {iata: "AZI", airport: "Bateen Airport"},
  {iata: "AZN", airport: "Andizhan Airport"},
  {iata: "AZO", airport: "Battle Creek International Airport"},
  {iata: "AZP", airport: "Atizapan Airport"},
  {iata: "AZR", airport: "Adrar Airport"},
  {iata: "AZS", airport: "El Catey Airport"},
  {iata: "BAA", airport: "Bialla Airport"},
  {iata: "BAB", airport: "Beale Air Force Base"},
  {iata: "BAC", airport: "Barranca De Upia Airport"},
  {iata: "BAD", airport: "Barksdale Air Force Base"},
  {iata: "BAE", airport: "Barcelonnette Airport"},
  {iata: "BAF", airport: "Barnes Airport"},
  {iata: "BAG", airport: "Loakan Airport"},
  {iata: "BAH", airport: "Bahrain International Airport"},
  {iata: "BAI", airport: "Buenos Aires Airport"},
  {iata: "BAJ", airport: "Bali Airport"},
  {iata: "BAK", airport: "Metropolitan Area"},
  {iata: "BAL", airport: "Batman Airport"},
  {iata: "BAM", airport: "Lander County Airport"},
  {iata: "BAN", airport: "Basongo Airport"},
  {iata: "BAO", airport: "Udorn Airport"},
  {iata: "BAP", airport: "Baibara Airport"},
  {iata: "BAQ", airport: "E Cortissoz Airport"},
  {iata: "BAS", airport: "Balalae Airport"},
  {iata: "BAT", airport: "Barretos Airport"},
  {iata: "BAU", airport: "Bauru Airport"},
  {iata: "BAV", airport: "Baotou Airport"},
  {iata: "BAW", airport: "Biawonque Airport"},
  {iata: "BAX", airport: "Barnaul Airport"},
  {iata: "BAY", airport: "Baia Mare Airport"},
  {iata: "BAZ", airport: "Barbelos Airport"},
  {iata: "BBA", airport: "Teniente Vidal Airport"},
  {iata: "BBB", airport: "Benson Municipal Airport"},
  {iata: "BBC", airport: "Bay City Airport"},
  {iata: "BBD", airport: "Curtis Field"},
  {iata: "BBE", airport: "Big Bell Airport"},
  {iata: "BBF", airport: "Burlington Airport"},
  {iata: "BBG", airport: "Butaritari Airport"},
  {iata: "BBH", airport: "Barth Airport"},
  {iata: "BBI", airport: "Bhubaneswar Airport"},
  {iata: "BBJ", airport: "Bitburg Air Base"},
  {iata: "BBK", airport: "Kasane Airport"},
  {iata: "BBL", airport: "Babolsar Airport"},
  {iata: "BBM", airport: "Battambang Airport"},
  {iata: "BBN", airport: "Bario Airport"},
  {iata: "BBO", airport: "Berbera Airport"},
  {iata: "BBP", airport: "Bembridge Airport"},
  {iata: "BBQ", airport: "Barbuda Airport"},
  {iata: "BBR", airport: "Baillif Airport"},
  {iata: "BBS", airport: "Blackbush Airport"},
  {iata: "BBT", airport: "Berberati Airport"},
  {iata: "BBU", airport: "Baneasa Airport"},
  {iata: "BBW", airport: "Broken Bow Airport"},
  {iata: "BBX", airport: "Wings Field"},
  {iata: "BBY", airport: "Bambari Airport"},
  {iata: "BBZ", airport: "Zambezi Airport"},
  {iata: "BCA", airport: "Baracoa Airport"},
  {iata: "BCB", airport: "Virginia Tech Airport"},
  {iata: "BCD", airport: "Bacolod Airport"},
  {iata: "BCE", airport: "Bryce Airport"},
  {iata: "BCF", airport: "Bouca Airport"},
  {iata: "BCG", airport: "Bemichi Airport"},
  {iata: "BCH", airport: "English Madeira Airport"},
  {iata: "BCI", airport: "Barcaldine Airport"},
  {iata: "BCJ", airport: "Baca Grande Airport"},
  {iata: "BCK", airport: "Bolwarra Airport"},
  {iata: "BCL", airport: "Barra Colorado Airport"},
  {iata: "BCM", airport: "Bacau Airport"},
  {iata: "BCN", airport: "Barcelona Airport"},
  {iata: "BCO", airport: "Jinka Airport"},
  {iata: "BCP", airport: "Bambu Airport"},
  {iata: "BCQ", airport: "Brack Airport"},
  {iata: "BCR", airport: "Boca Do Acre Airport"},
  {iata: "BCS", airport: "Southern Sea Plane"},
  {iata: "BCT", airport: "Boca Raton Public Airport"},
  {iata: "BCU", airport: "Bauchi Airport"},
  {iata: "BCV", airport: "Belmopan Airport"},
  {iata: "BCW", airport: "Benguera Island Airport"},
  {iata: "BCX", airport: "Beloreck Airport"},
  {iata: "BCY", airport: "Bulchi Airport"},
  {iata: "BCZ", airport: "Bickerton Island Airport"},
  {iata: "BDA", airport: "Bermuda International Airport"},
  {iata: "BDB", airport: "Bundaberg Airport"},
  {iata: "BDC", airport: "Barra Do Corda Airport"},
  {iata: "BDD", airport: "Badu Island Airport"},
  {iata: "BDE", airport: "Baudette Airport"},
  {iata: "BDF", airport: "Rinkenberger Airport"},
  {iata: "BDG", airport: "Blanding Airport"},
  {iata: "BDH", airport: "Bandar Lengeh Airport"},
  {iata: "BDI", airport: "Bird Island Airport"},
  {iata: "BDJ", airport: "Sjamsudin Noor Airport"},
  {iata: "BDL", airport: "Bradley International Airport"},
  {iata: "BDM", airport: "Bandirma Airport"},
  {iata: "BDN", airport: "Talhar Airport"},
  {iata: "BDO", airport: "Husein Sastranegara Airport"},
  {iata: "BDP", airport: "Bhadrapur Airport"},
  {iata: "BDQ", airport: "Vadodara Airport"},
  {iata: "BDR", airport: "Igor I. Sikorsky Memorial Airport"},
  {iata: "BDS", airport: "Papola Casale Airport"},
  {iata: "BDT", airport: "Gbadolite Airport"},
  {iata: "BDU", airport: "Bardufoss Airport"},
  {iata: "BDV", airport: "Moba Airport"},
  {iata: "BDW", airport: "Bedford Downs Airport"},
  {iata: "BDX", airport: "Broadus Airport"},
  {iata: "BDY", airport: "State Airport"},
  {iata: "BDZ", airport: "Baindoung Airport"},
  {iata: "BEA", airport: "Bereina Airport"},
  {iata: "BEB", airport: "Benbecula Airport"},
  {iata: "BEC", airport: "Beech Airport"},
  {iata: "BED", airport: "Hanscom Field"},
  {iata: "BEE", airport: "Beagle Bay Airport"},
  {iata: "BEF", airport: "Bluefields Airport"},
  {iata: "BEG", airport: "Beograd Airport"},
  {iata: "BEH", airport: "Ross Field"},
  {iata: "BEI", airport: "Beica Airport"},
  {iata: "BEJ", airport: "Berau Airport"},
  {iata: "BEK", airport: "Bareli Airport"},
  {iata: "BEL", airport: "Val De Cans Airport"},
  {iata: "BEM", airport: "Bossembele Airport"},
  {iata: "BEN", airport: "Benina International Airport"},
  {iata: "BEO", airport: "Belmont Airport"},
  {iata: "BEP", airport: "Bellary Airport"},
  {iata: "BEQ", airport: "Honington Airport"},
  {iata: "BES", airport: "Guipavas Airport"},
  {iata: "BET", airport: "Bethel Airport"},
  {iata: "BEU", airport: "Bedourie Airport"},
  {iata: "BEW", airport: "Beira Airport"},
  {iata: "BEX", airport: "Royal Air Force Station"},
  {iata: "BEY", airport: "Beirut International Airport"},
  {iata: "BEZ", airport: "Beru Airport"},
  {iata: "BFA", airport: "Bahia Negra Airport"},
  {iata: "BFC", airport: "Bloomfield Airport"},
  {iata: "BFD", airport: "Bradford Airport"},
  {iata: "BFE", airport: "Bielefeld Airport"},
  {iata: "BFF", airport: "Scotts Bluff County Airport"},
  {iata: "BFG", airport: "Bullfrog Basin Airport"},
  {iata: "BFH", airport: "Bacacheri Airport"},
  {iata: "BFI", airport: "Boeing Field International Airport"},
  {iata: "BFJ", airport: "Ba Airport"},
  {iata: "BFK", airport: "Buckley Air National Guard Base"},
  {iata: "BFL", airport: "Meadows Field"},
  {iata: "BFM", airport: "Mobile Aerospace Field"},
  {iata: "BFN", airport: "Bloemfontein International Airport"},
  {iata: "BFO", airport: "Buffalo Range Airport"},
  {iata: "BFP", airport: "Beaver Falls Airport"},
  {iata: "BFQ", airport: "Bahia Pinas Airport"},
  {iata: "BFR", airport: "Virgil I Grissom Municipal Airport"},
  {iata: "BFS", airport: "Belfast International Airport"},
  {iata: "BFT", airport: "County Airport"},
  {iata: "BFU", airport: "Bengbu Airport"},
  {iata: "BFV", airport: "Buri Ram Airport"},
  {iata: "BFW", airport: "Sidi Belabbes Airport"},
  {iata: "BFX", airport: "Bafoussam Airport"},
  {iata: "BGA", airport: "Palo Negro Airport"},
  {iata: "BGB", airport: "Booue Airport"},
  {iata: "BGC", airport: "Braganca Airport"},
  {iata: "BGD", airport: "Borger Airport"},
  {iata: "BGE", airport: "Decatur County Airport"},
  {iata: "BGF", airport: "Bangui Airport"},
  {iata: "BGH", airport: "Abbaye Airport"},
  {iata: "BGI", airport: "Grantley Adams International Airport"},
  {iata: "BGJ", airport: "Borgarfjordur Eystri Airport"},
  {iata: "BGK", airport: "Big Creek Airport"},
  {iata: "BGL", airport: "Baglung Airport"},
  {iata: "BGM", airport: "Binghamton Airport"},
  {iata: "BGN", airport: "Royal Air Force"},
  {iata: "BGO", airport: "Flesland Airport"},
  {iata: "BGP", airport: "Bongo Airport"},
  {iata: "BGQ", airport: "Big Lake Airport"},
  {iata: "BGR", airport: "Bangor International Airport"},
  {iata: "BGS", airport: "Webb Air Force Base"},
  {iata: "BGT", airport: "Bagdad Airport"},
  {iata: "BGU", airport: "Bangassou Airport"},
  {iata: "BGV", airport: "Bento Goncalves Airport"},
  {iata: "BGW", airport: "Al Muthana Airport"},
  {iata: "BGX", airport: "Bage Airport"},
  {iata: "BGY", airport: "Orio Al Serio Airport"},
  {iata: "BGZ", airport: "Braga Airport"},
  {iata: "BHA", airport: "Bahia De Caraquez Airport"},
  {iata: "BHB", airport: "Bar Harbor Airport"},
  {iata: "BHC", airport: "Bhurban Heliport"},
  {iata: "BHD", airport: "Belfast City Airport"},
  {iata: "BHE", airport: "Blenheim Airport"},
  {iata: "BHF", airport: "Bahia Cupica Airport"},
  {iata: "BHG", airport: "Brus Laguna Airport"},
  {iata: "BHH", airport: "Bisha Airport"},
  {iata: "BHI", airport: "Comandante Airport"},
  {iata: "BHJ", airport: "Rudra Mata Airport"},
  {iata: "BHK", airport: "Bukhara Airport"},
  {iata: "BHL", airport: "Bahai Angeles Airport"},
  {iata: "BHM", airport: "Birmingham Airport"},
  {iata: "BHN", airport: "Beihan Airport"},
  {iata: "BHO", airport: "Bhopal Airport"},
  {iata: "BHP", airport: "Bhojpur Airport"},
  {iata: "BHQ", airport: "Broken Hill Airport"},
  {iata: "BHR", airport: "Bharatpur Airport"},
  {iata: "BHS", airport: "Raglan Airport"},
  {iata: "BHT", airport: "Brighton Downs Airport"},
  {iata: "BHU", airport: "Bhavnagar Airport"},
  {iata: "BHV", airport: "Bahawalpur Airport"},
  {iata: "BHW", airport: "Bhagatanwala Airport"},
  {iata: "BHX", airport: "Birmingham International Airport"},
  {iata: "BHY", airport: "Beihai Airport"},
  {iata: "BIA", airport: "Poretta Airport"},
  {iata: "BIB", airport: "Baidoa Airport"},
  {iata: "BIC", airport: "Big Creek Airport"},
  {iata: "BID", airport: "Block Island Airport"},
  {iata: "BIE", airport: "Beatrice Airport"},
  {iata: "BIF", airport: "Biggs Army Air Field"},
  {iata: "BIH", airport: "Bishop Airport"},
  {iata: "BIJ", airport: "Biliau Airport"},
  {iata: "BIK", airport: "Mokmer Airport"},
  {iata: "BIL", airport: "Billings Airport"},
  {iata: "BIM", airport: "Bimini International Airport"},
  {iata: "BIN", airport: "Bamiyan Airport"},
  {iata: "BIO", airport: "Bilbao Airport"},
  {iata: "BIP", airport: "Bulimba Airport"},
  {iata: "BIQ", airport: "Biarritz Parme Airport"},
  {iata: "BIR", airport: "Biratnagar Airport"},
  {iata: "BIS", airport: "Bismarck Airport"},
  {iata: "BIT", airport: "Baitadi Airport"},
  {iata: "BIU", airport: "Bildudalur Airport"},
  {iata: "BIV", airport: "Bria Airport"},
  {iata: "BIW", airport: "Billiluna Airport"},
  {iata: "BIX", airport: "Keesler Air Force Base"},
  {iata: "BIY", airport: "Bisho Airport"},
  {iata: "BIZ", airport: "Bimin Airport"},
  {iata: "BJA", airport: "Bejaia Airport"},
  {iata: "BJB", airport: "Bojnord Airport"},
  {iata: "BJC", airport: "Jeffco Airport"},
  {iata: "BJD", airport: "Bakkafjordur Airport"},
  {iata: "BJF", airport: "Batsfjord Airport"},
  {iata: "BJG", airport: "Bolaang Airport"},
  {iata: "BJH", airport: "Bajhang Airport"},
  {iata: "BJI", airport: "Bemidji Airport"},
  {iata: "BJJ", airport: "Wayne County Airport"},
  {iata: "BJK", airport: "Benjina Airport"},
  {iata: "BJL", airport: "Yundum International Airport"},
  {iata: "BJM", airport: "Bujumbura International Airport"},
  {iata: "BJN", airport: "Bajone Airport"},
  {iata: "BJO", airport: "Bermejo Airport"},
  {iata: "BJP", airport: "Braganca Paulista Airport"},
  {iata: "BJR", airport: "Bahar Dar Airport"},
  {iata: "BJT", airport: "Bentota River Airport"},
  {iata: "BJU", airport: "Bajura Airport"},
  {iata: "BJV", airport: "Milas Airport"},
  {iata: "BJW", airport: "Bajawa Airport"},
  {iata: "BJX", airport: "Del Bajio Airport"},
  {iata: "BJY", airport: "Batajnica Airport"},
  {iata: "BJZ", airport: "Talaveral La Real Airport"},
  {iata: "BKA", airport: "Bykovo Airport"},
  {iata: "BKB", airport: "Bikaner Airport"},
  {iata: "BKC", airport: "Buckland Airport"},
  {iata: "BKD", airport: "Stephens County Airport"},
  {iata: "BKE", airport: "Baker Airport"},
  {iata: "BKH", airport: "Barking Sands Airport"},
  {iata: "BKI", airport: "Kota Kinabalu Airport"},
  {iata: "BKJ", airport: "Boke Airport"},
  {iata: "BKK", airport: "Airport"},
  {iata: "BKL", airport: "Burke Lakefront Airport"},
  {iata: "BKM", airport: "Bakalalan Airport"},
  {iata: "BKN", airport: "Birni Nkoni Airport"},
  {iata: "BKO", airport: "Bamako Airport"},
  {iata: "BKP", airport: "Barkly Downs Airport"},
  {iata: "BKQ", airport: "Blackall Airport"},
  {iata: "BKR", airport: "Bokoro Airport"},
  {iata: "BKS", airport: "Padangkemiling Airport"},
  {iata: "BKT", airport: "Blackstone Army Air Field"},
  {iata: "BKU", airport: "Betioky Airport"},
  {iata: "BKW", airport: "Beckley Airport"},
  {iata: "BKX", airport: "Brookings Airport"},
  {iata: "BKY", airport: "Kamenbe"},
  {iata: "BKZ", airport: "Bukoba Airport"},
  {iata: "BLA", airport: "Gen J A Anzoategui Airport"},
  {iata: "BLB", airport: "Balboa Airport"},
  {iata: "BLC", airport: "Bali Airport"},
  {iata: "BLD", airport: "Boulder City Airport"},
  {iata: "BLE", airport: "Dala Airport"},
  {iata: "BLF", airport: "Mercer County Airport"},
  {iata: "BLG", airport: "Belaga Airport"},
  {iata: "BLH", airport: "Blythe Airport"},
  {iata: "BLI", airport: "Bellingham Airport"},
  {iata: "BLJ", airport: "Batna Airport"},
  {iata: "BLK", airport: "Blackpool Airport"},
  {iata: "BLL", airport: "Billund Airport"},
  {iata: "BLM", airport: "Monmouth County Airport"},
  {iata: "BLN", airport: "Benalla Airport"},
  {iata: "BLO", airport: "Blonduos Airport"},
  {iata: "BLP", airport: "Bellavista Airport"},
  {iata: "BLQ", airport: "Guglielmo Marconi Airport"},
  {iata: "BLR", airport: "Bengaluru International Airport"},
  {iata: "BLS", airport: "Bollon Airport"},
  {iata: "BLT", airport: "Blackwater Airport"},
  {iata: "BLU", airport: "Blue Canyon Airport"},
  {iata: "BLV", airport: "Scott AFB/Mid America"},
  {iata: "BLW", airport: "Bellows Field"},
  {iata: "BLX", airport: "Belluno Airport"},
  {iata: "BLY", airport: "Belmullet Airport"},
  {iata: "BLZ", airport: "Chileka Airport"},
  {iata: "BMA", airport: "Bromma Airport"},
  {iata: "BMB", airport: "Bumba Airport"},
  {iata: "BMC", airport: "Brigham City Airport"},
  {iata: "BMD", airport: "Belo Airport"},
  {iata: "BME", airport: "Broome Airport"},
  {iata: "BMF", airport: "Bakouma Airport"},
  {iata: "BMG", airport: "Bloomington Airport"},
  {iata: "BMH", airport: "Bomai Airport"},
  {iata: "BMI", airport: "Bloomington-Normal Airport"},
  {iata: "BMJ", airport: "Baramita Airport"},
  {iata: "BMK", airport: "Borkum Airport"},
  {iata: "BML", airport: "Berlin Airport"},
  {iata: "BMM", airport: "Airport"},
  {iata: "BMN", airport: "Bamerny Airport"},
  {iata: "BMO", airport: "Bhamo Airport"},
  {iata: "BMP", airport: "Brampton Island Airport"},
  {iata: "BMQ", airport: "Bamburi Airport"},
  {iata: "BMR", airport: "Baltrum Airport"},
  {iata: "BMS", airport: "Brumado Airport"},
  {iata: "BMT", airport: "Beaumont Municipal Airport"},
  {iata: "BMU", airport: "Bima Airport"},
  {iata: "BMV", airport: "Phung-Duc Airport"},
  {iata: "BMW", airport: "Bordj Badji Mokhtar Airport"},
  {iata: "BMY", airport: "Belep Island Airport"},
  {iata: "BMZ", airport: "Bamu Airport"},
  {iata: "BNA", airport: "Nashville Metropolitan Airport"},
  {iata: "BNB", airport: "Boende Airport"},
  {iata: "BNC", airport: "Beni Airport"},
  {iata: "BND", airport: "Bandar Abbas Airport"},
  {iata: "BNE", airport: "Brisbane International Airport"},
  {iata: "BNG", airport: "Banning Airport"},
  {iata: "BNH", airport: "Barnes Airport"},
  {iata: "BNI", airport: "Benin City Airport"},
  {iata: "BNK", airport: "Ballina Byron Airport"},
  {iata: "BNL", airport: "Barnwell County Airport"},
  {iata: "BNM", airport: "Bodinumu Airport"},
  {iata: "BNN", airport: "Bronnoy Airport"},
  {iata: "BNO", airport: "Burns Airport"},
  {iata: "BNP", airport: "Bannu Airport"},
  {iata: "BNQ", airport: "Baganga Airport"},
  {iata: "BNR", airport: "Banfora Airport"},
  {iata: "BNS", airport: "Barinas Airport"},
  {iata: "BNT", airport: "Bundi Airport"},
  {iata: "BNU", airport: "Blumenau Airport"},
  {iata: "BNV", airport: "Boana Airport"},
  {iata: "BNW", airport: "Boone Airport"},
  {iata: "BNX", airport: "Banja Luka Airport"},
  {iata: "BNY", airport: "Bellona Airport"},
  {iata: "BNZ", airport: "Banz Airport"},
  {iata: "BOA", airport: "Boma Airport"},
  {iata: "BOB", airport: "Motu-mute Airport"},
  {iata: "BOC", airport: "Bocas Del Toro Airport"},
  {iata: "BOD", airport: "Bordeaux Airport"},
  {iata: "BOE", airport: "Boundji Airport"},
  {iata: "BOF", airport: "Bolling Air Force Base"},
  {iata: "BOG", airport: "Eldorado Airport"},
  {iata: "BOH", airport: "Bournemouth Airport"},
  {iata: "BOI", airport: "Boise Air Terminal (Gowen Field)"},
  {iata: "BOJ", airport: "Airport"},
  {iata: "BOK", airport: "Brookings State Airport"},
  {iata: "BOL", airport: "Bally Kelly Airport"},
  {iata: "BOM", airport: "Chhatrapati Shivaji International Airport"},
  {iata: "BON", airport: "Flamingo International Airport"},
  {iata: "BOO", airport: "Bodo Airport"},
  {iata: "BOP", airport: "Bouar Airport"},
  {iata: "BOQ", airport: "Boku Airport"},
  {iata: "BOR", airport: "Fontaine Airport"},
  {iata: "BOS", airport: "Logan International Airport"},
  {iata: "BOT", airport: "Boset Airport"},
  {iata: "BOU", airport: "Bourges Airport"},
  {iata: "BOV", airport: "Boang Airport"},
  {iata: "BOW", airport: "Bartow Airport"},
  {iata: "BOX", airport: "Borroloola Airport"},
  {iata: "BOY", airport: "Borgo Airport"},
  {iata: "BOZ", airport: "Bozoum Airport"},
  {iata: "BPA", airport: "Grumman Airport"},
  {iata: "BPB", airport: "Boridi Airport"},
  {iata: "BPC", airport: "Bamenda Airport"},
  {iata: "BPD", airport: "Bapi Airport"},
  {iata: "BPE", airport: "Bagan Airport"},
  {iata: "BPF", airport: "Batuna Airport"},
  {iata: "BPG", airport: "Barra Do Garcas Airport"},
  {iata: "BPH", airport: "Bislig Airport"},
  {iata: "BPI", airport: "Big Piney-Marbleton Airport"},
  {iata: "BPK", airport: "Biangabip Airport"},
  {iata: "BPN", airport: "Sepingan Airport"},
  {iata: "BPS", airport: "Porto Seguro Airport"},
  {iata: "BPT", airport: "Jefferson County Airport"},
  {iata: "BPU", airport: "Beppu Airport"},
  {iata: "BPX", airport: "Bangda Airport"},
  {iata: "BPY", airport: "Besalampy Airport"},
  {iata: "BQA", airport: "Baler Airport"},
  {iata: "BQB", airport: "Bussellton Airport"},
  {iata: "BQE", airport: "Bubaque Airport"},
  {iata: "BQH", airport: "Biggin Hill Airport"},
  {iata: "BQI", airport: "Bagani Airport"},
  {iata: "BQK", airport: "Glynco Jetport"},
  {iata: "BQL", airport: "Boulia Airport"},
  {iata: "BQN", airport: "Borinquen Airport"},
  {iata: "BQQ", airport: "Barra Airport"},
  {iata: "BQS", airport: "Blagoveschensk Airport"},
  {iata: "BQT", airport: "Brest Airport"},
  {iata: "BQU", airport: "Bequia Airport"},
  {iata: "BQW", airport: "Balgo Hills Airport"},
  {iata: "BRA", airport: "Barreiras Airport"},
  {iata: "BRB", airport: "Barreirinha"},
  {iata: "BRC", airport: "San Carlos de Bariloche International Airport"},
  {iata: "BRD", airport: "Crow Wing County Airport"},
  {iata: "BRE", airport: "Bremen Airport"},
  {iata: "BRF", airport: "Bradford Airport"},
  {iata: "BRG", airport: "Whitesburg Municipal Airport"},
  {iata: "BRH", airport: "Brahman Airport"},
  {iata: "BRI", airport: "Palese Airport"},
  {iata: "BRJ", airport: "Bright Airport"},
  {iata: "BRK", airport: "Bourke Airport"},
  {iata: "BRL", airport: "Burlington Airport"},
  {iata: "BRM", airport: "Barquisimeto Airport"},
  {iata: "BRN", airport: "Belp Airport"},
  {iata: "BRO", airport: "South Padre Island International Airport"},
  {iata: "BRP", airport: "Biaru Airport"},
  {iata: "BRQ", airport: "Turany Airport"},
  {iata: "BRR", airport: "North Bay Airport"},
  {iata: "BRS", airport: "Bristol Airport"},
  {iata: "BRT", airport: "Bathurst Island Airport"},
  {iata: "BRU", airport: "National Airport"},
  {iata: "BRV", airport: "Bremerhaven Airport"},
  {iata: "BRW", airport: "Wiley Post/Will Rogers Memorial Airport"},
  {iata: "BRX", airport: "Barahona Airport"},
  {iata: "BRY", airport: "Samuels Field"},
  {iata: "BSA", airport: "Bossaso Airport"},
  {iata: "BSB", airport: "Brasilia International Airport"},
  {iata: "BSC", airport: "Bahia Solano Airport"},
  {iata: "BSD", airport: "Baoshan Airport"},
  {iata: "BSE", airport: "Sematan Airport"},
  {iata: "BSF", airport: "Bradshaw Army Air Field"},
  {iata: "BSG", airport: "Bata Airport"},
  {iata: "BSH", airport: "Brighton Airport"},
  {iata: "BSI", airport: "Blairsville Airport"},
  {iata: "BSJ", airport: "Bairnsdale Airport"},
  {iata: "BSK", airport: "Biskra Airport"},
  {iata: "BSL", airport: "EuroAirport Swiss"},
  {iata: "BSM", airport: "Bishe-Kola Airport"},
  {iata: "BSN", airport: "Bossangoa Airport"},
  {iata: "BSO", airport: "Basco Airport"},
  {iata: "BSP", airport: "Bensbach Airport"},
  {iata: "BSQ", airport: "Bisbee Municipal Airport"},
  {iata: "BSR", airport: "Basra International Airport"},
  {iata: "BSS", airport: "Balsas Airport"},
  {iata: "BST", airport: "Bost Airport"},
  {iata: "BSU", airport: "Basankusu Airport"},
  {iata: "BSV", airport: "Besakoa Airport"},
  {iata: "BSX", airport: "Bassein Airport"},
  {iata: "BSY", airport: "Bardera Airport"},
  {iata: "BSZ", airport: "Bartletts Airport"},
  {iata: "BTA", airport: "Bertoua Airport"},
  {iata: "BTB", airport: "Betou Airport"},
  {iata: "BTC", airport: "Batticaloa Airport"},
  {iata: "BTD", airport: "Brunette Downs Airport"},
  {iata: "BTE", airport: "Bonthe Airport"},
  {iata: "BTF", airport: "Salt Lake Skypark"},
  {iata: "BTG", airport: "Batangafo Airport"},
  {iata: "BTH", airport: "Hang Nadim Airport"},
  {iata: "BTI", airport: "Barter Island Airport"},
  {iata: "BTJ", airport: "Blang Bintang Airport"},
  {iata: "BTK", airport: "Bratsk Airport"},
  {iata: "BTL", airport: "WK Kellogg Regional Airport"},
  {iata: "BTM", airport: "Butte Airport"},
  {iata: "BTN", airport: "Bennettsville Airport"},
  {iata: "BTO", airport: "Botopasie Airport"},
  {iata: "BTP", airport: "Graham Field"},
  {iata: "BTQ", airport: "Butare Airport"},
  {iata: "BTR", airport: "Ryan Airport"},
  {iata: "BTS", airport: "Ivanka Airport"},
  {iata: "BTT", airport: "Bettles Airport"},
  {iata: "BTU", airport: "Bintulu Airport"},
  {iata: "BTV", airport: "Burlington International Airport"},
  {iata: "BTW", airport: "Batulicin Airport"},
  {iata: "BTX", airport: "Betoota Airport"},
  {iata: "BTY", airport: "Beatty Airport"},
  {iata: "BTZ", airport: "Bursa Airport"},
  {iata: "BUA", airport: "Buka Airport"},
  {iata: "BUB", airport: "Burwell Municipal Airport"},
  {iata: "BUC", airport: "Burketown Airport"},
  {iata: "BUD", airport: "Ferihegy Airport"},
  {iata: "BUF", airport: "Buffalo Niagara International Airport"},
  {iata: "BUI", airport: "Bokondini Airport"},
  {iata: "BUJ", airport: "Ain Eddis Airport"},
  {iata: "BUK", airport: "Albuq Airport"},
  {iata: "BUL", airport: "Bulolo Airport"},
  {iata: "BUM", airport: "Butler Airport"},
  {iata: "BUN", airport: "Buenaventura Airport"},
  {iata: "BUO", airport: "Burao Airport"},
  {iata: "BUP", airport: "Bhatinda Airport"},
  {iata: "BUQ", airport: "Bulawayo Airport"},
  {iata: "BUR", airport: "Bob Hope Airport"},
  {iata: "BUS", airport: "Batumi Airport"},
  {iata: "BUT", airport: "Burtonwood Airport"},
  {iata: "BUV", airport: "Bella Union Airport"},
  {iata: "BUW", airport: "Baubau Airport"},
  {iata: "BUX", airport: "Bunia Airport"},
  {iata: "BUY", airport: "Bunbury Airport"},
  {iata: "BUZ", airport: "Bushehr Airport"},
  {iata: "BVA", airport: "Beauvais-Tille Airport"},
  {iata: "BVB", airport: "Boa Vista Airport"},
  {iata: "BVC", airport: "Airport"},
  {iata: "BVE", airport: "Laroche Airport"},
  {iata: "BVF", airport: "Dama Airport"},
  {iata: "BVG", airport: "Berlevag Airport"},
  {iata: "BVH", airport: "Vilhena Airport"},
  {iata: "BVI", airport: "Birdsville Airport"},
  {iata: "BVK", airport: "Huacaraje Airport"},
  {iata: "BVL", airport: "Baures Airport"},
  {iata: "BVM", airport: "Belmonte Airport"},
  {iata: "BVO", airport: "Bartlesville Airport"},
  {iata: "BVP", airport: "Bolovip Airport"},
  {iata: "BVR", airport: "Esperadinha Airport"},
  {iata: "BVS", airport: "Breves Airport"},
  {iata: "BVW", airport: "Batavia Downs Airport"},
  {iata: "BVX", airport: "Batesville Municipal Airport"},
  {iata: "BVY", airport: "Beverly Airport"},
  {iata: "BVZ", airport: "Beverley Springs Airport"},
  {iata: "BWA", airport: "Bhairawa Airport"},
  {iata: "BWB", airport: "Barrow Island Airport"},
  {iata: "BWC", airport: "Brawley Airport"},
  {iata: "BWD", airport: "Brownwood Airport"},
  {iata: "BWE", airport: "Braunschweig Airport"},
  {iata: "BWF", airport: "Walney Island Airport"},
  {iata: "BWG", airport: "Warren County Airport"},
  {iata: "BWH", airport: "Butterworth Airport"},
  {iata: "BWI", airport: "Balt./Wash. International Airport"},
  {iata: "BWJ", airport: "Bawan Airport"},
  {iata: "BWK", airport: "Bol Airport"},
  {iata: "BWL", airport: "Blackwell Airport"},
  {iata: "BWM", airport: "Bowman Airport"},
  {iata: "BWN", airport: "Brunei International Airport"},
  {iata: "BWO", airport: "Balakovo Airport"},
  {iata: "BWP", airport: "Bewani Airport"},
  {iata: "BWQ", airport: "Brewarrina Airport"},
  {iata: "BWS", airport: "Blaine Airport"},
  {iata: "BWT", airport: "Burnie Wynyard Airport"},
  {iata: "BWU", airport: "Bankstown Airport"},
  {iata: "BWY", airport: "Bentwaters Street Airport"},
  {iata: "BXA", airport: "George R. Carr Airport"},
  {iata: "BXB", airport: "Babo Airport"},
  {iata: "BXC", airport: "Boxborough Airport"},
  {iata: "BXD", airport: "Bade Airport"},
  {iata: "BXE", airport: "Bakel Airport"},
  {iata: "BXF", airport: "Belburn Airport"},
  {iata: "BXG", airport: "Bendigo Airport"},
  {iata: "BXH", airport: "Balhash Airport"},
  {iata: "BXJ", airport: "Burundai Airport"},
  {iata: "BXK", airport: "Buckeye Airport"},
  {iata: "BXL", airport: "Blue Lagoon Airport"},
  {iata: "BXM", airport: "Batom Airport"},
  {iata: "BXN", airport: "Imsik Airport"},
  {iata: "BXO", airport: "Buochs Airport"},
  {iata: "BXR", airport: "Bam Airport"},
  {iata: "BXS", airport: "Borrego Springs Airport"},
  {iata: "BXT", airport: "Bontang Airport"},
  {iata: "BXU", airport: "Butuan Airport"},
  {iata: "BXV", airport: "Breiddalsvik Airport"},
  {iata: "BXX", airport: "Borama Airport"},
  {iata: "BXZ", airport: "Bunsil Airport"},
  {iata: "BYA", airport: "Boundary Airport"},
  {iata: "BYC", airport: "Yacuiba Airport"},
  {iata: "BYD", airport: "Beidah Airport"},
  {iata: "BYG", airport: "Buffalo Municipal Airport"},
  {iata: "BYH", airport: "Blytheville Air Force Base"},
  {iata: "BYI", airport: "Rupert Airport"},
  {iata: "BYL", airport: "Bella Yella Airport"},
  {iata: "BYM", airport: "C.M. de Cespedes Airport"},
  {iata: "BYN", airport: "Bayankhongor Airport"},
  {iata: "BYO", airport: "Bonito Airport"},
  {iata: "BYQ", airport: "Bunyu Airport"},
  {iata: "BYR", airport: "Laeso Airport"},
  {iata: "BYS", airport: "Bicycle Lake Army Air Field"},
  {iata: "BYT", airport: "Bantry Airport"},
  {iata: "BYU", airport: "Bindlacher-Berg Airport"},
  {iata: "BYW", airport: "Blakely Island Airport"},
  {iata: "BYX", airport: "Baniyala Airport"},
  {iata: "BZA", airport: "San Pedro Airport"},
  {iata: "BZB", airport: "Bazaruto Island Airport"},
  {iata: "BZC", airport: "Buzios Airport"},
  {iata: "BZD", airport: "Balranald Airport"},
  {iata: "BZE", airport: "Philip S.W. Goldson International Airport"},
  {iata: "BZG", airport: "Bydgoszcz Airport"},
  {iata: "BZH", airport: "Bumi Hills Airport"},
  {iata: "BZI", airport: "Balikesir Airport"},
  {iata: "BZK", airport: "Briansk Airport"},
  {iata: "BZL", airport: "Barisal Airport"},
  {iata: "BZM", airport: "Woensdrecht Airport"},
  {iata: "BZN", airport: "Gallatin Field"},
  {iata: "BZO", airport: "Bolzano Airport"},
  {iata: "BZP", airport: "Bizant Airport"},
  {iata: "BZR", airport: "Beziers Vias Airport"},
  {iata: "BZS", airport: "Buzzards Point S Airport"},
  {iata: "BZT", airport: "Hinkles Ferry"},
  {iata: "BZU", airport: "Buta Airport"},
  {iata: "BZV", airport: "Maya Maya Airport"},
  {iata: "BZY", airport: "Beltsy Airport"},
  {iata: "BZZ", airport: "RAF Station"},
  {iata: "CAA", airport: "Catacamas Airport"},
  {iata: "CAB", airport: "Cabinda Airport"},
  {iata: "CAC", airport: "Cascavel Airport"},
  {iata: "CAD", airport: "Cadillac Airport"},
  {iata: "CAE", airport: "Columbia Metropolitan Airport"},
  {iata: "CAF", airport: "Carauari Airport"},
  {iata: "CAG", airport: "Elmas Airport"},
  {iata: "CAH", airport: "Ca Mau Airport"},
  {iata: "CAI", airport: "Cairo International Airport"},
  {iata: "CAJ", airport: "Canaima Airport"},
  {iata: "CAK", airport: "Akron/Canton Regional Airport"},
  {iata: "CAL", airport: "Machrihanish Airport"},
  {iata: "CAM", airport: "Camiri Airport"},
  {iata: "CAN", airport: "Baiyun Airport"},
  {iata: "CAO", airport: "Clayton Airport"},
  {iata: "CAP", airport: "Cap Haitien Airport"},
  {iata: "CAQ", airport: "Caucasia Airport"},
  {iata: "CAR", airport: "Caribou Municipal Airport"},
  {iata: "CAS", airport: "Anfa Airport"},
  {iata: "CAT", airport: "Cat Island Airport"},
  {iata: "CAU", airport: "Caruaru Airport"},
  {iata: "CAW", airport: "Bartolomeu Lisandro Airport"},
  {iata: "CAX", airport: "Carlisle Airport"},
  {iata: "CAY", airport: "Rochambeau Airport"},
  {iata: "CAZ", airport: "Cobar Airport"},
  {iata: "CBB", airport: "J Wilsterman Airport"},
  {iata: "CBC", airport: "Cherrabun Airport"},
  {iata: "CBD", airport: "Car Nicobar Airport"},
  {iata: "CBE", airport: "Wiley Ford Airport"},
  {iata: "CBF", airport: "Council Bluffs Municipal Airport"},
  {iata: "CBG", airport: "Cambridge Airport"},
  {iata: "CBH", airport: "Leger Airport"},
  {iata: "CBI", airport: "Cape Barren Island Airport"},
  {iata: "CBJ", airport: "Cabo Rojo Airport"},
  {iata: "CBK", airport: "Colby Municipal Airport"},
  {iata: "CBL", airport: "Ciudad Bolivar Airport"},
  {iata: "CBM", airport: "Columbus Air Force Base"},
  {iata: "CBN", airport: "Penggung Airport"},
  {iata: "CBO", airport: "Awang Airport"},
  {iata: "CBP", airport: "Coimbra Airport"},
  {iata: "CBQ", airport: "Calabar Airport"},
  {iata: "CBR", airport: "Canberra Airport"},
  {iata: "CBS", airport: "Oro Negro Airport"},
  {iata: "CBT", airport: "Catumbela Airport"},
  {iata: "CBU", airport: "Cottbus Airport"},
  {iata: "CBV", airport: "Coban Airport"},
  {iata: "CBW", airport: "Campo Mourao Airport"},
  {iata: "CBX", airport: "Condobolin Airport"},
  {iata: "CBY", airport: "Canobie Airport"},
  {iata: "CCA", airport: "Chaffee Air Force Base"},
  {iata: "CCB", airport: "Cable Airport"},
  {iata: "CCC", airport: "Cayo Coco Airport"},
  {iata: "CCE", airport: "Grand Case Airport"},
  {iata: "CCF", airport: "Salvaza Airport"},
  {iata: "CCG", airport: "Crane County Airport"},
  {iata: "CCH", airport: "Chile Chico Airport"},
  {iata: "CCI", airport: "Concordia Airport"},
  {iata: "CCJ", airport: "Calicut Airport"},
  {iata: "CCK", airport: "Cocos Islands Airport"},
  {iata: "CCL", airport: "Chinchilla Airport"},
  {iata: "CCM", airport: "Criciuma Airport"},
  {iata: "CCN", airport: "Chakcharan Airport"},
  {iata: "CCO", airport: "Carimagua Airport"},
  {iata: "CCP", airport: "Carriel Sur Airport"},
  {iata: "CCQ", airport: "Cachoeira Airport"},
  {iata: "CCR", airport: "Buchanan Field"},
  {iata: "CCS", airport: "Simon Bolivar Airport"},
  {iata: "CCT", airport: "Colonia Catriel Airport"},
  {iata: "CCU", airport: "Netaji Subhas Chandra Airport"},
  {iata: "CCV", airport: "Craig Cove Airport"},
  {iata: "CCW", airport: "Cowell Airport"},
  {iata: "CCX", airport: "Caceres Airport"},
  {iata: "CCY", airport: "Charles City Municipal Airport"},
  {iata: "CCZ", airport: "Chub Cay Airport"},
  {iata: "CDA", airport: "Cooinda Airport"},
  {iata: "CDB", airport: "Cold Bay Airport"},
  {iata: "CDC", airport: "Cedar City Airport"},
  {iata: "CDD", airport: "Cauquira Airport"},
  {iata: "CDE", airport: "Caledonia Airport"},
  {iata: "CDG", airport: "Charles De Gaulle Airport"},
  {iata: "CDH", airport: "Harrell Field"},
  {iata: "CDI", airport: "Cachoeiro de Itapemirim Airport"},
  {iata: "CDJ", airport: "Conceicao Do Araguaia Airport"},
  {iata: "CDK", airport: "Lewis Airport"},
  {iata: "CDL", airport: "Candle Airport"},
  {iata: "CDN", airport: "Woodward Field"},
  {iata: "CDO", airport: "Cradock Airport"},
  {iata: "CDP", airport: "Cuddapah Airport"},
  {iata: "CDQ", airport: "Croydon Airport"},
  {iata: "CDR", airport: "Maliron Airport"},
  {iata: "CDS", airport: "Childress Airport"},
  {iata: "CDU", airport: "Camden Airport"},
  {iata: "CDV", airport: "Mudhole Smith Airport"},
  {iata: "CDW", airport: "Caldwell Wright Airport"},
  {iata: "CDY", airport: "Cagayan De Sulu Airport"},
  {iata: "CDZ", airport: "Cadiz Airport"},
  {iata: "CEA", airport: "Cessna Aircraft Field"},
  {iata: "CEB", airport: "Mactan International Airport"},
  {iata: "CEC", airport: "Mc Namara Field"},
  {iata: "CED", airport: "Ceduna Airport"},
  {iata: "CEE", airport: "Cherepovets Airport"},
  {iata: "CEF", airport: "Westover Metro Airport"},
  {iata: "CEG", airport: "Chester Airport"},
  {iata: "CEH", airport: "Chelinda Airport"},
  {iata: "CEI", airport: "Chiang Rai Airport"},
  {iata: "CEJ", airport: "Chernigov Airport"},
  {iata: "CEK", airport: "Chelyabinsk Airport"},
  {iata: "CEM", airport: "Central Airport"},
  {iata: "CEN", airport: "Ciudad Obregon Airport"},
  {iata: "CEP", airport: "Concepcion Airport"},
  {iata: "CEQ", airport: "Mandelieu Airport"},
  {iata: "CER", airport: "Maupertus Airport"},
  {iata: "CES", airport: "Cessnock Airport"},
  {iata: "CET", airport: "Le Pontreau Airport"},
  {iata: "CEU", airport: "Oconee County Airport"},
  {iata: "CEV", airport: "Mettle Field"},
  {iata: "CEW", airport: "Bob Sikes Airport"},
  {iata: "CEY", airport: "Calloway County Airport"},
  {iata: "CEZ", airport: "Montezuma County Airport"},
  {iata: "CFA", airport: "Coffee Point Airport"},
  {iata: "CFB", airport: "Cabo Frio Airport"},
  {iata: "CFC", airport: "Cacador Airport"},
  {iata: "CFD", airport: "Coulter Field"},
  {iata: "CFE", airport: "Aulnat Airport"},
  {iata: "CFG", airport: "Cienfuegos Airport"},
  {iata: "CFH", airport: "Clifton Hills Airport"},
  {iata: "CFI", airport: "Camfield Airport"},
  {iata: "CFK", airport: "Chlef Airport"},
  {iata: "CFN", airport: "Donegal Airport"},
  {iata: "CFO", airport: "Confreza Airport"},
  {iata: "CFP", airport: "Carpentaria Downs Airport"},
  {iata: "CFQ", airport: "Creston Airport"},
  {iata: "CFR", airport: "Carpiquet Airport"},
  {iata: "CFS", airport: "Coffs Harbour Airport"},
  {iata: "CFT", airport: "Morenci Airport"},
  {iata: "CFU", airport: "I. Kapodistrias Airport"},
  {iata: "CFV", airport: "Coffeyville Municipal Airport"},
  {iata: "CGA", airport: "Craig Sea Plane Base"},
  {iata: "CGB", airport: "M. Rondon Airport"},
  {iata: "CGC", airport: "Cape Gloucester Airport"},
  {iata: "CGD", airport: "Changde Airport"},
  {iata: "CGE", airport: "Cambridge Airport"},
  {iata: "CGF", airport: "Cuyahoga County Airport"},
  {iata: "CGG", airport: "Casiguran Airport"},
  {iata: "CGH", airport: "Congonhas Airport"},
  {iata: "CGI", airport: "Cape Girardeau Airport"},
  {iata: "CGJ", airport: "Chingola Airport"},
  {iata: "CGK", airport: "Soekarno-Hatta International Airport"},
  {iata: "CGM", airport: "Mambajao Airport"},
  {iata: "CGN", airport: "Koeln/Bonn Airport"},
  {iata: "CGO", airport: "Zhengzhou Airport"},
  {iata: "CGP", airport: "Patenga Airport"},
  {iata: "CGQ", airport: "Changchun Airport"},
  {iata: "CGR", airport: "Campo Grande Internacional Airport"},
  {iata: "CGS", airport: "College Park Airport"},
  {iata: "CGT", airport: "Chinguitti Airport"},
  {iata: "CGU", airport: "Ciudad Guayana Airport"},
  {iata: "CGV", airport: "Caiguna Airport"},
  {iata: "CGX", airport: "Merrill C Meigs Field"},
  {iata: "CGY", airport: "Lumbia Airport"},
  {iata: "CGZ", airport: "Casa Grande Municipal Airport"},
  {iata: "CHA", airport: "Lovell Field"},
  {iata: "CHB", airport: "Chilas Airport"},
  {iata: "CHC", airport: "Christchurch International Airport"},
  {iata: "CHE", airport: "Reenroe Airport"},
  {iata: "CHF", airport: "Jinhae Airport"},
  {iata: "CHG", airport: "Chaoyang Airport"},
  {iata: "CHH", airport: "Chachapoyas Airport"},
  {iata: "CHJ", airport: "Chipinge Airport"},
  {iata: "CHK", airport: "Chickasha Municipal Airport"},
  {iata: "CHL", airport: "Challis Airport"},
  {iata: "CHM", airport: "Chimbote Airport"},
  {iata: "CHN", airport: "Jeonju Airport"},
  {iata: "CHO", airport: "Albemarle Airport"},
  {iata: "CHP", airport: "Circle Hot Springs Airport"},
  {iata: "CHQ", airport: "Souda Airport"},
  {iata: "CHR", airport: "Chateauroux Airport"},
  {iata: "CHS", airport: "Charleston International Airport"},
  {iata: "CHT", airport: "Karewa Airport"},
  {iata: "CHU", airport: "Chuathbaluk Airport"},
  {iata: "CHV", airport: "Chaves Airport"},
  {iata: "CHW", airport: "Jiuquan Airport"},
  {iata: "CHX", airport: "Changuinola Airport"},
  {iata: "CHY", airport: "Choiseul Bay Airport"},
  {iata: "CHZ", airport: "State Airport"},
  {iata: "CIA", airport: "Ciampino Airport"},
  {iata: "CIB", airport: "Ap In The Sky Airport"},
  {iata: "CIC", airport: "Chico Airport"},
  {iata: "CID", airport: "Cedar Rapids Airport"},
  {iata: "CIE", airport: "Collie Airport"},
  {iata: "CIF", airport: "Chifeng Airport"},
  {iata: "CIG", airport: "Craig-Moffat Airport"},
  {iata: "CIH", airport: "Changzhi Airport"},
  {iata: "CIJ", airport: "E. Beltram Airport"},
  {iata: "CIK", airport: "Chalkyitsik Airport"},
  {iata: "CIM", airport: "Cimitarra Airport"},
  {iata: "CIN", airport: "Carroll Airport"},
  {iata: "CIO", airport: "MCAL Lopez Airport"},
  {iata: "CIP", airport: "Chipata Airport"},
  {iata: "CIQ", airport: "Chiquimula Airport"},
  {iata: "CIR", airport: "Cairo Airport"},
  {iata: "CIS", airport: "Canton Island Airport"},
  {iata: "CIT", airport: "Shimkent Airport"},
  {iata: "CIU", airport: "Chippewa County Airport"},
  {iata: "CIW", airport: "Canouan Island Airport"},
  {iata: "CIX", airport: "Cornel Ruiz Airport"},
  {iata: "CIY", airport: "Comiso Airport"},
  {iata: "CIZ", airport: "Coari Airport"},
  {iata: "CJA", airport: "Cajamarca Airport"},
  {iata: "CJB", airport: "Peelamedu Airport"},
  {iata: "CJC", airport: "El Loa Airport"},
  {iata: "CJD", airport: "Candilejas Airport"},
  {iata: "CJH", airport: "Chilko Lake Airport"},
  {iata: "CJI", airport: "Ciudad Real Airport"},
  {iata: "CJJ", airport: "Cheongju Airport"},
  {iata: "CJL", airport: "Chitral Airport"},
  {iata: "CJM", airport: "Chumphon Airport"},
  {iata: "CJN", airport: "El Cajon Airport"},
  {iata: "CJS", airport: "Abraham Gonzalez International Airport"},
  {iata: "CJT", airport: "Copalar Airport"},
  {iata: "CJU", airport: "Jeju Airport"},
  {iata: "CKA", airport: "Kegelman Air Field"},
  {iata: "CKB", airport: "Benedum Airport"},
  {iata: "CKC", airport: "Cherkassy Airport"},
  {iata: "CKD", airport: "Crooked Creek Airport"},
  {iata: "CKE", airport: "Clear Lake Airport"},
  {iata: "CKG", airport: "Chongqing Airport"},
  {iata: "CKH", airport: "Chokurdah Airport"},
  {iata: "CKI", airport: "Croker Island Airport"},
  {iata: "CKK", airport: "Cherokee Village Airport"},
  {iata: "CKL", airport: "Chkalovsky Airport"},
  {iata: "CKM", airport: "Fletcher Field"},
  {iata: "CKN", airport: "Crookston Municipal Airport"},
  {iata: "CKO", airport: "Cornelio Procopio Airport"},
  {iata: "CKR", airport: "Crane Island Airport"},
  {iata: "CKS", airport: "Carajas Airport"},
  {iata: "CKT", airport: "Sarakhs Airport"},
  {iata: "CKV", airport: "Outlaw Field"},
  {iata: "CKX", airport: "Chicken Airport"},
  {iata: "CKY", airport: "Conakry Airport"},
  {iata: "CKZ", airport: "Canakkale Airport"},
  {iata: "CLA", airport: "Comilla Airport"},
  {iata: "CLB", airport: "Castlebar Airport"},
  {iata: "CLC", airport: "Metroport Airport"},
  {iata: "CLD", airport: "Carlsbad Airport"},
  {iata: "CLE", airport: "Hopkins International Airport"},
  {iata: "CLF", airport: "Coltishall Ab"},
  {iata: "CLG", airport: "Coalinga Airport"},
  {iata: "CLH", airport: "Coolah Airport"},
  {iata: "CLI", airport: "Clintonville Airport"},
  {iata: "CLJ", airport: "Napoca Airport"},
  {iata: "CLK", airport: "Clinton Municipal Airport"},
  {iata: "CLL", airport: "Easterwood Field"},
  {iata: "CLM", airport: "Fairchild International Airport"},
  {iata: "CLN", airport: "Carolina Airport"},
  {iata: "CLO", airport: "Alfonso B. Aragon Airport"},
  {iata: "CLP", airport: "Clarks Point Airport"},
  {iata: "CLQ", airport: "Colima Airport"},
  {iata: "CLR", airport: "Calipatria Airport"},
  {iata: "CLS", airport: "Centralia Airport"},
  {iata: "CLT", airport: "Douglas Airport"},
  {iata: "CLU", airport: "Columbus Municipal Airport"},
  {iata: "CLV", airport: "Caldas Novas Airport"},
  {iata: "CLW", airport: "Executive Airport"},
  {iata: "CLX", airport: "Clorinda Airport"},
  {iata: "CLY", airport: "Sainte Catherine Airport"},
  {iata: "CLZ", airport: "Calabozo Airport"},
  {iata: "CMA", airport: "Cunnamulla Airport"},
  {iata: "CMB", airport: "Bandaranayake International Airport"},
  {iata: "CMC", airport: "Camocim Airport"},
  {iata: "CMD", airport: "Cootamundra Airport"},
  {iata: "CME", airport: "Ciudad Del Carmen Airport"},
  {iata: "CMF", airport: "Chambery Airport"},
  {iata: "CMG", airport: "Corumba Internacional Airport"},
  {iata: "CMH", airport: "Port Columbus International Airport"},
  {iata: "CMI", airport: "Willard University Airport"},
  {iata: "CMJ", airport: "Chi Mei Airport"},
  {iata: "CMK", airport: "Club Makokola Airport"},
  {iata: "CML", airport: "Camooweal Airport"},
  {iata: "CMM", airport: "Carmelita Airport"},
  {iata: "CMN", airport: "Mohamed V Airport"},
  {iata: "CMO", airport: "Obbia Airport"},
  {iata: "CMP", airport: "Campo Alegre Airport"},
  {iata: "CMQ", airport: "Clermont Airport"},
  {iata: "CMR", airport: "Colmar-Houssen Airport"},
  {iata: "CMS", airport: "Scusciuban Airport"},
  {iata: "CMT", airport: "Cameta Airport"},
  {iata: "CMU", airport: "Chimbu Airport"},
  {iata: "CMV", airport: "Coromandel Airport"},
  {iata: "CMW", airport: "Ign Agramonte International Airport"},
  {iata: "CMX", airport: "Houghton County Airport"},
  {iata: "CMY", airport: "Camp McCoy Army Air Field"},
  {iata: "CMZ", airport: "Caia Airport"},
  {iata: "CNA", airport: "Cananea Airport"},
  {iata: "CNB", airport: "Coonamble Airport"},
  {iata: "CNC", airport: "Coconut Island Airport"},
  {iata: "CND", airport: "Kogalniceanu Airport"},
  {iata: "CNE", airport: "Canon City Airport"},
  {iata: "CNF", airport: "Tancredo Neves International Airport"},
  {iata: "CNG", airport: "Parvaud Airport"},
  {iata: "CNH", airport: "Claremont Municipal Airport"},
  {iata: "CNI", airport: "Changhai Airport"},
  {iata: "CNJ", airport: "Cloncurry Airport"},
  {iata: "CNK", airport: "Blosser Municipal Airport"},
  {iata: "CNL", airport: "Sindal Airport"},
  {iata: "CNM", airport: "Carlsbad Airport"},
  {iata: "CNN", airport: "Kannur International Airport"},
  {iata: "CNO", airport: "Chino Airport"},
  {iata: "CNP", airport: "Neerlerit Inaat Airport"},
  {iata: "CNQ", airport: "Camba Punta Airport"},
  {iata: "CNR", airport: "Chanaral Airport"},
  {iata: "CNS", airport: "Cairns Airport"},
  {iata: "CNT", airport: "Charata Airport"},
  {iata: "CNU", airport: "Martin Johnson Airport"},
  {iata: "CNV", airport: "Canavieiras Airport"},
  {iata: "CNW", airport: "James Connall Airport"},
  {iata: "CNX", airport: "Chiang Mai International Airport"},
  {iata: "CNY", airport: "Canyonlands Field"},
  {iata: "COA", airport: "Columbia Airport"},
  {iata: "COB", airport: "Coolibah Airport"},
  {iata: "COC", airport: "Concordia Airport"},
  {iata: "COD", airport: "Yellowstone Regional Airport"},
  {iata: "COF", airport: "Patrick Air Force Base"},
  {iata: "COG", airport: "Mandinga Airport"},
  {iata: "COH", airport: "Cooch Behar Airport"},
  {iata: "COI", airport: "Merritt Island Airport"},
  {iata: "COJ", airport: "Coonabarabran Airport"},
  {iata: "COK", airport: "Kochi Airport"},
  {iata: "COL", airport: "Coll Island Airport"},
  {iata: "COM", airport: "Coleman Airport"},
  {iata: "CON", airport: "Concord Airport"},
  {iata: "COO", airport: "Cotonou Airport"},
  {iata: "COP", airport: "Cooperstown Airport"},
  {iata: "COQ", airport: "Choibalsan Airport"},
  {iata: "COR", airport: "Pajas Blancas Airport"},
  {iata: "COS", airport: "Colorado Springs Airport"},
  {iata: "COT", airport: "Cotulla Airport"},
  {iata: "COU", airport: "Columbia Regional Airport"},
  {iata: "COV", airport: "Covilha Airport"},
  {iata: "COW", airport: "Coquimbo Airport"},
  {iata: "COX", airport: "Congo Town Airport"},
  {iata: "COY", airport: "Coolawanyah Airport"},
  {iata: "COZ", airport: "Constanza Airport"},
  {iata: "CPA", airport: "A. Tubman Airport"},
  {iata: "CPB", airport: "Capurgana Airport"},
  {iata: "CPC", airport: "Chapelco Airport"},
  {iata: "CPD", airport: "Coober Pedy Airport"},
  {iata: "CPE", airport: "Campeche International Airport"},
  {iata: "CPF", airport: "Cepu Airport"},
  {iata: "CPG", airport: "Carmen De Patagones Airport"},
  {iata: "CPH", airport: "Airport"},
  {iata: "CPI", airport: "Cape Orford Airport"},
  {iata: "CPL", airport: "Chaparral Airport"},
  {iata: "CPM", airport: "Compton Airport"},
  {iata: "CPN", airport: "Cape Rodney Airport"},
  {iata: "CPO", airport: "Chamonate Airport"},
  {iata: "CPQ", airport: "Campinas International Airport"},
  {iata: "CPR", airport: "Casper Airport"},
  {iata: "CPS", airport: "Bi-State Parks Airport"},
  {iata: "CPT", airport: "Cape Town International Airport"},
  {iata: "CPU", airport: "Cururupu Airport"},
  {iata: "CPV", airport: "Joao Suassuna Airport"},
  {iata: "CPX", airport: "Culebra Airport"},
  {iata: "CQA", airport: "Canarana Airport"},
  {iata: "CQD", airport: "Shahre-Kord Airport"},
  {iata: "CQF", airport: "Calais Airport"},
  {iata: "CQP", airport: "Cape Flattery Airport"},
  {iata: "CQS", airport: "Costa Marques Airport"},
  {iata: "CQT", airport: "Caquetania Airport"},
  {iata: "CRA", airport: "Craiova Airport"},
  {iata: "CRB", airport: "Collarenebri Airport"},
  {iata: "CRC", airport: "Cartago Airport"},
  {iata: "CRD", airport: "Comodoro Rivadavia Airport"},
  {iata: "CRE", airport: "Grand Strand Airport"},
  {iata: "CRF", airport: "Carnot Airport"},
  {iata: "CRG", airport: "Craig Municipal Airport"},
  {iata: "CRH", airport: "Cherribah Airport"},
  {iata: "CRI", airport: "Crooked Island Airport"},
  {iata: "CRJ", airport: "Coorabie Airport"},
  {iata: "CRK", airport: "Clark Field"},
  {iata: "CRL", airport: "Charleroi Brussels South Airport"},
  {iata: "CRM", airport: "National Airport"},
  {iata: "CRN", airport: "Cromarty Airport"},
  {iata: "CRO", airport: "Corcoran Airport"},
  {iata: "CRP", airport: "Corpus Christi International Airport"},
  {iata: "CRQ", airport: "Caravelas Airport"},
  {iata: "CRR", airport: "Ceres Airport"},
  {iata: "CRS", airport: "Corsicana Airport"},
  {iata: "CRT", airport: "Crossett Municipal Airport"},
  {iata: "CRU", airport: "Carriacou Island Airport"},
  {iata: "CRV", airport: "Crotone Airport"},
  {iata: "CRW", airport: "Yeager Airport"},
  {iata: "CRX", airport: "Roscoe Turner Airport"},
  {iata: "CRY", airport: "Carlton Hill Airport"},
  {iata: "CRZ", airport: "Turkmenabad Airport"},
  {iata: "CSA", airport: "Colonsay Island Airport"},
  {iata: "CSB", airport: "Caransebes Airport"},
  {iata: "CSC", airport: "Canas Airport"},
  {iata: "CSD", airport: "Cresswell Downs Airport"},
  {iata: "CSE", airport: "Crested Butte Airport"},
  {iata: "CSF", airport: "Creil Airport"},
  {iata: "CSG", airport: "Metropolitan Area"},
  {iata: "CSH", airport: "Solovetsky Airport"},
  {iata: "CSI", airport: "Casino Airport"},
  {iata: "CSJ", airport: "Cape St. Jacques Airport"},
  {iata: "CSK", airport: "Cap Skirring Airport"},
  {iata: "CSM", airport: "Sherman Airport"},
  {iata: "CSN", airport: "Carson City Airport"},
  {iata: "CSO", airport: "Cochstedt Airport"},
  {iata: "CSQ", airport: "Creston Municipal Airport"},
  {iata: "CSR", airport: "Casuarito Airport"},
  {iata: "CSS", airport: "Cassilandia Airport"},
  {iata: "CST", airport: "Castaway Airport"},
  {iata: "CSU", airport: "Santa Cruz Do Sul Airport"},
  {iata: "CSV", airport: "Crossville Memorial Airport"},
  {iata: "CSW", airport: "Colorado do Oeste Airport"},
  {iata: "CSX", airport: "Changsha Airport"},
  {iata: "CSY", airport: "Cheboksary Airport"},
  {iata: "CSZ", airport: "Brigadier Hector Ruiz"},
  {iata: "CTA", airport: "Fontanarossa Airport"},
  {iata: "CTB", airport: "Cut Bank Airport"},
  {iata: "CTC", airport: "Catamarca Airport"},
  {iata: "CTD", airport: "Chitre Airport"},
  {iata: "CTE", airport: "Carti Airport"},
  {iata: "CTF", airport: "Coatepeque Airport"},
  {iata: "CTG", airport: "Rafael Nunez Airport"},
  {iata: "CTH", airport: "Chestercounty Carlson Airport"},
  {iata: "CTK", airport: "Canton Airport"},
  {iata: "CTL", airport: "Charleville Airport"},
  {iata: "CTM", airport: "Chetumal Airport"},
  {iata: "CTN", airport: "Cooktown Airport"},
  {iata: "CTO", airport: "Peconic River Airport"},
  {iata: "CTP", airport: "Carutapera Airport"},
  {iata: "CTQ", airport: "Do Palmar Airport"},
  {iata: "CTR", airport: "Cattle Creek Airport"},
  {iata: "CTS", airport: "Chitose Airport"},
  {iata: "CTT", airport: "Le Castellet Airport"},
  {iata: "CTU", airport: "Chengdu Airport"},
  {iata: "CTW", airport: "Cottonwood Airport"},
  {iata: "CTX", airport: "Cortland Airport"},
  {iata: "CTY", airport: "Cross City Airport"},
  {iata: "CTZ", airport: "Sampson County Airport"},
  {iata: "CUA", airport: "Ciudad Constitucion Airport"},
  {iata: "CUB", airport: "Owens Field"},
  {iata: "CUC", airport: "Camilo Dazo Airport"},
  {iata: "CUD", airport: "Caloundra Airport"},
  {iata: "CUE", airport: "Cuenca Airport"},
  {iata: "CUF", airport: "Levaldigi Airport"},
  {iata: "CUG", airport: "Cudal Airport"},
  {iata: "CUH", airport: "Cushing Municipal Airport"},
  {iata: "CUI", airport: "Currillo Airport"},
  {iata: "CUJ", airport: "Culion Airport"},
  {iata: "CUK", airport: "Caye Caulker Airport"},
  {iata: "CUL", airport: "Fedl De Bachigualato Airport"},
  {iata: "CUM", airport: "Cumana Airport"},
  {iata: "CUN", airport: "Cancun Airport"},
  {iata: "CUO", airport: "Caruru Airport"},
  {iata: "CUP", airport: "Carupano Airport"},
  {iata: "CUQ", airport: "Coen Airport"},
  {iata: "CUR", airport: "Aeropuerto Hato"},
  {iata: "CUS", airport: "Columbus Municipal Airport"},
  {iata: "CUT", airport: "Cutral Airport"},
  {iata: "CUU", airport: "Gen Fierro Villalobos Airport"},
  {iata: "CUV", airport: "Casigua Airport"},
  {iata: "CUX", airport: "Cuddihy Field"},
  {iata: "CUY", airport: "Cue Airport"},
  {iata: "CUZ", airport: "Velazco Astete Airport"},
  {iata: "CVA", airport: "Civic Ar Heliport"},
  {iata: "CVB", airport: "Chungribu Airport"},
  {iata: "CVC", airport: "Cleve Airport"},
  {iata: "CVE", airport: "Covenas Airport"},
  {iata: "CVF", airport: "Courchevel Airport"},
  {iata: "CVG", airport: "Cincinnati/Northern Kentucky Airport"},
  {iata: "CVH", airport: "Caviahue Airport"},
  {iata: "CVI", airport: "Caleta Olivia Airport"},
  {iata: "CVJ", airport: "Cuernavaca Airport"},
  {iata: "CVL", airport: "Cape Vogel Airport"},
  {iata: "CVM", airport: "Ciudad Victoria Airport"},
  {iata: "CVN", airport: "Clovis Municipal Airport"},
  {iata: "CVO", airport: "Corvallis Municipal Airport"},
  {iata: "CVQ", airport: "Carnarvon Airport"},
  {iata: "CVR", airport: "Hughes Airport"},
  {iata: "CVS", airport: "Cannon Air Force Base"},
  {iata: "CVT", airport: "Baginton Airport"},
  {iata: "CVU", airport: "Corvo Island (Azores) Airport"},
  {iata: "CWA", airport: "Central Wisconsin Airport"},
  {iata: "CWB", airport: "Afonso Pena Airport"},
  {iata: "CWC", airport: "Chernovtsy Airport"},
  {iata: "CWG", airport: "Callaway Gardens Airport"},
  {iata: "CWI", airport: "Clinton Airport"},
  {iata: "CWL", airport: "Cardiff-Wales Airport"},
  {iata: "CWO", airport: "Ft. Wolter Air Force Base"},
  {iata: "CWP", airport: "Campbellpore Airport"},
  {iata: "CWR", airport: "Cowarie Airport"},
  {iata: "CWS", airport: "Center Island Airport"},
  {iata: "CWT", airport: "Cowra Airport"},
  {iata: "CWW", airport: "Corowa Airport"},
  {iata: "CXA", airport: "Caicara De Oro Airport"},
  {iata: "CXB", airport: "Coxs Bazar Airport"},
  {iata: "CXH", airport: "Coal Harbour Sea Plane Base"},
  {iata: "CXI", airport: "Island Airport"},
  {iata: "CXJ", airport: "Campo Dos Bugres Airport"},
  {iata: "CXL", airport: "Calexico International Airport"},
  {iata: "CXN", airport: "Candala Airport"},
  {iata: "CXO", airport: "Montgomery County Airport"},
  {iata: "CXP", airport: "Tunggul Wulung Airport"},
  {iata: "CXQ", airport: "Christmas Creek Airport"},
  {iata: "CXR", airport: "Cam Rahn Airport"},
  {iata: "CXT", airport: "Charters Towers Airport"},
  {iata: "CYA", airport: "Les Cayes Airport"},
  {iata: "CYB", airport: "Gerrard-Smith Airport"},
  {iata: "CYC", airport: "Caye Chapel Airport"},
  {iata: "CYE", airport: "Crystal Lake Airport"},
  {iata: "CYF", airport: "Chefornak Sea Plane Base"},
  {iata: "CYG", airport: "Corryong Airport"},
  {iata: "CYI", airport: "Chiayi Airport"},
  {iata: "CYL", airport: "Coyoles Airport"},
  {iata: "CYO", airport: "Cayo Largo Del Sur Airport"},
  {iata: "CYP", airport: "Calbayog Airport"},
  {iata: "CYR", airport: "Colonia Airport"},
  {iata: "CYS", airport: "Cheyenne Airport"},
  {iata: "CYU", airport: "Cuyo Airport"},
  {iata: "CYW", airport: "Celaya"},
  {iata: "CYX", airport: "Cherskiy Airport"},
  {iata: "CYZ", airport: "Cauayan Airport"},
  {iata: "CZA", airport: "Chichen Itza Airport"},
  {iata: "CZB", airport: "Carlos Ruhl Airport"},
  {iata: "CZE", airport: "Coro Airport"},
  {iata: "CZH", airport: "Corozal Airport"},
  {iata: "CZJ", airport: "Corazon De Jesus Airport"},
  {iata: "CZK", airport: "Cascade Locks/Stevens Airport"},
  {iata: "CZL", airport: "Ain El Bey Airport"},
  {iata: "CZM", airport: "Cozumel Airport"},
  {iata: "CZN", airport: "Chisana Field"},
  {iata: "CZS", airport: "Campo Internacional Airport"},
  {iata: "CZT", airport: "Carrizo Springs Airport"},
  {iata: "CZU", airport: "Corozal Airport"},
  {iata: "CZW", airport: "Czestochowa Airport"},
  {iata: "CZX", airport: "Changzhou Airport"},
  {iata: "CZY", airport: "Cluny Airport"},
  {iata: "CZZ", airport: "Campo Airport"},
  {iata: "DAA", airport: "Davison Army Air Field"},
  {iata: "DAB", airport: "Daytona Beach Regional Airport"},
  {iata: "DAC", airport: "Zia International Airport"},
  {iata: "DAD", airport: "Da Nang Airport"},
  {iata: "DAE", airport: "Daparizo Airport"},
  {iata: "DAF", airport: "Daup Airport"},
  {iata: "DAG", airport: "Barstow-Daggett Airport"},
  {iata: "DAH", airport: "Dathina Airport"},
  {iata: "DAI", airport: "Darjeeling Airport"},
  {iata: "DAJ", airport: "Dauan Island Airport"},
  {iata: "DAK", airport: "Dakhla Airport"},
  {iata: "DAL", airport: "Love Field"},
  {iata: "DAM", airport: "Damascus International Airport"},
  {iata: "DAN", airport: "Danville Municipal Airport"},
  {iata: "DAO", airport: "Dabo Airport"},
  {iata: "DAP", airport: "Darchula Airport"},
  {iata: "DAR", airport: "Dar Es Salaam International Airport"},
  {iata: "DAS", airport: "Great Bear Lake Airport"},
  {iata: "DAT", airport: "Datong Airport"},
  {iata: "DAU", airport: "Daru Airport"},
  {iata: "DAV", airport: "Enrique Malek Airport"},
  {iata: "DAX", airport: "Daxian Airport"},
  {iata: "DAY", airport: "James Cox Dayton International Airport"},
  {iata: "DAZ", airport: "Darwaz Airport"},
  {iata: "DBA", airport: "Dalbandin Airport"},
  {iata: "DBD", airport: "Dhanbad Airport"},
  {iata: "DBM", airport: "Debra Marcos Airport"},
  {iata: "DBN", airport: "Dublin Municipal Airport"},
  {iata: "DBO", airport: "Dubbo Airport"},
  {iata: "DBP", airport: "Debepare Airport"},
  {iata: "DBQ", airport: "Dubuque Municipal Airport"},
  {iata: "DBS", airport: "Dubois Airport"},
  {iata: "DBT", airport: "Debra Tabor Airport"},
  {iata: "DBU", airport: "Dambula Oya Tank Airport"},
  {iata: "DBV", airport: "Dubrovnik Airport"},
  {iata: "DBY", airport: "Dalby Airport"},
  {iata: "DCA", airport: "Ronald Reagan National Airport"},
  {iata: "DCF", airport: "Cane Field Airport"},
  {iata: "DCI", airport: "Rafsu Decimomannu Airport"},
  {iata: "DCM", airport: "Mazamet Airport"},
  {iata: "DCR", airport: "Decatur Hi-Way Airport"},
  {iata: "DCU", airport: "Pyor Airport"},
  {iata: "DDC", airport: "Dodge City Municipal Airport"},
  {iata: "DDG", airport: "Dandong Airport"},
  {iata: "DDI", airport: "Daydream Island Airport"},
  {iata: "DDM", airport: "Dodoima Airport"},
  {iata: "DDN", airport: "Delta Downs Airport"},
  {iata: "DDP", airport: "Dorado Beach Airport"},
  {iata: "DDU", airport: "Dadu Airport"},
  {iata: "DEA", airport: "Dera Ghazi Khan Airport"},
  {iata: "DEB", airport: "Debrecen Airport"},
  {iata: "DEC", airport: "Decatur Airport"},
  {iata: "DED", airport: "Dehra Dun Airport"},
  {iata: "DEF", airport: "Dezful Airport"},
  {iata: "DEH", airport: "Decorah Municipal Airport"},
  {iata: "DEI", airport: "Denis Island Airport"},
  {iata: "DEL", airport: "Indira Gandhi International Airport"},
  {iata: "DEM", airport: "Dembidollo Airport"},
  {iata: "DEN", airport: "Denver International Airport"},
  {iata: "DEO", airport: "Hyatt Regency Heliport"},
  {iata: "DEP", airport: "Deparizo Airport"},
  {iata: "DER", airport: "Derim Airport"},
  {iata: "DES", airport: "Desroches Airport"},
  {iata: "DET", airport: "Detroit City Airport"},
  {iata: "DEZ", airport: "Al Jafrah Airport"},
  {iata: "DFI", airport: "Defiance Memorial Airport"},
  {iata: "DFP", airport: "Drumduff Airport"},
  {iata: "DFW", airport: "Dallas/Ft. Worth International Airport"},
  {iata: "DGA", airport: "Dangriga Airport"},
  {iata: "DGC", airport: "Degahbur Airport"},
  {iata: "DGD", airport: "Dalgaranga Airport"},
  {iata: "DGE", airport: "Mudgee Airport"},
  {iata: "DGF", airport: "Douglas Lake Airport"},
  {iata: "DGL", airport: "Douglas Municipal Airport"},
  {iata: "DGM", airport: "Dongguan Airport"},
  {iata: "DGN", airport: "Naval Air Field"},
  {iata: "DGO", airport: "Guadalupe Victoria Airport"},
  {iata: "DGP", airport: "Daugavpils Airport"},
  {iata: "DGR", airport: "Dargaville Airport"},
  {iata: "DGT", airport: "Dumaguete Airport"},
  {iata: "DGU", airport: "Dedougou Airport"},
  {iata: "DGW", airport: "Converse County Airport"},
  {iata: "DHA", airport: "King Abdulaziz Ab"},
  {iata: "DHD", airport: "Durham Downs Airport"},
  {iata: "DHF", airport: "Al Dhafra Military Airport"},
  {iata: "DHI", airport: "Dhangarhi Airport"},
  {iata: "DHL", airport: "Dhala Airport"},
  {iata: "DHM", airport: "Gaggal Airport"},
  {iata: "DHN", airport: "Dothan Airport"},
  {iata: "DHR", airport: "De Kooy Airport"},
  {iata: "DHT", airport: "Dalhart Airport"},
  {iata: "DIB", airport: "Chabua Airport"},
  {iata: "DIC", airport: "Dili Airport"},
  {iata: "DIE", airport: "Antsiranana/Arrachart Airport"},
  {iata: "DIG", airport: "Diqing Airport"},
  {iata: "DIJ", airport: "Dijon Airport"},
  {iata: "DIK", airport: "Dickinson Airport"},
  {iata: "DIL", airport: "Comoro Airport"},
  {iata: "DIN", airport: "Dien Bien Airport"},
  {iata: "DIO", airport: "Diomede Island Airport"},
  {iata: "DIP", airport: "Diapaga Airport"},
  {iata: "DIQ", airport: "Divinopolis Airport"},
  {iata: "DIR", airport: "Aba Tenna D Yilma Airport"},
  {iata: "DIS", airport: "Loubomo Airport"},
  {iata: "DIU", airport: "Diu Airport"},
  {iata: "DIY", airport: "Diyarbakir Airport"},
  {iata: "DJA", airport: "Djougou Airport"},
  {iata: "DJB", airport: "Sultan Taha Syarifudn Airport"},
  {iata: "DJE", airport: "Melita Airport"},
  {iata: "DJG", airport: "Inedbirenne Airport"},
  {iata: "DJJ", airport: "Sentani Airport"},
  {iata: "DJM", airport: "Djambala Airport"},
  {iata: "DJN", airport: "Delta Junction Airport"},
  {iata: "DJU", airport: "Djupivogur Airport"},
  {iata: "DKI", airport: "Dunk Island Airport"},
  {iata: "DKK", airport: "Dunkirk Airport"},
  {iata: "DKR", airport: "Yoff Airport"},
  {iata: "DKS", airport: "Dikson Airport"},
  {iata: "DKV", airport: "Docker River Airport"},
  {iata: "DLA", airport: "Douala Airport"},
  {iata: "DLC", airport: "Dalian Airport"},
  {iata: "DLD", airport: "Dagali Airport"},
  {iata: "DLE", airport: "Tavaux Airport"},
  {iata: "DLF", airport: "Laughlin Air Force Base"},
  {iata: "DLG", airport: "Dillingham Municipal Airport"},
  {iata: "DLH", airport: "Duluth International Airport"},
  {iata: "DLI", airport: "Lienkhang Airport"},
  {iata: "DLK", airport: "Dulkaninna Airport"},
  {iata: "DLL", airport: "Dillon Airport"},
  {iata: "DLM", airport: "Dalaman Airport"},
  {iata: "DLN", airport: "Dillon Airport"},
  {iata: "DLO", airport: "Dolomi Airport"},
  {iata: "DLP", airport: "Disneyland Paris Airport"},
  {iata: "DLS", airport: "The Dalles Airport"},
  {iata: "DLU", airport: "Dali Airport"},
  {iata: "DLV", airport: "Delissaville Airport"},
  {iata: "DLY", airport: "Dillons Bay Airport"},
  {iata: "DLZ", airport: "Dalanzadgad Airport"},
  {iata: "DMA", airport: "Davis Monthan Air Force Base"},
  {iata: "DMB", airport: "Dzhambyl Airport"},
  {iata: "DMD", airport: "Doomadgee Airport"},
  {iata: "DME", airport: "Domodedovo Airport"},
  {iata: "DMK", airport: "Don Muang International Airport"},
  {iata: "DMM", airport: "King Fahad International Airport"},
  {iata: "DMN", airport: "Deming Airport"},
  {iata: "DMO", airport: "Sedalia Airport"},
  {iata: "DMR", airport: "Dhamar Airport"},
  {iata: "DMT", airport: "Diamantino Airport"},
  {iata: "DMU", airport: "Dimapur Airport"},
  {iata: "DNA", airport: "Kadena Air Force Base"},
  {iata: "DNB", airport: "Dunbar Airport"},
  {iata: "DND", airport: "Dundee Airport"},
  {iata: "DNE", airport: "Dallas North Airport"},
  {iata: "DNF", airport: "Martuba Airport"},
  {iata: "DNG", airport: "Doongan Airport"},
  {iata: "DNH", airport: "Dunhuang Airport"},
  {iata: "DNI", airport: "Wad Medani Airport"},
  {iata: "DNK", airport: "Dnepropetrovsk Airport"},
  {iata: "DNL", airport: "Daniel Field"},
  {iata: "DNM", airport: "Denham Airport"},
  {iata: "DNN", airport: "Dalton Municipal Airport"},
  {iata: "DNO", airport: "Dianopolis Airport"},
  {iata: "DNP", airport: "Dang Airport"},
  {iata: "DNQ", airport: "Deniliquin Airport"},
  {iata: "DNR", airport: "Pleurtuit Airport"},
  {iata: "DNS", airport: "Denison Municipal Airport"},
  {iata: "DNT", airport: "Santa Ana Downtown Heliport"},
  {iata: "DNU", airport: "Dinangat Airport"},
  {iata: "DNV", airport: "Vermilion County Airport"},
  {iata: "DNX", airport: "Galegu Airport"},
  {iata: "DNZ", airport: "Cardak Airport"},
  {iata: "DOA", airport: "Doany Airport"},
  {iata: "DOB", airport: "Dobo Airport"},
  {iata: "DOC", airport: "Dornoch Airport"},
  {iata: "DOD", airport: "Dodoma Airport"},
  {iata: "DOE", airport: "Djoemoe Airport"},
  {iata: "DOG", airport: "Dongola Airport"},
  {iata: "DOH", airport: "Doha Airport"},
  {iata: "DOI", airport: "Doini Airport"},
  {iata: "DOK", airport: "Donetsk Airport"},
  {iata: "DOL", airport: "Saint Gatien Airport"},
  {iata: "DOM", airport: "Melville Hall Airport"},
  {iata: "DON", airport: "Dos Lagunas Airport"},
  {iata: "DOO", airport: "Dorobisoro Airport"},
  {iata: "DOP", airport: "Dolpa Airport"},
  {iata: "DOR", airport: "Dori Airport"},
  {iata: "DOS", airport: "Dios Airport"},
  {iata: "DOU", airport: "Dourados Airport"},
  {iata: "DOV", airport: "Dover Air Force Base"},
  {iata: "DOX", airport: "Dongara Airport"},
  {iata: "DOY", airport: "Dongying Airport"},
  {iata: "DPA", airport: "Dupage County Airport"},
  {iata: "DPE", airport: "Dieppe Airport"},
  {iata: "DPG", airport: "Michael Army Air Field"},
  {iata: "DPK", airport: "Deer Park Airport"},
  {iata: "DPL", airport: "Dipolog Airport"},
  {iata: "DPO", airport: "Devonport Airport"},
  {iata: "DPS", airport: "Ngurah Rai Airport"},
  {iata: "DPU", airport: "Dumpu Airport"},
  {iata: "DQA", airport: "Daqing"},
  {iata: "DRA", airport: "Desert Rock Airport"},
  {iata: "DRB", airport: "Derby Airport"},
  {iata: "DRD", airport: "Dorunda Station Airport"},
  {iata: "DRE", airport: "Drummond Island Airport"},
  {iata: "DRG", airport: "Deering Airport"},
  {iata: "DRH", airport: "Dabra Airport"},
  {iata: "DRI", airport: "Beauregard Parish Airport"},
  {iata: "DRJ", airport: "Drietabbetje Airport"},
  {iata: "DRM", airport: "Drama Airport"},
  {iata: "DRN", airport: "Dirranbandi Airport"},
  {iata: "DRO", airport: "La Plata Airport"},
  {iata: "DRR", airport: "Durrie Airport"},
  {iata: "DRS", airport: "Dresden Airport"},
  {iata: "DRT", airport: "Del Rio International Airport"},
  {iata: "DRU", airport: "Drummond Airport"},
  {iata: "DRW", airport: "Darwin Airport"},
  {iata: "DRY", airport: "Drysdale River Airport"},
  {iata: "DSA", airport: "Doncaster Sheffield Airport"},
  {iata: "DSC", airport: "Dschang Airport"},
  {iata: "DSD", airport: "La Desirade Airport"},
  {iata: "DSE", airport: "Combolcha Airport"},
  {iata: "DSG", airport: "Dilasag Airport"},
  {iata: "DSI", airport: "Destin Airport"},
  {iata: "DSK", airport: "Dera Ismail Khan Airport"},
  {iata: "DSL", airport: "Daru Airport"},
  {iata: "DSM", airport: "Des Moines Airport"},
  {iata: "DSN", airport: "Dongsheng Airport"},
  {iata: "DSV", airport: "Dansville Airport"},
  {iata: "DTA", airport: "Delta Airport"},
  {iata: "DTD", airport: "Datadawai Airport"},
  {iata: "DTE", airport: "Camarines Norte Airport"},
  {iata: "DTH", airport: "Death Valley Airport"},
  {iata: "DTL", airport: "Detroit Lakes Municipal Airport"},
  {iata: "DTM", airport: "Dortmund Airport"},
  {iata: "DTN", airport: "Shreveport Downtown Airport"},
  {iata: "DTR", airport: "Decatur Island Airport"},
  {iata: "DTW", airport: "Wayne County Airport"},
  {iata: "DUA", airport: "Eaker Airport"},
  {iata: "DUB", airport: "Dublin Airport"},
  {iata: "DUC", airport: "Halliburton Airport"},
  {iata: "DUD", airport: "Dunedin Airport"},
  {iata: "DUE", airport: "Dundo Airport"},
  {iata: "DUF", airport: "Pine Island Airport"},
  {iata: "DUG", airport: "Bisbee-Douglas International Airport"},
  {iata: "DUJ", airport: "Jefferson County Airport"},
  {iata: "DUK", airport: "Dukuduk Airport"},
  {iata: "DUM", airport: "Pinang Kampai Airport"},
  {iata: "DUN", airport: "Dundas Airport"},
  {iata: "DUQ", airport: "Duncan/Quam Airport"},
  {iata: "DUR", airport: "Louis Botha Airport"},
  {iata: "DUS", airport: "Dusseldorf Airport"},
  {iata: "DUT", airport: "Emergency Field"},
  {iata: "DVA", airport: "Deva Airport"},
  {iata: "DVK", airport: "Diavik Airport"},
  {iata: "DVL", airport: "Devils Lake Airport"},
  {iata: "DVN", airport: "Davenport Airport"},
  {iata: "DVO", airport: "Mati Airport"},
  {iata: "DVP", airport: "Davenport Downs Airport"},
  {iata: "DVR", airport: "Daly River Airport"},
  {iata: "DVT", airport: "Phoenix-Deer Valley Airport"},
  {iata: "DWA", airport: "Dwamawa Airport"},
  {iata: "DWB", airport: "Soalala Airport"},
  {iata: "DWD", airport: "Dawadmi Airport"},
  {iata: "DWF", airport: "Wright Air Force Base"},
  {iata: "DWH", airport: "David Wayne Hooks Airport"},
  {iata: "DWN", airport: "Oklahoma City Downtown Airpark"},
  {iata: "DWS", airport: "Walt Disney World Airport"},
  {iata: "DXA", airport: "Deux Alpes Airport"},
  {iata: "DXB", airport: "Dubai International Airport"},
  {iata: "DXD", airport: "Dixie Airport"},
  {iata: "DXR", airport: "Danbury Airport"},
  {iata: "DYA", airport: "Dysart Airport"},
  {iata: "DYG", airport: "Dayong Airport"},
  {iata: "DYL", airport: "Doylestown Airport"},
  {iata: "DYM", airport: "Diamantina Lakes Airport"},
  {iata: "DYR", airport: "Anadyr Airport"},
  {iata: "DYS", airport: "Dyess Air Force Base"},
  {iata: "DYU", airport: "Dushanbe Airport"},
  {iata: "DYW", airport: "Daly Waters Airport"},
  {iata: "DZA", airport: "Dzaoudzi Airport"},
  {iata: "DZI", airport: "Codazzi Airport"},
  {iata: "DZN", airport: "Zhezhazgan Airport"},
  {iata: "DZO", airport: "Durazno Airport"},
  {iata: "DZU", airport: "Dazu Airport"},
  {iata: "EAA", airport: "Eagle Airport"},
  {iata: "EAB", airport: "Abbse Airport"},
  {iata: "EAE", airport: "Emae Airport"},
  {iata: "EAL", airport: "Elenak Airport"},
  {iata: "EAM", airport: "Nejran Airport"},
  {iata: "EAN", airport: "Phifer Field"},
  {iata: "EAR", airport: "Kearney Airport"},
  {iata: "EAS", airport: "San Sebastian Airport"},
  {iata: "EAT", airport: "Pangborn Field"},
  {iata: "EAU", airport: "Eau Claire Airport"},
  {iata: "EBA", airport: "Marina Di Campo Airport"},
  {iata: "EBB", airport: "Entebbe Airport"},
  {iata: "EBD", airport: "El Obeid Airport"},
  {iata: "EBG", airport: "El Bagre Airport"},
  {iata: "EBJ", airport: "Esbjerg Airport"},
  {iata: "EBM", airport: "El Borma Airport"},
  {iata: "EBN", airport: "Ebadon Airport"},
  {iata: "EBR", airport: "Baton Rouge Downtown Airport"},
  {iata: "EBS", airport: "Webster City Municipal Airport"},
  {iata: "EBU", airport: "Boutheon Airport"},
  {iata: "EBW", airport: "Ebolowa Airport"},
  {iata: "ECA", airport: "Emmet County Airport"},
  {iata: "ECG", airport: "Elizabeth City Airport"},
  {iata: "ECH", airport: "Echuca Airport"},
  {iata: "ECN", airport: "Ercan Airport"},
  {iata: "ECO", airport: "El Encanto Airport"},
  {iata: "ECR", airport: "El Charco Airport"},
  {iata: "ECS", airport: "Mondell Airport"},
  {iata: "EDA", airport: "Edna Bay Airport"},
  {iata: "EDB", airport: "Eldebba Airport"},
  {iata: "EDD", airport: "Erlunda Airport"},
  {iata: "EDE", airport: "Edenton Municipal Airport"},
  {iata: "EDF", airport: "Elmendorf Air Force Base"},
  {iata: "EDG", airport: "Weide Army Air Field"},
  {iata: "EDI", airport: "Turnhouse Airport"},
  {iata: "EDK", airport: "El Dorado Airport"},
  {iata: "EDL", airport: "Eldoret Airport"},
  {iata: "EDM", airport: "Les Ajoncs Airport"},
  {iata: "EDO", airport: "Edremit/Korfez Airport"},
  {iata: "EDQ", airport: "Erandique Airport"},
  {iata: "EDR", airport: "Edward River Airport"},
  {iata: "EDW", airport: "Edwards Air Force Base"},
  {iata: "EED", airport: "Needles Airport"},
  {iata: "EEK", airport: "Eek Airport"},
  {iata: "EEN", airport: "Dillant-Hopkins Airport"},
  {iata: "EFD", airport: "Ellington Field"},
  {iata: "EFG", airport: "Efogi Airport"},
  {iata: "EFK", airport: "Newport Airport"},
  {iata: "EFL", airport: "Argostolion Airport"},
  {iata: "EFW", airport: "Jefferson Municipal Airport"},
  {iata: "EGA", airport: "Engati Airport"},
  {iata: "EGC", airport: "Roumanieres Airport"},
  {iata: "EGE", airport: "Eagle County Airport"},
  {iata: "EGI", airport: "Duke Field"},
  {iata: "EGL", airport: "Neghelli Airport"},
  {iata: "EGM", airport: "Sege Airport"},
  {iata: "EGN", airport: "Geneina Airport"},
  {iata: "EGO", airport: "Belgorod Airport"},
  {iata: "EGP", airport: "Maverick County Airport"},
  {iata: "EGS", airport: "Egilsstadir Airport"},
  {iata: "EGV", airport: "Eagle River Airport"},
  {iata: "EGX", airport: "Egegik Airport"},
  {iata: "EHL", airport: "El Bolson Airport"},
  {iata: "EHM", airport: "Cape Newenham Airport"},
  {iata: "EHT", airport: "Rentschler Airport"},
  {iata: "EIA", airport: "Popondetta Airport"},
  {iata: "EIB", airport: "Eisenach Airport"},
  {iata: "EIE", airport: "Eniseysk Airport"},
  {iata: "EIH", airport: "Einasleigh Airport"},
  {iata: "EIN", airport: "Eindhoven Airport"},
  {iata: "EIS", airport: "Island Airport"},
  {iata: "EJA", airport: "Variguies Airport"},
  {iata: "EJH", airport: "Wedjh Airport"},
  {iata: "EJT", airport: "Enijet Airport"},
  {iata: "EKA", airport: "Murray Field"},
  {iata: "EKB", airport: "Ekibastuz Airport"},
  {iata: "EKD", airport: "Elkedra Airport"},
  {iata: "EKE", airport: "Ekereku Airport"},
  {iata: "EKI", airport: "Elkhart Municipal Airport"},
  {iata: "EKN", airport: "Elkins Airport"},
  {iata: "EKO", airport: "Elko Airport"},
  {iata: "EKT", airport: "Eskilstuna Airport"},
  {iata: "EKX", airport: "Elizabethtown Airport"},
  {iata: "ELA", airport: "Eagle Lake Airport"},
  {iata: "ELB", airport: "San Bernado Airport"},
  {iata: "ELC", airport: "Elcho Island Airport"},
  {iata: "ELD", airport: "Goodwin Field"},
  {iata: "ELE", airport: "El Real Airport"},
  {iata: "ELF", airport: "El Fasher Airport"},
  {iata: "ELG", airport: "El Golea Airport"},
  {iata: "ELH", airport: "North Eleuthera International Airport"},
  {iata: "ELI", airport: "Elim Airport"},
  {iata: "ELJ", airport: "El Recreo Airport"},
  {iata: "ELK", airport: "Elk City Municipal Airport"},
  {iata: "ELL", airport: "Ellisras Airport"},
  {iata: "ELM", airport: "Elmira Regional Airport"},
  {iata: "ELN", airport: "Bowers Field"},
  {iata: "ELO", airport: "Eldorado Airport"},
  {iata: "ELP", airport: "El Paso International Airport"},
  {iata: "ELQ", airport: "Gassim Airport"},
  {iata: "ELR", airport: "Elelim, Irian Jaya Airport"},
  {iata: "ELS", airport: "East London Airport"},
  {iata: "ELT", airport: "Tour Sinai City Airport"},
  {iata: "ELU", airport: "Guemar Airport"},
  {iata: "ELV", airport: "Elfin Cove Sea Plane Base"},
  {iata: "ELX", airport: "El Tigre Airport"},
  {iata: "ELY", airport: "Yelland Airport"},
  {iata: "ELZ", airport: "Wellsville Municipal Airport"},
  {iata: "EMA", airport: "East Midlands Airport"},
  {iata: "EMB", airport: "Embarkadero Airport"},
  {iata: "EMD", airport: "Emerald Airport"},
  {iata: "EME", airport: "Emden Airport"},
  {iata: "EMG", airport: "Empangeni Airport"},
  {iata: "EMI", airport: "Emirau Airport"},
  {iata: "EMK", airport: "Emmonak Airport"},
  {iata: "EML", airport: "Emmen Airport"},
  {iata: "EMM", airport: "Kemmerer Airport"},
  {iata: "EMN", airport: "Nema Airport"},
  {iata: "EMO", airport: "Emo Airport"},
  {iata: "EMP", airport: "Emporia Airport"},
  {iata: "EMS", airport: "Embessa Airport"},
  {iata: "EMT", airport: "El Monte Airport"},
  {iata: "EMX", airport: "El Maiten Airport"},
  {iata: "EMY", airport: "El Minya Airport"},
  {iata: "ENA", airport: "Kenai Airport"},
  {iata: "ENB", airport: "Eneabba Airport"},
  {iata: "ENC", airport: "Essey Airport"},
  {iata: "END", airport: "Vance Air Force Base"},
  {iata: "ENE", airport: "Ende Airport"},
  {iata: "ENF", airport: "Enontekio Airport"},
  {iata: "ENH", airport: "Enshi Airport"},
  {iata: "ENI", airport: "El Nido Airport"},
  {iata: "ENJ", airport: "El Naranjo Airport"},
  {iata: "ENK", airport: "Saint Angelo Airport"},
  {iata: "ENL", airport: "Centralia Municipal Airport"},
  {iata: "ENO", airport: "Teniente Prim Alarcon Airport"},
  {iata: "ENQ", airport: "Coronel Enrique Soto Cano AB Airport"},
  {iata: "ENS", airport: "Twente Airport"},
  {iata: "ENU", airport: "Enugu Airport"},
  {iata: "ENV", airport: "Wendover Airport"},
  {iata: "ENW", airport: "Kenosha Municipal Airport"},
  {iata: "EOH", airport: "Enrique Olaya Herrera Airport"},
  {iata: "EOI", airport: "Eday Airport"},
  {iata: "EOK", airport: "Keokuk Airport"},
  {iata: "EOR", airport: "El Dorado Airporr"},
  {iata: "EOS", airport: "Neosho Airport"},
  {iata: "EOZ", airport: "Elorza Airport"},
  {iata: "EPA", airport: "El Palomar Airport"},
  {iata: "EPG", airport: "Browns Airport"},
  {iata: "EPH", airport: "Ephrata Airport"},
  {iata: "EPI", airport: "Epi Airport"},
  {iata: "EPK", airport: "Episkopi Airport"},
  {iata: "EPL", airport: "Mirecourt Airport"},
  {iata: "EPN", airport: "Epena Airport"},
  {iata: "EPR", airport: "Esperance Airport"},
  {iata: "EPS", airport: "El Portillo Airport"},
  {iata: "EPT", airport: "Eliptamin Airport"},
  {iata: "EPU", airport: "Parnu Airport"},
  {iata: "EQS", airport: "Esquel Airport"},
  {iata: "ERA", airport: "Erigavo Airport"},
  {iata: "ERB", airport: "Ernabella Airport"},
  {iata: "ERC", airport: "Erzincan Airport"},
  {iata: "ERD", airport: "Berdyansk Airport"},
  {iata: "ERE", airport: "Erave Airport"},
  {iata: "ERF", airport: "Erfurt Airport"},
  {iata: "ERH", airport: "Errachidia Airport"},
  {iata: "ERI", airport: "Erie International Airport"},
  {iata: "ERM", airport: "Comandante Kraemer Airport"},
  {iata: "ERN", airport: "Eirunepe Airport"},
  {iata: "ERR", airport: "Errol Airport"},
  {iata: "ERS", airport: "Eros Airport"},
  {iata: "ERT", airport: "Erdenet Airport"},
  {iata: "ERU", airport: "Erume Airport"},
  {iata: "ERV", airport: "Kerrville Airport"},
  {iata: "ERZ", airport: "Erzurum Airport"},
  {iata: "ESB", airport: "Esenboga Airport"},
  {iata: "ESC", airport: "Delta County Airport"},
  {iata: "ESD", airport: "Orcas Island Airport"},
  {iata: "ESE", airport: "Ensenada Airport"},
  {iata: "ESF", airport: "Esler Field"},
  {iata: "ESG", airport: "Mariscal Estigarribia Airport"},
  {iata: "ESH", airport: "Shoreham Airport"},
  {iata: "ESI", airport: "Espinosa Airport"},
  {iata: "ESK", airport: "Eskisehir Airport"},
  {iata: "ESL", airport: "Elista Airport"},
  {iata: "ESM", airport: "Esmeraldas Airport"},
  {iata: "ESN", airport: "Easton Airport"},
  {iata: "ESO", airport: "Espanola Airport"},
  {iata: "ESP", airport: "Birchwood-Pocono Airport"},
  {iata: "ESR", airport: "El Salvador Airport"},
  {iata: "ESS", airport: "Essen Airport"},
  {iata: "EST", airport: "Estherville Municipal Airport"},
  {iata: "ESU", airport: "Essaouira Airport"},
  {iata: "ESW", airport: "State Airport"},
  {iata: "ETB", airport: "West Bend Airport"},
  {iata: "ETD", airport: "Etadunna Airport"},
  {iata: "ETE", airport: "Genda Wuha Airport"},
  {iata: "ETH", airport: "Elat Airport"},
  {iata: "ETN", airport: "Eastland Municipal Airport"},
  {iata: "ETS", airport: "Enterprise Municipal Airport"},
  {iata: "ETZ", airport: "Metz-Nancy-Lorraine Airport"},
  {iata: "EUA", airport: "Kaufana Airport"},
  {iata: "EUC", airport: "Eucla Airport"},
  {iata: "EUE", airport: "Eureka Airport"},
  {iata: "EUF", airport: "Weedon Field"},
  {iata: "EUG", airport: "Eugene Airport"},
  {iata: "EUM", airport: "Neumuenster Airport"},
  {iata: "EUN", airport: "Hassan I Airport"},
  {iata: "EUQ", airport: "Evelio Javier Airport"},
  {iata: "EUX", airport: "F D Roosevelt Airport"},
  {iata: "EVA", airport: "Evadale Landing Strip"},
  {iata: "EVD", airport: "Eva Downs Airport"},
  {iata: "EVE", airport: "Evenes Airport"},
  {iata: "EVG", airport: "Sveg Airport"},
  {iata: "EVH", airport: "Evans Head Airport"},
  {iata: "EVM", airport: "Eveleth Airport"},
  {iata: "EVN", airport: "Yerevan Airport"},
  {iata: "EVV", airport: "Dress Regional Airport"},
  {iata: "EVW", airport: "Evanston Airport"},
  {iata: "EVX", airport: "Evreux Airport"},
  {iata: "EWB", airport: "New Bedford Airport"},
  {iata: "EWD", airport: "Wildman Lake Airport"},
  {iata: "EWE", airport: "Ewer Airport"},
  {iata: "EWI", airport: "Enarotali Airport"},
  {iata: "EWK", airport: "Newton City-County Airport"},
  {iata: "EWN", airport: "Coastal Carolina Regional Airport"},
  {iata: "EWO", airport: "Ewo Airport"},
  {iata: "EWR", airport: "Newark Liberty International Airport"},
  {iata: "EWY", airport: "Greenham Royal Air Force"},
  {iata: "EXI", airport: "Excursion Inlet Sea Plane Base"},
  {iata: "EXM", airport: "Exmouth Gulf Airport"},
  {iata: "EXT", airport: "Exeter Airport"},
  {iata: "EYL", airport: "Yelimane Airport"},
  {iata: "EYP", airport: "El Yopal Airport"},
  {iata: "EYR", airport: "Yerington Airport"},
  {iata: "EYS", airport: "Elive Springs Airport"},
  {iata: "EYW", airport: "Key West International Airport"},
  {iata: "EZE", airport: "Ministro Pistarini Airport"},
  {iata: "EZS", airport: "Elazig Airport"},
  {iata: "FAA", airport: "Faranah Airport"},
  {iata: "FAB", airport: "Farnborough Airport"},
  {iata: "FAC", airport: "Faaite Airport"},
  {iata: "FAE", airport: "Vagar Airport"},
  {iata: "FAF", airport: "Felker Army Air Field"},
  {iata: "FAG", airport: "Fagurholsmyri Airport"},
  {iata: "FAH", airport: "Farah Airport"},
  {iata: "FAI", airport: "Fairbanks International Airport"},
  {iata: "FAJ", airport: "Fajardo Airport"},
  {iata: "FAL", airport: "Roma Falcon State Airport"},
  {iata: "FAM", airport: "Farmington Regional Airport"},
  {iata: "FAN", airport: "Lista Airport"},
  {iata: "FAO", airport: "Faro Airport"},
  {iata: "FAQ", airport: "Freida River Airport"},
  {iata: "FAR", airport: "Hector Field"},
  {iata: "FAS", airport: "Faskrudsfjordur Airport"},
  {iata: "FAT", airport: "Fresno Air Terminal"},
  {iata: "FAV", airport: "Fakarava Airport"},
  {iata: "FAY", airport: "Fayetteville Municipal Airport"},
  {iata: "FAZ", airport: "Fasa Airport"},
  {iata: "FBD", airport: "Faizabad Airport"},
  {iata: "FBE", airport: "Francisco Beltrao Airport"},
  {iata: "FBG", airport: "Simmons Army Air Field"},
  {iata: "FBL", airport: "Faribault Municipal Airport"},
  {iata: "FBM", airport: "Luano"},
  {iata: "FBR", airport: "Fort Bridger Airport"},
  {iata: "FBS", airport: "Friday Harbor SPB"},
  {iata: "FBY", airport: "Fairbury Municipal Airport"},
  {iata: "FCB", airport: "Ficksburg Sentra Oes Airport"},
  {iata: "FCH", airport: "Fresno-Chandler Airport"},
  {iata: "FCM", airport: "Flying Cloud Airport"},
  {iata: "FCN", airport: "Cuxhaven/Nordholz Airport"},
  {iata: "FCO", airport: "Fiumicino Airport"},
  {iata: "FCS", airport: "Butts Army Air Field"},
  {iata: "FCT", airport: "Firing Center Army Air Field"},
  {iata: "FCY", airport: "Forrest City Municipal Airport"},
  {iata: "FDB", airport: "Principe Da Beira Airport"},
  {iata: "FDE", airport: "Bringeland Airport"},
  {iata: "FDF", airport: "Lamentin Airport"},
  {iata: "FDH", airport: "Friedrichshafen Airport"},
  {iata: "FDK", airport: "Frederick Municipal Airport"},
  {iata: "FDR", airport: "Frederick Municipal Airport"},
  {iata: "FDU", airport: "Bandundu Airport"},
  {iata: "FDY", airport: "Findlay Airport"},
  {iata: "FEA", airport: "Fetlar Airport"},
  {iata: "FEB", airport: "Sanfebagar Airport"},
  {iata: "FEC", airport: "Feira De Santana Airport"},
  {iata: "FEG", airport: "Fergana Airport"},
  {iata: "FEJ", airport: "Feijo Airport"},
  {iata: "FEL", airport: "Fuerstenfeldbruck Airport"},
  {iata: "FEN", airport: "Fernando De Noronha Airport"},
  {iata: "FEP", airport: "Albertus Airport"},
  {iata: "FES", airport: "San Fernando Airport"},
  {iata: "FET", airport: "Fremont Municipal Airport"},
  {iata: "FEW", airport: "Warren Air Force Base"},
  {iata: "FEZ", airport: "Sais Airport"},
  {iata: "FFA", airport: "First Flight Airport"},
  {iata: "FFD", airport: "Royal Air Force Station"},
  {iata: "FFL", airport: "Fairfield Municipal Airport"},
  {iata: "FFM", airport: "Fergus Falls Airport"},
  {iata: "FFO", airport: "Patterson Air Force Base"},
  {iata: "FFT", airport: "Capital City Airport"},
  {iata: "FFU", airport: "Futaleufu Airport"},
  {iata: "FGD", airport: "Fderik Airport"},
  {iata: "FGI", airport: "Fagali I Airport"},
  {iata: "FGL", airport: "Fox Glacier Airport"},
  {iata: "FGR", airport: "Fuengirola Airport"},
  {iata: "FGU", airport: "Fangatau Airport"},
  {iata: "FHU", airport: "Fort Huachuca/Sierra Vista Municipal Airport"},
  {iata: "FHZ", airport: "Fakahina Airport"},
  {iata: "FID", airport: "Elizabeth Field"},
  {iata: "FIE", airport: "Fair Isle Airport"},
  {iata: "FIG", airport: "Fria Airport"},
  {iata: "FIK", airport: "Finke Airport"},
  {iata: "FIL", airport: "Fillmore Municipal Airport"},
  {iata: "FIN", airport: "Finschhafen Airport"},
  {iata: "FIZ", airport: "Fitzroy Crossing Airport"},
  {iata: "FJR", airport: "Fujairah International Airport"},
  {iata: "FKB", airport: "Soellingen Airport"},
  {iata: "FKH", airport: "Sculthorp Royal Air Force"},
  {iata: "FKI", airport: "Kisangani Airport"},
  {iata: "FKJ", airport: "Fukui Airport"},
  {iata: "FKL", airport: "Chess-Lambertin Airport"},
  {iata: "FKN", airport: "Franklin Municipal Airport"},
  {iata: "FKQ", airport: "Fak Fak Airport"},
  {iata: "FKS", airport: "Fukushima Airport"},
  {iata: "FLA", airport: "Capitolio Airport"},
  {iata: "FLB", airport: "Cangapara Airport"},
  {iata: "FLC", airport: "Falls Creek Airport"},
  {iata: "FLD", airport: "Fond Du Lac Airport"},
  {iata: "FLE", airport: "Fort Lee Army Air Field"},
  {iata: "FLF", airport: "Schaferhaus Airport"},
  {iata: "FLG", airport: "Pulliam Field"},
  {iata: "FLH", airport: "Flotta Airport"},
  {iata: "FLI", airport: "Flateyri Airport"},
  {iata: "FLL", airport: "Ft. Lauderdale International Airport"},
  {iata: "FLM", airport: "Filadelfia Airport"},
  {iata: "FLN", airport: "Hercilio Luz Airport"},
  {iata: "FLO", airport: "Florence Airport"},
  {iata: "FLP", airport: "Flippin Airport"},
  {iata: "FLR", airport: "Peretola Airport"},
  {iata: "FLS", airport: "Flinders Island Airport"},
  {iata: "FLU", airport: "Flushing Airport"},
  {iata: "FLV", airport: "Sherman Army Air Field"},
  {iata: "FLW", airport: "Santa Cruz Airport"},
  {iata: "FLX", airport: "Fallon Municipal Airport"},
  {iata: "FLY", airport: "Finley Airport"},
  {iata: "FMA", airport: "El Pucu Airport"},
  {iata: "FMG", airport: "Flamingo Airport"},
  {iata: "FMH", airport: "Otis Air Force Base"},
  {iata: "FMI", airport: "Kalemie Airport"},
  {iata: "FMM", airport: "Memmingen Airport"},
  {iata: "FMN", airport: "Farmington Municipal Airport"},
  {iata: "FMO", airport: "Muenster Airport"},
  {iata: "FMS", airport: "Fort Madison Municipal Airport"},
  {iata: "FMY", airport: "Page Field"},
  {iata: "FNA", airport: "Lungi International Airport"},
  {iata: "FNB", airport: "Neubrandenburg Airport"},
  {iata: "FNC", airport: "Madeira Airport"},
  {iata: "FNE", airport: "Fane Airport"},
  {iata: "FNG", airport: "Fada Ngourma Airport"},
  {iata: "FNH", airport: "Fincha Airport"},
  {iata: "FNI", airport: "Garons Airport"},
  {iata: "FNJ", airport: "Sunan"},
  {iata: "FNL", airport: "Fort Collins/Loveland Municipal Airport"},
  {iata: "FNT", airport: "Bishop Airport"},
  {iata: "FOA", airport: "Foula Airport"},
  {iata: "FOB", airport: "Fort Bragg Airport"},
  {iata: "FOC", airport: "Fuzhou Airport"},
  {iata: "FOD", airport: "Fort Dodge Airport"},
  {iata: "FOE", airport: "Forbes Air Force Base"},
  {iata: "FOG", airport: "Gino Lisa Airport"},
  {iata: "FOK", airport: "Suffolk County Airport"},
  {iata: "FOM", airport: "Foumban Airport"},
  {iata: "FON", airport: "Fortuna Airport"},
  {iata: "FOO", airport: "Numfor Airport"},
  {iata: "FOP", airport: "Morris Army Air Field"},
  {iata: "FOR", airport: "Pinto Martins Airport"},
  {iata: "FOS", airport: "Forrest Airport"},
  {iata: "FOT", airport: "Forster Airport"},
  {iata: "FOU", airport: "Fougamou Airport"},
  {iata: "FOY", airport: "Foya Airport"},
  {iata: "FPO", airport: "Grand Bahama International Airport"},
  {iata: "FPR", airport: "Saint Lucie County Airport"},
  {iata: "FPY", airport: "Perry-Foley Airport"},
  {iata: "FRA", airport: "Frankfurt International Airport"},
  {iata: "FRB", airport: "Forbes Airport"},
  {iata: "FRC", airport: "Franca Airport"},
  {iata: "FRD", airport: "Friday Harbor Airport"},
  {iata: "FRE", airport: "Fera Island Airport"},
  {iata: "FRF", airport: "Rhein-Main Air Force Base"},
  {iata: "FRG", airport: "Republic Field"},
  {iata: "FRH", airport: "French Lick Municipal Airport"},
  {iata: "FRI", airport: "Marshall Army Air Field"},
  {iata: "FRJ", airport: "Frejus Airport"},
  {iata: "FRK", airport: "Fregate Island Airport"},
  {iata: "FRL", airport: "Luigi Ridolfi Airport"},
  {iata: "FRM", airport: "Fairmont Airport"},
  {iata: "FRN", airport: "Bryant Army Air Field"},
  {iata: "FRO", airport: "Flora Airport"},
  {iata: "FRQ", airport: "Feramin Airport"},
  {iata: "FRR", airport: "Warren County Airport"},
  {iata: "FRS", airport: "Santa Elena Airport"},
  {iata: "FRT", airport: "Frutillar Airport"},
  {iata: "FRU", airport: "Bishkek Airport"},
  {iata: "FRW", airport: "Francistown Airport"},
  {iata: "FRY", airport: "Fryeburg Airport"},
  {iata: "FRZ", airport: "Fritzlar Air Base"},
  {iata: "FSC", airport: "Sud Corse Airport"},
  {iata: "FSD", airport: "Sioux Falls Regional Airport (Jo Foss Field)"},
  {iata: "FSI", airport: "Post Aaf"},
  {iata: "FSK", airport: "Fort Scott Municipal Airport"},
  {iata: "FSL", airport: "Fossil Downs Airport"},
  {iata: "FSM", airport: "Fort Smith Municipal Airport"},
  {iata: "FSN", airport: "Haley AAF"},
  {iata: "FSP", airport: "Saint Pierre Airport"},
  {iata: "FSS", airport: "Kinloss Airport"},
  {iata: "FST", airport: "Pecos County Airport"},
  {iata: "FSU", airport: "Fort Sumner Airport"},
  {iata: "FTA", airport: "Futuna Airport"},
  {iata: "FTE", airport: "El Calafate"},
  {iata: "FTI", airport: "Fituita Airport"},
  {iata: "FTK", airport: "Godman Army Air Field"},
  {iata: "FTU", airport: "Marillac Airport"},
  {iata: "FTW", airport: "Meacham Field"},
  {iata: "FTX", airport: "Owando Airport"},
  {iata: "FTY", airport: "Fulton County Airport"},
  {iata: "FUB", airport: "Fulleborn Airport"},
  {iata: "FUD", airport: "Sui Fen He Airport"},
  {iata: "FUE", airport: "Puerto del Rosario Airport"},
  {iata: "FUG", airport: "Fuyang Airport"},
  {iata: "FUJ", airport: "Fukue Airport"},
  {iata: "FUK", airport: "Fukuoka Airport"},
  {iata: "FUL", airport: "Fullerton Municipal Airport"},
  {iata: "FUM", airport: "Fuma Airport"},
  {iata: "FUN", airport: "Funafuti Atol International Airport"},
  {iata: "FUO", airport: "Fuoshan Airport"},
  {iata: "FUT", airport: "Futuna Island Airport"},
  {iata: "FVL", airport: "Flora Valley Airport"},
  {iata: "FVR", airport: "Forrest River Airport"},
  {iata: "FWA", airport: "Fort Wayne Municipal Airport/Baer Field"},
  {iata: "FWH", airport: "Carswell Air Force Base"},
  {iata: "FWM", airport: "Fort WilliamHeliport"},
  {iata: "FXE", airport: "Executive Airport"},
  {iata: "FXO", airport: "Cuamba Airport"},
  {iata: "FXY", airport: "Forest City Municipal Airport"},
  {iata: "FYM", airport: "Fayetteville Municipal Airport"},
  {iata: "FYN", airport: "Fuyun Airport"},
  {iata: "FYT", airport: "Faya Airport"},
  {iata: "FYU", airport: "Fort Yukon Airport"},
  {iata: "FYV", airport: "Fayetteville Municipal Airport (Drake Field)"},
  {iata: "FZO", airport: "Filton Airport"},
  {iata: "GAA", airport: "Guamal Airport"},
  {iata: "GAB", airport: "Gabbs Airport"},
  {iata: "GAC", airport: "Gracias Airport"},
  {iata: "GAD", airport: "Gadsden Municipal Airport"},
  {iata: "GAE", airport: "Gabes Airport"},
  {iata: "GAF", airport: "Gafsa Airport"},
  {iata: "GAG", airport: "Gage Airport"},
  {iata: "GAH", airport: "Gayndah Airport"},
  {iata: "GAI", airport: "Montgomery County Airport"},
  {iata: "GAJ", airport: "Junmachi Airport"},
  {iata: "GAL", airport: "Galena Airport"},
  {iata: "GAM", airport: "Gambell Airport"},
  {iata: "GAN", airport: "Gan/Seenu Airport"},
  {iata: "GAO", airport: "Los Canos Airport"},
  {iata: "GAP", airport: "Gusap Airport"},
  {iata: "GAQ", airport: "Gao Airport"},
  {iata: "GAR", airport: "Garaina Airport"},
  {iata: "GAS", airport: "Garissa Airport"},
  {iata: "GAT", airport: "Tallard Airport"},
  {iata: "GAU", airport: "Borjhar Airport"},
  {iata: "GAV", airport: "Gag Island Airport"},
  {iata: "GAW", airport: "Gangaw Airport"},
  {iata: "GAX", airport: "Gamba Airport"},
  {iata: "GAY", airport: "Gaya Airport"},
  {iata: "GAZ", airport: "Guasopa Airport"},
  {iata: "GBA", airport: "Big Bay Airport"},
  {iata: "GBB", airport: "Gara-Djebilet Airport"},
  {iata: "GBC", airport: "Gasuke Airport"},
  {iata: "GBD", airport: "Great Bend Airport"},
  {iata: "GBE", airport: "Sir Seretse Khama International Airport"},
  {iata: "GBF", airport: "Negarbo Airport"},
  {iata: "GBG", airport: "Galesburg Airport"},
  {iata: "GBJ", airport: "Les Bases Airport"},
  {iata: "GBK", airport: "Gbangbatok Airport"},
  {iata: "GBL", airport: "Goulburn Island Airport"},
  {iata: "GBM", airport: "Garbaharey Airport"},
  {iata: "GBN", airport: "San Giovanni Rotondo Airport"},
  {iata: "GBO", airport: "Baltimore Greenbelt T Airport"},
  {iata: "GBP", airport: "Gamboola Airport"},
  {iata: "GBQ", airport: "Muharraq Airport"},
  {iata: "GBR", airport: "Great Barrington Airport"},
  {iata: "GBS", airport: "Port Fitzroy Airport"},
  {iata: "GBT", airport: "Gorgon Airport"},
  {iata: "GBU", airport: "Khashm El Girba Airport"},
  {iata: "GBV", airport: "Gibb River Airport"},
  {iata: "GBZ", airport: "Great Barrier Island Airport"},
  {iata: "GCA", airport: "Guacamaya Airport"},
  {iata: "GCC", airport: "Campbell County Airport"},
  {iata: "GCH", airport: "Gachsaran Airport"},
  {iata: "GCI", airport: "Guernsey Airport"},
  {iata: "GCJ", airport: "Johannesburg-Grand Central Airport"},
  {iata: "GCK", airport: "Garden City Municipal Airport"},
  {iata: "GCM", airport: "Owen Roberts International Airport"},
  {iata: "GCN", airport: "National Park Airport"},
  {iata: "GCV", airport: "Gravatai Airport"},
  {iata: "GCY", airport: "Greenville Municipal Airport"},
  {iata: "GDA", airport: "Gounda Airport"},
  {iata: "GDC", airport: "Donaldson Center Airport"},
  {iata: "GDD", airport: "Gordon Downs Airport"},
  {iata: "GDE", airport: "Gode/Iddidole Airport"},
  {iata: "GDG", airport: "Magdagachi Airport"},
  {iata: "GDI", airport: "Gordil Airport"},
  {iata: "GDJ", airport: "Gandajika Airport"},
  {iata: "GDL", airport: "Miguel Hidal Airport"},
  {iata: "GDM", airport: "Gardner Municipal Airport"},
  {iata: "GDN", airport: "Rebiechowo Airport"},
  {iata: "GDO", airport: "Vare Maria Airport"},
  {iata: "GDP", airport: "Guadalupe Airport"},
  {iata: "GDQ", airport: "Gondar Airport"},
  {iata: "GDT", airport: "Grand Turk Island Airport"},
  {iata: "GDV", airport: "Dawson Community Airport"},
  {iata: "GDW", airport: "Gladwin Airport"},
  {iata: "GDX", airport: "Magadan Airport"},
  {iata: "GDZ", airport: "Gelendzik Airport"},
  {iata: "GEA", airport: "Magenta Airport"},
  {iata: "GEB", airport: "Gebe Airport"},
  {iata: "GEC", airport: "Gecitkale Airport"},
  {iata: "GED", airport: "Sussex County Airport"},
  {iata: "GEE", airport: "George Town Airport"},
  {iata: "GEG", airport: "Spokane International Airport"},
  {iata: "GEI", airport: "Green Islands Airport"},
  {iata: "GEL", airport: "Sepe Tiaraju Airport"},
  {iata: "GEN", airport: "Puente Genil Airport"},
  {iata: "GEO", airport: "Cheddi Jagan International Airport"},
  {iata: "GER", airport: "Rafael Cabrera Airport"},
  {iata: "GES", airport: "Buayan Airport"},
  {iata: "GET", airport: "Geraldton Airport"},
  {iata: "GEV", airport: "Gallivare Airport"},
  {iata: "GEW", airport: "Gewoya Airport"},
  {iata: "GEX", airport: "Geelong Airport"},
  {iata: "GEY", airport: "South Big Horn County Airport"},
  {iata: "GFA", airport: "Malmstrom Air Force Base"},
  {iata: "GFD", airport: "Pope Field"},
  {iata: "GFE", airport: "Grenfell Airport"},
  {iata: "GFF", airport: "Griffith Airport"},
  {iata: "GFK", airport: "Grand Forks Airport"},
  {iata: "GFL", airport: "Warren County Airport"},
  {iata: "GFN", airport: "Grafton Airport"},
  {iata: "GFO", airport: "Bartica Airport"},
  {iata: "GFR", airport: "Granville Airport"},
  {iata: "GFY", airport: "Grootfontein Airport"},
  {iata: "GGD", airport: "Gregory Downs Airport"},
  {iata: "GGE", airport: "Georgetown Airport"},
  {iata: "GGG", airport: "Gregg County Airport"},
  {iata: "GGL", airport: "Gilgal Airport"},
  {iata: "GGR", airport: "Garoe Airport"},
  {iata: "GGS", airport: "Gobernador Gregores Airport"},
  {iata: "GGT", airport: "Exuma International Airport"},
  {iata: "GGW", airport: "Glasgow International Airport"},
  {iata: "GHA", airport: "Noumerate Airport"},
  {iata: "GHD", airport: "Ghimbi Airport"},
  {iata: "GHE", airport: "Garachine Airport"},
  {iata: "GHF", airport: "Giebelstadt Airport"},
  {iata: "GHM", airport: "Centerville Municipal Airport"},
  {iata: "GHN", airport: "Guanghan Airport"},
  {iata: "GHT", airport: "Ghat Airport"},
  {iata: "GHU", airport: "Gualeguaychu Airport"},
  {iata: "GIB", airport: "North Front Airport"},
  {iata: "GIC", airport: "Boigu Island Airport"},
  {iata: "GID", airport: "Gitega Airport"},
  {iata: "GIF", airport: "Gilbert Field Airport"},
  {iata: "GIG", airport: "Galeao Antonio Carlos Jobim International Airport"},
  {iata: "GII", airport: "Siguiri Airport"},
  {iata: "GIL", airport: "Gilgit Airport"},
  {iata: "GIM", airport: "Miele Mimbale Airport"},
  {iata: "GIR", airport: "Girardot Airport"},
  {iata: "GIS", airport: "Gisborne Airport"},
  {iata: "GIT", airport: "Geita Airport"},
  {iata: "GIY", airport: "Giyani Airport"},
  {iata: "GIZ", airport: "Jazan Airport"},
  {iata: "GJA", airport: "Guanaja Airport"},
  {iata: "GJL", airport: "Jijel Airport"},
  {iata: "GJM", airport: "Guajara-Mirim Airport"},
  {iata: "GJR", airport: "Gjogur Airport"},
  {iata: "GJT", airport: "Grand Junction Regional Airport"},
  {iata: "GKA", airport: "Goroka Airport"},
  {iata: "GKE", airport: "Geilenkirchen Airport"},
  {iata: "GKH", airport: "Gorkha Airport"},
  {iata: "GKL", airport: "Great Keppel Island Airport"},
  {iata: "GKO", airport: "Kongoboumba Airport"},
  {iata: "GKT", airport: "Gatlinburg Airport"},
  {iata: "GLA", airport: "Glasgow International Airport"},
  {iata: "GLC", airport: "Geladi Airport"},
  {iata: "GLD", airport: "Renner Field"},
  {iata: "GLE", airport: "Gainesville Municipal Airport"},
  {iata: "GLF", airport: "Golfito Airport"},
  {iata: "GLG", airport: "Glengyle Airport"},
  {iata: "GLH", airport: "Greenville Airport"},
  {iata: "GLI", airport: "Glen Innes Airport"},
  {iata: "GLK", airport: "Galcaio Airport"},
  {iata: "GLL", airport: "Klanten Airport"},
  {iata: "GLM", airport: "Glenormiston Airport"},
  {iata: "GLN", airport: "Goulimime Airport"},
  {iata: "GLO", airport: "Gloucestershire Airport"},
  {iata: "GLP", airport: "Gulgubip Airport"},
  {iata: "GLR", airport: "Otsego County Airport"},
  {iata: "GLS", airport: "Scholes Field"},
  {iata: "GLT", airport: "Gladstone Airport"},
  {iata: "GLV", airport: "Golovin Airport"},
  {iata: "GLW", airport: "Glasgow Municipal Airport"},
  {iata: "GLX", airport: "Galela Airport"},
  {iata: "GLY", airport: "Goldsworthy Airport"},
  {iata: "GLZ", airport: "Gilze-Rijen Airport"},
  {iata: "GMA", airport: "Gemena Airport"},
  {iata: "GMB", airport: "Gambela Airport"},
  {iata: "GMC", airport: "Guerima Airport"},
  {iata: "GME", airport: "Gomel Airport"},
  {iata: "GMI", airport: "Gasmata Island Airport"},
  {iata: "GMM", airport: "Gamboma Airport"},
  {iata: "GMN", airport: "Greymouth Airport"},
  {iata: "GMP", airport: "Gimpo International Airport"},
  {iata: "GMR", airport: "Gambier Island Airport"},
  {iata: "GMS", airport: "Guimaraes Airport"},
  {iata: "GMU", airport: "Greenville Downtown Airport"},
  {iata: "GMV", airport: "Monument Valley Airport"},
  {iata: "GMY", airport: "Rheindahlen Airport"},
  {iata: "GMZ", airport: "La Gomera Airport"},
  {iata: "GNA", airport: "Grodno Airport"},
  {iata: "GNB", airport: "Grenoble-Isere Airport"},
  {iata: "GND", airport: "Point Saline International Airport"},
  {iata: "GNE", airport: "Ghent Airport"},
  {iata: "GNG", airport: "Gooding Airport"},
  {iata: "GNI", airport: "Green Island Airport"},
  {iata: "GNM", airport: "Guanambi Airport"},
  {iata: "GNN", airport: "Ghinnir Airport"},
  {iata: "GNR", airport: "General Roca Airport"},
  {iata: "GNS", airport: "Gunungsitoli Airport"},
  {iata: "GNT", airport: "Milan Airport"},
  {iata: "GNU", airport: "Goodnews Bay Airport"},
  {iata: "GNV", airport: "Gainesville Regional Airport"},
  {iata: "GNY", airport: "Granby-Grand Co"},
  {iata: "GNZ", airport: "Ghanzi Airport"},
  {iata: "GOA", airport: "Cristoforo Colombo Airport"},
  {iata: "GOB", airport: "Goba Airport"},
  {iata: "GOC", airport: "Gora Airport"},
  {iata: "GOE", airport: "Gonalia Airport"},
  {iata: "GOF", airport: "Goodfellow Air Force Base"},
  {iata: "GOG", airport: "Gobabis Airport"},
  {iata: "GOH", airport: "Nuuk Airport"},
  {iata: "GOI", airport: "Dabolim Airport"},
  {iata: "GOJ", airport: "Nizhniy Novgorod Airport"},
  {iata: "GOK", airport: "Guthrie Airport"},
  {iata: "GOL", airport: "State Airport"},
  {iata: "GOM", airport: "Goma Airport"},
  {iata: "GON", airport: "Groton-New London Airport"},
  {iata: "GOO", airport: "Goondiwindi Airport"},
  {iata: "GOP", airport: "Gorakhpur Airport"},
  {iata: "GOQ", airport: "Golmud Airport"},
  {iata: "GOR", airport: "Gore Airport"},
  {iata: "GOS", airport: "Gosford Airport"},
  {iata: "GOT", airport: "Landvetter Airport"},
  {iata: "GOU", airport: "Garoua Airport"},
  {iata: "GOV", airport: "Nhulunbuy Airport"},
  {iata: "GOY", airport: "Amparai Airport"},
  {iata: "GOZ", airport: "Gorna Orechovitsa Airport"},
  {iata: "GPA", airport: "Araxos Airport"},
  {iata: "GPB", airport: "Tancredo Thomaz Faria Airport"},
  {iata: "GPI", airport: "Glacier Park International Airport"},
  {iata: "GPI", airport: "Guapi Airport"},
  {iata: "GPL", airport: "Guapiles Airport"},
  {iata: "GPN", airport: "Garden Point Airport"},
  {iata: "GPO", airport: "General Pico Airport"},
  {iata: "GPS", airport: "Baltra Airport"},
  {iata: "GPT", airport: "Biloxi Regional Airport"},
  {iata: "GPZ", airport: "Grand Rapids Airport"},
  {iata: "GQJ", airport: "Machrihanish Airport"},
  {iata: "GQQ", airport: "Galion Airport"},
  {iata: "GRA", airport: "Gamarra Airport"},
  {iata: "GRB", airport: "Austin-Straubel Field"},
  {iata: "GRC", airport: "Grand Cess Airport"},
  {iata: "GRD", airport: "Greenwood Airport"},
  {iata: "GRE", airport: "Greenville Municipal Airport"},
  {iata: "GRF", airport: "Gray Army Air Field"},
  {iata: "GRG", airport: "Gardez Airport"},
  {iata: "GRH", airport: "Garuahi Airport"},
  {iata: "GRI", airport: "Grand Island Airport"},
  {iata: "GRJ", airport: "George Airport"},
  {iata: "GRK", airport: "Gray Army Air Field"},
  {iata: "GRL", airport: "Garasa Airport"},
  {iata: "GRM", airport: "Devils Track Airport"},
  {iata: "GRN", airport: "Gordon Airport"},
  {iata: "GRO", airport: "Costa Brava Airport"},
  {iata: "GRP", airport: "Gurupi Airport"},
  {iata: "GRQ", airport: "Eelde Airport"},
  {iata: "GRR", airport: "Gerald R. Ford International Airport"},
  {iata: "GRS", airport: "Baccarini Airport"},
  {iata: "GRT", airport: "Gujrat Airport"},
  {iata: "GRU", airport: "Guarulhos International Airport"},
  {iata: "GRV", airport: "Groznyy Airport"},
  {iata: "GRW", airport: "Graciosa Island Airport"},
  {iata: "GRX", airport: "Granada Airport"},
  {iata: "GRY", airport: "Grimsey Airport"},
  {iata: "GRZ", airport: "Thalerhof Airport"},
  {iata: "GSA", airport: "Long Pasia Airport"},
  {iata: "GSB", airport: "Seymour Johnson Air Force Base"},
  {iata: "GSC", airport: "Gascoyne Junction Airport"},
  {iata: "GSE", airport: "Saeve Airport"},
  {iata: "GSH", airport: "Goshen Airport"},
  {iata: "GSL", airport: "Taltheilei Narrows Airport"},
  {iata: "GSM", airport: "Gheshm Airport"},
  {iata: "GSN", airport: "Mount Gunson Airport"},
  {iata: "GSO", airport: "Piedmont Triad International Airport"},
  {iata: "GSP", airport: "Greenville-Spartanburg Airport"},
  {iata: "GSQ", airport: "Shark Elowainat Airport"},
  {iata: "GSR", airport: "Gardo Airport"},
  {iata: "GSS", airport: "Sabi Sabi Airport"},
  {iata: "GST", airport: "Gustavus Airport"},
  {iata: "GSU", airport: "Gedaref Airport"},
  {iata: "GSY", airport: "Binbrook Airport"},
  {iata: "GTA", airport: "Gatokae Aerodrom"},
  {iata: "GTB", airport: "Genting Airport"},
  {iata: "GTE", airport: "Alyangula Airport"},
  {iata: "GTF", airport: "Great Falls International Airport"},
  {iata: "GTG", airport: "Grantsburg Municipal Airport"},
  {iata: "GTI", airport: "Guettin Airport"},
  {iata: "GTK", airport: "Sungei Tekai Airport"},
  {iata: "GTN", airport: "Glentanner Airport"},
  {iata: "GTO", airport: "Tolotio Airport"},
  {iata: "GTR", airport: "Golden Triangle Regional Airport"},
  {iata: "GTS", airport: "Granites Airport"},
  {iata: "GTT", airport: "Georgetown Airport"},
  {iata: "GTW", airport: "Holesov Airport"},
  {iata: "GTY", airport: "Gettysburg Airport"},
  {iata: "GUA", airport: "La Aurora Airport"},
  {iata: "GUB", airport: "Guerrero Negro Airport"},
  {iata: "GUC", airport: "Gunnison Airport"},
  {iata: "GUD", airport: "Goundam Airport"},
  {iata: "GUE", airport: "Guriaso Airport"},
  {iata: "GUF", airport: "Edwards Airport"},
  {iata: "GUG", airport: "Guari Airport"},
  {iata: "GUH", airport: "Gunnedah Airport"},
  {iata: "GUI", airport: "Guiria Airport"},
  {iata: "GUJ", airport: "Guaratingueta Airport"},
  {iata: "GUL", airport: "Goulburn Airport"},
  {iata: "GUM", airport: "A.B. Won Pat International Airport"},
  {iata: "GUN", airport: "Gunter Air Force Base"},
  {iata: "GUO", airport: "Gualaco Airport"},
  {iata: "GUP", airport: "Senator Clark Airport"},
  {iata: "GUQ", airport: "Guanare Airport"},
  {iata: "GUR", airport: "Gurney Airport"},
  {iata: "GUS", airport: "Grissom Air Force Base"},
  {iata: "GUT", airport: "Guetersloh Airport"},
  {iata: "GUU", airport: "Grundarf Jordur Airport"},
  {iata: "GUV", airport: "Mougulu Airport"},
  {iata: "GUW", airport: "Atyrau Airport"},
  {iata: "GUX", airport: "Guna Airport"},
  {iata: "GUY", airport: "Guymon Airport"},
  {iata: "GUZ", airport: "Guarapari Airport"},
  {iata: "GVA", airport: "Geneve-Cointrin Airport"},
  {iata: "GVE", airport: "Gordonsville Municipal Airport"},
  {iata: "GVI", airport: "Green River Airport"},
  {iata: "GVL", airport: "Lee Gilmer Memorial Airport"},
  {iata: "GVP", airport: "Greenvale Airport"},
  {iata: "GVR", airport: "Governador Valadares Airport"},
  {iata: "GVT", airport: "Majors Field"},
  {iata: "GVW", airport: "Richards-Gebaur Airport"},
  {iata: "GVX", airport: "Sandviken Airport"},
  {iata: "GWA", airport: "Gwa Airport"},
  {iata: "GWD", airport: "Gwadar Airport"},
  {iata: "GWE", airport: "Gweru Airport"},
  {iata: "GWL", airport: "Gwalior Airport"},
  {iata: "GWN", airport: "Gnarowein Airport"},
  {iata: "GWO", airport: "Leflore Airport"},
  {iata: "GWS", airport: "Glenwood Springs Municipal"},
  {iata: "GWT", airport: "Westerland - Sylt Airport"},
  {iata: "GWV", airport: "Glendale Airport"},
  {iata: "GWW", airport: "R.A.F. Gatow Airport"},
  {iata: "GWY", airport: "Carnmore Airport"},
  {iata: "GXF", airport: "Seiyun Airport"},
  {iata: "GXG", airport: "Negage Airport"},
  {iata: "GXH", airport: "Mildenhall NAF"},
  {iata: "GXQ", airport: "Ten. Vidal Airport"},
  {iata: "GXX", airport: "Yagoua Airport"},
  {iata: "GXY", airport: "Weld County Airport"},
  {iata: "GYA", airport: "Guayaramerin Airport"},
  {iata: "GYD", airport: "Heydar Aliyev International Airport"},
  {iata: "GYE", airport: "Simon Bolivar Airport"},
  {iata: "GYI", airport: "Gisenyi Airport"},
  {iata: "GYL", airport: "Argyle Airport"},
  {iata: "GYM", airport: "Gen Jose M Yanez Airport"},
  {iata: "GYN", airport: "Santa Genoveva Airport"},
  {iata: "GYP", airport: "Gympie Airport"},
  {iata: "GYR", airport: "Litchfield Airport"},
  {iata: "GYS", airport: "Guang Yuan Airport"},
  {iata: "GYY", airport: "Gary Regional Airport"},
  {iata: "GZA", airport: "Gaza International Airport"},
  {iata: "GZI", airport: "Ghazni Airport"},
  {iata: "GZM", airport: "Gozo Airport"},
  {iata: "GZO", airport: "Gizo Airport"},
  {iata: "GZT", airport: "Gaziantep Airport"},
  {iata: "GZW", airport: "Ghazvin Airport"},
  {iata: "HAA", airport: "Hasvik Airport"},
  {iata: "HAB", airport: "Marion County Airport"},
  {iata: "HAC", airport: "Hachijo Jima Airport"},
  {iata: "HAD", airport: "Halmstad Airport"},
  {iata: "HAE", airport: "Havasupai Airport"},
  {iata: "HAF", airport: "Half Moon Airport"},
  {iata: "HAH", airport: "Prince Said Ibrahim In Airport"},
  {iata: "HAI", airport: "Dr. Haines Airport"},
  {iata: "HAJ", airport: "Hanover Airport"},
  {iata: "HAK", airport: "Haikou Airport"},
  {iata: "HAL", airport: "Halali Airport"},
  {iata: "HAM", airport: "Fuhlsbuettel Airport"},
  {iata: "HAN", airport: "Noi Bai International Airport"},
  {iata: "HAO", airport: "Hamilton Airport"},
  {iata: "HAP", airport: "Long Island Airport"},
  {iata: "HAQ", airport: "Hanimaadhoo Airport"},
  {iata: "HAR", airport: "Harrisburg Skyport"},
  {iata: "HAS", airport: "Hail Airport"},
  {iata: "HAT", airport: "Heathlands Airport"},
  {iata: "HAU", airport: "Haugesund Airport"},
  {iata: "HAV", airport: "Jose Marti International Airport"},
  {iata: "HAW", airport: "Haverfordwest Airport"},
  {iata: "HAX", airport: "Hatbox Field"},
  {iata: "HAZ", airport: "Hatzfeldthaven Airport"},
  {iata: "HBA", airport: "Hobart Airport"},
  {iata: "HBB", airport: "Industrial Airpark"},
  {iata: "HBD", airport: "Habi Airport"},
  {iata: "HBE", airport: "Borg El Arab Airport"},
  {iata: "HBG", airport: "Bobby L. Chain Municipal Airport"},
  {iata: "HBN", airport: "Phu-bon Airport"},
  {iata: "HBO", airport: "Humboldt Municipal Airport"},
  {iata: "HBR", airport: "Hobart Airport"},
  {iata: "HBT", airport: "Hafr Albatin Airport"},
  {iata: "HBX", airport: "Hubli Airport"},
  {iata: "HCA", airport: "Howard County Airport"},
  {iata: "HCC", airport: "Columbia County Airport"},
  {iata: "HCM", airport: "Eli Airport"},
  {iata: "HCN", airport: "Hengchun Airport"},
  {iata: "HCQ", airport: "Halls Creek Airport"},
  {iata: "HCR", airport: "Holy Cross Airport"},
  {iata: "HCS", airport: "Randburg Heliport"},
  {iata: "HCW", airport: "Cheraw Airport"},
  {iata: "HDB", airport: "Heidelberg Airport"},
  {iata: "VDH", airport: "Dong Hoi Airport Vietnam"},
  {iata: "HDE", airport: "Brewster Field"},
  {iata: "HDF", airport: "Heringsdorf Airport"},
  {iata: "HDH", airport: "Dillingham Airfield"},
  {iata: "HDM", airport: "Hamadan Airport"},
  {iata: "HDN", airport: "Yampa Valley Airport"},
  {iata: "HDR", airport: "Havadarya Airport"},
  {iata: "HDS", airport: "Hoedspruit Airport"},
  {iata: "HDY", airport: "Hat Yai Airport"},
  {iata: "HEA", airport: "Herat Airport"},
  {iata: "HEB", airport: "Henzada Airport"},
  {iata: "HEE", airport: "Thompson-Robbins Airport"},
  {iata: "HEH", airport: "Heho Airport"},
  {iata: "HEI", airport: "Heide-Buesum Airport"},
  {iata: "HEK", airport: "Heihe Airport"},
  {iata: "HEL", airport: "Helsinki-Vantaa Airport"},
  {iata: "HEM", airport: "Helsinki-Malmi Airport"},
  {iata: "HEN", airport: "Hendon Airport"},
  {iata: "HEO", airport: "Haelogo Airport"},
  {iata: "HER", airport: "N. Kazantzakis Airport"},
  {iata: "HES", airport: "State Airport"},
  {iata: "HET", airport: "Hohhot Airport"},
  {iata: "HEV", airport: "Huelva Airport"},
  {iata: "HEW", airport: "Athens Hellinikon Airport"},
  {iata: "HEX", airport: "Herrera Airport"},
  {iata: "HEY", airport: "Hanchey Army Heliport"},
  {iata: "HEZ", airport: "Hardy-Anders Airport"},
  {iata: "HFA", airport: "Haifa Airport"},
  {iata: "HFD", airport: "Brainard Airport"},
  {iata: "HFE", airport: "Hefei Airport"},
  {iata: "HFF", airport: "Mackall Army Air Field"},
  {iata: "HFN", airport: "Hornafjordur Airport"},
  {iata: "HFS", airport: "Hagfors Airport"},
  {iata: "HFT", airport: "Hammerfest Airport"},
  {iata: "HGA", airport: "Hargeisa Airport"},
  {iata: "HGD", airport: "Hughenden Airport"},
  {iata: "HGH", airport: "Hangzhou Airport"},
  {iata: "HGL", airport: "Helgoland Airport"},
  {iata: "HGN", airport: "Mae Hong Son Airport"},
  {iata: "HGR", airport: "Wash. County Regional Airport"},
  {iata: "HGS", airport: "Hastings Airport"},
  {iata: "HGT", airport: "Hunter Army Air Field"},
  {iata: "HGU", airport: "Kagamuga Airport"},
  {iata: "HHA", airport: "Changsha Huanghua Airport"},
  {iata: "HHE", airport: "Hachinohe Airport"},
  {iata: "HHH", airport: "Hilton Head Airport"},
  {iata: "HHI", airport: "Wheeler Air Force Base"},
  {iata: "HHN", airport: "Hahn Airport"},
  {iata: "HHQ", airport: "Hua Hin Airport"},
  {iata: "HHR", airport: "Hawthorne Airport"},
  {iata: "HHZ", airport: "Hikueru Airport"},
  {iata: "HIB", airport: "Chisholm Airport"},
  {iata: "HIC", airport: "Iscor Heliport"},
  {iata: "HID", airport: "Horn Island Airport"},
  {iata: "HIE", airport: "Whitefield Regional Airport"},
  {iata: "HIF", airport: "Hill Air Force Base"},
  {iata: "HIG", airport: "Highbury Airport"},
  {iata: "HIH", airport: "Hook Island Airport"},
  {iata: "HII", airport: "Lake Havasu City Municipal Airport"},
  {iata: "HIJ", airport: "Hiroshima International Airport"},
  {iata: "HIK", airport: "Hickam Air Force Base"},
  {iata: "HIL", airport: "Shillavo Airport"},
  {iata: "HIM", airport: "Hingurakgoda Airport"},
  {iata: "HIN", airport: "Sacheon Airport"},
  {iata: "HIO", airport: "Portland Hillsboro Airport"},
  {iata: "HIP", airport: "Headingly Airport"},
  {iata: "HIR", airport: "Henderson International Airport"},
  {iata: "HIS", airport: "Hayman Island Airport"},
  {iata: "HIT", airport: "Hivaro Airport"},
  {iata: "HIW", airport: "Hiroshima West Airport"},
  {iata: "HIX", airport: "Hiva Oa Airport"},
  {iata: "HJR", airport: "Khajuraho Airport"},
  {iata: "HJT", airport: "Khujirt Airport"},
  {iata: "HKA", airport: "Blytheville Municipal Airport"},
  {iata: "HKB", airport: "Healy Lake Airport"},
  {iata: "HKD", airport: "Hakodate Airport"},
  {iata: "HKG", airport: "Hong Kong International Airport"},
  {iata: "HKK", airport: "Hokitika Airport"},
  {iata: "HKN", airport: "Hoskins Airport"},
  {iata: "HKS", airport: "Hawkins Field"},
  {iata: "HKT", airport: "Phuket International Airport"},
  {iata: "HKV", airport: "Haskovo Airport"},
  {iata: "HKY", airport: "Hickory Airport"},
  {iata: "HLA", airport: "Lanseria Airport"},
  {iata: "HLB", airport: "Hillenbrand Airport"},
  {iata: "HLC", airport: "Hill City Airport"},
  {iata: "HLD", airport: "Hailar Airport"},
  {iata: "HLF", airport: "Hultsfred Airport"},
  {iata: "HLG", airport: "Ohio County Airport"},
  {iata: "HLH", airport: "Ulanhot Airport"},
  {iata: "HLI", airport: "Hollister Airport"},
  {iata: "HLL", airport: "Hillside Airport"},
  {iata: "HLM", airport: "Park Township Airport"},
  {iata: "HLN", airport: "Helena Airport"},
  {iata: "HLP", airport: "Halim Perdana Kusuma Airport"},
  {iata: "HLR", airport: "Fort Hood Army Air Field"},
  {iata: "HLS", airport: "St. Helens Airport"},
  {iata: "HLT", airport: "Hamilton Airport"},
  {iata: "HLU", airport: "Houailou Airport"},
  {iata: "HLV", airport: "Helenvale Airport"},
  {iata: "HLW", airport: "Hluhluwe Airport"},
  {iata: "HLY", airport: "Holyhead Airport"},
  {iata: "HLZ", airport: "Hamilton Airport"},
  {iata: "HMA", airport: "Khanty-Mansiysk"},
  {iata: "HME", airport: "Oued Irara Airport"},
  {iata: "HMG", airport: "Hermannsburg Airport"},
  {iata: "HMI", airport: "Hami Airport"},
  {iata: "HMJ", airport: "Khmelnitskiy Airport"},
  {iata: "HMN", airport: "Holloman Air Force Base"},
  {iata: "HMO", airport: "Gen Pesqueira Garcia Airport"},
  {iata: "HMR", airport: "Hamar Airport"},
  {iata: "HMT", airport: "Ryan Field"},
  {iata: "HMV", airport: "Hemavan Airport"},
  {iata: "HNA", airport: "Hanamaki Airport"},
  {iata: "HNB", airport: "Huntingburg Municipal Airport"},
  {iata: "HNC", airport: "Hatteras Airport"},
  {iata: "HND", airport: "Haneda Airport"},
  {iata: "HNG", airport: "Hienghene Airport"},
  {iata: "HNH", airport: "Hoonah Airport"},
  {iata: "HNI", airport: "Heiweni Airport"},
  {iata: "HNK", airport: "Hinchinbrooke Island Airport"},
  {iata: "HNL", airport: "Honolulu International Airport"},
  {iata: "HNM", airport: "Hana Airport"},
  {iata: "HNN", airport: "Honinabi Airport"},
  {iata: "HNO", airport: "Hercegnovi Airport"},
  {iata: "HNS", airport: "Haines Municipal Airport"},
  {iata: "HNX", airport: "Hanna Airport"},
  {iata: "HNY", airport: "Hengyang Airport"},
  {iata: "HOA", airport: "Hola Airport"},
  {iata: "HOB", airport: "Lea County Airport"},
  {iata: "HOC", airport: "Komako Airport"},
  {iata: "HOD", airport: "Hodeidah Airport"},
  {iata: "HOE", airport: "Houeisay Airport"},
  {iata: "HOF", airport: "Alahsa Airport"},
  {iata: "HOG", airport: "Frank Pais Airport"},
  {iata: "HOH", airport: "Hohenems Airport"},
  {iata: "HOI", airport: "Hao Island Airport"},
  {iata: "HOK", airport: "Hooker Creek Airport"},
  {iata: "HOM", airport: "Homer Airport"},
  {iata: "HON", airport: "Howes Airport"},
  {iata: "HOO", airport: "Nhon Co Airport"},
  {iata: "HOP", airport: "Campbell Army Air Field"},
  {iata: "HOQ", airport: "Hof Airport"},
  {iata: "HOR", airport: "Horta Airport"},
  {iata: "HOS", airport: "Oscar Reguera Airport"},
  {iata: "HOT", airport: "Memorial Field"},
  {iata: "HOU", airport: "Hobby Airport"},
  {iata: "HOV", airport: "Hovden Airport"},
  {iata: "HOX", airport: "HoMalin Airport"},
  {iata: "HOY", airport: "Hoy Island Airport"},
  {iata: "HPB", airport: "Hooper Bay Airport"},
  {iata: "HPE", airport: "Hope Vale Airport"},
  {iata: "HPH", airport: "Catbi Airport"},
  {iata: "HPN", airport: "Westchester County Airport"},
  {iata: "HPR", airport: "Pretoria Central Heliport"},
  {iata: "HPT", airport: "Hampton Municipal Airport"},
  {iata: "HPV", airport: "Princeville Airport"},
  {iata: "HPY", airport: "Baytown Airport"},
  {iata: "HQM", airport: "Bowerman Airport"},
  {iata: "HRA", airport: "Mansehra Airport"},
  {iata: "HRB", airport: "Harbin Airport"},
  {iata: "HRC", airport: "Zhairem Airport"},
  {iata: "HRE", airport: "Harare Airport"},
  {iata: "HRG", airport: "Hurghada Airport"},
  {iata: "HRJ", airport: "Chaurjhari Airport"},
  {iata: "HRK", airport: "Kharkov Airport"},
  {iata: "HRL", airport: "Valley International Airport"},
  {iata: "HRN", airport: "Heron Island Heliport"},
  {iata: "HRO", airport: "Boone County Airport"},
  {iata: "HRR", airport: "Herrera Airport"},
  {iata: "HRS", airport: "Harrismith Airport"},
  {iata: "HRT", airport: "Linton-On-Ouse Airport"},
  {iata: "HRY", airport: "Henbury Airport"},
  {iata: "HRZ", airport: "Horizontina Airport"},
  {iata: "HSB", airport: "Raleigh Airport"},
  {iata: "HSC", airport: "Shaoguan Airport"},
  {iata: "HSG", airport: "Saga Airport"},
  {iata: "HSH", airport: "Henderson Sky Harbor Airport"},
  {iata: "HSI", airport: "Hastings Airport"},
  {iata: "HSL", airport: "Huslia Airport"},
  {iata: "HSM", airport: "Horsham Airport"},
  {iata: "HSN", airport: "Zhoushan Airport"},
  {iata: "HSP", airport: "Ingalls Field"},
  {iata: "HSS", airport: "Hissar Airport"},
  {iata: "HST", airport: "Homestead Air Force Base"},
  {iata: "HSV", airport: "Huntsville International Airport"},
  {iata: "HSZ", airport: "Hsinchu Airport"},
  {iata: "HTA", airport: "Chita Airport"},
  {iata: "HTB", airport: "Terre-de-Bas Airport"},
  {iata: "HTF", airport: "Hatfield Airport"},
  {iata: "HTG", airport: "Hatanga Airport"},
  {iata: "HTH", airport: "Hawthorne Airport"},
  {iata: "HTI", airport: "Hamilton Island Airport"},
  {iata: "HTL", airport: "Roscommon County Airport"},
  {iata: "HTM", airport: "Khatgal Airport"},
  {iata: "HTN", airport: "Hotan Airport"},
  {iata: "HTO", airport: "East Hampton Airport"},
  {iata: "HTR", airport: "Hateruma Airport"},
  {iata: "HTS", airport: "Tri-State/Milton Airport"},
  {iata: "HTU", airport: "Hopetown Airport"},
  {iata: "HTV", airport: "Huntsville Airport"},
  {iata: "HTW", airport: "Huntington County Airport"},
  {iata: "HTZ", airport: "Hato Corozal Airport"},
  {iata: "HUA", airport: "Redstone Army Air Field"},
  {iata: "HUB", airport: "Humbert River Airport"},
  {iata: "HUC", airport: "Humacao Airport"},
  {iata: "HUD", airport: "Humboldt Airport"},
  {iata: "HUE", airport: "Humera Airport"},
  {iata: "HUF", airport: "Hulman Field"},
  {iata: "HUG", airport: "Huehuetenango Airport"},
  {iata: "HUH", airport: "Huahine Airport"},
  {iata: "HUI", airport: "Phu Bai Airport"},
  {iata: "HUJ", airport: "Hugo Airport"},
  {iata: "HUK", airport: "Hukuntsi Airport"},
  {iata: "HUL", airport: "Houlton International Airport"},
  {iata: "HUM", airport: "Terrebonne Airport"},
  {iata: "HUN", airport: "Hualien Airport"},
  {iata: "HUQ", airport: "Houn Airport"},
  {iata: "HUS", airport: "Hughes Municipal Airport"},
  {iata: "HUT", airport: "Hutchinson Airport"},
  {iata: "HUU", airport: "Huanuco Airport"},
  {iata: "HUV", airport: "Hudiksvall Airport"},
  {iata: "HUX", airport: "Huatulco Airport"},
  {iata: "HUY", airport: "Humberside Airport"},
  {iata: "HUZ", airport: "Huizhou Airport"},
  {iata: "HVA", airport: "Analalava Airport"},
  {iata: "HVB", airport: "Hervey Bay Airport"},
  {iata: "HVD", airport: "Khovd Airport"},
  {iata: "HVE", airport: "Hanksville Intermediate Airport"},
  {iata: "HVG", airport: "Valan Airport"},
  {iata: "HVK", airport: "Holmavik Airport"},
  {iata: "HVM", airport: "Hvammstangi Airport"},
  {iata: "HVN", airport: "New Haven Airport"},
  {iata: "HVR", airport: "Havre City County Airport"},
  {iata: "HVS", airport: "Hartsville Municipal Airport"},
  {iata: "HWA", airport: "Hawabango Airport"},
  {iata: "HWD", airport: "Hayward Air Terminal"},
  {iata: "HWK", airport: "Wilpena Pound Airport"},
  {iata: "HWN", airport: "Hwange National Park Airport"},
  {iata: "HWO", airport: "North Perry Airport"},
  {iata: "HXX", airport: "Hay Airport"},
  {iata: "HYA", airport: "Barnstable Airport"},
  {iata: "HYC", airport: "High Wycombe Airport"},
  {iata: "HYD", airport: "Rajiv Gandhi International Airport"},
  {iata: "HYF", airport: "Hayfields Airport"},
  {iata: "HYG", airport: "Hydaburg Sea Plane Base"},
  {iata: "HYL", airport: "Hollis Sea Plane Base"},
  {iata: "HYN", airport: "Huangyan Airport"},
  {iata: "HYR", airport: "Hayward Municipal Airport"},
  {iata: "HYS", airport: "Hays Municipal Airport"},
  {iata: "HYV", airport: "Hyvinkaa Airport"},
  {iata: "HZB", airport: "Merville/Calonne Airport"},
  {iata: "HZG", airport: "Hanzhong Airport"},
  {iata: "HZK", airport: "Husavik Airport"},
  {iata: "HZL", airport: "Hazleton Airport"},
  {iata: "HZV", airport: "Hazyview Airport"},
  {iata: "IAA", airport: "Igarka Airport"},
  {iata: "IAB", airport: "McConnell Air Force Base"},
  {iata: "IAD", airport: "Dulles International Airport"},
  {iata: "IAG", airport: "Niagara Falls International Airport"},
  {iata: "IAH", airport: "George Bush Intercontinental Airport"},
  {iata: "IAM", airport: "In Amenas Airport"},
  {iata: "IAN", airport: "Bob Barker Memorial Airport"},
  {iata: "IAQ", airport: "Bahregan Airport"},
  {iata: "IAR", airport: "Yaroslavl Airport"},
  {iata: "IAS", airport: "Iasi Airport"},
  {iata: "IAU", airport: "Iaura Airport"},
  {iata: "IBA", airport: "Ibadan Airport"},
  {iata: "IBE", airport: "Ibague Airport"},
  {iata: "IBI", airport: "Iboki Airport"},
  {iata: "IBO", airport: "Ibo Airport"},
  {iata: "IBP", airport: "Iberia Airport"},
  {iata: "IBZ", airport: "Ibiza Airport"},
  {iata: "ICA", airport: "Icabaru Airport"},
  {iata: "ICI", airport: "Cicia Airport"},
  {iata: "ICK", airport: "Nieuw Nickerie Airport"},
  {iata: "ICL", airport: "Clarinda Municipal Airport"},
  {iata: "ICN", airport: "Incheon International Airport"},
  {iata: "ICO", airport: "Sicogon Island Airport"},
  {iata: "ICR", airport: "Nicaro Airport"},
  {iata: "ICT", airport: "Mid-Continent Airport"},
  {iata: "IDA", airport: "Fanning Field"},
  {iata: "IDB", airport: "Idre Airport"},
  {iata: "IDF", airport: "Idiofa Airport"},
  {iata: "IDG", airport: "Ida Grove Municipal Airport"},
  {iata: "IDI", airport: "Indiana Airport"},
  {iata: "IDK", airport: "Indulkana Airport"},
  {iata: "IDN", airport: "Indagen Airport"},
  {iata: "IDO", airport: "Santa Isabel do Morro Airport"},
  {iata: "IDP", airport: "Independence Airport"},
  {iata: "IDR", airport: "Indore Airport"},
  {iata: "IEG", airport: "Babimost Airport"},
  {iata: "IEJ", airport: "Iejima Airport"},
  {iata: "IES", airport: "Riesa Airport"},
  {iata: "IEV", airport: "Kiev-Zhulhany Airport"},
  {iata: "IFA", airport: "Iowa Falls Airport"},
  {iata: "IFF", airport: "Iffley Airport"},
  {iata: "IFH", airport: "Hesa Airport"},
  {iata: "IFJ", airport: "Isafjordur Airport"},
  {iata: "IFL", airport: "Innisfail Airport"},
  {iata: "IFN", airport: "Isfahan Airport"},
  {iata: "IFO", airport: "Ivano-Frankovsk Airport"},
  {iata: "IFP", airport: "Laughlin Bullhead International Airport"},
  {iata: "IGA", airport: "Inagua Airport"},
  {iata: "IGB", airport: "Ingeniero Jacobacci Airport"},
  {iata: "IGE", airport: "Iguela Airport"},
  {iata: "IGG", airport: "Igiugig Airport"},
  {iata: "IGH", airport: "Ingham Airport"},
  {iata: "IGL", airport: "Cigli Military Airport"},
  {iata: "IGM", airport: "Kingman Airport"},
  {iata: "IGN", airport: "Maria Cristina Airport"},
  {iata: "IGO", airport: "Chigorodo Airport"},
  {iata: "IGR", airport: "Cataratas Airport"},
  {iata: "IGU", airport: "Cataratas Airport"},
  {iata: "IHA", airport: "Niihama Airport"},
  {iata: "IHC", airport: "Inhaca Airport"},
  {iata: "IHN", airport: "Qishn Airport"},
  {iata: "IHO", airport: "Ihosy Airport"},
  {iata: "IHR", airport: "Iran Shahr Airport"},
  {iata: "IHU", airport: "Ihu Airport"},
  {iata: "IIA", airport: "Inishmaan Airport"},
  {iata: "IIL", airport: "Ilaam Airport"},
  {iata: "IIN", airport: "Nishinoomote Airport"},
  {iata: "IIS", airport: "Nissan Island Airport"},
  {iata: "IJK", airport: "Izhevsk Airport"},
  {iata: "IJU", airport: "J. Batista Bos Filho Airport"},
  {iata: "IJX", airport: "Jacksonville Municipal Airport"},
  {iata: "IKA", airport: "Imam Khomeini Airport"},
  {iata: "IKB", airport: "Wilkes County Airport"},
  {iata: "IKI", airport: "Iki Airport"},
  {iata: "IKK", airport: "Greater Kankakee Airport"},
  {iata: "IKL", airport: "Ikela Airport"},
  {iata: "IKO", airport: "Nikolski Air Force Station"},
  {iata: "IKP", airport: "Inkerman Airport"},
  {iata: "IKS", airport: "Tiksi Airport"},
  {iata: "IKT", airport: "Irkutsk Airport"},
  {iata: "ILA", airport: "Illaga Airport"},
  {iata: "ILB", airport: "Ilha Solteira Airport"},
  {iata: "ILE", airport: "Killeen Municipal Airport"},
  {iata: "ILF", airport: "Ilford Airport"},
  {iata: "ILG", airport: "New Castle Airport"},
  {iata: "ILI", airport: "Iliamna Airport"},
  {iata: "ILK", airport: "Ilaka Airport"},
  {iata: "ILL", airport: "Willmar Airport"},
  {iata: "ILM", airport: "Wilmington International Airport"},
  {iata: "ILN", airport: "Clinton Field"},
  {iata: "ILO", airport: "Mandurriao Airport"},
  {iata: "ILP", airport: "Ile Des Pins Airport"},
  {iata: "ILQ", airport: "Ilo Airport"},
  {iata: "ILR", airport: "Ilorin Airport"},
  {iata: "ILU", airport: "Kilaguni Airport"},
  {iata: "ILY", airport: "Glenegedale Airport"},
  {iata: "ILZ", airport: "Zilina Airport"},
  {iata: "IMA", airport: "Iamalele Airport"},
  {iata: "IMB", airport: "Imbaimadai Airport"},
  {iata: "IMD", airport: "Imonda Airport"},
  {iata: "IMF", airport: "Imphal Municipal Airport"},
  {iata: "IMG", airport: "Inhaminga Airport"},
  {iata: "IMI", airport: "Ine Island Airport"},
  {iata: "IMK", airport: "Simikot Airport"},
  {iata: "IML", airport: "Imperial Airport"},
  {iata: "IMM", airport: "Immokalee Airport"},
  {iata: "IMN", airport: "Imane Airport"},
  {iata: "IMO", airport: "Zemio Airport"},
  {iata: "IMP", airport: "Imperatriz Airport"},
  {iata: "IMT", airport: "Ford Airport"},
  {iata: "IMZ", airport: "Nimroz Airport"},
  {iata: "INA", airport: "Inta Airport"},
  {iata: "INB", airport: "Independence Airport"},
  {iata: "INC", airport: "Yinchuan Airport"},
  {iata: "IND", airport: "Indianapolis International Airport"},
  {iata: "INE", airport: "Chinde Airport"},
  {iata: "INF", airport: "In Guezzam Airport"},
  {iata: "ING", airport: "Lago Argentino Airport"},
  {iata: "INH", airport: "Inhambane Airport"},
  {iata: "INI", airport: "Nis Airport"},
  {iata: "INJ", airport: "Injune Airport"},
  {iata: "INK", airport: "Wink Airport"},
  {iata: "INL", airport: "Falls International Airport"},
  {iata: "INM", airport: "Innamincka Airport"},
  {iata: "INN", airport: "Kranebitten Airport"},
  {iata: "INO", airport: "Inongo Airport"},
  {iata: "INQ", airport: "Inisheer Airport"},
  {iata: "INR", airport: "Kincheloe Air Force Base"},
  {iata: "INS", airport: "Af Aux Airport"},
  {iata: "INT", airport: "Smith-Reynolds Airport"},
  {iata: "INU", airport: "Nauru Island International Airport"},
  {iata: "INV", airport: "Inverness Airport"},
  {iata: "INW", airport: "Winslow Airport"},
  {iata: "INX", airport: "Inanwatan Airport"},
  {iata: "INY", airport: "Inyati Airport"},
  {iata: "INZ", airport: "In Salah Airport"},
  {iata: "IOA", airport: "Ioannina Airport"},
  {iata: "IOK", airport: "Iokea Airport"},
  {iata: "IOM", airport: "Ronaldsway Airport"},
  {iata: "ION", airport: "Impfondo Airport"},
  {iata: "IOP", airport: "Ioma Airport"},
  {iata: "IOR", airport: "Kilronan Airport"},
  {iata: "IOS", airport: "Eduardo Gomes Airport"},
  {iata: "IOU", airport: "Ile Ouen Airport"},
  {iata: "IOW", airport: "Iowa City Airport"},
  {iata: "IPA", airport: "Ipota Airport"},
  {iata: "IPC", airport: "Mataveri International Airport"},
  {iata: "IPE", airport: "Ipil Airport"},
  {iata: "IPG", airport: "Ipiranga Airport"},
  {iata: "IPH", airport: "Ipoh Airport"},
  {iata: "IPI", airport: "San Luis Airport"},
  {iata: "IPL", airport: "Imperial County Airport"},
  {iata: "IPN", airport: "Usiminas Airport"},
  {iata: "IPT", airport: "Lycoming County Airport"},
  {iata: "IPU", airport: "Ipiau Airport"},
  {iata: "IPW", airport: "Ipswich Airport"},
  {iata: "IQM", airport: "Qiemo Airport"},
  {iata: "IQN", airport: "Qingyang Airport"},
  {iata: "IQQ", airport: "Cavancha Airport"},
  {iata: "IQT", airport: "C.F. Secada Airport"},
  {iata: "IRA", airport: "Kirakira Airport"},
  {iata: "IRB", airport: "Iraan Municipal Airport"},
  {iata: "IRC", airport: "Circle City Airport"},
  {iata: "IRD", airport: "Ishurdi Airport"},
  {iata: "IRE", airport: "Irece Airport"},
  {iata: "IRG", airport: "Lockhart River Airport"},
  {iata: "IRI", airport: "Nduli Airport"},
  {iata: "IRJ", airport: "La Rioja Airport"},
  {iata: "IRK", airport: "Kirksville Municipal Airport"},
  {iata: "IRN", airport: "Iriona Airport"},
  {iata: "IRO", airport: "Birao Airport"},
  {iata: "IRP", airport: "Matari"},
  {iata: "IRS", airport: "Kirsch Municipal"},
  {iata: "ISA", airport: "Mount Isa Airport"},
  {iata: "ISB", airport: "Islamabad International Airport"},
  {iata: "ISD", airport: "Iscuande Airport"},
  {iata: "ISE", airport: "Isparta Airport"},
  {iata: "ISG", airport: "Ishigaki Airport"},
  {iata: "ISH", airport: "Ischia Airport"},
  {iata: "ISI", airport: "Isisford Airport"},
  {iata: "ISJ", airport: "Isla Mujeres Airport"},
  {iata: "ISK", airport: "Gandhinagar Airport"},
  {iata: "ISM", airport: "Kissimmee Municipal Airport"},
  {iata: "ISN", airport: "Sloulin Field International Airport"},
  {iata: "ISO", airport: "Stallings Field"},
  {iata: "ISP", airport: "Long Island MacArthur Airport"},
  {iata: "ISQ", airport: "Schoolcraft County Airport"},
  {iata: "ISS", airport: "Wiscasset Airport"},
  {iata: "IST", airport: "Ataturk Airport"},
  {iata: "ISW", airport: "Alexander Field"},
  {iata: "ITA", airport: "Itacoatiara Airport"},
  {iata: "ITB", airport: "Itaituba Airport"},
  {iata: "ITE", airport: "Itubera Airport"},
  {iata: "ITH", airport: "Tompkins County Airport"},
  {iata: "ITI", airport: "Itambacuri Airport"},
  {iata: "ITK", airport: "Itokama Airport"},
  {iata: "ITM", airport: "Itami Airport"},
  {iata: "ITN", airport: "Itabuna Airport"},
  {iata: "ITO", airport: "Hilo International Airport"},
  {iata: "ITP", airport: "Itaperuna Airport"},
  {iata: "ITQ", airport: "Itaqui Airport"},
  {iata: "ITR", airport: "Itumbiara Airport"},
  {iata: "IUE", airport: "Hanan Airport"},
  {iata: "IUL", airport: "Ilu Airport"},
  {iata: "IUM", airport: "Summit Lake Airport"},
  {iata: "IUS", airport: "Inus Airport"},
  {iata: "IVA", airport: "Ambanja Airport"},
  {iata: "IVC", airport: "Invercargill Airport"},
  {iata: "IVG", airport: "Ivangrad Airport"},
  {iata: "IVL", airport: "Ivalo Airport"},
  {iata: "IVO", airport: "Chivolo Airport"},
  {iata: "IVR", airport: "Inverell Airport"},
  {iata: "IVW", airport: "Inverway Airport"},
  {iata: "IWA", airport: "Ivanovo Airport"},
  {iata: "IWD", airport: "Gogebic County Airport"},
  {iata: "IWJ", airport: "Iwami Airport"},
  {iata: "IWO", airport: "Iwo Jima Air Base"},
  {iata: "IWS", airport: "West Houston Airport"},
  {iata: "IXA", airport: "Singerbhil Airport"},
  {iata: "IXB", airport: "Bagdogra Airport"},
  {iata: "IXC", airport: "Chandigarh Airport"},
  {iata: "IXD", airport: "Bamrauli Airport"},
  {iata: "IXE", airport: "Bajpe Airport"},
  {iata: "IXG", airport: "Sambre Airport"},
  {iata: "IXH", airport: "Kailashahar Airport"},
  {iata: "IXI", airport: "Lilabari Airport"},
  {iata: "IXJ", airport: "Satwari Airport"},
  {iata: "IXK", airport: "Keshod Airport"},
  {iata: "IXL", airport: "Leh Airport"},
  {iata: "IXM", airport: "Madurai Airport"},
  {iata: "IXN", airport: "Khowai Airport"},
  {iata: "IXP", airport: "Pathankot Airport"},
  {iata: "IXQ", airport: "Kamalpur Airport"},
  {iata: "IXR", airport: "Ranchi Airport"},
  {iata: "IXS", airport: "Kumbhirgram Airport"},
  {iata: "IXT", airport: "Pasighat Airport"},
  {iata: "IXU", airport: "Chikkalthana Airport"},
  {iata: "IXV", airport: "Along Airport"},
  {iata: "IXW", airport: "Sonari Airport"},
  {iata: "IXY", airport: "Kandla Airport"},
  {iata: "IXZ", airport: "Port Blair Airport"},
  {iata: "IYK", airport: "Kern County Airport"},
  {iata: "IZO", airport: "Izumo Airport"},
  {iata: "IZT", airport: "Ixtepec Airport"},
  {iata: "JAA", airport: "Jalalabad Airport"},
  {iata: "JAB", airport: "Jabiru Airport"},
  {iata: "JAC", airport: "Jackson Hole Airport"},
  {iata: "JAD", airport: "Jandakot Airport"},
  {iata: "JAE", airport: "Technology Park Heliport"},
  {iata: "JAF", airport: "Kankesanturai Airport"},
  {iata: "JAG", airport: "Jacobabad Airport"},
  {iata: "JAH", airport: "Agora Helipad"},
  {iata: "JAI", airport: "Sanganeer Airport"},
  {iata: "JAJ", airport: "Perimeter Mall Heliport"},
  {iata: "JAK", airport: "Jacmel Airport"},
  {iata: "JAL", airport: "Jalapa Airport"},
  {iata: "JAM", airport: "Jambol Airport"},
  {iata: "JAN", airport: "Jackson International Airport"},
  {iata: "JAO", airport: "Beaver Ruin Heliport"},
  {iata: "JAP", airport: "Punta Renes Airport"},
  {iata: "JAQ", airport: "Jacquinot Bay Airport"},
  {iata: "JAR", airport: "Jahrom Airport"},
  {iata: "JAS", airport: "County Airport"},
  {iata: "JAU", airport: "Jauja Airport"},
  {iata: "JAV", airport: "Ilulissat Airport"},
  {iata: "JAX", airport: "Jacksonville International Airport"},
  {iata: "JBC", airport: "Boston City Heliport"},
  {iata: "JBK", airport: "Berkeley Airport"},
  {iata: "JBR", airport: "Jonesboro Airport"},
  {iata: "JBS", airport: "Hacienda Business Park Heliport"},
  {iata: "JCA", airport: "Croisette Heliport"},
  {iata: "JCB", airport: "Joacaba Airport"},
  {iata: "JCC", airport: "China Basin Heliport"},
  {iata: "JCD", airport: "St. Croix Downtown Heliport"},
  {iata: "JCE", airport: "Convention Center Heliport"},
  {iata: "JCH", airport: "Qasigiannguit Airport"},
  {iata: "JCI", airport: "Johnson Industrial Airport"},
  {iata: "JCJ", airport: "Chuja Heliport"},
  {iata: "JCK", airport: "Julia Creek Airport"},
  {iata: "JCM", airport: "Jacobina Airport"},
  {iata: "JCN", airport: "Incheon Heliport"},
  {iata: "JCO", airport: "Comino Heliport"},
  {iata: "JCR", airport: "Jacareacanga Airport"},
  {iata: "JCT", airport: "Kimble County Airport"},
  {iata: "JCU", airport: "Ceuta Heliport"},
  {iata: "JCY", airport: "Johnson Airport"},
  {iata: "JDA", airport: "John Day Airport"},
  {iata: "JDB", airport: "Dallas Downtown Heliport"},
  {iata: "JDF", airport: "Francisco De Assis Airport"},
  {iata: "JDH", airport: "Jodhpur Airport"},
  {iata: "JDM", airport: "Miami Downtown Heliport"},
  {iata: "JDN", airport: "Jordan Airport"},
  {iata: "JDO", airport: "Regional Do Cariri Airport"},
  {iata: "JDP", airport: "Heliport De Paris"},
  {iata: "JDT", airport: "Minneapolis Downtown Heliport"},
  {iata: "JDX", airport: "Central Business District Heliport"},
  {iata: "JDY", airport: "Downey Heliport"},
  {iata: "JDZ", airport: "Jingdezhen Airport"},
  {iata: "JED", airport: "King Abdulaziz International Airport"},
  {iata: "JEE", airport: "Jeremie Airport"},
  {iata: "JEF", airport: "Jefferson City Memorial Airport"},
  {iata: "JEG", airport: "Aasiaat Airport"},
  {iata: "JEM", airport: "Emeryville Heliport"},
  {iata: "JEQ", airport: "Jequie Airport"},
  {iata: "JER", airport: "States Airport"},
  {iata: "JEV", airport: "Evry Heliport"},
  {iata: "JFK", airport: "John F. Kennedy International Airport"},
  {iata: "JFM", airport: "Fremantle Heliport"},
  {iata: "JFN", airport: "Ashtabula Airport"},
  {iata: "JFR", airport: "Paamiut Airport"},
  {iata: "JGA", airport: "Govardhanpur Airport"},
  {iata: "JGB", airport: "Jagdalpur Airport"},
  {iata: "JGC", airport: "Grand Canyon Heliport"},
  {iata: "JGE", airport: "Geoje Heliport"},
  {iata: "JGL", airport: "Galleria Heliport"},
  {iata: "JGN", airport: "Jiayuguan Airport"},
  {iata: "JGO", airport: "Qeqertarsuaq Airport"},
  {iata: "JGP", airport: "Greenway Plaza Heliport"},
  {iata: "JGQ", airport: "Transco Tower Galleria Heliport"},
  {iata: "JGR", airport: "Gronnedal Heliport"},
  {iata: "JGS", airport: "Ji An/Jing Gang Shan Airport"},
  {iata: "JGX", airport: "Glendale Heliport"},
  {iata: "JHB", airport: "Sultan Ismail International Airport"},
  {iata: "JHC", airport: "Island Heliport"},
  {iata: "JHE", airport: "Helsingborg Heliport"},
  {iata: "JHG", airport: "Gasa Airport"},
  {iata: "JHM", airport: "Kapalua Airport"},
  {iata: "JHQ", airport: "Shute Harbour Heliport"},
  {iata: "JHS", airport: "Sisimiut Airport"},
  {iata: "JHW", airport: "Jamestown Airport"},
  {iata: "JHY", airport: "Hyatt Regency Heliport"},
  {iata: "JIA", airport: "Juina Airport"},
  {iata: "JIB", airport: "Ambouli Airport"},
  {iata: "JIJ", airport: "Jigiga Airport"},
  {iata: "JIK", airport: "Ikaria Airport"},
  {iata: "JIL", airport: "Jilin Airport"},
  {iata: "JIM", airport: "Jimma Airport"},
  {iata: "JIN", airport: "Jinja Airport"},
  {iata: "JIO", airport: "Ontario International Heliport"},
  {iata: "JIP", airport: "Jipijapa Airport"},
  {iata: "JIR", airport: "Jiri Airport"},
  {iata: "JIU", airport: "Jiujiang Airport"},
  {iata: "JIW", airport: "Jiwani Airport"},
  {iata: "JJI", airport: "Juanjui Airport"},
  {iata: "JJN", airport: "Jinjiang Airport"},
  {iata: "JJU", airport: "Qaqortoq Heliport"},
  {iata: "JKG", airport: "Axamo Airport"},
  {iata: "JKH", airport: "Chios Airport"},
  {iata: "JKR", airport: "Janakpur Airport"},
  {iata: "JKV", airport: "Jacksonville Airport"},
  {iata: "JLB", airport: "Long Beach Heliport"},
  {iata: "JLD", airport: "Landskrona Heliport"},
  {iata: "JLH", airport: "United States Army Heliport"},
  {iata: "JLN", airport: "Joplin Airport"},
  {iata: "JLO", airport: "Jesolo Airport"},
  {iata: "JLP", airport: "Juan Les Pins Airport"},
  {iata: "JLR", airport: "Jabalpur Airport"},
  {iata: "JLS", airport: "Jales Airport"},
  {iata: "JMA", airport: "Marriot Astrodome Heliport"},
  {iata: "JMC", airport: "Marin County Airport"},
  {iata: "JMD", airport: "Market Centre Heliport"},
  {iata: "JMH", airport: "Schaumburg Marriott Heliport"},
  {iata: "JMK", airport: "Mikonos Airport"},
  {iata: "JMM", airport: "Malmo Harbour Heliport"},
  {iata: "JMN", airport: "Mankato Municipal Heliport"},
  {iata: "JMO", airport: "Jomsom Airport"},
  {iata: "JMS", airport: "Jamestown Airport"},
  {iata: "JMU", airport: "Jiamusi Airport"},
  {iata: "JMY", airport: "Mammy Yoko Heliport"},
  {iata: "JNA", airport: "Januaria Airport"},
  {iata: "JNB", airport: "Johannesburg International Airport"},
  {iata: "JNG", airport: "Jining Airport"},
  {iata: "JNH", airport: "North Park Inn Heliport"},
  {iata: "JNI", airport: "Junin Airport"},
  {iata: "JNN", airport: "Nanortalik Airport"},
  {iata: "JNP", airport: "Newport Beach Heliport"},
  {iata: "JNS", airport: "Narsaq Heliport"},
  {iata: "JNU", airport: "Juneau International Airport"},
  {iata: "JNX", airport: "Naxos Airport"},
  {iata: "JNZ", airport: "Liaoning Province Airport"},
  {iata: "JOC", airport: "Centerport Heliport"},
  {iata: "JOE", airport: "Joensuu Airport"},
  {iata: "JOG", airport: "Adisutjipto Airport"},
  {iata: "JOH", airport: "Port St. Johns Airport"},
  {iata: "JOI", airport: "Cubatao Airport"},
  {iata: "JOK", airport: "Joshkar-Ola Airport"},
  {iata: "JOL", airport: "Jolo Airport"},
  {iata: "JOM", airport: "Njombe Airport"},
  {iata: "JON", airport: "Josephstaal Airport"},
  {iata: "JOP", airport: "Josephstaal Airport"},
  {iata: "JOR", airport: "The City Heliport"},
  {iata: "JOS", airport: "Jos Airport"},
  {iata: "JOT", airport: "Joliet Municipal Airport"},
  {iata: "JPA", airport: "Castro Pinto Airport"},
  {iata: "JPD", airport: "Pasadena Heliport"},
  {iata: "JPN", airport: "Pentagon Army Airport"},
  {iata: "JPR", airport: "Ji-Parana Airport"},
  {iata: "JPT", airport: "Texas Park Ten Heliport"},
  {iata: "JPU", airport: "La Defense Heliport"},
  {iata: "JQA", airport: "Qaarsut Airport"},
  {iata: "JQE", airport: "Jaque Airport"},
  {iata: "JRA", airport: "West 30th Street Heliport"},
  {iata: "JRB", airport: "New York Downtown Manhattan Heliport"},
  {iata: "JRC", airport: "Rochester Municipal Heliport"},
  {iata: "JRD", airport: "Riverside Heliport"},
  {iata: "JRE", airport: "East 60th Street Heliport"},
  {iata: "JRH", airport: "Rowriah Airport"},
  {iata: "JRK", airport: "Arsuk Airport"},
  {iata: "JRN", airport: "Juruena Airport"},
  {iata: "JRO", airport: "Kilimanjaro Airport"},
  {iata: "JRS", airport: "Jerusalem Airport"},
  {iata: "JSA", airport: "Jaisalmer Airport"},
  {iata: "JSD", airport: "Sikorsky Heliport"},
  {iata: "JSG", airport: "San Rafael Heliport"},
  {iata: "JSH", airport: "Sitia Airport"},
  {iata: "JSI", airport: "Skiathos Airport"},
  {iata: "JSK", airport: "St. Cloud Municipal Heliport"},
  {iata: "JSL", airport: "Steel Pier Heliport"},
  {iata: "JSM", airport: "Jose San de Martin Airport"},
  {iata: "JSO", airport: "Sodertalje Heliport"},
  {iata: "JSP", airport: "Seogwipo Heliport"},
  {iata: "JSR", airport: "Jessore Airport"},
  {iata: "JSS", airport: "Spetsai Island Airport"},
  {iata: "JST", airport: "Cambria County Airport"},
  {iata: "JSU", airport: "Maniitsoq Heliport"},
  {iata: "JSY", airport: "Syros Island Airport"},
  {iata: "JTI", airport: "Jatai Airport"},
  {iata: "JTO", airport: "Thousand Oaks Heliport"},
  {iata: "JTR", airport: "Thira Airport"},
  {iata: "JTY", airport: "Astypalaia Airport"},
  {iata: "JUA", airport: "Juara Airport"},
  {iata: "JUB", airport: "Juba Airport"},
  {iata: "JUI", airport: "Juist Airport"},
  {iata: "JUJ", airport: "El Cadillal Airport"},
  {iata: "JUL", airport: "Juliaca Airport"},
  {iata: "JUM", airport: "Jumla Airport"},
  {iata: "JUN", airport: "Jundah Airport"},
  {iata: "JUO", airport: "Jurado Airport"},
  {iata: "JUP", airport: "Cable Heliport"},
  {iata: "JUR", airport: "Jurien Bay Airport"},
  {iata: "JUT", airport: "Juticalpa Airport"},
  {iata: "JUV", airport: "Upernavik Heliport"},
  {iata: "JUZ", airport: "Juzhou Airport"},
  {iata: "JVA", airport: "Ankavandra Airport"},
  {iata: "JVI", airport: "Kupper Airport"},
  {iata: "JVL", airport: "Rock County Airport"},
  {iata: "JWA", airport: "Jwaneng Airport"},
  {iata: "JWH", airport: "West Chase Hilton Heliport"},
  {iata: "JWL", airport: "Woodlawns Heliport"},
  {iata: "JWN", airport: "Zanjan Airport"},
  {iata: "JXN", airport: "Reynolds Municipal Airport"},
  {iata: "JYR", airport: "Jiroft Airport"},
  {iata: "JYV", airport: "Jyvaskyla Airport"},
  {iata: "JZH", airport: "Jiu Zhai Huang Long Airport"},
  {iata: "KAA", airport: "Kasama Airport"},
  {iata: "KAB", airport: "Kariba Airport"},
  {iata: "KAC", airport: "Kameshli Airport"},
  {iata: "KAD", airport: "Kaduna Airport"},
  {iata: "KAE", airport: "Kake Sea Plane Base"},
  {iata: "KAF", airport: "Karato Airport"},
  {iata: "KAG", airport: "Gangneung Airport"},
  {iata: "KAH", airport: "Melbourne City Heliport"},
  {iata: "KAI", airport: "Kaieteur Airport"},
  {iata: "KAJ", airport: "Kajaani Airport"},
  {iata: "KAK", airport: "Kar Airport"},
  {iata: "KAL", airport: "Kaltag Airport"},
  {iata: "KAM", airport: "Kamaran Island Airport"},
  {iata: "KAN", airport: "Aminu Kano International Airport"},
  {iata: "KAO", airport: "Kuusamo Airport"},
  {iata: "KAP", airport: "Kapanga Airport"},
  {iata: "KAQ", airport: "Kamulai Airport"},
  {iata: "KAR", airport: "Kamarang Airport"},
  {iata: "KAS", airport: "Karasburg Airport"},
  {iata: "KAT", airport: "Kaitaia Airport"},
  {iata: "KAU", airport: "Kauhava Airport"},
  {iata: "KAV", airport: "Kavanayen Airport"},
  {iata: "KAW", airport: "Kawthaung Airport"},
  {iata: "KAX", airport: "Kalbarri Airport"},
  {iata: "KAY", airport: "Wakaya Island Airport"},
  {iata: "KAZ", airport: "Kau Airport"},
  {iata: "KBA", airport: "Kabala Airport"},
  {iata: "KBB", airport: "Kirkimbie Airport"},
  {iata: "KBC", airport: "Birch Creek Airport"},
  {iata: "KBD", airport: "Kimberley Downs Airport"},
  {iata: "KBE", airport: "Hot Springs Sea Plane Base"},
  {iata: "KBF", airport: "Karubaga Airport"},
  {iata: "KBG", airport: "Kabalega Falls Airport"},
  {iata: "KBH", airport: "Kalat Airport"},
  {iata: "KBI", airport: "Kribi Airport"},
  {iata: "KBJ", airport: "King Canyon Airport"},
  {iata: "KBL", airport: "Khwaja Rawash Airport"},
  {iata: "KBM", airport: "Kabwum Airport"},
  {iata: "KBN", airport: "Kabinda Airport"},
  {iata: "KBO", airport: "Kabalo Airport"},
  {iata: "KBP", airport: "Kiev-Borispol Airport"},
  {iata: "KBQ", airport: "Kasungu Airport"},
  {iata: "KBR", airport: "Pengkalan Chepa Airport"},
  {iata: "KBS", airport: "Bo Airport"},
  {iata: "KBU", airport: "Kotabaru Airport"},
  {iata: "KBV", airport: "Krabi Airport"},
  {iata: "KBX", airport: "Kambuaya Airport"},
  {iata: "KBY", airport: "Streaky Bay Airport"},
  {iata: "KBZ", airport: "Kaikoura Airport"},
  {iata: "KCA", airport: "Kuqa Airport"},
  {iata: "KCB", airport: "Tepoe Airstrip"},
  {iata: "KCC", airport: "Coffman Cove Sea Plane Base"},
  {iata: "KCD", airport: "Kamur Airport"},
  {iata: "KCE", airport: "Collinsville Airport"},
  {iata: "KCF", airport: "Kadanwari Airport"},
  {iata: "KCG", airport: "Fisheries Airport"},
  {iata: "KCH", airport: "Kuching Airport"},
  {iata: "KCI", airport: "Kon Airport"},
  {iata: "KCJ", airport: "Komaio Airport"},
  {iata: "KCK", airport: "Fairfax Field"},
  {iata: "KCL", airport: "Lagoon Airport"},
  {iata: "KCM", airport: "Kahramanmaras Airport"},
  {iata: "KCO", airport: "Cengiz Topel Airport"},
  {iata: "KCP", airport: "Kamenets-Podolskiy Airport"},
  {iata: "KCQ", airport: "Chignik Lake Airport"},
  {iata: "KCS", airport: "Kings Creek Station Airport"},
  {iata: "KCT", airport: "Koggala Airport"},
  {iata: "KCU", airport: "Masindi Airport"},
  {iata: "KCZ", airport: "Kochi Airport"},
  {iata: "KDA", airport: "Kolda Airport"},
  {iata: "KDB", airport: "Kambalda Airport"},
  {iata: "KDC", airport: "Kandi Airport"},
  {iata: "KDD", airport: "Khuzdar Airport"},
  {iata: "KDE", airport: "Koroba Airport"},
  {iata: "KDF", airport: "Kouba Airport"},
  {iata: "KDH", airport: "Kandahar Airport"},
  {iata: "KDI", airport: "Wolter Monginsidi Airport"},
  {iata: "KDJ", airport: "Ndjole Airport"},
  {iata: "KDL", airport: "Kardla Airport"},
  {iata: "KDM", airport: "Kaadedhdhoo Airport"},
  {iata: "KDN", airport: "Ndende Airport"},
  {iata: "KDO", airport: "Kadhdhoo Airport"},
  {iata: "KDP", airport: "Kandep Airport"},
  {iata: "KDQ", airport: "Kamberatoro Airport"},
  {iata: "KDR", airport: "Kardjali Airport"},
  {iata: "KDR", airport: "Kandrian"},
  {iata: "KDS", airport: "Kamaran Downs Airport"},
  {iata: "KDT", airport: "Kamphangsaen Airport"},
  {iata: "KDU", airport: "Skardu Airport"},
  {iata: "KDV", airport: "Kandavu Airport"},
  {iata: "KDW", airport: "Victoria Resevour Kandy Airport"},
  {iata: "KDY", airport: "Mahaweli Airport"},
  {iata: "KEA", airport: "Keisah Airport"},
  {iata: "KEB", airport: "English Bay Airport"},
  {iata: "KEC", airport: "Kasenga Airport"},
  {iata: "KED", airport: "Kaedi Airport"},
  {iata: "KEE", airport: "Kelle Airport"},
  {iata: "KEF", airport: "Keflavik International Airport"},
  {iata: "KEG", airport: "Keglsugl Airport"},
  {iata: "KEH", airport: "Kenmore Air Harbor Airport"},
  {iata: "KEI", airport: "Kepi Airport"},
  {iata: "KEJ", airport: "Kemerovo Airport"},
  {iata: "KEK", airport: "Ekwok Airport"},
  {iata: "KEL", airport: "Holtenau Airport"},
  {iata: "KEM", airport: "Kemi/Tornio Airport"},
  {iata: "KEN", airport: "Kenema Airport"},
  {iata: "KEP", airport: "Nepalganj Airport"},
  {iata: "KEQ", airport: "Kebar Airport"},
  {iata: "KER", airport: "Kerman Airport"},
  {iata: "KES", airport: "Kelsey Airport"},
  {iata: "KET", airport: "Keng Tung Airport"},
  {iata: "KEV", airport: "Halli Airport"},
  {iata: "KEW", airport: "Keewaywin Airport"},
  {iata: "KEX", airport: "Kanabea Airport"},
  {iata: "KEY", airport: "Kericho Airport"},
  {iata: "KEZ", airport: "Kelaniya River Airport"},
  {iata: "KFA", airport: "Kiffa Airport"},
  {iata: "KFG", airport: "Kalkurung Airport"},
  {iata: "KFP", airport: "False Pass Airport"},
  {iata: "KFS", airport: "Kastamonu Airport"},
  {iata: "KGA", airport: "Kananga Airport"},
  {iata: "KGB", airport: "Konge Airport"},
  {iata: "KGC", airport: "Kingscote Airport"},
  {iata: "KGD", airport: "Kaliningrad Airport"},
  {iata: "KGE", airport: "Kagau Airport"},
  {iata: "KGF", airport: "Karaganda Airport"},
  {iata: "KGG", airport: "Kedougou Airport"},
  {iata: "KGH", airport: "Yongai Airport"},
  {iata: "KGI", airport: "Kalgoorlie Airport"},
  {iata: "KGJ", airport: "Karonga Airport"},
  {iata: "KGK", airport: "New Koliganek Airport"},
  {iata: "KGL", airport: "Gregoire Kayibanda Airport"},
  {iata: "KGN", airport: "Kasongo"},
  {iata: "KGN", airport: "Kasongo Lunda Airport"},
  {iata: "KGO", airport: "Kirovograd Airport"},
  {iata: "KGP", airport: "Kogalym International Airport"},
  {iata: "KGR", airport: "Kulgera Airport"},
  {iata: "KGS", airport: "Kos Airport"},
  {iata: "KGU", airport: "Keningau Airport"},
  {iata: "KGW", airport: "Kagi Airport"},
  {iata: "KGX", airport: "Grayling Airport"},
  {iata: "KGY", airport: "Kingaroy Airport"},
  {iata: "KHA", airport: "Khaneh Airport"},
  {iata: "KHC", airport: "Kerch Airport"},
  {iata: "KHD", airport: "Khorramabad Airport"},
  {iata: "KHE", airport: "Kherson Airport"},
  {iata: "KHG", airport: "Kashi Airport"},
  {iata: "KHH", airport: "Kaohsiung International Airport"},
  {iata: "KHI", airport: "Quaid-E-Azam International Airport"},
  {iata: "KHJ", airport: "Kauhajoki Airport"},
  {iata: "KHK", airport: "Khark Airport"},
  {iata: "KHL", airport: "Khulna Airport"},
  {iata: "KHM", airport: "Khamtis Airport"},
  {iata: "KHN", airport: "Nanchang Airport"},
  {iata: "KHO", airport: "Khoka Moya Airport"},
  {iata: "KHR", airport: "Kharkhorin Airport"},
  {iata: "KHS", airport: "Khasab Airport"},
  {iata: "KHT", airport: "Khost Airport"},
  {iata: "KHU", airport: "Kremenchug Airport"},
  {iata: "KHV", airport: "Novyy Airport"},
  {iata: "KHW", airport: "Khwai River Lodge Airport"},
  {iata: "KHY", airport: "Khoy Airport"},
  {iata: "KHZ", airport: "Kauehi Airport"},
  {iata: "KIA", airport: "Kaiapit Airport"},
  {iata: "KIC", airport: "Mesa Del Rey Airport"},
  {iata: "KID", airport: "Kristianstad Airport"},
  {iata: "KIE", airport: "Aropa Airport"},
  {iata: "KIF", airport: "Kingfisher Lake Airport"},
  {iata: "KIG", airport: "Koingnaas Airport"},
  {iata: "KIH", airport: "Kish Island Airport"},
  {iata: "KII", airport: "Kibuli Airport"},
  {iata: "KIJ", airport: "Niigata Airport"},
  {iata: "KIK", airport: "Kirkuk Airport"},
  {iata: "KIL", airport: "Kilwa Airport"},
  {iata: "KIM", airport: "Kimberley Airport"},
  {iata: "KIN", airport: "Norman Manley Airport"},
  {iata: "KIO", airport: "Kili Island Airport"},
  {iata: "KIP", airport: "Kickapoo Airport"},
  {iata: "KIQ", airport: "Kira Airport"},
  {iata: "KIR", airport: "Kerry County Airport"},
  {iata: "KIS", airport: "Kisumu Airport"},
  {iata: "KIT", airport: "Kithira Airport"},
  {iata: "KIU", airport: "Kiunga Airport"},
  {iata: "KIV", airport: "Chisinau Airport"},
  {iata: "KIW", airport: "Southdowns Airport"},
  {iata: "KIX", airport: "Kansai International Airport"},
  {iata: "KIY", airport: "Kilwa Airport"},
  {iata: "KIZ", airport: "Kikinonda Airport"},
  {iata: "KJA", airport: "Krasnojarsk Airport"},
  {iata: "KJK", airport: "Kortrijk Airport"},
  {iata: "KJP", airport: "Kerama Airport"},
  {iata: "KJU", airport: "Kamiraba Airport"},
  {iata: "KKA", airport: "Koyuk Airport"},
  {iata: "KKB", airport: "Kitui Bay Sea Plane Base"},
  {iata: "KKC", airport: "Khon Kaen Airport"},
  {iata: "KKD", airport: "Kokoda Airport"},
  {iata: "KKE", airport: "Kerikeri Airport"},
  {iata: "KKG", airport: "Konawaruk Airport"},
  {iata: "KKH", airport: "Kongiganak Airport"},
  {iata: "KKI", airport: "Akiachak Sea Plane Base"},
  {iata: "KKJ", airport: "Kokura Airport"},
  {iata: "KKM", airport: "Lop Buri Airport"},
  {iata: "KKN", airport: "Hoeybuktmoen Airport"},
  {iata: "KKO", airport: "Kaikohe Airport"},
  {iata: "KKP", airport: "Koolburra Airport"},
  {iata: "KKR", airport: "Kaukura Atoll Airport"},
  {iata: "KKT", airport: "Kentland Airport"},
  {iata: "KKU", airport: "Ekuk Airport"},
  {iata: "KKW", airport: "Kikwit Airport"},
  {iata: "KKX", airport: "Kikaiga Shima Airport"},
  {iata: "KKY", airport: "Kilkenny Airport"},
  {iata: "KKZ", airport: "Koh Kong Airport"},
  {iata: "KLB", airport: "Kalabo Airport"},
  {iata: "KLC", airport: "Kaolack Airport"},
  {iata: "KLD", airport: "Migalovo Airport"},
  {iata: "KLE", airport: "Kaele Airport"},
  {iata: "KLF", airport: "Kaluga Airport"},
  {iata: "KLG", airport: "Kalskag Municipal Airport"},
  {iata: "KLH", airport: "Kolhapur Airport"},
  {iata: "KLI", airport: "Kotakoli"},
  {iata: "KLI", airport: "Kota Koli Airport"},
  {iata: "KLJ", airport: "Klaipeda Airport"},
  {iata: "KLK", airport: "Kalokol Airport"},
  {iata: "KLL", airport: "Levelock Airport"},
  {iata: "KLM", airport: "Kalaleh Airport"},
  {iata: "KLN", airport: "Larsen Sea Plane Base"},
  {iata: "KLO", airport: "Kalibo Airport"},
  {iata: "KLQ", airport: "Keluang Airport"},
  {iata: "KLR", airport: "Kalmar Airport"},
  {iata: "KLS", airport: "Longview Airport"},
  {iata: "KLT", airport: "Kaiserslautern Airport"},
  {iata: "KLU", airport: "Klagenfurt Airport"},
  {iata: "KLV", airport: "Karlovy Vary Airport"},
  {iata: "KLW", airport: "Klawock Airport"},
  {iata: "KLX", airport: "Kalamata Airport"},
  {iata: "KLY", airport: "Kalima Airport"},
  {iata: "KLZ", airport: "Kleinzee Airport"},
  {iata: "KMA", airport: "Kerema Airport"},
  {iata: "KMB", airport: "Koinambe Airport"},
  {iata: "KMC", airport: "King Khalid Military City Airport"},
  {iata: "KMD", airport: "Mandji Airport"},
  {iata: "KME", airport: "Kamembe Airport"},
  {iata: "KMF", airport: "Kamina Airport"},
  {iata: "KMG", airport: "Kunming Airport"},
  {iata: "KMH", airport: "Kuruman Airport"},
  {iata: "KMI", airport: "Miyazaki Airport"},
  {iata: "KMJ", airport: "Kumamoto Airport"},
  {iata: "KMK", airport: "Makabana Airport"},
  {iata: "KML", airport: "Kamileroi Airport"},
  {iata: "KMM", airport: "Kiman Airport"},
  {iata: "KMN", airport: "Kamina Airport"},
  {iata: "KMO", airport: "Manokotak Sea Plane Base"},
  {iata: "KMP", airport: "J.G.H. Van Der Wath Airport"},
  {iata: "KMQ", airport: "Komatsu Airport"},
  {iata: "KMR", airport: "Karimui Airport"},
  {iata: "KMS", airport: "Kumasi Airport"},
  {iata: "KMT", airport: "Kampot Airport"},
  {iata: "KMU", airport: "Kismayu Airport"},
  {iata: "KMV", airport: "Kalemyo Airport"},
  {iata: "KMW", airport: "Kostroma Airport"},
  {iata: "KMX", airport: "Khamis Mushait Airport"},
  {iata: "KMY", airport: "Moser Bay Airport"},
  {iata: "KMZ", airport: "Kaoma Airport"},
  {iata: "KNA", airport: "Vina del Mar Airport"},
  {iata: "KNB", airport: "Kanab Airport"},
  {iata: "KND", airport: "Kindu Airport"},
  {iata: "KNE", airport: "Kanainj Airport"},
  {iata: "KNF", airport: "Marham Royal Air Force"},
  {iata: "KNG", airport: "Kaimana Airport"},
  {iata: "KNH", airport: "Shang-Yi Airport"},
  {iata: "KNI", airport: "Katanning Airport"},
  {iata: "KNJ", airport: "Kindamba Airport"},
  {iata: "KNK", airport: "Kakhonak Airport"},
  {iata: "KNL", airport: "Kelanoa Airport"},
  {iata: "KNM", airport: "Kaniama Airport"},
  {iata: "KNN", airport: "Kankan Airport"},
  {iata: "KNO", airport: "Knokke/Het Zoute Airport"},
  {iata: "KNQ", airport: "Kone Airport"},
  {iata: "KNR", airport: "Jam Airport"},
  {iata: "KNS", airport: "King Island Airport"},
  {iata: "KNT", airport: "Kennett Municipal Airport"},
  {iata: "KNU", airport: "Kanpur Airport"},
  {iata: "KNV", airport: "Knights Inlet Airport"},
  {iata: "KNW", airport: "New Stuyahok Airport"},
  {iata: "KNX", airport: "Kununurra Airport"},
  {iata: "KNY", airport: "Kinoosao Airport"},
  {iata: "KNZ", airport: "Kenieba Airport"},
  {iata: "KOA", airport: "Keahole Airport"},
  {iata: "KOB", airport: "Koutaba Airport"},
  {iata: "KOC", airport: "Koumac Airport"},
  {iata: "KOD", airport: "Kotabangun Airport"},
  {iata: "KOE", airport: "Eltari Airport"},
  {iata: "KOF", airport: "Komatipoort Airport"},
  {iata: "KOG", airport: "Khong Airport"},
  {iata: "KOH", airport: "Koolatah Airport"},
  {iata: "KOI", airport: "Kirkwall Airport"},
  {iata: "KOJ", airport: "Kagoshima Airport"},
  {iata: "KOK", airport: "Kruunupyy Airport"},
  {iata: "KOL", airport: "Koumala Airport"},
  {iata: "KOM", airport: "Komo Airport"},
  {iata: "KON", airport: "Kontum Airport"},
  {iata: "KOO", airport: "Kongolo Airport"},
  {iata: "KOP", airport: "Kamphaeng Saen"},
  {iata: "KOP", airport: "Nakhon Phanom Airport"},
  {iata: "KOQ", airport: "Koethen Airport"},
  {iata: "KOR", airport: "Kokoro Airport"},
  {iata: "KOS", airport: "Sihanoukville Airport"},
  {iata: "KOT", airport: "Kotlik Airport"},
  {iata: "KOU", airport: "Koulamoutou Airport"},
  {iata: "KOV", airport: "Kokshetau Airport"},
  {iata: "KOW", airport: "Ganzhou Airport"},
  {iata: "KOX", airport: "Kokonao Airport"},
  {iata: "KOY", airport: "Olga Bay Sea Plane Base"},
  {iata: "KOZ", airport: "Ouzinkie Sea Plane Base"},
  {iata: "KPA", airport: "Kopiago Airport"},
  {iata: "KPB", airport: "Point Baker Sea Plane Base"},
  {iata: "KPC", airport: "Port Clarence Airport"},
  {iata: "KPD", airport: "King Of Prussia Airport"},
  {iata: "KPE", airport: "Yapsei Airport"},
  {iata: "KPF", airport: "Kondubol Airport"},
  {iata: "KPG", airport: "Kurupung Airport"},
  {iata: "KPI", airport: "Kapit Airport"},
  {iata: "KPL", airport: "Kapal Airport"},
  {iata: "KPM", airport: "Kompiam Airport"},
  {iata: "KPN", airport: "Kipnuk Sea Plane Base"},
  {iata: "KPO", airport: "Pohang Airport"},
  {iata: "KPP", airport: "Kalpowar Airport"},
  {iata: "KPR", airport: "Port Williams Sea Plane Base"},
  {iata: "KPS", airport: "Kempsey Airport"},
  {iata: "KPT", airport: "Jackpot Airport"},
  {iata: "KPV", airport: "Perryville Sea Plane Base"},
  {iata: "KPY", airport: "Port Bailey Sea Plane Base"},
  {iata: "KQA", airport: "Akutan Airport"},
  {iata: "KQB", airport: "Koonibba Airport"},
  {iata: "KQL", airport: "Kol Airport"},
  {iata: "KRA", airport: "Kerang Airport"},
  {iata: "KRB", airport: "Karumba Airport"},
  {iata: "KRC", airport: "Kerinci Airport"},
  {iata: "KRD", airport: "Kurundi Airport"},
  {iata: "KRE", airport: "Kirundo Airport"},
  {iata: "KRF", airport: "Kramfors Airport"},
  {iata: "KRG", airport: "Karasabai Airport"},
  {iata: "KRH", airport: "Redhill"},
  {iata: "KRI", airport: "Kikori Airport"},
  {iata: "KRJ", airport: "Karawari Airport"},
  {iata: "KRK", airport: "J. Paul II Balice International Airport"},
  {iata: "KRL", airport: "Korla Airport"},
  {iata: "KRM", airport: "Karanambo Airport"},
  {iata: "KRN", airport: "Kiruna Airport"},
  {iata: "KRO", airport: "Kurgan Airport"},
  {iata: "KRP", airport: "Karup Airport"},
  {iata: "KRQ", airport: "Kramatorsk Airport"},
  {iata: "KRR", airport: "Krasnodar Airport"},
  {iata: "KRS", airport: "Kjevik Airport"},
  {iata: "KRT", airport: "Civil Airport"},
  {iata: "KRU", airport: "Kerau Airport"},
  {iata: "KRV", airport: "Kerio Valley Airport"},
  {iata: "KRW", airport: "Turkmanbashi Airport"},
  {iata: "KRX", airport: "Kar Kar Airport"},
  {iata: "KRY", airport: "Karamay Airport"},
  {iata: "KRZ", airport: "Kiri Airport"},
  {iata: "KSA", airport: "Kosrae Airport"},
  {iata: "KSB", airport: "Kasanombe Airport"},
  {iata: "KSC", airport: "Barca Airport"},
  {iata: "KSD", airport: "Karlstad Airport"},
  {iata: "KSE", airport: "Kasese Airport"},
  {iata: "KSF", airport: "Kassel-Calden Airport"},
  {iata: "KSG", airport: "Kisengan Airport"},
  {iata: "KSH", airport: "Kermanshah Airport"},
  {iata: "KSI", airport: "Kissidougou Airport"},
  {iata: "KSJ", airport: "Kasos Island Airport"},
  {iata: "KSK", airport: "Karlskoga Airport"},
  {iata: "KSL", airport: "Kassala Airport"},
  {iata: "KSN", airport: "Kostanay Airport"},
  {iata: "KSO", airport: "Aristoteles Airport"},
  {iata: "KSP", airport: "Kosipe Airport"},
  {iata: "KSQ", airport: "Karshi Airport"},
  {iata: "KSR", airport: "Sandy River Airpor"},
  {iata: "KSS", airport: "Sikasso Airport"},
  {iata: "KST", airport: "Kosti Airport"},
  {iata: "KSU", airport: "Kvernberget Airport"},
  {iata: "KSV", airport: "Springvale Airport"},
  {iata: "KSX", airport: "Yasuru Airport"},
  {iata: "KSY", airport: "Kars Airport"},
  {iata: "KSZ", airport: "Kotlas Airport"},
  {iata: "KTA", airport: "Karratha Airport"},
  {iata: "KTB", airport: "Thorne Bay Airport"},
  {iata: "KTD", airport: "Kitadaito Airport"},
  {iata: "KTE", airport: "Kerteh Airport"},
  {iata: "KTF", airport: "Takaka Airport"},
  {iata: "KTG", airport: "Ketapang Airport"},
  {iata: "KTI", airport: "Kratie Airport"},
  {iata: "KTK", airport: "Kanua Airport"},
  {iata: "KTL", airport: "Kitale Airport"},
  {iata: "KTM", airport: "Tribhuvan Airport"},
  {iata: "KTN", airport: "Ketchikan International Airport"},
  {iata: "KTO", airport: "Kato Airport"},
  {iata: "KTP", airport: "Tinson Airport"},
  {iata: "KTQ", airport: "Kitee Airport"},
  {iata: "KTR", airport: "Tindal Airport"},
  {iata: "KTS", airport: "Brevig Mission Airport"},
  {iata: "KTT", airport: "Kittila Airport"},
  {iata: "KTU", airport: "Kota Airport"},
  {iata: "KTV", airport: "Kamarata Airport"},
  {iata: "KTW", airport: "Pyrzowice Airport"},
  {iata: "KTX", airport: "Koutiala Airport"},
  {iata: "KUA", airport: "Kuantan Airport"},
  {iata: "KUC", airport: "Kuria Airport"},
  {iata: "KUD", airport: "Kudat Airport"},
  {iata: "KUF", airport: "Samara Airport"},
  {iata: "KUG", airport: "Kubin Island Airport"},
  {iata: "KUH", airport: "Kushiro Airport"},
  {iata: "KUI", airport: "Kawau Island Airport"},
  {iata: "KUJ", airport: "Kushimoto Airport"},
  {iata: "KUK", airport: "Kasigluk Airport"},
  {iata: "KUL", airport: "Lumpur International Airport"},
  {iata: "KUM", airport: "Yakushima Airport"},
  {iata: "KUN", airport: "Kaunas Airport"},
  {iata: "KUO", airport: "Kuopio Airport"},
  {iata: "KUP", airport: "Kupiano Airport"},
  {iata: "KUQ", airport: "Kuri Airport"},
  {iata: "KUR", airport: "Kuran-O-Munjan Airport"},
  {iata: "KUS", airport: "Kulusuk Airport"},
  {iata: "KUT", airport: "Kutaisi Airport"},
  {iata: "KUU", airport: "Bhuntar Airport"},
  {iata: "KUV", airport: "Gunsan Airport"},
  {iata: "KUX", airport: "Kuyol Airport"},
  {iata: "KUY", airport: "Kamusi Airport"},
  {iata: "KUZ", airport: "Gunsan Air Base"},
  {iata: "KVA", airport: "Megas Alexandros Airport"},
  {iata: "KVB", airport: "Skovde Airport"},
  {iata: "KVC", airport: "King Cove Airport"},
  {iata: "KVD", airport: "Gyandzha Airport"},
  {iata: "KVE", airport: "Kitava Airport"},
  {iata: "KVG", airport: "Kavieng Airport"},
  {iata: "KVK", airport: "Kirovsk Airport"},
  {iata: "KVL", airport: "Kivalina Airport"},
  {iata: "KVU", airport: "Korolevu Airport"},
  {iata: "KVX", airport: "Kirov Airport"},
  {iata: "KWA", airport: "Kwajalein Airport"},
  {iata: "KWB", airport: "Karimunjawa Airport"},
  {iata: "KWE", airport: "Guiyang Airport"},
  {iata: "KWF", airport: "Waterfall Sea Plane Base"},
  {iata: "KWG", airport: "Krivoy Rog Airport"},
  {iata: "KWH", airport: "Khwahan Airport"},
  {iata: "KWI", airport: "Kuwait International Airport"},
  {iata: "KWJ", airport: "Gwangju Airport"},
  {iata: "KWK", airport: "Kwigillingok Airport"},
  {iata: "KWL", airport: "Guilin Airport"},
  {iata: "KWM", airport: "Kowanyama Airport"},
  {iata: "KWN", airport: "Kwinhagak Airport"},
  {iata: "KWO", airport: "Kawito Airport"},
  {iata: "KWP", airport: "Village Sea Plane Base"},
  {iata: "KWT", airport: "Kwethluk Airport"},
  {iata: "KWV", airport: "Kurwina Airport"},
  {iata: "KWX", airport: "Kiwai Island Airport"},
  {iata: "KWY", airport: "Kiwayu Airport"},
  {iata: "KWZ", airport: "Kolwezi Airport"},
  {iata: "KXA", airport: "Kasaan Sea Plane Base"},
  {iata: "KXE", airport: "Klerksdorp Airport"},
  {iata: "KXF", airport: "Koro Airport"},
  {iata: "KXK", airport: "Komsomolsk Na Amure Airport"},
  {iata: "KXR", airport: "Karoola Airport"},
  {iata: "KXU", airport: "Katiu Airport"},
  {iata: "KYA", airport: "Konya Airport"},
  {iata: "KYD", airport: "Orchid Island Airport"},
  {iata: "KYE", airport: "Kleyate Airport"},
  {iata: "KYF", airport: "Yeelirrie Airport"},
  {iata: "KYI", airport: "Yalata Mission Airport"},
  {iata: "KYK", airport: "Karluk Airport"},
  {iata: "KYL", airport: "Port Largo Airport"},
  {iata: "KYN", airport: "Milton Keynes Airport"},
  {iata: "KYO", airport: "Topp of Tampa Airport"},
  {iata: "KYP", airport: "Kyaukpyu Airport"},
  {iata: "KYS", airport: "Kayes Airport"},
  {iata: "KYT", airport: "Kyauktaw Airport"},
  {iata: "KYU", airport: "Koyukuk Airport"},
  {iata: "KYX", airport: "Yalumet Airport"},
  {iata: "KYZ", airport: "Kyzyl Airport"},
  {iata: "KZB", airport: "Zachar Bay Sea Plane Base"},
  {iata: "KZC", airport: "Kompong-Chhna Airport"},
  {iata: "KZD", airport: "Krakor Airport"},
  {iata: "KZF", airport: "Kaintiba Airport"},
  {iata: "KZG", airport: "Kitzingen Airport"},
  {iata: "KZI", airport: "Philippos Airport"},
  {iata: "KZK", airport: "Kompong Thom Airport"},
  {iata: "KZN", airport: "Kazan Airport"},
  {iata: "KZO", airport: "Kzyl-Orda Airport"},
  {iata: "KZS", airport: "Kastelorizo Airport"},
  {iata: "LAA", airport: "Lamar Field"},
  {iata: "LAB", airport: "Lablab Airport"},
  {iata: "LAC", airport: "Layang-Layang Airstrip"},
  {iata: "LAD", airport: "4 de Fevereiro Airport"},
  {iata: "LAE", airport: "Nadzab Airport"},
  {iata: "LAF", airport: "Purdue University Airport"},
  {iata: "LAG", airport: "La Guaira Airport"},
  {iata: "LAH", airport: "Labuha Airport"},
  {iata: "LAI", airport: "Servel Airport"},
  {iata: "LAJ", airport: "Lages Airport"},
  {iata: "LAK", airport: "Aklavik Airport"},
  {iata: "LAL", airport: "Lakeland Municipal Airport"},
  {iata: "LAM", airport: "Los Alamos Airport"},
  {iata: "LAN", airport: "Capital City Airport"},
  {iata: "LAO", airport: "Laoag Airport"},
  {iata: "LAP", airport: "Leon Airport"},
  {iata: "LAQ", airport: "La Braq Airport"},
  {iata: "LAR", airport: "General Brees Field"},
  {iata: "LAS", airport: "McCarran Airport "},
  {iata: "LAU", airport: "Lamu Airport"},
  {iata: "LAW", airport: "Lawton Municipal Airport"},
  {iata: "LAX", airport: "Los Angeles International Airport"},
  {iata: "LAY", airport: "Ladysmith Airport"},
  {iata: "LAZ", airport: "Bom Jesus Da Lapa Airport"},
  {iata: "LBA", airport: "Leeds/Bradford Airport"},
  {iata: "LBB", airport: "Lubbock International Airport"},
  {iata: "LBC", airport: "Blankensee Airport"},
  {iata: "LBD", airport: "Khudzhand Airport"},
  {iata: "LBE", airport: "Westmoreland County Airport"},
  {iata: "LBF", airport: "Lee Bird Field"},
  {iata: "LBG", airport: "Le Bourget Airport"},
  {iata: "LBH", airport: "Palm Beach Sea Plane Base"},
  {iata: "LBI", airport: "Le Sequestre Airport"},
  {iata: "LBJ", airport: "Mutiara Airport"},
  {iata: "LBK", airport: "Liboi Airport"},
  {iata: "LBL", airport: "Liberal Municipal Airport"},
  {iata: "LBM", airport: "Luabo Airport"},
  {iata: "LBN", airport: "Lake Baringo Airport"},
  {iata: "LBO", airport: "Lusambo Airport"},
  {iata: "LBP", airport: "Long Banga Airfield"},
  {iata: "LBQ", airport: "Lambarene Airport"},
  {iata: "LBR", airport: "Labrea Airport"},
  {iata: "LBS", airport: "Labasa Airport"},
  {iata: "LBT", airport: "Lumberton Airport"},
  {iata: "LBU", airport: "Labuan Airport"},
  {iata: "LBV", airport: "Libreville Airport"},
  {iata: "LBW", airport: "Long Bawan Airport"},
  {iata: "LBX", airport: "Lubang Airport"},
  {iata: "LBY", airport: "Montoir Airport"},
  {iata: "LCA", airport: "Larnaca Airport"},
  {iata: "LCB", airport: "Pontes-e-Lacerda Airport"},
  {iata: "LCC", airport: "Galatina Airport"},
  {iata: "LCD", airport: "Louis Trichardt Airport"},
  {iata: "LCE", airport: "Goloson International Airport"},
  {iata: "LCF", airport: "Las Vegas Airport"},
  {iata: "LCG", airport: "La Coruna Airport"},
  {iata: "LCH", airport: "Lake Charles Municipal Airport"},
  {iata: "LCI", airport: "Laconia Municipal Airport"},
  {iata: "LCJ", airport: "Lodz Lublinek Airport"},
  {iata: "LCK", airport: "Rickenbacker Airport"},
  {iata: "LCL", airport: "La Coloma Airport"},
  {iata: "LCM", airport: "La Cumbre Airport"},
  {iata: "LCN", airport: "Balcanoona Airport"},
  {iata: "LCO", airport: "Lague Airport"},
  {iata: "LCP", airport: "Loncopue Airport"},
  {iata: "LCR", airport: "La Chorrera Airport"},
  {iata: "LCS", airport: "Las Canas Airport"},
  {iata: "LCV", airport: "Lucca Airport"},
  {iata: "LCX", airport: "Liancheng Airport"},
  {iata: "LCY", airport: "London City Airport"},
  {iata: "LDA", airport: "Malda Airport"},
  {iata: "LDB", airport: "Londrina Airport"},
  {iata: "LDC", airport: "Lindeman Island Airport"},
  {iata: "LDE", airport: "Tarbes Ossun Lourdes Airport"},
  {iata: "LDG", airport: "Leshukonskoye Airport"},
  {iata: "LDH", airport: "Lord Howe Island Airport"},
  {iata: "LDI", airport: "Kikwetu Airport"},
  {iata: "LDJ", airport: "Linden Airport"},
  {iata: "LDK", airport: "Hovby Airport"},
  {iata: "LDM", airport: "Mason Co"},
  {iata: "LDN", airport: "Lamidanda Airport"},
  {iata: "LDO", airport: "Ladouanie Airport"},
  {iata: "LDR", airport: "Lodar Airport"},
  {iata: "LDU", airport: "Lahad Datu Airport"},
  {iata: "LDV", airport: "Landivisiau Airport"},
  {iata: "LDW", airport: "Lansdowne Airport"},
  {iata: "LDX", airport: "Saint Laurent du Maroni Airport"},
  {iata: "LDY", airport: "Eglinton Airport"},
  {iata: "LDZ", airport: "Londolozi Airport"},
  {iata: "LEA", airport: "Learmonth Airport"},
  {iata: "LEB", airport: "Lebanon Regional Airport"},
  {iata: "LEC", airport: "Chapada Diamantina Airport"},
  {iata: "LED", airport: "Pulkovo Airport"},
  {iata: "LEE", airport: "Leesburg Airport"},
  {iata: "LEF", airport: "Lebakeng Airport"},
  {iata: "LEG", airport: "Aleg Airport"},
  {iata: "LEH", airport: "Octeville Airport"},
  {iata: "LEI", airport: "Almeria Airport"},
  {iata: "LEJ", airport: "Leipzig/Halle Airport"},
  {iata: "LEK", airport: "Labe Airport"},
  {iata: "LEL", airport: "Lake Evella Airport"},
  {iata: "LEM", airport: "Lemmon Airport"},
  {iata: "LEN", airport: "Leon Airport"},
  {iata: "LEO", airport: "Leconi Airport"},
  {iata: "LEP", airport: "Leopoldina Airport"},
  {iata: "LEQ", airport: "Lands End Airport"},
  {iata: "LER", airport: "Leinster Airport"},
  {iata: "LES", airport: "Lesobeng Airport"},
  {iata: "LET", airport: "Gen. A.V. Cobo Airport"},
  {iata: "LEU", airport: "Aeroport De La Seu"},
  {iata: "LEV", airport: "Levuka Airfield"},
  {iata: "LEW", airport: "Auburn Airport"},
  {iata: "LEX", airport: "Blue Grass Airport"},
  {iata: "LEY", airport: "Lelystad Airport"},
  {iata: "LEZ", airport: "La Esperanza Airport"},
  {iata: "LFB", airport: "Lumbo Airport"},
  {iata: "LFI", airport: "Langley Air Force Base"},
  {iata: "LFK", airport: "Lufkin Angelina County Airport"},
  {iata: "LFM", airport: "Lamerd Airport"},
  {iata: "LFN", airport: "Franklin Airport"},
  {iata: "LFO", airport: "Kelafo Airport"},
  {iata: "LFP", airport: "Lakefield Airport"},
  {iata: "LFR", airport: "La Fria Airport"},
  {iata: "LFT", airport: "Lafayette Regional Airport"},
  {iata: "LFW", airport: "Lome Airport"},
  {iata: "LGA", airport: "La Guardia Airport"},
  {iata: "LGB", airport: "Long Beach Municipal Airport"},
  {iata: "LGC", airport: "Calloway Airport"},
  {iata: "LGD", airport: "La Grande Airport"},
  {iata: "LGE", airport: "Lake Gregory Airport"},
  {iata: "LGF", airport: "Laguna Army Air Field"},
  {iata: "LGG", airport: "Bierset Airport"},
  {iata: "LGH", airport: "Leigh Creek Airport"},
  {iata: "LGI", airport: "Deadmans Cay Airport"},
  {iata: "LGK", airport: "Langkawi Airport"},
  {iata: "LGL", airport: "Long Lellang Airport"},
  {iata: "LGM", airport: "Laiagam Airport"},
  {iata: "LGN", airport: "Linga Linga Airport"},
  {iata: "LGO", airport: "Langeoog Airport"},
  {iata: "LGP", airport: "Legaspi Airport"},
  {iata: "LGQ", airport: "Lago Agrio Airport"},
  {iata: "LGR", airport: "Cochrane Airport"},
  {iata: "LGS", airport: "Malargue Airport"},
  {iata: "LGT", airport: "Las Gaviotas Airport"},
  {iata: "LGU", airport: "Cache Airport"},
  {iata: "LGW", airport: "Gatwick Airport"},
  {iata: "LGX", airport: "Lugh Ganane Airport"},
  {iata: "LGY", airport: "Lagunillas Airport"},
  {iata: "LHA", airport: "Lahr Airport"},
  {iata: "LHE", airport: "Lahore Airport"},
  {iata: "LHG", airport: "Lightning Ridge Airport"},
  {iata: "LHI", airport: "Lereh Airport"},
  {iata: "LHK", airport: "Guanghua Airport"},
  {iata: "LHN", airport: "Lishan Airport"},
  {iata: "LHP", airport: "Lehu Airport"},
  {iata: "LHR", airport: "Heathrow Airport"},
  {iata: "LHS", airport: "Las Heras Airport"},
  {iata: "LHU", airport: "Lianshulu Airport"},
  {iata: "LHV", airport: "W T Piper Memorial Airport"},
  {iata: "LHW", airport: "Lanzhou Airport"},
  {iata: "LIA", airport: "Liangping Airport"},
  {iata: "LIB", airport: "Limbunya Airport"},
  {iata: "LIC", airport: "Limon Municipal Airport"},
  {iata: "LID", airport: "Valkenburg Airport"},
  {iata: "LIE", airport: "Libenge Airport"},
  {iata: "LIF", airport: "Lifou Airport"},
  {iata: "LIG", airport: "Bellegarde Airport"},
  {iata: "LIH", airport: "Kauai Island Airport"},
  {iata: "LII", airport: "Mulia Airport"},
  {iata: "LIK", airport: "Likiep Airport"},
  {iata: "LIL", airport: "Lesquin Airport"},
  {iata: "LIM", airport: "J Chavez International Airport"},
  {iata: "LIN", airport: "Linate Airport"},
  {iata: "LIO", airport: "Limon Airport"},
  {iata: "LIP", airport: "Lins Airport"},
  {iata: "LIQ", airport: "Lisala Airport"},
  {iata: "LIR", airport: "Liberia Airport"},
  {iata: "LIS", airport: "Airport"},
  {iata: "LIT", airport: "Little Rock Regional Airport"},
  {iata: "LIU", airport: "Linosa Heliport"},
  {iata: "LIW", airport: "Loikaw Airport"},
  {iata: "LIX", airport: "Likoma Airport"},
  {iata: "LIY", airport: "Wright Army Air Field"},
  {iata: "LIZ", airport: "Loring Air Force Base"},
  {iata: "LJA", airport: "Lodja Airport"},
  {iata: "LJC", airport: "Intercontinental Airport"},
  {iata: "LJG", airport: "Lijiang Airport"},
  {iata: "LJN", airport: "Brazoria County Airport"},
  {iata: "LJU", airport: "Brnik Airport"},
  {iata: "LKA", airport: "Larantuka Airport"},
  {iata: "LKB", airport: "Lakeba Airport"},
  {iata: "LKC", airport: "Lekana Airport"},
  {iata: "LKD", airport: "Lakeland Downs Airport"},
  {iata: "LKE", airport: "Lake Union Sea Plane Base"},
  {iata: "LKG", airport: "Lokichoggio Airport"},
  {iata: "LKH", airport: "Long Akah Airport"},
  {iata: "LKI", airport: "Lakeside United States Air Force"},
  {iata: "LKL", airport: "Banak Airport"},
  {iata: "LKN", airport: "Leknes Airport"},
  {iata: "LKO", airport: "Amausi Airport"},
  {iata: "LKP", airport: "Lake Placid Airport"},
  {iata: "LKR", airport: "Las Khoreh Airport"},
  {iata: "LKS", airport: "Lakeside Airport"},
  {iata: "LKU", airport: "Lake Rudolf Airport"},
  {iata: "LKV", airport: "Lake County Airport"},
  {iata: "LKY", airport: "Lake Manyara Airport"},
  {iata: "LKZ", airport: "Lakenheath RAF"},
  {iata: "LLA", airport: "Kallax Airport"},
  {iata: "LLE", airport: "Malelane Airport"},
  {iata: "LLF", airport: "Ling Ling Airport"},
  {iata: "LLG", airport: "Chillagoe Airport"},
  {iata: "LLH", airport: "Las Limas Airport"},
  {iata: "LLI", airport: "Lalibela Airport"},
  {iata: "LLL", airport: "Lissadell Airport"},
  {iata: "LLM", airport: "Long Lama Airport"},
  {iata: "LLN", airport: "Kelila Airport"},
  {iata: "LLP", airport: "Linda Downs Airport"},
  {iata: "LLS", airport: "Las Lomitas Airport"},
  {iata: "LLU", airport: "Alluitsup Paa Airport"},
  {iata: "LLW", airport: "Lilongwe International Airport"},
  {iata: "LLX", airport: "Lyndonville Airport"},
  {iata: "LLY", airport: "Burlington County Airport"},
  {iata: "LMA", airport: "Lake Minchumina Airport"},
  {iata: "LMB", airport: "Salima Airport"},
  {iata: "LMC", airport: "Lamacarena Airport"},
  {iata: "LMD", airport: "Los Menucos Airport"},
  {iata: "LME", airport: "Arnage Airport"},
  {iata: "LMG", airport: "Lamassa Airport"},
  {iata: "LMH", airport: "Limon Airport"},
  {iata: "LMI", airport: "Lumi Airport"},
  {iata: "LML", airport: "Lae Airport"},
  {iata: "LMM", airport: "Federal Airport"},
  {iata: "LMN", airport: "Limbang Airport"},
  {iata: "LMO", airport: "Royal Air Force Station"},
  {iata: "LMP", airport: "Lampedusa Airport"},
  {iata: "LMQ", airport: "Marsa el Brega Airport"},
  {iata: "LMR", airport: "Lima Acres Airport"},
  {iata: "LMS", airport: "Winston County Airport"},
  {iata: "LMT", airport: "Kingsley Field"},
  {iata: "LMX", airport: "Lopez De Micay Airport"},
  {iata: "LMY", airport: "Lake Murray Airport"},
  {iata: "LMZ", airport: "Palma Airport"},
  {iata: "LNA", airport: "Palm Beach County Airport"},
  {iata: "LNB", airport: "Lamen Bay Airport"},
  {iata: "LNC", airport: "Lengbati Airport"},
  {iata: "LND", airport: "Hunt Field"},
  {iata: "LNE", airport: "Lonorore Airport"},
  {iata: "LNF", airport: "Munbil Airport"},
  {iata: "LNG", airport: "Lese Airport"},
  {iata: "LNH", airport: "Lake Nash Airport"},
  {iata: "LNJ", airport: "Lincang Airport"},
  {iata: "LNK", airport: "Lincoln Municipal Airport"},
  {iata: "LNM", airport: "Langimar Airport"},
  {iata: "LNN", airport: "Lost Nation Airport"},
  {iata: "LNO", airport: "Leonora Airport"},
  {iata: "LNP", airport: "Wise Airport"},
  {iata: "LNQ", airport: "Loani Airport"},
  {iata: "LNR", airport: "Tri County Airport"},
  {iata: "LNS", airport: "Lancaster Airport"},
  {iata: "LNV", airport: "Lihir Island Airport"},
  {iata: "LNX", airport: "Smolensk Airport"},
  {iata: "LNY", airport: "Lanai Airport"},
  {iata: "LNZ", airport: "Hoersching Airport"},
  {iata: "LOA", airport: "Lorraine Airport"},
  {iata: "LOB", airport: "Los Andes Airport"},
  {iata: "LOC", airport: "Lock Airport"},
  {iata: "LOD", airport: "Longana Airport"},
  {iata: "LOE", airport: "Loei Airport"},
  {iata: "LOF", airport: "Loen Airport"},
  {iata: "LOG", airport: "Longview Airport"},
  {iata: "LOH", airport: "Loja Airport"},
  {iata: "LOI", airport: "Helmuth Baungartem Airport"},
  {iata: "LOK", airport: "Lodwar Airport"},
  {iata: "LOL", airport: "Derby Field"},
  {iata: "LOM", airport: "Francisco P. V. y R. Airport"},
  {iata: "LON", airport: "London Airports"},
  {iata: "LOQ", airport: "Lobatse Airport"},
  {iata: "LOR", airport: "Lowe Army Heliport"},
  {iata: "LOS", airport: "Murtala Muhammed Airport"},
  {iata: "LOT", airport: "Lewis Lockport Airport"},
  {iata: "LOU", airport: "Bowman Field"},
  {iata: "LOV", airport: "Monclova Airport"},
  {iata: "LOW", airport: "Louisa Airport"},
  {iata: "LOY", airport: "Loyangalani Airport"},
  {iata: "LOZ", airport: "Corbin-London Airport"},
  {iata: "LPA", airport: "Airport De Gran Canaria"},
  {iata: "LPB", airport: "El Alto Airport"},
  {iata: "LPC", airport: "Lompoc Airport"},
  {iata: "LPD", airport: "La Pedrera Airport"},
  {iata: "LPE", airport: "La Primavera Airport"},
  {iata: "LPG", airport: "La Plata Airport"},
  {iata: "LPH", airport: "Lochgilphead Heliport"},
  {iata: "LPI", airport: "Linkoping Airport"},
  {iata: "LPJ", airport: "Pijiguaos Airport"},
  {iata: "LPK", airport: "Lipetsk Airport"},
  {iata: "LPL", airport: "Liverpool John Lennon Airport"},
  {iata: "LPM", airport: "Lamap Airport"},
  {iata: "LPO", airport: "Laporte Municipal Airport"},
  {iata: "LPP", airport: "Lappeenranta Airport"},
  {iata: "LPQ", airport: "Luang Prabang Airport"},
  {iata: "LPS", airport: "Lopez Island Airport"},
  {iata: "LPT", airport: "Lampang Airport"},
  {iata: "LPU", airport: "Long Apung Airport"},
  {iata: "LPX", airport: "Liepaya Airport"},
  {iata: "LPY", airport: "Loudes Airport"},
  {iata: "LQK", airport: "Pickens Airport"},
  {iata: "LQM", airport: "Puerto Leguizamo Airport"},
  {iata: "LQN", airport: "Qala Nau Airport"},
  {iata: "LRA", airport: "Larisa Airport"},
  {iata: "LRB", airport: "Leribe Airport"},
  {iata: "LRC", airport: "Laarbruch R.A.F. Airport"},
  {iata: "LRD", airport: "Laredo International Airport"},
  {iata: "LRE", airport: "Longreach Airport"},
  {iata: "LRF", airport: "Little Rock Air Force Base"},
  {iata: "LRG", airport: "Lora Lai Airport"},
  {iata: "LRH", airport: "Laleu Airport"},
  {iata: "LRI", airport: "Lorica Airport"},
  {iata: "LRJ", airport: "Lemars Municipal Airport"},
  {iata: "LRL", airport: "Niamtougou Airport"},
  {iata: "LRM", airport: "La Romana Airport"},
  {iata: "LRN", airport: "Larson Air Force Base"},
  {iata: "LRO", airport: "Sharpe Army Air Field"},
  {iata: "LRQ", airport: "Laurie River Airport"},
  {iata: "LRR", airport: "Lar Airport"},
  {iata: "LRS", airport: "Leros Airport"},
  {iata: "LRT", airport: "Lann Bihoue Airport"},
  {iata: "LRU", airport: "Las Cruces Municipal Airport"},
  {iata: "LRV", airport: "Los Roques Airport"},
  {iata: "LSA", airport: "Losuia Airport"},
  {iata: "LSB", airport: "Lordsburg Airport"},
  {iata: "LSC", airport: "La Florida Airport"},
  {iata: "LSE", airport: "La Crosse Municipal Airport"},
  {iata: "LSF", airport: "Lawson Army Air Field"},
  {iata: "LSH", airport: "Lashio Airport"},
  {iata: "LSI", airport: "Sumburgh Airport"},
  {iata: "LSJ", airport: "Long Island Airport"},
  {iata: "LSK", airport: "Lusk Municipal"},
  {iata: "LSL", airport: "Los Chiles Airport"},
  {iata: "LSM", airport: "Lawas Airport"},
  {iata: "LSN", airport: "Los Banos Airport"},
  {iata: "LSO", airport: "Talmont Airport"},
  {iata: "LSP", airport: "Josefa Camejo Airport"},
  {iata: "LSS", airport: "Terre-de-Haut Airport"},
  {iata: "LST", airport: "Launceston Airport"},
  {iata: "LSU", airport: "Long Sukang Airport"},
  {iata: "LSV", airport: "Nellis Air Force Base"},
  {iata: "LSW", airport: "Lhoksumawe Airport"},
  {iata: "LSX", airport: "Lhok Sukon Airport"},
  {iata: "LSY", airport: "Lismore Airport"},
  {iata: "LSZ", airport: "Losinj Airport"},
  {iata: "LTA", airport: "Letaba Airport"},
  {iata: "LTB", airport: "Latrobe Airport"},
  {iata: "LTC", airport: "Lai Airport"},
  {iata: "LTD", airport: "Ghadames Airport"},
  {iata: "LTF", airport: "Leitre Airport"},
  {iata: "LTG", airport: "Langtang Airport"},
  {iata: "LTH", airport: "Lathrop Wells Airport"},
  {iata: "LTI", airport: "Altai Airport"},
  {iata: "LTK", airport: "Latakia Airport"},
  {iata: "LTL", airport: "Lastourville Airport"},
  {iata: "LTM", airport: "Lethem Airport"},
  {iata: "LTN", airport: "Luton Airport"},
  {iata: "LTO", airport: "Loreto Airport"},
  {iata: "LTP", airport: "Lyndhurst Airport"},
  {iata: "LTQ", airport: "Le Touquet Airport"},
  {iata: "LTR", airport: "Letterkenny Airport"},
  {iata: "LTS", airport: "Altus Air Force Base"},
  {iata: "LTT", airport: "La Mole Airport"},
  {iata: "LTV", airport: "Lotusvale Airport"},
  {iata: "LTW", airport: "Saint Marys County Airport"},
  {iata: "LTX", airport: "Cotapaxi International Airport"},
  {iata: "LUA", airport: "Lukla Airport"},
  {iata: "LUB", airport: "Lumid Pau Airport"},
  {iata: "LUC", airport: "Laucala Island Airport"},
  {iata: "LUD", airport: "Luderitz Airport"},
  {iata: "LUF", airport: "Luke Air Force Base"},
  {iata: "LUG", airport: "Lugano Airport"},
  {iata: "LUH", airport: "Ludhiana Airport"},
  {iata: "LUI", airport: "La Union Airport"},
  {iata: "LUJ", airport: "Lusikisiki Airport"},
  {iata: "LUK", airport: "Cincinnati Municipal Airport"},
  {iata: "LUL", airport: "Hesler-Noble Field"},
  {iata: "LUM", airport: "Mangshi Airport"},
  {iata: "LUN", airport: "Lusaka Airport"},
  {iata: "LUO", airport: "Luena Airport"},
  {iata: "LUP", airport: "Kalaupapa Airport"},
  {iata: "LUQ", airport: "San Luis Airport"},
  {iata: "LUR", airport: "Cape Lisburne Airport"},
  {iata: "LUS", airport: "Lusanga Airport"},
  {iata: "LUT", airport: "Laura Station Airport"},
  {iata: "LUU", airport: "Laura Airport"},
  {iata: "LUV", airport: "Langgur Airport"},
  {iata: "LUW", airport: "Luwuk Airport"},
  {iata: "LUX", airport: "Luxembourg Airport"},
  {iata: "LUY", airport: "Lushoto Airport"},
  {iata: "LUZ", airport: "Lushan Airport"},
  {iata: "LVA", airport: "Entrammes Airport"},
  {iata: "LVB", airport: "Livramento Do Brumado"},
  {iata: "LVB", airport: "Dos Galpoes Airport"},
  {iata: "LVD", airport: "Lime Village Airport"},
  {iata: "LVI", airport: "Livingstone Airport"},
  {iata: "LVK", airport: "Livermore Airport"},
  {iata: "LVL", airport: "Lawrenceville Airport"},
  {iata: "LVM", airport: "Mission Field"},
  {iata: "LVO", airport: "Laverton Airport"},
  {iata: "LVP", airport: "Lavan Island Airport"},
  {iata: "LVS", airport: "Las Vegas Airport"},
  {iata: "LWA", airport: "Lwbak Airport"},
  {iata: "LWB", airport: "Greenbrier Valley Airport"},
  {iata: "LWC", airport: "Lawrence Airport"},
  {iata: "LWE", airport: "Lewoleba Airport"},
  {iata: "LWH", airport: "Lawn Hill Airport"},
  {iata: "LWI", airport: "Lowai Airport"},
  {iata: "LWK", airport: "Lerwick/Tingwall Airport"},
  {iata: "LWL", airport: "Harriet Field"},
  {iata: "LWM", airport: "Lawrence Airport"},
  {iata: "LWN", airport: "Leninakan Airport"},
  {iata: "LWO", airport: "Snilow Airport"},
  {iata: "LWR", airport: "Leeuwarden Airport"},
  {iata: "LWS", airport: "Nez Perce County Regional Airport"},
  {iata: "LWT", airport: "Lewistown Municipal Airport"},
  {iata: "LWV", airport: "Lawrenceville Municipal Airport"},
  {iata: "LWY", airport: "Lawas Airport"},
  {iata: "LXA", airport: "Lhasa Airport"},
  {iata: "LXG", airport: "Luang Namtha Airport"},
  {iata: "LXI", airport: "Linxi Airport"},
  {iata: "LXN", airport: "Lexington Airport"},
  {iata: "LXR", airport: "Luxor Airport"},
  {iata: "LXS", airport: "Limnos Airport"},
  {iata: "LXU", airport: "Lukulu Airport"},
  {iata: "LXV", airport: "Leadville Airport"},
  {iata: "LYA", airport: "Luoyang Airport"},
  {iata: "LYB", airport: "Little Cayman Airport"},
  {iata: "LYC", airport: "Lycksele Airport"},
  {iata: "LYE", airport: "Royal Air Force Station"},
  {iata: "LYG", airport: "Lianyungang Airport"},
  {iata: "LYH", airport: "Preston-Glenn Field"},
  {iata: "LYI", airport: "Linyi Airport"},
  {iata: "LYK", airport: "Lunyuk Airport"},
  {iata: "LYN", airport: "Bron Airport"},
  {iata: "LYO", airport: "Rice County Municipal Airport"},
  {iata: "LYP", airport: "Faisalabad Airport"},
  {iata: "LYR", airport: "Svalbard Airport"},
  {iata: "LYS", airport: "Lyon Saint-Exupery International Airport"},
  {iata: "LYT", airport: "Lady Elliot Island Airport"},
  {iata: "LYU", airport: "Ely Airport"},
  {iata: "LYX", airport: "Lydd International Airport"},
  {iata: "LZA", airport: "Luiza Airport"},
  {iata: "LZC", airport: "Lazaro Cardenas Airport"},
  {iata: "LZD", airport: "Lanzhoudong Airport"},
  {iata: "LZH", airport: "Liuzhou Airport"},
  {iata: "LZI", airport: "Luozi Airport"},
  {iata: "LZN", airport: "Nangan Airport (Matsu Islands)"},
  {iata: "LZO", airport: "Luzhou Airport"},
  {iata: "LZR", airport: "Lizard Island Airport"},
  {iata: "MAA", airport: "Chennai Airport"},
  {iata: "MAB", airport: "Maraba Airport"},
  {iata: "MAC", airport: "Smart Airport"},
  {iata: "MAD", airport: "Barajas Airport"},
  {iata: "MAE", airport: "Madera Airport"},
  {iata: "MAF", airport: "Midland International Airport"},
  {iata: "MAG", airport: "Madang Airport"},
  {iata: "MAH", airport: "Mahon Airport"},
  {iata: "MAI", airport: "Mangochi Airport"},
  {iata: "MAJ", airport: "Amata Kabua International Airport"},
  {iata: "MAK", airport: "Malakal Airport"},
  {iata: "MAL", airport: "Mangole Airport"},
  {iata: "MAM", airport: "Matamoros Airport"},
  {iata: "MAN", airport: "Manchester International Airport"},
  {iata: "MAO", airport: "Eduardo Gomes International Airport"},
  {iata: "MAP", airport: "Mamai Airport"},
  {iata: "MAQ", airport: "Mae Sot Airport"},
  {iata: "MAR", airport: "La Chinita Airport"},
  {iata: "MAS", airport: "Momote Airport"},
  {iata: "MAT", airport: "Matadi Airport"},
  {iata: "MAU", airport: "Maupiti Airport"},
  {iata: "MAV", airport: "Maloelap Airport"},
  {iata: "MAW", airport: "Malden Airport"},
  {iata: "MAX", airport: "Matam Airport"},
  {iata: "MAY", airport: "Mangrove Cay Airport"},
  {iata: "MAZ", airport: "Eugenio M. De Hostos Airport"},
  {iata: "MBA", airport: "Moi International Airport"},
  {iata: "MBB", airport: "Marble Bar Airport"},
  {iata: "MBC", airport: "Mbigou Airport"},
  {iata: "MBD", airport: "Mmabatho International Airport"},
  {iata: "MBE", airport: "Monbetsu Airport"},
  {iata: "MBF", airport: "Mount Buffalo Airport"},
  {iata: "MBG", airport: "Mobridge Airport"},
  {iata: "MBH", airport: "Maryborough Airport"},
  {iata: "MBI", airport: "Mbeya Airport"},
  {iata: "MBJ", airport: "Sangster International Airport"},
  {iata: "MBK", airport: "Matupa Airport"},
  {iata: "MBL", airport: "Blacker Airport"},
  {iata: "MBM", airport: "Mkambati Airport"},
  {iata: "MBN", airport: "Mt. Barnett Airport"},
  {iata: "MBO", airport: "Mamburao Airport"},
  {iata: "MBP", airport: "Moyobamba Airport"},
  {iata: "MBQ", airport: "Mbarara Airport"},
  {iata: "MBR", airport: "Mbout Airport"},
  {iata: "MBS", airport: "Tri City Airport"},
  {iata: "MBT", airport: "Masbate Airport"},
  {iata: "MBU", airport: "Mbambanakira Airport"},
  {iata: "MBV", airport: "Masa Airport"},
  {iata: "MBW", airport: "Moorabbin Airport"},
  {iata: "MBX", airport: "Maribor Airport"},
  {iata: "MBY", airport: "Moberly Airport"},
  {iata: "MBZ", airport: "Maues Airport"},
  {iata: "MCA", airport: "Macenta Airport"},
  {iata: "MCB", airport: "Pike County Airport"},
  {iata: "MCC", airport: "McClellan Air Force Base"},
  {iata: "MCD", airport: "Mackinac Island Airport"},
  {iata: "MCE", airport: "Merced Municipal Airport"},
  {iata: "MCF", airport: "Mac Dill Air Force Base"},
  {iata: "MCG", airport: "Mc Grath Airport"},
  {iata: "MCH", airport: "Machala Airport"},
  {iata: "MCI", airport: "Kansas City International Airport"},
  {iata: "MCJ", airport: "Maicao Airport"},
  {iata: "MCK", airport: "Mc Cook Airport"},
  {iata: "MCM", airport: "Monte Carlo Heliport"},
  {iata: "MCN", airport: "Lewis B. Wilson Airport"},
  {iata: "MCO", airport: "Orlando International Airport"},
  {iata: "MCP", airport: "Macapa Internacional Airport"},
  {iata: "MCQ", airport: "Miskolc Airport"},
  {iata: "MCR", airport: "Melchor De Menco Airport"},
  {iata: "MCS", airport: "Monte Caseros Airport"},
  {iata: "MCT", airport: "Seeb Airport"},
  {iata: "MCU", airport: "Gueret (Lepaud) Airport"},
  {iata: "MCV", airport: "Mcarthur River Airport"},
  {iata: "MCW", airport: "Mason City Airport"},
  {iata: "MCX", airport: "Makhachkala Airport"},
  {iata: "MCY", airport: "Maroochydore Airport"},
  {iata: "MCZ", airport: "Palmares Airport"},
  {iata: "MDA", airport: "Martindale Army Air Field"},
  {iata: "MDB", airport: "Melinda Airport"},
  {iata: "MDC", airport: "Samratulangi Airport"},
  {iata: "MDD", airport: "Midland Airpark"},
  {iata: "MDE", airport: "Jose Maria Cordova"},
  {iata: "MDF", airport: "Mooreland Municipal"},
  {iata: "MDF", airport: "Medford Airport"},
  {iata: "MDG", airport: "Mudanjiang Airport"},
  {iata: "MDH", airport: "Southern Illinois Airport"},
  {iata: "MDI", airport: "Makurdi Airport"},
  {iata: "MDJ", airport: "Madras City-County Airport"},
  {iata: "MDK", airport: "Mbandaka Airport"},
  {iata: "MDL", airport: "Annisaton Airport"},
  {iata: "MDM", airport: "Munduku Airport"},
  {iata: "MDN", airport: "Jefferson Proving Ground"},
  {iata: "MDP", airport: "Mindiptana Airport"},
  {iata: "MDQ", airport: "Mar Del Plata Airport"},
  {iata: "MDS", airport: "Middle Caicos Airport"},
  {iata: "MDT", airport: "Harrisburg International Airport"},
  {iata: "MDU", airport: "Mendi Airport"},
  {iata: "MDV", airport: "Medouneu Airport"},
  {iata: "MDW", airport: "Midway Airport"},
  {iata: "MDX", airport: "Mercedes Airport"},
  {iata: "MDY", airport: "Sand Island Field"},
  {iata: "MDZ", airport: "El Plumerillo Airport"},
  {iata: "MEA", airport: "Macae Airport"},
  {iata: "MEB", airport: "Essendon Airport"},
  {iata: "MEC", airport: "Manta Airport"},
  {iata: "MED", airport: "Mohammad Bin Abdulaziz Airport"},
  {iata: "MEE", airport: "Mare Airport"},
  {iata: "MEF", airport: "Melfi Airport"},
  {iata: "MEG", airport: "Malange Airport"},
  {iata: "MEH", airport: "Mehamn Airport"},
  {iata: "MEI", airport: "Key Field"},
  {iata: "MEJ", airport: "Meadville Airport"},
  {iata: "MEK", airport: "Meknes Airport"},
  {iata: "MEL", airport: "Tullamarine Airport"},
  {iata: "MEM", airport: "Memphis International Airport"},
  {iata: "MEN", airport: "Brenoux Airport"},
  {iata: "MEO", airport: "Dare County Regional Airport"},
  {iata: "MEP", airport: "Mersing Airport"},
  {iata: "MEQ", airport: "Seunagan Airport"},
  {iata: "MER", airport: "Castle Air Force Base"},
  {iata: "MES", airport: "Polania Airport"},
  {iata: "MET", airport: "Moreton Airport"},
  {iata: "MEU", airport: "Monte Dourado Airport"},
  {iata: "MEV", airport: "Douglas County Airport"},
  {iata: "MEW", airport: "Mweka Airport"},
  {iata: "MEX", airport: "Juarez International Airport"},
  {iata: "MEY", airport: "Meghauli Airport"},
  {iata: "MEZ", airport: "Messina Airport"},
  {iata: "MFA", airport: "Mafia Airport"},
  {iata: "MFB", airport: "Monfort Airport"},
  {iata: "MFC", airport: "Mafeteng Airport"},
  {iata: "MFD", airport: "Lahm Municipal Airport"},
  {iata: "MFE", airport: "Miller International Airport"},
  {iata: "MFF", airport: "Moanda Airport"},
  {iata: "MFG", airport: "Muzaffarabad Airport"},
  {iata: "MFH", airport: "Mesquite Airport"},
  {iata: "MFI", airport: "Marshfield Municipal Airport"},
  {iata: "MFJ", airport: "Moala Airport"},
  {iata: "MFK", airport: "Matsu Airport"},
  {iata: "MFL", airport: "Mount Full Stop Airport"},
  {iata: "MFM", airport: "Macau Airport"},
  {iata: "MFN", airport: "Milford Sound Airport"},
  {iata: "MFO", airport: "Manguna Airport"},
  {iata: "MFP", airport: "Manners Creek Airport"},
  {iata: "MFQ", airport: "Maradi Airport"},
  {iata: "MFR", airport: "Rogue Valley International-Medford Airport"},
  {iata: "MFS", airport: "Miraflores Airport"},
  {iata: "MFT", airport: "Machu Picchu Airport"},
  {iata: "MFU", airport: "Mfuwe Airport"},
  {iata: "MFV", airport: "Accomack County Airport"},
  {iata: "MFW", airport: "Magaruque Airport"},
  {iata: "MFX", airport: "Meribel Airport"},
  {iata: "MFZ", airport: "Mesalia Airport"},
  {iata: "MGA", airport: "Augusto C Sandino Airport"},
  {iata: "MGB", airport: "Mount Gambier Airport"},
  {iata: "MGC", airport: "Michigan City Airport"},
  {iata: "MGD", airport: "Magdalena Airport"},
  {iata: "MGE", airport: "Dobbins Air Force Base"},
  {iata: "MGF", airport: "Regional De Maringa"},
  {iata: "MGG", airport: "Margarima Airport"},
  {iata: "MGH", airport: "Margate Airport"},
  {iata: "MGI", airport: "Matagorda Air Force Base"},
  {iata: "MGJ", airport: "Orange County Airport"},
  {iata: "MGK", airport: "Mong Ton Airport"},
  {iata: "MGL", airport: "Moenchen-Gl. DUS Exp Airport"},
  {iata: "MGM", airport: "Dannelly Field"},
  {iata: "MGN", airport: "Baracoa Airport"},
  {iata: "MGO", airport: "Manega Airport"},
  {iata: "MGP", airport: "Manga Airport"},
  {iata: "MGQ", airport: "Mogadishu International Airport"},
  {iata: "MGR", airport: "Thomasville Airport"},
  {iata: "MGS", airport: "Mangaia Island Airport"},
  {iata: "MGT", airport: "Milingimbi Airport"},
  {iata: "MGU", airport: "Manaung"},
  {iata: "MGV", airport: "Margaret River Station Airport"},
  {iata: "MGW", airport: "Morgantown Airport"},
  {iata: "MGX", airport: "Moabi Airport"},
  {iata: "MGY", airport: "Montgomery County Airport"},
  {iata: "MGZ", airport: "Myeik Airport"},
  {iata: "MHA", airport: "Mahdia Airport"},
  {iata: "MHB", airport: "Mechanics Bay Airport"},
  {iata: "MHD", airport: "Mashad Airport"},
  {iata: "MHE", airport: "Mitchell Municipal Airport"},
  {iata: "MHF", airport: "Morichal Airport"},
  {iata: "MHG", airport: "Mannheim Airport"},
  {iata: "MHH", airport: "Marsh Harbour International Airport"},
  {iata: "MHI", airport: "Musha Airport"},
  {iata: "MHJ", airport: "Misrak Gashamo Airport"},
  {iata: "MHK", airport: "Manhattan Municipal Airport"},
  {iata: "MHL", airport: "Memorial Municipal Airport"},
  {iata: "MHN", airport: "Mullen Airport"},
  {iata: "MHO", airport: "Mount House Airport"},
  {iata: "MHP", airport: "Minsk International 1 Airport"},
  {iata: "MHQ", airport: "Mariehamn Airport"},
  {iata: "MHR", airport: "Mather Air Force Base"},
  {iata: "MHS", airport: "Rep Airport"},
  {iata: "MHT", airport: "Manchester Municipal Airport"},
  {iata: "MHU", airport: "Mount Hotham"},
  {iata: "MHV", airport: "Kern County Airport"},
  {iata: "MHW", airport: "Monteagudo Airport"},
  {iata: "MHX", airport: "Manihiki Island Airport"},
  {iata: "MHY", airport: "Morehead Airport"},
  {iata: "MHZ", airport: "Mildenhall Airport"},
  {iata: "MIA", airport: "Miami International Airport"},
  {iata: "MIB", airport: "Minot Air Force Base"},
  {iata: "MIC", airport: "Crystal Airport"},
  {iata: "MID", airport: "Rejon Airport"},
  {iata: "MIE", airport: "Delaware County Airport"},
  {iata: "MIF", airport: "Roy Hurd Memorial Airport"},
  {iata: "MIG", airport: "Mian Yang Airport"},
  {iata: "MIH", airport: "Mitchell Plateau Airport"},
  {iata: "MII", airport: "Dr Gastao Vidigal Airport"},
  {iata: "MIJ", airport: "Mili Island Airport"},
  {iata: "MIK", airport: "Mikkeli Airport"},
  {iata: "MIM", airport: "Merimbula Airport"},
  {iata: "MIN", airport: "Minnipa Airport"},
  {iata: "MIO", airport: "Miami Airport"},
  {iata: "MIQ", airport: "Millard Airport"},
  {iata: "MIR", airport: "Habib Bourguiba International Airport"},
  {iata: "MIS", airport: "Misima Island Airport"},
  {iata: "MIT", airport: "Kern County Airport"},
  {iata: "MIU", airport: "Maiduguri Airport"},
  {iata: "MIV", airport: "Millville Airport"},
  {iata: "MIW", airport: "Marshalltown Municipal Airport"},
  {iata: "MIX", airport: "Miriti Airport"},
  {iata: "MIZ", airport: "Mainoru Airport"},
  {iata: "MJA", airport: "Manja Airport"},
  {iata: "MJB", airport: "Mejit Island Airport"},
  {iata: "MJD", airport: "Mohenjo Daro Airport"},
  {iata: "MJE", airport: "Majkin Airport"},
  {iata: "MJF", airport: "Kjaerstad Airport"},
  {iata: "MJG", airport: "Mayajigua Airport"},
  {iata: "MJH", airport: "Majma Airport"},
  {iata: "MJI", airport: "Mitiga, Tripoli Airport"},
  {iata: "MJJ", airport: "Moki Airport"},
  {iata: "MJK", airport: "Shark Bay Airport"},
  {iata: "MJL", airport: "Mouila Airport"},
  {iata: "MJM", airport: "Mbuji Mayi Airport"},
  {iata: "MJN", airport: "Amborovy Airport"},
  {iata: "MJO", airport: "Mount Etjo Lodge Airport"},
  {iata: "MJP", airport: "Manjimup Airport"},
  {iata: "MJQ", airport: "Jackson Airport"},
  {iata: "MJR", airport: "Miramar Airport"},
  {iata: "MJT", airport: "Mytilene Airport"},
  {iata: "MJU", airport: "Mamuju Airport"},
  {iata: "MJV", airport: "San Javier Airport"},
  {iata: "MJW", airport: "Mahenye Airfield"},
  {iata: "MJX", airport: "Robert J. Miller Airport"},
  {iata: "MJY", airport: "Mangunjaya Airport"},
  {iata: "MJZ", airport: "Mirnyj Airport"},
  {iata: "MKA", airport: "Marianske Lazne Airport"},
  {iata: "MKB", airport: "Mekambo Airport"},
  {iata: "MKC", airport: "Kansas City Downtown Municipal Airport"},
  {iata: "MKD", airport: "Chagni Airport"},
  {iata: "MKE", airport: "General Mitchell Airport"},
  {iata: "MKF", airport: "McKenna Army Air Field"},
  {iata: "MKG", airport: "Muskegon Airport"},
  {iata: "MKH", airport: "Mokhotlong Airport"},
  {iata: "MKJ", airport: "Makoua Airport"},
  {iata: "MKK", airport: "Molokai Airport"},
  {iata: "MKL", airport: "Mckellar Airport"},
  {iata: "MKM", airport: "Mukah Airport"},
  {iata: "MKN", airport: "Malekolon Airport"},
  {iata: "MKO", airport: "Davis Field"},
  {iata: "MKP", airport: "Makemo Airport"},
  {iata: "MKQ", airport: "Mopah Airport"},
  {iata: "MKR", airport: "Meekatharra Airport"},
  {iata: "MKS", airport: "Mekane Selam Airport"},
  {iata: "MKT", airport: "Mankato Municipal Airport"},
  {iata: "MKU", airport: "Makokou Airport"},
  {iata: "MKV", airport: "Mt. Cavenagh Airport"},
  {iata: "MKW", airport: "Rendani Airport"},
  {iata: "MKX", airport: "Mukalla Airport"},
  {iata: "MKY", airport: "Mackay Airport"},
  {iata: "MKZ", airport: "Batu Berendum Airport"},
  {iata: "MLA", airport: "Luqa Airport"},
  {iata: "MLB", airport: "Melbourne International Airport"},
  {iata: "MLC", airport: "Mc Alester Airport"},
  {iata: "MLD", airport: "Malad City Airport"},
  {iata: "MLE", airport: "Male International Airport"},
  {iata: "MLF", airport: "Milford Airport"},
  {iata: "MLG", airport: "Malang Airport"},
  {iata: "MLH", airport: "EuroAirport French"},
  {iata: "MLI", airport: "Quad-City Airport"},
  {iata: "MLJ", airport: "Baldwin County Airport"},
  {iata: "MLK", airport: "Malta"},
  {iata: "MLL", airport: "Marshall Airport"},
  {iata: "MLM", airport: "Morelia Airport"},
  {iata: "MLN", airport: "Melilla Airport"},
  {iata: "MLO", airport: "Milos Airport"},
  {iata: "MLP", airport: "Malabang Airport"},
  {iata: "MLQ", airport: "Malalaua Airport"},
  {iata: "MLR", airport: "Millicent Airport"},
  {iata: "MLS", airport: "Miles City Municipal Airport"},
  {iata: "MLT", airport: "Millinocket Airport"},
  {iata: "MLU", airport: "Monroe Regional Airport"},
  {iata: "MLV", airport: "Merluna Airport"},
  {iata: "MLW", airport: "Sprigg Payne Airport"},
  {iata: "MLX", airport: "Malatya Airport"},
  {iata: "MLY", airport: "Manley Hot Springs Airport"},
  {iata: "MLZ", airport: "Melo Airport"},
  {iata: "MMB", airport: "Memanbetsu Airport"},
  {iata: "MMC", airport: "Ciudad Mante Airport"},
  {iata: "MMD", airport: "Maridor Airport"},
  {iata: "MME", airport: "Durham Tees Valley Airport"},
  {iata: "MMF", airport: "Mamfe Airport"},
  {iata: "MMG", airport: "Mount Magnet Airport"},
  {iata: "MMH", airport: "Mammoth Lakes Airport"},
  {iata: "MMI", airport: "McMinn County Airport"},
  {iata: "MMJ", airport: "Matsumoto Airport"},
  {iata: "MMK", airport: "Murmansk Airport"},
  {iata: "MML", airport: "Marshall Municipal Airport-Ryan Field"},
  {iata: "MMM", airport: "Middlemount Airport"},
  {iata: "MMN", airport: "Minute Man Airfield"},
  {iata: "MMO", airport: "Vila Do Maio Airport"},
  {iata: "MMP", airport: "Mompos Airport"},
  {iata: "MMQ", airport: "Mbala Airport"},
  {iata: "MMR", airport: "Camp Maybry Army Heliport"},
  {iata: "MMS", airport: "Selfs Airport"},
  {iata: "MMT", airport: "Mc Entire Air National Guard Base"},
  {iata: "MMU", airport: "Morristown Municipal Airport"},
  {iata: "MMW", airport: "Moma Airport"},
  {iata: "MMX", airport: "Sturup Airport"},
  {iata: "MMY", airport: "Hirara Airport"},
  {iata: "MMZ", airport: "Maimana Airport"},
  {iata: "MNA", airport: "Melangguane Airport"},
  {iata: "MNB", airport: "Moanda Airport"},
  {iata: "MNC", airport: "Nacala Airport"},
  {iata: "MND", airport: "Medina Airport"},
  {iata: "MNE", airport: "Mungerannie Airport"},
  {iata: "MNF", airport: "Mana Island Airstrip"},
  {iata: "MNG", airport: "Maningrida Airport"},
  {iata: "MNH", airport: "Minneriya Airport"},
  {iata: "MNI", airport: "Bramble Airport"},
  {iata: "MNJ", airport: "Mananjary Airport"},
  {iata: "MNK", airport: "Maiana Airport"},
  {iata: "MNL", airport: "Ninoy Aquino International Airport"},
  {iata: "MNM", airport: "Menominee Airport"},
  {iata: "MNN", airport: "Marion Municipal Airport"},
  {iata: "MNO", airport: "Manono Airport"},
  {iata: "MNQ", airport: "Monto Airport"},
  {iata: "MNR", airport: "Mongu Airport"},
  {iata: "MNS", airport: "Mansa Airport"},
  {iata: "MNT", airport: "Minto Airport"},
  {iata: "MNU", airport: "Maulmyine Airport"},
  {iata: "MNV", airport: "Mountain Valley Airport"},
  {iata: "MNW", airport: "Macdonald Downs Airport"},
  {iata: "MNX", airport: "Manicore Airport"},
  {iata: "MNY", airport: "Mono Airport"},
  {iata: "MNZ", airport: "Manassas Airport"},
  {iata: "MOA", airport: "Orestes Acosta Airport"},
  {iata: "MOB", airport: "Mobile Municipal Airport"},
  {iata: "MOC", airport: "Montes Claros Airport"},
  {iata: "MOD", airport: "Modesto Municipal Airport"},
  {iata: "MOE", airport: "Momeik Airport"},
  {iata: "MOF", airport: "Waioti Airport"},
  {iata: "MOG", airport: "Mong Hsat Airport"},
  {iata: "MOH", airport: "Mohanbari Airport"},
  {iata: "MOI", airport: "Mitiaro Island Airport"},
  {iata: "MOJ", airport: "Moengo Airport"},
  {iata: "MOL", airport: "Aro Airport"},
  {iata: "MOM", airport: "Moudjeria Airport"},
  {iata: "MON", airport: "Mount Cook Airport"},
  {iata: "MOO", airport: "Moomba Airport"},
  {iata: "MOP", airport: "Mount Pleasant Municipal Airport"},
  {iata: "MOQ", airport: "Morondava Airport"},
  {iata: "MOR", airport: "Moore-Murrell Airport"},
  {iata: "MOS", airport: "Moses Point Intermediate Airport"},
  {iata: "MOT", airport: "Minot International Airport"},
  {iata: "MOU", airport: "Mountain Village Airport"},
  {iata: "MOV", airport: "Moranbah Airport"},
  {iata: "MOX", airport: "Morris Municipal Airport"},
  {iata: "MOY", airport: "Monterrey Airport"},
  {iata: "MOZ", airport: "Temae Airport"},
  {iata: "MPA", airport: "Mpacha Airport"},
  {iata: "MPB", airport: "Miami Sea Plane Base"},
  {iata: "MPC", airport: "Muko-Muko Airport"},
  {iata: "MPD", airport: "Mirpur Khas Airport"},
  {iata: "MPE", airport: "Madison Airport"},
  {iata: "MPF", airport: "Mapoda Airport"},
  {iata: "MPG", airport: "Makini Airport"},
  {iata: "MPH", airport: "Malay Airport"},
  {iata: "MPI", airport: "Mamitupo Airport"},
  {iata: "MPJ", airport: "Petit Jean Park Airport"},
  {iata: "MPK", airport: "Mokpo Airport"},
  {iata: "MPL", airport: "Mediterranee Airport"},
  {iata: "MPM", airport: "Maputo International Airport"},
  {iata: "MPN", airport: "Mount Pleasant Airport"},
  {iata: "MPO", airport: "Mount Pocono Airport"},
  {iata: "MPP", airport: "Mulatupo Airport"},
  {iata: "MPQ", airport: "Maan Airport"},
  {iata: "MPR", airport: "McPherson Airport"},
  {iata: "MPS", airport: "Mount Pleasant Airport"},
  {iata: "MPT", airport: "Maliana Airport"},
  {iata: "MPU", airport: "Mapua Airport"},
  {iata: "MPV", airport: "Edward F Knapp State Airport"},
  {iata: "MPW", airport: "Mariupol Airport"},
  {iata: "MPX", airport: "Miyanmin Airport"},
  {iata: "MPY", airport: "Maripasoula Airport"},
  {iata: "MPZ", airport: "Mount Pleasant Municipal Airport"},
  {iata: "MQA", airport: "Mandora Airport"},
  {iata: "MQB", airport: "Macomb Municipal Airport"},
  {iata: "MQC", airport: "Miquelon Airport"},
  {iata: "MQD", airport: "Maquinchao Airport"},
  {iata: "MQE", airport: "Marqua Airport"},
  {iata: "MQF", airport: "Magnitogorsk Airport"},
  {iata: "MQG", airport: "Midgard Airport"},
  {iata: "MQH", airport: "Minacu Municipal Airport"},
  {iata: "MQI", airport: "Quincy Airport"},
  {iata: "MQJ", airport: "Merkez Airport"},
  {iata: "MQK", airport: "San Matias Airport"},
  {iata: "MQL", airport: "Mildura Airport"},
  {iata: "MQM", airport: "Mardin Airport"},
  {iata: "MQN", airport: "Mo I Rana Airport"},
  {iata: "MQO", airport: "Malam Airport"},
  {iata: "MQP", airport: "Kruger Mpumalanga International Airport"},
  {iata: "MQQ", airport: "Moundou Airport"},
  {iata: "MQR", airport: "Mosquera Airport"},
  {iata: "MQS", airport: "Mustique Airport"},
  {iata: "MQT", airport: "Sawyer International Airport"},
  {iata: "MQU", airport: "Mariquita Airport"},
  {iata: "MQV", airport: "Mostaganem Airport"},
  {iata: "MQW", airport: "Telfair-Wheeler Airport"},
  {iata: "MQX", airport: "Makale Airport"},
  {iata: "MQY", airport: "Smyrna Airport"},
  {iata: "MQZ", airport: "Margaret River Airport"},
  {iata: "MRA", airport: "Misurata Airport"},
  {iata: "MRB", airport: "Martinsburg Airport"},
  {iata: "MRC", airport: "Maury County Airport"},
  {iata: "MRD", airport: "A Carnevalli Airport"},
  {iata: "MRE", airport: "Mara Lodges Airport"},
  {iata: "MRF", airport: "Marfa Municipal Airport"},
  {iata: "MRG", airport: "Mareeba Airport"},
  {iata: "MRH", airport: "May River Airport"},
  {iata: "MRJ", airport: "Marcala Airport"},
  {iata: "MRK", airport: "Marco Island Airport"},
  {iata: "MRL", airport: "Miners Lake Airport"},
  {iata: "MRM", airport: "Manari Airport"},
  {iata: "MRN", airport: "Lenoir Airport"},
  {iata: "MRO", airport: "Masterton Airport"},
  {iata: "MRP", airport: "Marla Airport"},
  {iata: "MRQ", airport: "Marinduque Airport"},
  {iata: "MRR", airport: "Macara Airport"},
  {iata: "MRS", airport: "Marseille Airport"},
  {iata: "MRT", airport: "Moroak Airport"},
  {iata: "MRV", airport: "Mineralnye Vody Airport"},
  {iata: "MRW", airport: "Maribo Airport"},
  {iata: "MRX", airport: "Mahshahr Airport"},
  {iata: "MRY", airport: "Monterey Peninsula Airport"},
  {iata: "MRZ", airport: "Moree Airport"},
  {iata: "MSA", airport: "Muskrat Dam Airport"},
  {iata: "MSB", airport: "Marigot Sea Plane Base"},
  {iata: "MSC", airport: "Falcon Field"},
  {iata: "MSD", airport: "Mt. Pleasant Airport"},
  {iata: "MSE", airport: "Kent International Airport"},
  {iata: "MSF", airport: "Mount Swan Airport"},
  {iata: "MSG", airport: "Matsaile Airport"},
  {iata: "MSI", airport: "Masalembo Airport"},
  {iata: "MSJ", airport: "Misawa Airport"},
  {iata: "MSL", airport: "Muscle Shoals Airport"},
  {iata: "MSM", airport: "Masi Manimba Airport"},
  {iata: "MSN", airport: "Dane County Regional Airport"},
  {iata: "MSO", airport: "Johnson-Bell Field"},
  {iata: "MSP", airport: "St Paul International Airport"},
  {iata: "MSQ", airport: "Minsk International 2 Airport"},
  {iata: "MSR", airport: "Mus Airport"},
  {iata: "MSS", airport: "Richards Field"},
  {iata: "MST", airport: "Maastricht/Aachen Airport"},
  {iata: "MSU", airport: "Moshoeshoe International Airport"},
  {iata: "MSV", airport: "Sullivan County International Airport"},
  {iata: "MSW", airport: "Massawa Airport"},
  {iata: "MSX", airport: "Mossendjo Airport"},
  {iata: "MSY", airport: "Louis Armstrong International Airport"},
  {iata: "MSZ", airport: "Namibe Airport"},
  {iata: "MTA", airport: "Matamata Airport"},
  {iata: "MTB", airport: "Montel Libano Airport"},
  {iata: "MTC", airport: "Selfridge Air National Guard Base"},
  {iata: "MTD", airport: "Mount Sanford Airport"},
  {iata: "MTE", airport: "Monte Alegre Airport"},
  {iata: "MTF", airport: "Mizan Teferi Airport"},
  {iata: "MTG", airport: "Mato Grosso Airport"},
  {iata: "MTH", airport: "Marathon Flight Strip"},
  {iata: "MTI", airport: "Mosteiros Airport"},
  {iata: "MTJ", airport: "Montrose County Airport"},
  {iata: "MTK", airport: "Makin Island Airport"},
  {iata: "MTL", airport: "Maitland Airport"},
  {iata: "MTM", airport: "Metlakatla Sea Plane Base"},
  {iata: "MTN", airport: "Glenn L. Martin Airport"},
  {iata: "MTO", airport: "Coles County Memorial Airport"},
  {iata: "MTP", airport: "Sky Portal Airport"},
  {iata: "MTQ", airport: "Mitchell Airport"},
  {iata: "MTR", airport: "S. Jeronimo Airport"},
  {iata: "MTS", airport: "Matsapha International Airport"},
  {iata: "MTT", airport: "Minatitlan Airport"},
  {iata: "MTU", airport: "Montepuez Airport"},
  {iata: "MTV", airport: "Mota Lava Airport"},
  {iata: "MTW", airport: "Manitowoc Municipal Airport"},
  {iata: "MTY", airport: "Gen Mariano Escobedo Airport"},
  {iata: "MUA", airport: "Munda Airport"},
  {iata: "MUB", airport: "Maun Airport"},
  {iata: "MUC", airport: "Franz Josef Strauss Airport"},
  {iata: "MUD", airport: "Mueda Airport"},
  {iata: "MUE", airport: "Kamuela Airport"},
  {iata: "MUF", airport: "Muting Airport"},
  {iata: "MUG", airport: "Mulege Airport"},
  {iata: "MUH", airport: "Mersa Matruh Airport"},
  {iata: "MUI", airport: "Muir Aaf"},
  {iata: "MUJ", airport: "Mui Airport"},
  {iata: "MUK", airport: "Mauke Island Airport"},
  {iata: "MUL", airport: "Spence Airport"},
  {iata: "MUM", airport: "Mumias Airport"},
  {iata: "MUN", airport: "Quiriquire Airport"},
  {iata: "MUO", airport: "Mountain Home Air Force Base"},
  {iata: "MUP", airport: "Mulga Park Airport"},
  {iata: "MUQ", airport: "Muccan Airport"},
  {iata: "MUR", airport: "Marudi Airport"},
  {iata: "MUT", airport: "Muscatine Airport"},
  {iata: "MUU", airport: "Mount Union Airport"},
  {iata: "MUV", airport: "Mustin Alf Airport"},
  {iata: "MUW", airport: "Mascara Airport"},
  {iata: "MUX", airport: "Multan Airport"},
  {iata: "MUY", airport: "Mouyondzi Airport"},
  {iata: "MUZ", airport: "Musoma Airport"},
  {iata: "MVA", airport: "Reykiahlid Airport"},
  {iata: "MVB", airport: "Franceville/Mvengue Airport"},
  {iata: "MVC", airport: "Monroe County Airport"},
  {iata: "MVD", airport: "Carrasco Airport"},
  {iata: "MVE", airport: "Montevideo Municipal Airport"},
  {iata: "MVF", airport: "Dixsept Rosado Airport"},
  {iata: "MVG", airport: "Mevang Airport"},
  {iata: "MVH", airport: "Macksville Airport"},
  {iata: "MVI", airport: "Manetai Airport"},
  {iata: "MVJ", airport: "Marlboro Airport"},
  {iata: "MVK", airport: "Mulka Airport"},
  {iata: "MVL", airport: "Morrisville-Stowe Airport"},
  {iata: "MVM", airport: "Monument Valley Airport"},
  {iata: "MVN", airport: "Mt Vernon-Outland Airport"},
  {iata: "MVO", airport: "Mongo Airport"},
  {iata: "MVP", airport: "Mitu Airport"},
  {iata: "MVQ", airport: "Mogilev Airport"},
  {iata: "MVR", airport: "Salam Airport"},
  {iata: "MVS", airport: "Mucuri Airport"},
  {iata: "MVT", airport: "Mataiva Airport"},
  {iata: "MVU", airport: "Musgrave Airport"},
  {iata: "MVV", airport: "Megeve Airport"},
  {iata: "MVW", airport: "Skagit Regional Airport"},
  {iata: "MVX", airport: "Minvoul Airport"},
  {iata: "MVZ", airport: "Masvingo Airport"},
  {iata: "MWA", airport: "Williamson County Airport"},
  {iata: "MWB", airport: "Morawa Airport"},
  {iata: "MWC", airport: "Lawrence J. Timmerman Airport"},
  {iata: "MWD", airport: "Mianwali Airport"},
  {iata: "MWE", airport: "Merowe Airport"},
  {iata: "MWF", airport: "Maewo Airport"},
  {iata: "MWG", airport: "Marawaka Airport"},
  {iata: "MWH", airport: "Grant County Airport"},
  {iata: "MWI", airport: "Maramoni Airport"},
  {iata: "MWJ", airport: "Matthews Ridge Airport"},
  {iata: "MWK", airport: "Matak Airport"},
  {iata: "MWL", airport: "Mineral Wells Airport"},
  {iata: "MWM", airport: "Windom Municipal Airport"},
  {iata: "MWN", airport: "Mwadui Airport"},
  {iata: "MWO", airport: "Hook Field"},
  {iata: "MWP", airport: "Mountain Airport"},
  {iata: "MWQ", airport: "Magwe Airport"},
  {iata: "MWS", airport: "Mount Wilson Airport"},
  {iata: "MWT", airport: "Moolawatana Airport"},
  {iata: "MWU", airport: "Mussau Airport"},
  {iata: "MWV", airport: "Mundulkiri Airport"},
  {iata: "MWW", airport: "Mouscron Airport"},
  {iata: "MWY", airport: "Miranda Downs Airport"},
  {iata: "MWZ", airport: "Mwanza Airport"},
  {iata: "MXA", airport: "Manila Municipal Airport"},
  {iata: "MXB", airport: "Masamba Airport"},
  {iata: "MXC", airport: "San Juan County Airport"},
  {iata: "MXD", airport: "Marion Downs Airport"},
  {iata: "MXE", airport: "Maxton Airport"},
  {iata: "MXF", airport: "Maxwell Air Force Base"},
  {iata: "MXG", airport: "Marlborough Airport"},
  {iata: "MXH", airport: "Moro Airport"},
  {iata: "MXI", airport: "Mati Airport"},
  {iata: "MXJ", airport: "Minna Airport"},
  {iata: "MXK", airport: "Mindik Airport"},
  {iata: "MXL", airport: "Mexicali Airport"},
  {iata: "MXM", airport: "Morombe Airport"},
  {iata: "MXN", airport: "Morlaix Airport"},
  {iata: "MXO", airport: "Monticello Municipal Airport"},
  {iata: "MXP", airport: "Malpensa Airport"},
  {iata: "MXQ", airport: "Mitchell River Airport"},
  {iata: "MXR", airport: "Mirgorod Airport"},
  {iata: "MXS", airport: "Maota Savall Island Airport"},
  {iata: "MXT", airport: "Maintirano Airport"},
  {iata: "MXU", airport: "Mullewa Airport"},
  {iata: "MXV", airport: "Moron Airport"},
  {iata: "MXW", airport: "Mandalgobi Airport"},
  {iata: "MXX", airport: "Mora Airport"},
  {iata: "MXZ", airport: "Mei Xian Airport"},
  {iata: "MYA", airport: "Moruya Airport"},
  {iata: "MYB", airport: "Mayoumba Airport"},
  {iata: "MYC", airport: "Maracay Airport"},
  {iata: "MYD", airport: "Malindi Airport"},
  {iata: "MYE", airport: "Miyake Jima Airport"},
  {iata: "MYF", airport: "Montgomery Field"},
  {iata: "MYG", airport: "Mayaguana Airport"},
  {iata: "MYH", airport: "Marble Canyon Airport"},
  {iata: "MYI", airport: "Murray Island Airport"},
  {iata: "MYJ", airport: "Matsuyama Airport"},
  {iata: "MYL", airport: "Mc Call Airport"},
  {iata: "MYM", airport: "Monkey Mountain Airport"},
  {iata: "MYN", airport: "Mareb Airport"},
  {iata: "MYO", airport: "Myroodah Airport"},
  {iata: "MYP", airport: "Mary Airport"},
  {iata: "MYQ", airport: "Mysore Airport"},
  {iata: "MYR", airport: "Myrtle Beach International Airport"},
  {iata: "MYS", airport: "Moyale Airport"},
  {iata: "MYT", airport: "Myitkyina Airport"},
  {iata: "MYU", airport: "Ellis Field"},
  {iata: "MYV", airport: "Yuba County Airport"},
  {iata: "MYW", airport: "Mtwara Airport"},
  {iata: "MYX", airport: "Menyamya Airport"},
  {iata: "MYY", airport: "Miri Airport"},
  {iata: "MYZ", airport: "Monkey Bay Airport"},
  {iata: "MZA", airport: "Muzaffarnagar Airport"},
  {iata: "MZB", airport: "Mocimboa da Praia Airport"},
  {iata: "MZC", airport: "Mitzic Airport"},
  {iata: "MZD", airport: "Mendez Airport"},
  {iata: "MZE", airport: "Manatee Airport"},
  {iata: "MZF", airport: "Wild Coast Sun Airport"},
  {iata: "MZG", airport: "Makung Airport"},
  {iata: "MZH", airport: "Merzifon Airport"},
  {iata: "MZI", airport: "Mopti Airport"},
  {iata: "MZJ", airport: "Marana Airport"},
  {iata: "MZK", airport: "Marakei Airport"},
  {iata: "MZL", airport: "Santaguida Airport"},
  {iata: "MZM", airport: "Frescaty Airport"},
  {iata: "MZN", airport: "Minj Airport"},
  {iata: "MZO", airport: "Sierra Maestra Airport"},
  {iata: "MZP", airport: "Motueka Airport"},
  {iata: "MZQ", airport: "Mkuze Airport"},
  {iata: "MZR", airport: "Mazar-I-Sharif Airport"},
  {iata: "MZS", airport: "Mostyn Airport"},
  {iata: "MZT", airport: "Gen Rafael Buelna Airport"},
  {iata: "MZU", airport: "Muzaffarpur Airport"},
  {iata: "MZV", airport: "Mulu Airport"},
  {iata: "MZW", airport: "Mechria Airport"},
  {iata: "MZX", airport: "Mena Airport"},
  {iata: "MZY", airport: "Mossel Bay Airport"},
  {iata: "MZZ", airport: "Marion Airport"},
  {iata: "NAA", airport: "Narrabri Airport"},
  {iata: "NAB", airport: "Albany Naval Air Station"},
  {iata: "NAC", airport: "Naracoorte Airport"},
  {iata: "NAD", airport: "Macanal Airport"},
  {iata: "NAE", airport: "Natitingou Airport"},
  {iata: "NAF", airport: "Banaina Airport"},
  {iata: "NAG", airport: "Sonegaon Airport"},
  {iata: "NAH", airport: "Naha Airport"},
  {iata: "NAI", airport: "Annai Airport"},
  {iata: "NAJ", airport: "Nakhichevan Airport"},
  {iata: "NAK", airport: "Nakhon Ratchasima Airport"},
  {iata: "NAL", airport: "Nalchik Airport"},
  {iata: "NAM", airport: "Namlea Airport"},
  {iata: "NAN", airport: "Nadi International Airport"},
  {iata: "NAO", airport: "Nanchong Airport"},
  {iata: "NAP", airport: "Naples Airport"},
  {iata: "NAQ", airport: "Qaanaaq Airport"},
  {iata: "NAR", airport: "Nare Airport"},
  {iata: "NAS", airport: "Nassau International Airport"},
  {iata: "NAT", airport: "Augusto Severo Airport"},
  {iata: "NAU", airport: "Napuka Island Airport"},
  {iata: "NAV", airport: "Nevsehir Airport"},
  {iata: "NAW", airport: "Narathiwat Airport"},
  {iata: "NAX", airport: "Barbers Point Airport"},
  {iata: "NAY", airport: "Nanyuan Airport"},
  {iata: "NBA", airport: "Nambaiyufa Airport"},
  {iata: "NBB", airport: "Barrancominas Airport"},
  {iata: "NBC", airport: "Naberevnye Chelny Airport"},
  {iata: "NBG", airport: "Naval Air Station/Alvin Callendar"},
  {iata: "NBH", airport: "Nambucca Heads Airport"},
  {iata: "NBL", airport: "San Blas Airport"},
  {iata: "NBO", airport: "Jomo Kenyatta International Airport"},
  {iata: "NBP", airport: "Battery Park City/North Cove Sea Plane Base"},
  {iata: "NBR", airport: "Nambour Airport"},
  {iata: "NBU", airport: "Glenwood Springs Naval Air Station"},
  {iata: "NBV", airport: "Cana Brava Airport"},
  {iata: "NBW", airport: "Guantanamo Naval Air Station"},
  {iata: "NBX", airport: "Nabire Airport"},
  {iata: "NCA", airport: "North Caicos Airport"},
  {iata: "NCG", airport: "Nueva Casas Grandes Airport"},
  {iata: "NCH", airport: "Nachingwea Airport"},
  {iata: "NCI", airport: "Necocli Airport"},
  {iata: "NCL", airport: "Newcastle Airport"},
  {iata: "NCN", airport: "New Chenega Airport"},
  {iata: "NCO", airport: "Naval Air Station"},
  {iata: "NCP", airport: "Cubi Pt Naval Air Station"},
  {iata: "NCQ", airport: "Atlanta Naval Air Station"},
  {iata: "NCR", airport: "San Carlos Airport"},
  {iata: "NCS", airport: "Newcastle Airport"},
  {iata: "NCT", airport: "Guanacaste Airport"},
  {iata: "NCU", airport: "Nukus Airport"},
  {iata: "NCY", airport: "Annecy-Meythet Airport"},
  {iata: "NDA", airport: "Bandanaira Airport"},
  {iata: "NDB", airport: "Nouadhibou Airport"},
  {iata: "NDC", airport: "Nanded Airport"},
  {iata: "NDE", airport: "Mandera Airport"},
  {iata: "NDG", airport: "Qiqihar Airport"},
  {iata: "NDI", airport: "Namudi Airport"},
  {iata: "NDJ", airport: "Ndjamena Airport"},
  {iata: "NDK", airport: "Namdrik Island Airport"},
  {iata: "NDL", airport: "Ndele Airport"},
  {iata: "NDM", airport: "Mendi Airport"},
  {iata: "NDN", airport: "Nadunumu Airport"},
  {iata: "NDO", airport: "La Palma Del Condado Airport"},
  {iata: "NDP", airport: "Ellyson Naval Air Station"},
  {iata: "NDR", airport: "Nador Airport"},
  {iata: "NDS", airport: "Sandstone Airport"},
  {iata: "NDU", airport: "Rundu Airport"},
  {iata: "NDV", airport: "United States Naval Heliport"},
  {iata: "NDY", airport: "Sanday Airport"},
  {iata: "NDZ", airport: "Cuxhaven Airport"},
  {iata: "NEA", airport: "Naval Air Station"},
  {iata: "NEC", airport: "Necochea Airport"},
  {iata: "NEF", airport: "Neftekamsk Airport"},
  {iata: "NEG", airport: "Negril Airport"},
  {iata: "NEJ", airport: "Nejjo Airport"},
  {iata: "NEK", airport: "Nekemt Airport"},
  {iata: "NEL", airport: "Naec Airport"},
  {iata: "NEN", airport: "Olf Usn Airport"},
  {iata: "NER", airport: "Neryungri Airport"},
  {iata: "NES", airport: "East 34th Street - Sea Plane Base"},
  {iata: "NEU", airport: "Sam Neua Airport"},
  {iata: "NEV", airport: "Newcastle Airport"},
  {iata: "NEW", airport: "Lakefront Airport"},
  {iata: "NFB", airport: "Detroit Naval Air Field"},
  {iata: "NFG", airport: "Nefteyugansk Airport"},
  {iata: "NFL", airport: "Naval Air Station"},
  {iata: "NFR", airport: "Nafoora Airport"},
  {iata: "NGA", airport: "Young Airport"},
  {iata: "NGB", airport: "Ningbo Airport"},
  {iata: "NGC", airport: "North Rim Airport"},
  {iata: "NGD", airport: "Anegada Airport"},
  {iata: "NGE", airport: "Ngaoundere Airport"},
  {iata: "NGI", airport: "Ngau Island Airport"},
  {iata: "NGL", airport: "Ngala Airfield"},
  {iata: "NGM", airport: "Agana Naval Air Station"},
  {iata: "NGN", airport: "Nargana Airport"},
  {iata: "NGO", airport: "Chubu Centrair International Airport"},
  {iata: "NGP", airport: "Naval Air Station"},
  {iata: "NGR", airport: "Ningerum Airport"},
  {iata: "NGS", airport: "Nagasaki Airport"},
  {iata: "NGU", airport: "Naval Air Station Chambers"},
  {iata: "NGW", airport: "Cabaniss Field"},
  {iata: "NGX", airport: "Manang Airport"},
  {iata: "NGZ", airport: "Naval Air Station"},
  {iata: "NHA", airport: "Nha Trang Airport"},
  {iata: "NHD", airport: "Minhad Military Airport"},
  {iata: "NHF", airport: "New Halfa Airport"},
  {iata: "NHK", airport: "Naval Air Station"},
  {iata: "NHS", airport: "Nushki Airport"},
  {iata: "NHT", airport: "Northolt Airport"},
  {iata: "NHV", airport: "Nuku Hiva Airport"},
  {iata: "NHX", airport: "Barin Olf Osn Airport"},
  {iata: "NHZ", airport: "Naval Air Station"},
  {iata: "NIA", airport: "Nimba Airport"},
  {iata: "NIB", airport: "Nikolai Airport"},
  {iata: "NIC", airport: "Nicosia Airport"},
  {iata: "NIF", airport: "Nifty Airport"},
  {iata: "NIG", airport: "Nikunau Airport"},
  {iata: "NIK", airport: "Niokolo Koba Airport"},
  {iata: "NIM", airport: "Niamey Airport"},
  {iata: "NIO", airport: "Nioki Airport"},
  {iata: "NIP", airport: "Jacksonville Naval Air Station"},
  {iata: "NIR", airport: "Chase Field Naval Air Station"},
  {iata: "NIS", airport: "Simberi Island Airport"},
  {iata: "NIT", airport: "Niort Airport"},
  {iata: "NIX", airport: "Nioro Airport"},
  {iata: "NJA", airport: "Naval Air Station"},
  {iata: "NJC", airport: "Nizhnevartovsk Airport"},
  {iata: "NJK", airport: "Naval Air Field"},
  {iata: "NKA", airport: "Nkan Airport"},
  {iata: "NKB", airport: "Noonkanbah Airport"},
  {iata: "NKC", airport: "Nouakchott Airport"},
  {iata: "NKD", airport: "Sinak, Irian Jaya Airport"},
  {iata: "NKG", airport: "Nanking Airport"},
  {iata: "NKI", airport: "Naukiti Airport"},
  {iata: "NKL", airport: "Nkolo Airport"},
  {iata: "NKM", airport: "Nagoya/Komaki Airport"},
  {iata: "NKN", airport: "Nankina Airport"},
  {iata: "NKO", airport: "Ankokoambo Airport"},
  {iata: "NKS", airport: "Nkongsamba Airport"},
  {iata: "NKU", airport: "Nkaus Airport"},
  {iata: "NKX", airport: "Miramar Naval Air Station"},
  {iata: "NKY", airport: "Nkayi Airport"},
  {iata: "NLA", airport: "Ndola Airport"},
  {iata: "NLC", airport: "Naval Air Station/Reeves Field"},
  {iata: "NLD", airport: "Quetzalcoatl International Airport"},
  {iata: "NLE", airport: "Jerry Tyler Memorial Airport"},
  {iata: "NLF", airport: "Darnley Island Airport"},
  {iata: "NLG", airport: "Nelson Lagoon Airport"},
  {iata: "NLK", airport: "Norfolk Island Airport"},
  {iata: "NLL", airport: "Nullagine Airport"},
  {iata: "NLP", airport: "Nelspruit Airport"},
  {iata: "NLS", airport: "Nicholson Airport"},
  {iata: "NLU", airport: "Santa Lucia Airport"},
  {iata: "NLV", airport: "Nikolaev Airport"},
  {iata: "NMA", airport: "Namangan Airport"},
  {iata: "NMB", airport: "Daman Airport"},
  {iata: "NME", airport: "Nightmute Airport"},
  {iata: "NMG", airport: "San Miguel Airport"},
  {iata: "NMN", airport: "Nomane Airport"},
  {iata: "NMP", airport: "New Moon Airport"},
  {iata: "NMR", airport: "Nappamerry Airport"},
  {iata: "NMS", airport: "Namsang Airport"},
  {iata: "NMT", airport: "Namtu Airport"},
  {iata: "NMU", airport: "Namu Airport"},
  {iata: "NNA", airport: "Naval Air Field"},
  {iata: "NNB", airport: "Santa Ana Airport"},
  {iata: "NND", airport: "Nangade Airport"},
  {iata: "NNG", airport: "Nanning Airport"},
  {iata: "NNI", airport: "Namutoni Airport"},
  {iata: "NNL", airport: "Nondalton Airport"},
  {iata: "NNM", airport: "Naryan-Mar Airport"},
  {iata: "NNR", airport: "Connemara Airport"},
  {iata: "NNT", airport: "Nan Airport"},
  {iata: "NNU", airport: "Nanuque Airport"},
  {iata: "NNX", airport: "Nunukan Airport"},
  {iata: "NNY", airport: "Nanyang Airport"},
  {iata: "NOA", airport: "Nowra Airport"},
  {iata: "NOB", airport: "Nosara Beach Airport"},
  {iata: "NOC", airport: "Ireland West Airport Knock"},
  {iata: "NOD", airport: "Norden Airport"},
  {iata: "NOE", airport: "Norddeich Airport"},
  {iata: "NOG", airport: "Nogales Airport"},
  {iata: "NOH", airport: "Naval Air Station"},
  {iata: "NOI", airport: "Novorossijsk Airport"},
  {iata: "NOJ", airport: "Nojabrxsk Airport"},
  {iata: "NOK", airport: "Nova Xavantina Airport"},
  {iata: "NOM", airport: "Nomad River Airport"},
  {iata: "NON", airport: "Nonouti Airport"},
  {iata: "NOO", airport: "Naoro Airport"},
  {iata: "NOP", airport: "Mactan-Cebu International"},
  {iata: "NOR", airport: "Nordfjordur Airport"},
  {iata: "NOS", airport: "Fascene Airport"},
  {iata: "NOT", airport: "Novato Airport"},
  {iata: "NOU", airport: "Tontouta Airport"},
  {iata: "NOV", airport: "Huambo Airport"},
  {iata: "NOZ", airport: "Novokuznetsk Airport"},
  {iata: "NPA", airport: "Pensacola Naval Air Station"},
  {iata: "NPE", airport: "Hawkes Bay Airport"},
  {iata: "NPG", airport: "Nipa Airport"},
  {iata: "NPH", airport: "Nephi Airport"},
  {iata: "NPL", airport: "New Plymouth Airport"},
  {iata: "NPO", airport: "Nangapinoh Airport"},
  {iata: "NPP", airport: "Napperby Airport"},
  {iata: "NPT", airport: "State Airport"},
  {iata: "NPU", airport: "San Pedro Uraba Airport"},
  {iata: "NQA", airport: "Naval Air Station"},
  {iata: "NQI", airport: "Naval Air Station"},
  {iata: "NQL", airport: "Niquelandia Airport"},
  {iata: "NQN", airport: "Neuquen Airport"},
  {iata: "NQT", airport: "Nottingham Airport"},
  {iata: "NQU", airport: "Nuqui Airport"},
  {iata: "NQX", airport: "Naval Air Station"},
  {iata: "NQY", airport: "St Mawgan Airport"},
  {iata: "NRA", airport: "Narrandera Airport"},
  {iata: "NRB", airport: "Mayport Naval Station"},
  {iata: "NRC", airport: "Aux Field"},
  {iata: "NRD", airport: "Norderney Airport"},
  {iata: "NRE", airport: "Namrole Airport"},
  {iata: "NRG", airport: "Narrogin Airport"},
  {iata: "NRI", airport: "Grand Lake Regional"},
  {iata: "NRI", airport: "Shangri-la Airport"},
  {iata: "NRK", airport: "Kungsangen Airport"},
  {iata: "NRL", airport: "North Ronaldsay Airport"},
  {iata: "NRM", airport: "Nara Airport"},
  {iata: "NRN", airport: "Niederrhein Airport"},
  {iata: "NRR", airport: "Roosevelt Naval Air Station"},
  {iata: "NRS", airport: "Naval Air Station"},
  {iata: "NRT", airport: "Narita Airport"},
  {iata: "NRV", airport: "United States Coast Guard Shore Station"},
  {iata: "NRY", airport: "Newry Airport"},
  {iata: "NSA", airport: "Noosa Airport"},
  {iata: "NSB", airport: "North Sea Plane Base"},
  {iata: "NSE", airport: "Whiting Field Naval Air Station"},
  {iata: "NSF", airport: "Andrews Navy Air Field"},
  {iata: "NSH", airport: "Now Shahr Airport"},
  {iata: "NSI", airport: "Nsimalen Airport"},
  {iata: "NSM", airport: "Norseman Airport"},
  {iata: "NSN", airport: "Nelson Airport"},
  {iata: "NSO", airport: "Scone Airport"},
  {iata: "NST", airport: "Nakhon Si Thammarat Airport"},
  {iata: "NSV", airport: "Noosaville Airport"},
  {iata: "NSX", airport: "North Sound Virgin Gorda Hovercraft/Launch Point"},
  {iata: "NSY", airport: "Sigonella Naval Air Field"},
  {iata: "NTA", airport: "Natadola Airport"},
  {iata: "NTB", airport: "Notodden Airport"},
  {iata: "NTD", airport: "Point Mugu Naval Air Station"},
  {iata: "NTE", airport: "Nantes Atlantique Airport"},
  {iata: "NTG", airport: "Nantong Airport"},
  {iata: "NTI", airport: "Bintuni Airport"},
  {iata: "NTJ", airport: "Manti-Ephraim Airport"},
  {iata: "NTL", airport: "Williamtown Airport"},
  {iata: "NTM", airport: "Miracena Do Norte Airport"},
  {iata: "NTN", airport: "Normanton Airport"},
  {iata: "NTO", airport: "Santo Antao Airport"},
  {iata: "NTQ", airport: "Noto Airport"},
  {iata: "NTR", airport: "Aeropuerto Del Norte"},
  {iata: "NTT", airport: "Kuini Lavenia Airport"},
  {iata: "NTU", airport: "Naval Air Station"},
  {iata: "NTX", airport: "Natuna Ranai Airport"},
  {iata: "NTY", airport: "Pilansberg Airport"},
  {iata: "NUB", airport: "Numbulwar Airport"},
  {iata: "NUD", airport: "En Nahud Airport"},
  {iata: "NUE", airport: "Metropolitan Area Airport"},
  {iata: "NUG", airport: "Nuguria Airport"},
  {iata: "NUH", airport: "Nunchia Airport"},
  {iata: "NUI", airport: "Nuiqsut Airport"},
  {iata: "NUJ", airport: "Nojeh Airport"},
  {iata: "NUK", airport: "Nukutavake Airport"},
  {iata: "NUL", airport: "Nulato Airport"},
  {iata: "NUN", airport: "Saufley Naval Air Station"},
  {iata: "NUP", airport: "Nunapitchuk Airport"},
  {iata: "NUQ", airport: "Moffett Field"},
  {iata: "NUR", airport: "Nullarbor Airport"},
  {iata: "NUS", airport: "Norsup Airport"},
  {iata: "NUT", airport: "Nutuve Airport"},
  {iata: "NUU", airport: "Nakuru Airport"},
  {iata: "NUW", airport: "Ault Field"},
  {iata: "NUX", airport: "Novyj Urengoj Airport"},
  {iata: "NVA", airport: "La Marguita Airport"},
  {iata: "NVD", airport: "Nevada Airport"},
  {iata: "NVG", airport: "Nueva Guinea Airport"},
  {iata: "NVI", airport: "Navoi Airport"},
  {iata: "NVK", airport: "Framnes Airport"},
  {iata: "NVP", airport: "Novo Aripuana Airport"},
  {iata: "NVR", airport: "Novgorod Airport"},
  {iata: "NVS", airport: "Nevers Airport"},
  {iata: "NVT", airport: "Navegantes Airport"},
  {iata: "NVY", airport: "Neyveli Airport"},
  {iata: "NWA", airport: "Moheli Airport"},
  {iata: "NWH", airport: "Parlin Field Airport"},
  {iata: "NWI", airport: "Norwich Airport"},
  {iata: "NWP", airport: "Naval Station"},
  {iata: "NWS", airport: "Pier 11-Wall St Sea Plane Base"},
  {iata: "NWT", airport: "Nowata Airport"},
  {iata: "NWU", airport: "Naval Air Station"},
  {iata: "NXX", airport: "Willow Grove Naval Air Station"},
  {iata: "NYE", airport: "Nyeri Airport"},
  {iata: "NYG", airport: "Quantico Naval Air Station"},
  {iata: "NYI", airport: "Sunyani Airport"},
  {iata: "NYK", airport: "Nanyuki Airport"},
  {iata: "NYL", airport: "Yuma International Airport"},
  {iata: "NYM", airport: "Nadym Airport"},
  {iata: "NYN", airport: "Nyngan Airport"},
  {iata: "NYO", airport: "Skavsta Airport"},
  {iata: "NYU", airport: "Nyaung-u Airport"},
  {iata: "NZC", airport: "Cecil Field Naval Air Station"},
  {iata: "NZE", airport: "Nzerekore Airport"},
  {iata: "NZH", airport: "Manzhouli Airport"},
  {iata: "NZO", airport: "Nzoia Airport"},
  {iata: "NZW", airport: "South Weymouth Airport"},
  {iata: "NZY", airport: "North Island Naval Air Station"},
  {iata: "OAG", airport: "Springhill Airport"},
  {iata: "OAJ", airport: "Albert J Ellis Airport"},
  {iata: "OAK", airport: "Metropolitan Oakland International Airport"},
  {iata: "OAL", airport: "Cacoal Airport"},
  {iata: "OAM", airport: "Oamaru Airport"},
  {iata: "OAN", airport: "Olanchito Airport"},
  {iata: "OAR", airport: "Fritzche Army Air Field"},
  {iata: "OAX", airport: "Xoxocotlan Airport"},
  {iata: "OBA", airport: "Oban Airport"},
  {iata: "OBC", airport: "Obock Airport"},
  {iata: "OBD", airport: "Obano Airport"},
  {iata: "OBE", airport: "Okeechobee County Airport"},
  {iata: "OBF", airport: "Oberpfaffenhofen Airport"},
  {iata: "OBI", airport: "Obidos Airport"},
  {iata: "OBK", airport: "Sky Harbor Airport"},
  {iata: "OBL", airport: "Zoersel Airport"},
  {iata: "OBM", airport: "Morobe Airport"},
  {iata: "OBN", airport: "Connel Airport"},
  {iata: "OBO", airport: "Obihiro Airport"},
  {iata: "OBS", airport: "Vals-Lanas Airport"},
  {iata: "OBT", airport: "Oakland/Coliseum Station"},
  {iata: "OBU", airport: "Kobuk/Wien Airport"},
  {iata: "OBX", airport: "Obo Airport"},
  {iata: "OBY", airport: "Ittoqqortoormiit Airport"},
  {iata: "OCA", airport: "Ocean Reef Airport"},
  {iata: "OCC", airport: "Coca Airport"},
  {iata: "OCE", airport: "Ocean City Municipal Airport"},
  {iata: "OCF", airport: "Taylor Field"},
  {iata: "OCH", airport: "Nacogdoches Airport"},
  {iata: "OCJ", airport: "Boscobel Airport"},
  {iata: "OCN", airport: "Oceanside Municipal Airport"},
  {iata: "OCV", airport: "Aguasclaras Airport"},
  {iata: "OCW", airport: "Warren Field"},
  {iata: "ODA", airport: "Ouadda Airport"},
  {iata: "ODB", airport: "Cordoba Airport"},
  {iata: "ODD", airport: "Oodnadatta Airport"},
  {iata: "ODE", airport: "Beldringe Airport"},
  {iata: "ODH", airport: "Royal Air Force Station"},
  {iata: "ODJ", airport: "Ouanda Djalle Airport"},
  {iata: "ODL", airport: "Guarapari"},
  {iata: "ODL", airport: "Cordillo Downs Airport"},
  {iata: "ODM", airport: "Metropolitan Area Airport"},
  {iata: "ODN", airport: "Long Seridan Airport"},
  {iata: "ODR", airport: "Ord River Airport"},
  {iata: "ODS", airport: "Odessa-Central Airport"},
  {iata: "ODW", airport: "Oak Harbor Airport"},
  {iata: "ODY", airport: "Oudomxay Airport"},
  {iata: "OEA", airport: "Oneal Airport"},
  {iata: "OEC", airport: "Ocussi Airport"},
  {iata: "OEL", airport: "Orel Airport"},
  {iata: "OEM", airport: "Vincent Fayks Airport"},
  {iata: "OEO", airport: "Osceola Municipal Airport"},
  {iata: "OER", airport: "Ornskoldsvik Airport"},
  {iata: "OES", airport: "San Antonio Oeste Airport"},
  {iata: "OFF", airport: "Offutt Afb"},
  {iata: "OFJ", airport: "Olafsfjordur Airport"},
  {iata: "OFK", airport: "Stefan Field"},
  {iata: "OFU", airport: "Airport"},
  {iata: "OGA", airport: "Searle Field"},
  {iata: "OGB", airport: "Orangeburg Municipal Airport"},
  {iata: "OGD", airport: "Ogden Municipal Airport"},
  {iata: "OGE", airport: "Ogeranang Airport"},
  {iata: "OGG", airport: "Kahului Airport"},
  {iata: "OGL", airport: "Ogle Airport"},
  {iata: "OGN", airport: "Yonaguni Airport"},
  {iata: "OGR", airport: "Bongor Airport"},
  {iata: "OGS", airport: "Ogdensburg Airport"},
  {iata: "OGX", airport: "Ain Beida Airport"},
  {iata: "OGZ", airport: "Vladikavkaz Airport"},
  {iata: "OHA", airport: "Royal Air Force Base"},
  {iata: "OHD", airport: "Ohrid Airport"},
  {iata: "OHI", airport: "Oshakati Airport"},
  {iata: "OHO", airport: "Okhotsk Airport"},
  {iata: "OHP", airport: "Oban Heliport"},
  {iata: "OHR", airport: "Wyk Airport"},
  {iata: "OHT", airport: "Kohat Airport"},
  {iata: "OIA", airport: "Ourilandia Airport"},
  {iata: "OIC", airport: "Eaton Airport"},
  {iata: "OIL", airport: "Splane Memorial Airport"},
  {iata: "OIM", airport: "Oshima Airport"},
  {iata: "OIR", airport: "Okushiri Airport"},
  {iata: "OIT", airport: "Oita Airport"},
  {iata: "OJC", airport: "Johnson Executive Airport"},
  {iata: "OKA", airport: "Naha Airport"},
  {iata: "OKB", airport: "Fraser Island Airport"},
  {iata: "OKC", airport: "Will Rogers Airport"},
  {iata: "OKD", airport: "Okadama Airport"},
  {iata: "OKE", airport: "Okino Erabu Airport"},
  {iata: "OKF", airport: "Okaukuejo Airport"},
  {iata: "OKG", airport: "Okoyo Airport"},
  {iata: "OKH", airport: "Cottesmor Royal Air Force"},
  {iata: "OKI", airport: "Oki Island Airport"},
  {iata: "OKJ", airport: "Okayama Airport"},
  {iata: "OKK", airport: "Kokomo Airport"},
  {iata: "OKL", airport: "Oksibil Airport"},
  {iata: "OKM", airport: "Okmulgee Airport"},
  {iata: "OKN", airport: "Okondja Airport"},
  {iata: "OKO", airport: "Yokota Air Force Base"},
  {iata: "OKP", airport: "Oksapmin Airport"},
  {iata: "OKQ", airport: "Okaba Airport"},
  {iata: "OKR", airport: "Yorke Island Airport"},
  {iata: "OKS", airport: "Oshkosh Airport"},
  {iata: "OKT", airport: "Oktiabrskij Airport"},
  {iata: "OKU", airport: "Mokuti Lodge Airport"},
  {iata: "OKV", airport: "Okao Airport"},
  {iata: "OKY", airport: "Oakey Airport"},
  {iata: "OLA", airport: "Orland Airport"},
  {iata: "OLB", airport: "Costa Smeralda Airport"},
  {iata: "OLD", airport: "Old Town Airport"},
  {iata: "OLE", airport: "Olean Municipal Airport"},
  {iata: "OLF", airport: "Wolf Point International Airport"},
  {iata: "OLH", airport: "Old Harbor Sea Plane Base"},
  {iata: "OLI", airport: "Rif Airport"},
  {iata: "OLJ", airport: "West Cost Santo Airport"},
  {iata: "OLK", airport: "Fuerte Olimpo Airport"},
  {iata: "OLM", airport: "Olympia Airport"},
  {iata: "OLO", airport: "Olomouc Airport"},
  {iata: "OLP", airport: "Olympic Dam Airport"},
  {iata: "OLQ", airport: "Olsobip Airport"},
  {iata: "OLS", airport: "Nogales International Airport"},
  {iata: "OLU", airport: "Columbus Airport"},
  {iata: "OLV", airport: "Olive Branch Airport"},
  {iata: "OLY", airport: "Olney Airport"},
  {iata: "OMA", airport: "Eppley Airfield"},
  {iata: "OMB", airport: "Omboue Airport"},
  {iata: "OMC", airport: "Ormoc Airport"},
  {iata: "OMD", airport: "Oranjemund Airport"},
  {iata: "OME", airport: "Nome Airport"},
  {iata: "OMF", airport: "King Hussein Airport"},
  {iata: "OMG", airport: "Omega Airport"},
  {iata: "OMH", airport: "Umieh Airport"},
  {iata: "OMI", airport: "Omidieh Airport"},
  {iata: "OMJ", airport: "Omura Airport"},
  {iata: "OMK", airport: "Omak Municipal Airport"},
  {iata: "OML", airport: "Omkalai Airport"},
  {iata: "OMN", airport: "Osmanabad Airport"},
  {iata: "OMO", airport: "Mostar Airport"},
  {iata: "OMR", airport: "Oradea Airport"},
  {iata: "OMS", airport: "Omsk Airport"},
  {iata: "OMY", airport: "Oddor Meanche Airport"},
  {iata: "ONA", airport: "Winona Municipal Airport"},
  {iata: "ONB", airport: "Ononge Airport"},
  {iata: "OND", airport: "Ondangwa Airport"},
  {iata: "ONG", airport: "Mornington Airport"},
  {iata: "ONH", airport: "Oneonta Municipal Airport"},
  {iata: "ONI", airport: "Moanamani Airport"},
  {iata: "ONJ", airport: "Odate Noshiro Airport"},
  {iata: "ONM", airport: "Socorro Airport"},
  {iata: "ONO", airport: "Ontario Airport"},
  {iata: "ONP", airport: "Newport Airport"},
  {iata: "ONQ", airport: "Zonguldak Airport"},
  {iata: "ONR", airport: "Monkira Airport"},
  {iata: "ONS", airport: "Onslow Airport"},
  {iata: "ONT", airport: "Ontario International Airport"},
  {iata: "ONU", airport: "Ono I Lau Airport"},
  {iata: "ONX", airport: "Colon Airport"},
  {iata: "ONY", airport: "Olney Airport"},
  {iata: "OOA", airport: "Oskaloosa Municipal Airport"},
  {iata: "OOK", airport: "Toksook Bay Airport"},
  {iata: "OOL", airport: "Gold Coast Airport"},
  {iata: "OOM", airport: "Cooma Airport"},
  {iata: "OOR", airport: "Mooraberree Airport"},
  {iata: "OOT", airport: "Onotoa Airport"},
  {iata: "OPA", airport: "Kopasker Airport"},
  {iata: "OPB", airport: "Open Bay Airport"},
  {iata: "OPF", airport: "Opa Locka"},
  {iata: "OPI", airport: "Oenpelli Airport"},
  {iata: "OPL", airport: "St Landry Parish Airport"},
  {iata: "OPO", airport: "Porto Airport"},
  {iata: "OPS", airport: "Sinop Airport"},
  {iata: "OPU", airport: "Balimo Airport"},
  {iata: "OPW", airport: "Opuwa Airport"},
  {iata: "ORA", airport: "Oran Airport"},
  {iata: "ORB", airport: "Orebro-Bofors Airport"},
  {iata: "ORC", airport: "Orocue Airport"},
  {iata: "ORE", airport: "Orleans Airport"},
  {iata: "ORF", airport: "Norfolk International Airport"},
  {iata: "ORG", airport: "Zorg En Hoop Airport"},
  {iata: "ORH", airport: "Worcester Airport"},
  {iata: "ORI", airport: "Port Lions Sea Plane Base"},
  {iata: "ORJ", airport: "Orinduik Airport"},
  {iata: "ORK", airport: "Cork Airport"},
  {iata: "ORL", airport: "Herndon Airport"},
  {iata: "ORM", airport: "Northampton Airport"},
  {iata: "ORN", airport: "Es Senia Airport"},
  {iata: "ORO", airport: "Yoro Airport"},
  {iata: "ORP", airport: "Orapa Airport"},
  {iata: "ORQ", airport: "Norwalk Heliport"},
  {iata: "ORR", airport: "Yorktown Airport"},
  {iata: "ORS", airport: "Waterport Airport"},
  {iata: "ORT", airport: "Northway Airport"},
  {iata: "ORU", airport: "Oruro Airport"},
  {iata: "ORV", airport: "Curtis Memorial Airport"},
  {iata: "ORW", airport: "Ormara Airport"},
  {iata: "ORX", airport: "Oriximina Airport"},
  {iata: "ORY", airport: "Orly Airport"},
  {iata: "ORZ", airport: "Orange Walk Airport"},
  {iata: "OSB", airport: "Osage Beach Airport"},
  {iata: "OSC", airport: "Wurtsmith Air Force Base"},
  {iata: "OSD", airport: "Froesoe Airport"},
  {iata: "OSE", airport: "Omora Airport"},
  {iata: "OSG", airport: "Ossima Airport"},
  {iata: "OSH", airport: "Wittman Field"},
  {iata: "OSI", airport: "Osijek Airport"},
  {iata: "OSK", airport: "Oskarshamn Airport"},
  {iata: "OSL", airport: "Oslo Airport"},
  {iata: "OSM", airport: "Mosul Airport"},
  {iata: "OSN", airport: "Ab Airport"},
  {iata: "OSP", airport: "Redzikowo Airport"},
  {iata: "OSR", airport: "Mosnov Airport"},
  {iata: "OSS", airport: "Osh Airport"},
  {iata: "OST", airport: "Ostend Airport"},
  {iata: "OSU", airport: "Ohio State University Airport"},
  {iata: "OSW", airport: "Orsk Airport"},
  {iata: "OSX", airport: "Attala County Airport"},
  {iata: "OSY", airport: "Namsos Airport"},
  {iata: "OSZ", airport: "Koszalin Airport"},
  {iata: "OTA", airport: "Mota Airport"},
  {iata: "OTC", airport: "Bol Airport"},
  {iata: "OTD", airport: "Contadora Airport"},
  {iata: "OTG", airport: "Worthington Airport"},
  {iata: "OTH", airport: "North Bend Airport"},
  {iata: "OTI", airport: "Morotai Island Airport"},
  {iata: "OTJ", airport: "Otjiwarongo Airport"},
  {iata: "OTL", airport: "Boutilimit Airport"},
  {iata: "OTM", airport: "Industrial Airport"},
  {iata: "OTN", airport: "Green Airport"},
  {iata: "OTO", airport: "Vor Airport"},
  {iata: "OTP", airport: "Otopeni International Airport"},
  {iata: "OTR", airport: "Coto 47 Airport"},
  {iata: "OTS", airport: "Anacortes Airport"},
  {iata: "OTU", airport: "Otu Airport"},
  {iata: "OTY", airport: "Oria Airport"},
  {iata: "OTZ", airport: "Kotzebue Airport"},
  {iata: "OUA", airport: "Ouagadougou Airport"},
  {iata: "OUD", airport: "Les Angades Airport"},
  {iata: "OUE", airport: "Ouesso Airport"},
  {iata: "OUG", airport: "Ouahigouya Airport"},
  {iata: "OUH", airport: "Oudtshoorn Airport"},
  {iata: "OUI", airport: "Ban Houel Airport"},
  {iata: "OUK", airport: "Outer Skerries Airport"},
  {iata: "OUL", airport: "Oulu Airport"},
  {iata: "OUM", airport: "Oum Hadjer Airport"},
  {iata: "OUN", airport: "Max Westheimer Airport"},
  {iata: "OUR", airport: "Batouri Airport"},
  {iata: "OUS", airport: "Ourinhos Airport"},
  {iata: "OUT", airport: "Bousso Airport"},
  {iata: "OUU", airport: "Ouanga Airport"},
  {iata: "OUZ", airport: "Zouerate Airport"},
  {iata: "OVA", airport: "Bekily Airport"},
  {iata: "OVB", airport: "Tolmachevo Airport"},
  {iata: "OVD", airport: "Asturias Airport"},
  {iata: "OVE", airport: "Oroville Airport"},
  {iata: "OVG", airport: "Overberg (FAOB)"},
  {iata: "OVL", airport: "Ovalle Airport"},
  {iata: "OVR", airport: "Olavarria Airport"},
  {iata: "OWA", airport: "Owatonna Airport"},
  {iata: "OWB", airport: "Daviess County Airport"},
  {iata: "OWD", airport: "Norwood Memorial Airport"},
  {iata: "OWE", airport: "Owendo Airport"},
  {iata: "OWK", airport: "Central Maine Airport"},
  {iata: "OXB", airport: "Osvaldo Vieira Airport"},
  {iata: "OXC", airport: "Waterbury-Oxford Airport"},
  {iata: "OXD", airport: "Miami University Airport"},
  {iata: "OXF", airport: "Kidlington Airport"},
  {iata: "OXO", airport: "Orientos Airport"},
  {iata: "OXR", airport: "Oxnard Airport"},
  {iata: "OXY", airport: "Morney Airport"},
  {iata: "OYA", airport: "Goya Airport"},
  {iata: "OYE", airport: "Oyem Airport"},
  {iata: "OYG", airport: "Moyo Airport"},
  {iata: "OYK", airport: "Oiapoque Airport"},
  {iata: "OYL", airport: "Moyale Airport"},
  {iata: "OYN", airport: "Ouyen Airport"},
  {iata: "OYO", airport: "Tres Arroyos Airport"},
  {iata: "OYP", airport: "St. Georges de L/Oyapock Airport"},
  {iata: "OYS", airport: "Yosemite National Park Airport"},
  {iata: "OZA", airport: "Ozona Airport"},
  {iata: "OZC", airport: "Labo Airport"},
  {iata: "OZH", airport: "Zaporozhye Airport"},
  {iata: "OZI", airport: "Bobadilla Airport"},
  {iata: "OZP", airport: "Moron Ab"},
  {iata: "OZP", airport: "Moron Airport"},
  {iata: "OZR", airport: "Cairns Army Air Field"},
  {iata: "OZU", airport: "Montilla Airport"},
  {iata: "OZZ", airport: "Ouarzazate Airport"},
  {iata: "PAA", airport: "Pa-an Airport"},
  {iata: "PAB", airport: "Bilaspur Airport"},
  {iata: "PAC", airport: "Paitilla Airport"},
  {iata: "PAD", airport: "Paderborn Airport"},
  {iata: "PAE", airport: "Snohomish County Airport"},
  {iata: "PAF", airport: "Pakuba Airport"},
  {iata: "PAG", airport: "Pagadian Airport"},
  {iata: "PAH", airport: "Barkley Regional Airport"},
  {iata: "PAI", airport: "Pailin Airport"},
  {iata: "PAJ", airport: "Para Chinar Airport"},
  {iata: "PAK", airport: "Port Allen Airport"},
  {iata: "PAL", airport: "Palanquero Airport"},
  {iata: "PAM", airport: "Tyndall Air Force Base"},
  {iata: "PAN", airport: "Pattani Airport"},
  {iata: "PAO", airport: "Palo Alto Airport"},
  {iata: "PAP", airport: "Mais Gate Airport"},
  {iata: "PAQ", airport: "Palmer Municipal Airport"},
  {iata: "PAR", airport: "Paris Metropolitan"},
  {iata: "PAS", airport: "Paros Airport"},
  {iata: "PAT", airport: "Patna Airport"},
  {iata: "PAU", airport: "Pauk Airport"},
  {iata: "PAV", airport: "Paulo Afonso Airport"},
  {iata: "PAW", airport: "Pambwa Airport"},
  {iata: "PAX", airport: "Port De Paix Airport"},
  {iata: "PAY", airport: "Pamol Airport"},
  {iata: "PAZ", airport: "Tajin Airport"},
  {iata: "PBB", airport: "Parnaiba"},
  {iata: "PBB", airport: "Paranaiba Airport"},
  {iata: "PBC", airport: "Huejotsingo Airport"},
  {iata: "PBD", airport: "Porbandar Airport"},
  {iata: "PBE", airport: "Puerto Berrio Airport"},
  {iata: "PBF", airport: "Grider Field"},
  {iata: "PBG", airport: "Plattsburgh Air Force Base"},
  {iata: "PBH", airport: "Paro Airport"},
  {iata: "PBI", airport: "West Palm Beach International Airport"},
  {iata: "PBJ", airport: "Paama Airport"},
  {iata: "PBL", airport: "Puerto Cabello Airport"},
  {iata: "PBM", airport: "Zanderij International Airport"},
  {iata: "PBO", airport: "Paraburdoo Airport"},
  {iata: "PBP", airport: "Punta Islita Airport"},
  {iata: "PBQ", airport: "Pimenta Bueno Airport"},
  {iata: "PBR", airport: "Puerto Barrios Airport"},
  {iata: "PBS", airport: "Patong Beach Airport"},
  {iata: "PBT", airport: "Puerto Leda Airport"},
  {iata: "PBU", airport: "Putao Airport"},
  {iata: "PBV", airport: "Porto Dos Gauchos Airport"},
  {iata: "PBX", airport: "Porto Alegre Do Norte Airport"},
  {iata: "PBY", airport: "Hamilton/Prosperine Airport"},
  {iata: "PBZ", airport: "Plettenberg Airport"},
  {iata: "PCA", airport: "Portage Creek Airport"},
  {iata: "PCB", airport: "Pondok Cabe Airport"},
  {iata: "PCC", airport: "Puerto Rico Airport"},
  {iata: "PCD", airport: "Prairie Du Chien Municipal Airport"},
  {iata: "PCE", airport: "Painter Creek Airport"},
  {iata: "PCG", airport: "Paso Caballos Airport"},
  {iata: "PCH", airport: "Palacios Airport"},
  {iata: "PCJ", airport: "Puerto La Victoria Airport"},
  {iata: "PCL", airport: "Capitan Rolden Airport"},
  {iata: "PCM", airport: "Playa Del Carmen Airport"},
  {iata: "PCN", airport: "Koromiko Airport"},
  {iata: "PCO", airport: "Punta Colorada Airport"},
  {iata: "PCP", airport: "Principe Airport"},
  {iata: "PCQ", airport: "Bounneua Airport"},
  {iata: "PCR", airport: "Puerto Carreno Airport"},
  {iata: "PCS", airport: "Picos Airport"},
  {iata: "PCT", airport: "Princeton Airport"},
  {iata: "PCU", airport: "Pearl River County Airport"},
  {iata: "PCV", airport: "Punta Chivato Airport"},
  {iata: "PDA", airport: "Puerto Inirida Airport"},
  {iata: "PDB", airport: "Pedro Bay Airport"},
  {iata: "PDC", airport: "Mueo Airport"},
  {iata: "PDD", airport: "Ponta De Ouro"},
  {iata: "PDE", airport: "Pandie Pandie Airport"},
  {iata: "PDF", airport: "Prado Airport"},
  {iata: "PDG", airport: "Tabing Airport"},
  {iata: "PDI", airport: "Pindiu Airport"},
  {iata: "PDK", airport: "Peachtree-Dekalb Airport"},
  {iata: "PDL", airport: "Nordela Airport"},
  {iata: "PDN", airport: "Parndana Airport"},
  {iata: "PDO", airport: "Pendopo Airport"},
  {iata: "PDP", airport: "Punta Del Este Airport"},
  {iata: "PDR", airport: "Presidente Dutra Municipal Airport"},
  {iata: "PDS", airport: "Piedras Negras Airport"},
  {iata: "PDT", airport: "Eastern Oregon Regional Airport"},
  {iata: "PDU", airport: "Paysandu Airport"},
  {iata: "PDV", airport: "Plovdiv Airport"},
  {iata: "PDX", airport: "Portland International Airport"},
  {iata: "PDZ", airport: "Pedernales Airport"},
  {iata: "PEA", airport: "Penneshaw Airport"},
  {iata: "PEB", airport: "Pebane Airport"},
  {iata: "PEC", airport: "Pelican Sea Plane Base"},
  {iata: "PED", airport: "Pardubice Airport"},
  {iata: "PEE", airport: "Perm Airport"},
  {iata: "PEF", airport: "Peenemuende Airport"},
  {iata: "PEG", airport: "Sant Egidio Airport"},
  {iata: "PEH", airport: "Pehuajo Airport"},
  {iata: "PEI", airport: "Matecana Airport"},
  {iata: "PEJ", airport: "Peschiei Airport"},
  {iata: "PEK", airport: "Capital Airport"},
  {iata: "PEL", airport: "Pelaneng Airport"},
  {iata: "PEM", airport: "Puerto Maldonado Airport"},
  {iata: "PEN", airport: "Penang International Airport"},
  {iata: "PEP", airport: "Peppimenarti Airport"},
  {iata: "PEQ", airport: "Pecos City Airport"},
  {iata: "PER", airport: "Perth Airport"},
  {iata: "PES", airport: "Petrozavodsk Airport"},
  {iata: "PET", airport: "Federal Airport"},
  {iata: "PEU", airport: "Puerto Lempira Airport"},
  {iata: "PEW", airport: "Peshawar Airport"},
  {iata: "PEX", airport: "Pechora Airport"},
  {iata: "PEY", airport: "Penong Airport"},
  {iata: "PEZ", airport: "Penza Airport"},
  {iata: "PFB", airport: "Passo Fundo Airport"},
  {iata: "PFC", airport: "State Airport"},
  {iata: "PFJ", airport: "Patrekstjord Airport"},
  {iata: "PFN", airport: "Bay County Airport"},
  {iata: "PFO", airport: "Paphos International Airport"},
  {iata: "PFQ", airport: "Parsabad Airport"},
  {iata: "PFR", airport: "Ilebo Airport"},
  {iata: "PGA", airport: "Page Airport"},
  {iata: "PGB", airport: "Panaoa Airport"},
  {iata: "PGC", airport: "Grant County Airport"},
  {iata: "PGD", airport: "Charlotte County Airport"},
  {iata: "PGE", airport: "Yegepa Airport"},
  {iata: "PGF", airport: "Llabanere Airport"},
  {iata: "PGG", airport: "Progresso Airport"},
  {iata: "PGH", airport: "Pantnagar Airport"},
  {iata: "PGK", airport: "Pangkalpinang Airport"},
  {iata: "PGL", airport: "Jackson County Airport"},
  {iata: "PGM", airport: "Port Graham Airport"},
  {iata: "PGN", airport: "Pangia Airport"},
  {iata: "PGO", airport: "Stevens Field"},
  {iata: "PGP", airport: "Porto Alegre Airport"},
  {iata: "PGR", airport: "Paragould Municipal Airport"},
  {iata: "PGS", airport: "Peach Springs Airport"},
  {iata: "PGV", airport: "Pitt-Greenville Airport"},
  {iata: "PGX", airport: "Perigueux Airport"},
  {iata: "PHA", airport: "Phan Rang Airport"},
  {iata: "PHB", airport: "Santos Dumont Airport"},
  {iata: "PHC", airport: "Port Harcourt Airport"},
  {iata: "PHD", airport: "Harry Clever Airport"},
  {iata: "PHE", airport: "Port Hedland Airport"},
  {iata: "PHF", airport: "Newport News/Williamsburg Airport"},
  {iata: "PHG", airport: "Port Harcourt City Airport"},
  {iata: "PHH", airport: "Phan Thiet Airport"},
  {iata: "PHI", airport: "Pinheiro Airport"},
  {iata: "PHJ", airport: "Port Hunter Airport"},
  {iata: "PHK", airport: "Palm Beach County Glades Airport"},
  {iata: "PHL", airport: "Philadelphia International Airport"},
  {iata: "PHM", airport: "Boeblingen Airport"},
  {iata: "PHN", airport: "St Clair County International Airport"},
  {iata: "PHO", airport: "Point Hope Airport"},
  {iata: "PHP", airport: "Phillip Airport"},
  {iata: "PHR", airport: "Pacific Harbor Airport"},
  {iata: "PHS", airport: "Phitsanulok Airport"},
  {iata: "PHT", airport: "Henry County Airport"},
  {iata: "PHU", airport: "Phu Vinh Airport"},
  {iata: "PHW", airport: "Phalaborwa Airport"},
  {iata: "PHX", airport: "Sky Harbor International Airport"},
  {iata: "PHY", airport: "Phetchabun Airport"},
  {iata: "PHZ", airport: "Phi Phi Island Airport"},
  {iata: "PIA", airport: "Greater Peoria Airport"},
  {iata: "PIB", airport: "Hattiesburg-Laurel Regional Airport"},
  {iata: "PIC", airport: "Pine Cay Airport"},
  {iata: "PID", airport: "Paradise Island Airport"},
  {iata: "PIE", airport: "St. Petersburg International Airport"},
  {iata: "PIF", airport: "Pingtung Airport"},
  {iata: "PIG", airport: "Pitinga Airport"},
  {iata: "PIH", airport: "Pocatello Airport"},
  {iata: "PIK", airport: "Prestwick Airport"},
  {iata: "PIL", airport: "Pilar Airport"},
  {iata: "PIM", airport: "Garden Harris County Airport"},
  {iata: "PIN", airport: "Parintins Airport"},
  {iata: "PIO", airport: "Pisco Airport"},
  {iata: "PIP", airport: "Pilot Point Airport"},
  {iata: "PIQ", airport: "Pipillipai Airport"},
  {iata: "PIR", airport: "Pierre Airport"},
  {iata: "PIS", airport: "Biard Airport"},
  {iata: "PIT", airport: "Pittsburgh International Airport"},
  {iata: "PIU", airport: "Piura Airport"},
  {iata: "PIV", airport: "Pirapora Airport"},
  {iata: "PIW", airport: "Pikwitonei Airport"},
  {iata: "PIX", airport: "Pico Island Airport"},
  {iata: "PIZ", airport: "Dew Station Airport"},
  {iata: "PJA", airport: "Pajala Airport"},
  {iata: "PJB", airport: "Payson Airport"},
  {iata: "PJC", airport: "Pedro Juan Caballero Airport"},
  {iata: "PJG", airport: "Panjgur Airport"},
  {iata: "PJM", airport: "Puerto Jimenez Airport"},
  {iata: "PJZ", airport: "Puerto Juarez Airport"},
  {iata: "PKA", airport: "Napaskiak Sea Plane Base"},
  {iata: "PKB", airport: "Wood County Airport"},
  {iata: "PKC", airport: "Petropavlovsk-Kamchatsky Airport"},
  {iata: "PKD", airport: "Park Rapids Airport"},
  {iata: "PKE", airport: "Parkes Airport"},
  {iata: "PKF", airport: "Park Falls Airport"},
  {iata: "PKG", airport: "Pangkor Airport"},
  {iata: "PKH", airport: "Alexion Airport"},
  {iata: "PKJ", airport: "Playa Grande Airport"},
  {iata: "PKK", airport: "Pakokku Airport"},
  {iata: "PKL", airport: "Pakatoa Island Airport"},
  {iata: "PKM", airport: "Port Kaituma Airport"},
  {iata: "PKN", airport: "Pangkalanbuun Airport"},
  {iata: "PKO", airport: "Parakou Airport"},
  {iata: "PKP", airport: "Puka Puka Airport"},
  {iata: "PKR", airport: "Pokhara Airport"},
  {iata: "PKS", airport: "Paksane Airport"},
  {iata: "PKT", airport: "Port Keats Airport"},
  {iata: "PKU", airport: "Simpang Tiga Airport"},
  {iata: "PKV", airport: "Pskov Airport"},
  {iata: "PKW", airport: "Selebi-Phikwe Airport"},
  {iata: "PKY", airport: "Palangkaraya Airport"},
  {iata: "PKZ", airport: "Pakse Airport"},
  {iata: "PLA", airport: "Planadas Airport"},
  {iata: "PLB", airport: "Clinton County Airport"},
  {iata: "PLC", airport: "Planeta Rica Airport"},
  {iata: "PLD", airport: "Playa Samara Airport"},
  {iata: "PLE", airport: "Paiela Airport"},
  {iata: "PLF", airport: "Pala Airport"},
  {iata: "PLH", airport: "Plymouth Airport"},
  {iata: "PLI", airport: "Palm Island Airport"},
  {iata: "PLJ", airport: "Placencia Airport"},
  {iata: "PLK", airport: "M Graham Clark Airport"},
  {iata: "PLL", airport: "Ponta Pelada Airport"},
  {iata: "PLM", airport: "Mahmud Badaruddin Ii Airport"},
  {iata: "PLN", airport: "Emmet County Airport"},
  {iata: "PLO", airport: "Port Lincoln Airport"},
  {iata: "PLP", airport: "La Palma Airport"},
  {iata: "PLQ", airport: "Palanga International Airport"},
  {iata: "PLR", airport: "St. Clair County Airport"},
  {iata: "PLS", airport: "Providenciales International Airport"},
  {iata: "PLT", airport: "Plato Airport"},
  {iata: "PLU", airport: "Pampulha Airport"},
  {iata: "PLV", airport: "Poltava Airport"},
  {iata: "PLW", airport: "Mutiara Airport"},
  {iata: "PLX", airport: "Semipalatinsk Airport"},
  {iata: "PLY", airport: "Plymouth Airport"},
  {iata: "PLZ", airport: "Port Elizabeth Airport"},
  {iata: "PMA", airport: "Wawi Airport"},
  {iata: "PMB", airport: "Pembina Intermediate Airport"},
  {iata: "PMC", airport: "Tepual Airport"},
  {iata: "PMD", airport: "Palmdale Air Force 42 Base"},
  {iata: "PME", airport: "Portsmouth Airport"},
  {iata: "PMF", airport: "Parma Airport"},
  {iata: "PMG", airport: "Ponta Pora International Airport"},
  {iata: "PMH", airport: "Portsmouth Regional Airport"},
  {iata: "PMI", airport: "Palma Mallorca Airport"},
  {iata: "PMK", airport: "Palm Island Airport"},
  {iata: "PML", airport: "Port Moller Air Force Station"},
  {iata: "PMM", airport: "Phanom Sarakham Airport"},
  {iata: "PMN", airport: "Pumani Airport"},
  {iata: "PMO", airport: "Punta Raisi Airport"},
  {iata: "PMP", airport: "Pimaga Airport"},
  {iata: "PMQ", airport: "Perito Moreno Airport"},
  {iata: "PMR", airport: "Palmerston North Airport"},
  {iata: "PMS", airport: "Palmyra Airport"},
  {iata: "PMT", airport: "Paramakotoi Airport"},
  {iata: "PMV", airport: "DelCaribe Gen S Marino Airport"},
  {iata: "PMW", airport: "Palmas Airport"},
  {iata: "PMX", airport: "Palmer Metropolitan Airport"},
  {iata: "PMY", airport: "El Tehuelche Airport"},
  {iata: "PNA", airport: "Pamplona Airport"},
  {iata: "PNB", airport: "Porto Nacional Airport"},
  {iata: "PNC", airport: "Ponca City Airport"},
  {iata: "PND", airport: "Punta Gorda Airport"},
  {iata: "PNE", airport: "North Philadelphia Airport"},
  {iata: "PNG", airport: "Paranagua Municipal Airport"},
  {iata: "PNH", airport: "Pochentong Airport"},
  {iata: "PNI", airport: "Pohnpei Airport"},
  {iata: "PNJ", airport: "Sha He Kou Airport"},
  {iata: "PNK", airport: "Supadio Airport"},
  {iata: "PNL", airport: "Pantelleria Airport"},
  {iata: "PNN", airport: "Princeton Airport"},
  {iata: "PNO", airport: "Pinotepa Nacional Airport"},
  {iata: "PNP", airport: "Girua Airport"},
  {iata: "PNQ", airport: "Lohegaon Airport"},
  {iata: "PNR", airport: "Pointe Noire Airport"},
  {iata: "PNS", airport: "Pensacola Regional Airport"},
  {iata: "PNT", airport: "Teniente J. Gallardo Airport"},
  {iata: "PNU", airport: "Panguitch Airport"},
  {iata: "PNV", airport: "Panevezys Airport"},
  {iata: "PNX", airport: "Grayson County Airport"},
  {iata: "PNY", airport: "Pondicherry Airport"},
  {iata: "PNZ", airport: "Petrolina Internacional Airport"},
  {iata: "POA", airport: "Salgado Filho Airport"},
  {iata: "POB", airport: "Pope Air Force Base"},
  {iata: "POC", airport: "Brackett Field"},
  {iata: "POD", airport: "Podor Airport"},
  {iata: "POE", airport: "Polk Army Air Field"},
  {iata: "POF", airport: "Earl Fields Memorial Airport"},
  {iata: "POG", airport: "Port Gentil Airport"},
  {iata: "POH", airport: "Pocahontas Municipal Airport"},
  {iata: "POI", airport: "Dyess Aaf"},
  {iata: "POI", airport: "Potosi Airport"},
  {iata: "POJ", airport: "Patos De Minas Airport"},
  {iata: "POL", airport: "Pemba Airport"},
  {iata: "POM", airport: "Jackson Field"},
  {iata: "PON", airport: "Poptun Airport"},
  {iata: "POO", airport: "Pocos De Caldas Airport"},
  {iata: "POP", airport: "La Union Airport"},
  {iata: "POR", airport: "Pori Airport"},
  {iata: "POS", airport: "Piarco Airport"},
  {iata: "POT", airport: "Ken Jones Airport"},
  {iata: "POU", airport: "Dutchess County Airport"},
  {iata: "POW", airport: "Portoroz Airport"},
  {iata: "POX", airport: "Cormeille En Vexin Airport"},
  {iata: "POY", airport: "Powell/Lovell Airport"},
  {iata: "POZ", airport: "Lawica Airport"},
  {iata: "PPA", airport: "Perry Lefors Field"},
  {iata: "PPB", airport: "A. De Barros Airport"},
  {iata: "PPD", airport: "Palmas Del Mar Air Strip"},
  {iata: "PPE", airport: "Puerto Penasco Airport"},
  {iata: "PPF", airport: "Tri-City Airport"},
  {iata: "PPG", airport: "Pago Pago International Airport"},
  {iata: "PPH", airport: "Peraitepuy Airport"},
  {iata: "PPI", airport: "Port Pirie Airport"},
  {iata: "PPJ", airport: "Pulau Panjang Airport"},
  {iata: "PPK", airport: "Petropavlovsk Airport"},
  {iata: "PPL", airport: "Phaplu Airport"},
  {iata: "PPM", airport: "Pompano Beach Airport"},
  {iata: "PPN", airport: "Machangara Airport"},
  {iata: "PPP", airport: "Whitsunday Coast Airport"},
  {iata: "PPQ", airport: "Paraparaumu Airport"},
  {iata: "PPR", airport: "Pasir Pangarayan Airport"},
  {iata: "PPS", airport: "Puerto Princesa Airport"},
  {iata: "PPT", airport: "Faaa Airport"},
  {iata: "PPU", airport: "Papun Airport"},
  {iata: "PPV", airport: "Port Protection Airport"},
  {iata: "PPW", airport: "Papa Westray Airport"},
  {iata: "PPX", airport: "Param Airport"},
  {iata: "PPY", airport: "Pouso Alegre Airport"},
  {iata: "PPZ", airport: "Puerto Paez Airport"},
  {iata: "PQC", airport: "Duong Dang Airport"},
  {iata: "PQI", airport: "Presque Isle Municipal Airport"},
  {iata: "PQM", airport: "Palenque Airport"},
  {iata: "PQQ", airport: "Port Macquarie Airport"},
  {iata: "PQS", airport: "Pilot Station Airport"},
  {iata: "PRA", airport: "Parana Airport"},
  {iata: "PRB", airport: "Paso Robles Airport"},
  {iata: "PRC", airport: "Prescott Airport"},
  {iata: "PRD", airport: "Pardoo Airport"},
  {iata: "PRE", airport: "Pore Airport"},
  {iata: "PRG", airport: "Prague-Ruzyne Airport"},
  {iata: "PRH", airport: "Phrae Airport"},
  {iata: "PRI", airport: "Praslin Island Airport"},
  {iata: "PRJ", airport: "Capri Airport"},
  {iata: "PRK", airport: "Prieska Airport"},
  {iata: "PRM", airport: "Portimao Airport"},
  {iata: "PRN", airport: "Pristina Airport"},
  {iata: "PRO", airport: "Perry Municipal Airport"},
  {iata: "PRP", airport: "Propriano Airport"},
  {iata: "PRQ", airport: "Pres. Roque Saenz Pena Airport"},
  {iata: "PRR", airport: "Paruima Airport"},
  {iata: "PRS", airport: "Parasi Airport"},
  {iata: "PRU", airport: "Prome Airport"},
  {iata: "PRV", airport: "Prerov Airport"},
  {iata: "PRW", airport: "Prentice Airport"},
  {iata: "PRX", airport: "Cox Field"},
  {iata: "PRY", airport: "Wonderboom Airport"},
  {iata: "PRZ", airport: "Prineville Airport"},
  {iata: "PSA", airport: "Gal Galilei Airport"},
  {iata: "PSB", airport: "Mid-State Airport"},
  {iata: "PSC", airport: "Tri-Cities Airport"},
  {iata: "PSD", airport: "Port Said Airport"},
  {iata: "PSE", airport: "Mercedita Airport"},
  {iata: "PSF", airport: "Pittsfield Airport"},
  {iata: "PSG", airport: "Petersburg Municipal Airport"},
  {iata: "PSH", airport: "St. Peter Airport"},
  {iata: "PSI", airport: "Pasni Airport"},
  {iata: "PSJ", airport: "Poso Airport"},
  {iata: "PSK", airport: "New River Valley Airport"},
  {iata: "PSL", airport: "Perth International Airport"},
  {iata: "PSM", airport: "Pease Air Force Base"},
  {iata: "PSN", airport: "Palestine Airport"},
  {iata: "PSO", airport: "Cano Airport"},
  {iata: "PSP", airport: "Palm Springs Municipal Airport"},
  {iata: "PSQ", airport: "Philadelphia Sea Plane Base"},
  {iata: "PSR", airport: "Liberi Airport"},
  {iata: "PSS", airport: "Posadas Airport"},
  {iata: "PST", airport: "Preston Airport"},
  {iata: "PSU", airport: "Putussibau Airport"},
  {iata: "PSV", airport: "Papa Stour Airport"},
  {iata: "PSW", airport: "Passos Airport"},
  {iata: "PSX", airport: "Palacios Airport"},
  {iata: "PSY", airport: "Port Stanley Airport"},
  {iata: "PSZ", airport: "Puerto Suarez Airport"},
  {iata: "PTA", airport: "Port Alsworth Airport"},
  {iata: "PTB", airport: "Petersburg Municipal Airport"},
  {iata: "PTE", airport: "Port Stephens Airport"},
  {iata: "PTF", airport: "Malololailai Airport"},
  {iata: "PTG", airport: "Polokwane Airport"},
  {iata: "PTH", airport: "Port Heiden Airport"},
  {iata: "PTI", airport: "Port Douglas Airport"},
  {iata: "PTJ", airport: "Portland Airport"},
  {iata: "PTK", airport: "Pontiac Airport"},
  {iata: "PTM", airport: "Palmarito Airport"},
  {iata: "PTN", airport: "Patterson Municipal Heliport"},
  {iata: "PTO", airport: "Pato Branco Municipal Airport"},
  {iata: "PTP", airport: "Le Raizet Airport"},
  {iata: "PTQ", airport: "Porto de Moz Airport"},
  {iata: "PTS", airport: "Pittsburg Municipal Airport"},
  {iata: "PTT", airport: "Pratt Airport"},
  {iata: "PTU", airport: "Platinum Airport"},
  {iata: "PTV", airport: "Porterville Airport"},
  {iata: "PTW", airport: "Pottstown/Limerick Airport"},
  {iata: "PTX", airport: "Pitalito Airport"},
  {iata: "PTY", airport: "Tocumen International Airport"},
  {iata: "PTZ", airport: "Pastaza Airport"},
  {iata: "PUA", airport: "Puas Airport"},
  {iata: "PUB", airport: "Pueblo Memorial Airport"},
  {iata: "PUC", airport: "Carbon County Airport"},
  {iata: "PUD", airport: "Puerto Deseado Airport"},
  {iata: "PUE", airport: "Puerto Obaldia Airport"},
  {iata: "PUF", airport: "Uzein Airport"},
  {iata: "PUG", airport: "Port Augusta Airport"},
  {iata: "PUH", airport: "Pochutla Airport"},
  {iata: "PUI", airport: "Pureni Airport"},
  {iata: "PUJ", airport: "Punta Cana Airport"},
  {iata: "PUK", airport: "Pukarua Airport"},
  {iata: "PUL", airport: "Poulsbo Airport"},
  {iata: "PUM", airport: "Pomala Airport"},
  {iata: "PUN", airport: "Punia Airport"},
  {iata: "PUO", airport: "Prudhoe Bay Airport"},
  {iata: "PUP", airport: "Po Airport"},
  {iata: "PUQ", airport: "Pres Ibanez Airport"},
  {iata: "PUR", airport: "Puerto Rico Airport"},
  {iata: "PUS", airport: "Gimhae International Airport"},
  {iata: "PUT", airport: "Puttaprathi Airport"},
  {iata: "PUU", airport: "Puerto Asis Airport"},
  {iata: "PUV", airport: "Poum Airport"},
  {iata: "PUW", airport: "Moscow Regional Airport"},
  {iata: "PUX", airport: "Puerto Varas Airport"},
  {iata: "PUY", airport: "Pula Airport"},
  {iata: "PUZ", airport: "Puerto Cabezas Airport"},
  {iata: "PVA", airport: "Providencia Airport"},
  {iata: "PVC", airport: "Provincetown Airport"},
  {iata: "PVD", airport: "Theodore Francis Green State Airport"},
  {iata: "PVE", airport: "El Porvenir Airport"},
  {iata: "PVF", airport: "Placerville Airport"},
  {iata: "PVG", airport: "Pu Dong Airport"},
  {iata: "PVH", airport: "Belmonte Airport"},
  {iata: "PVI", airport: "Paranavia Airport"},
  {iata: "PVK", airport: "Aktion Airport"},
  {iata: "PVN", airport: "Pleven Airport"},
  {iata: "PVO", airport: "Portoviejo Airport"},
  {iata: "PVR", airport: "Ordaz"},
  {iata: "PVS", airport: "Provideniya Bay"},
  {iata: "PVS", airport: "Provideniya Airport"},
  {iata: "PVU", airport: "Provo Airport"},
  {iata: "PVW", airport: "Hale County Airport"},
  {iata: "PVX", airport: "Pope Vanoy Airport"},
  {iata: "PVZ", airport: "Casement Airport"},
  {iata: "PWA", airport: "Wiley Post Airport"},
  {iata: "PWD", airport: "Sherwood Airport"},
  {iata: "PWE", airport: "Pevek Airport"},
  {iata: "PWI", airport: "Beles Airport"},
  {iata: "PWK", airport: "Pal-Waukee Airport"},
  {iata: "PWL", airport: "Purwokerto Airport"},
  {iata: "PWM", airport: "Portland International Jetport"},
  {iata: "PWO", airport: "Pweto Airport"},
  {iata: "PWQ", airport: "Pavlodar Airport"},
  {iata: "PWT", airport: "Bremerton National Airport"},
  {iata: "PXL", airport: "Polacca Airport"},
  {iata: "PXM", airport: "Puerto Escondido Airport"},
  {iata: "PXO", airport: "Porto Santo Airport"},
  {iata: "PXR", airport: "Surin Airport"},
  {iata: "PXS", airport: "Puerto De Santa Maria Airport"},
  {iata: "PXU", airport: "Pleiku Airport"},
  {iata: "PYA", airport: "Puerto Boyaca Airport"},
  {iata: "PYB", airport: "Jeypore Airport"},
  {iata: "PYC", airport: "Playon Chico Airport"},
  {iata: "PYE", airport: "Penrhyn Island Airport"},
  {iata: "PYH", airport: "Puerto Ayacucho Airport"},
  {iata: "PYJ", airport: "Polyarnyj Airport"},
  {iata: "PYM", airport: "Plymouth Airport"},
  {iata: "PYN", airport: "Payan Airport"},
  {iata: "PYO", airport: "Putumayo Airport"},
  {iata: "PYR", airport: "Andravida Airport"},
  {iata: "PYV", airport: "Yaviza Airport"},
  {iata: "PYX", airport: "Pattaya Airport"},
  {iata: "PZA", airport: "Casanare Airport"},
  {iata: "PZB", airport: "Pietermaritzburg Airport"},
  {iata: "PZE", airport: "Penzance Airport"},
  {iata: "PZH", airport: "Zhob Airport"},
  {iata: "PZI", airport: "Pan Zhi Hua Bao An Ying"},
  {iata: "PZK", airport: "Puka Puka Island Airport"},
  {iata: "PZL", airport: "Zulu Inyala Airport"},
  {iata: "PZO", airport: "Puerto Ordaz Airport"},
  {iata: "PZU", airport: "Port Sudan Airport"},
  {iata: "QAC", airport: "Castro"},
  {iata: "QAK", airport: "Barbacena"},
  {iata: "QBC", airport: "Bella Coola Airport"},
  {iata: "QBX", airport: "Sobral"},
  {iata: "QCJ", airport: "Botucatu"},
  {iata: "QCN", airport: "Canela"},
  {iata: "QCP", airport: "Currais Novos"},
  {iata: "QCR", airport: "Curitibanos"},
  {iata: "QCU", airport: "Heliport"},
  {iata: "QDB", airport: "Cachoeira Do Sul"},
  {iata: "QDC", airport: "Dracena"},
  {iata: "QDF", airport: "Conselheiro Lafaiete"},
  {iata: "QDK", airport: "Dera Ghazi Khan"},
  {iata: "QDP", airport: "Dom Pedrito"},
  {iata: "QDV", airport: "Jundiai"},
  {iata: "QFI", airport: "Heliport"},
  {iata: "QFK", airport: "Selje Harbour"},
  {iata: "QFQ", airport: "Maloy Harbour"},
  {iata: "QFV", airport: "Bergen Rail Station"},
  {iata: "QGA", airport: "Guaira"},
  {iata: "QGC", airport: "Lencois Paulista"},
  {iata: "QGF", airport: "Montenegro"},
  {iata: "QGP", airport: "Garanhuns"},
  {iata: "QGQ", airport: "Attu Heliport"},
  {iata: "QGU", airport: "Gifu Aero"},
  {iata: "QGV", airport: "Neu Isenburg Airport"},
  {iata: "QHB", airport: "Piracicaba"},
  {iata: "QHN", airport: "Taguatinga"},
  {iata: "QHV", airport: "Novo Hamburgo"},
  {iata: "QID", airport: "Mello Viana"},
  {iata: "QIG", airport: "Iguatu"},
  {iata: "QIQ", airport: "Rio Claro"},
  {iata: "QIT", airport: "Itapetinga"},
  {iata: "QJE", airport: "Heliport"},
  {iata: "QJI", airport: "Heliport"},
  {iata: "QLA", airport: "Lasham"},
  {iata: "QLX", airport: "Lauterach Airport"},
  {iata: "QMF", airport: "Mafra"},
  {iata: "QMK", airport: "Heliport"},
  {iata: "QMM", airport: "Marina Di Massa Airport"},
  {iata: "QMQ", airport: "Muzuq Airport"},
  {iata: "QMV", airport: "Montvale Airport"},
  {iata: "QNS", airport: "Canoas Ab"},
  {iata: "QNV", airport: "Aeroclub"},
  {iata: "QNY", airport: "Marine Air Terminal"},
  {iata: "QOA", airport: "Mococa"},
  {iata: "QOJ", airport: "Sao Borja"},
  {iata: "QOX", airport: "Memmingen Ab"},
  {iata: "QPK", airport: "Strausberg"},
  {iata: "QPW", airport: "Heliport"},
  {iata: "QQM", airport: "Manchester Piccadilly"},
  {iata: "QQP", airport: "London Paddington"},
  {iata: "QRA", airport: "Randgermiston Airport"},
  {iata: "QRC", airport: "De La Independencia"},
  {iata: "QRE", airport: "Carazinho"},
  {iata: "QRF", airport: "Bragado"},
  {iata: "QRH", airport: "Metropolitan Area Airport"},
  {iata: "QRM", airport: "Narromine"},
  {iata: "QRO", airport: "Queretaro Airport"},
  {iata: "QRR", airport: "Warren"},
  {iata: "QRY", airport: "Ikerasaarsuk Heliport"},
  {iata: "QRZ", airport: "Resende"},
  {iata: "QSF", airport: "Setif Airport"},
  {iata: "QSM", airport: "Uetersen"},
  {iata: "QTL", airport: "Caratinga"},
  {iata: "QUB", airport: "Ubari Airport"},
  {iata: "QUF", airport: "Pirita Harbour Airport"},
  {iata: "QUG", airport: "Goodwood"},
  {iata: "QUN", airport: "A-306"},
  {iata: "QUP", airport: "Saqqaq Heliport"},
  {iata: "QUT", airport: "Utsunomiya Aero"},
  {iata: "QVB", airport: "Uniao Da Vitoria"},
  {iata: "QVP", airport: "Avare-Arandu"},
  {iata: "QWG", airport: "Wilgrove Air Park"},
  {iata: "QXC", airport: "Caxias"},
  {iata: "QXD", airport: "Cachoeiro Do Itapemirim"},
  {iata: "QYW", airport: "Cannes Vieux Port Ferry Service"},
  {iata: "QZN", airport: "Relizane Airport"},
  {iata: "RAA", airport: "Rakanda Airport"},
  {iata: "RAB", airport: "Tokua Airport"},
  {iata: "RAC", airport: "Horlick Airport"},
  {iata: "RAD", airport: "Road Town Airport"},
  {iata: "RAE", airport: "Arar Airport"},
  {iata: "RAF", airport: "Ras An Naqb Airport"},
  {iata: "RAG", airport: "Raglan Airport"},
  {iata: "RAH", airport: "Rafha Airport"},
  {iata: "RAI", airport: "Francisco Mendes Airport"},
  {iata: "NNS", airport: "Naini Saini Airport"},
  {iata: "RAK", airport: "Menara Airport"},
  {iata: "RAL", airport: "Riverside Municipal Airport"},
  {iata: "RAM", airport: "Ramingining Airport"},
  {iata: "RAN", airport: "La Spreta Airport"},
  {iata: "RAO", airport: "Leite Lopes Airport"},
  {iata: "RAP", airport: "Rapid City Regional Airport"},
  {iata: "RAQ", airport: "Sugimanuru Airport"},
  {iata: "RAR", airport: "Rarotonga Airport"},
  {iata: "RAS", airport: "Rasht Airport"},
  {iata: "RAT", airport: "Raduzhnyi Airport"},
  {iata: "RAU", airport: "Rangpur Airport"},
  {iata: "RAV", airport: "Cravo Norte Airport"},
  {iata: "RAW", airport: "Arawa Airport"},
  {iata: "RAX", airport: "Oram Airport"},
  {iata: "RAY", airport: "Rothsay Heliport"},
  {iata: "RAZ", airport: "Rawala Kot Airport"},
  {iata: "RBA", airport: "Sale Airport"},
  {iata: "RBB", airport: "Borba Airport"},
  {iata: "RBC", airport: "Robinvale Airport"},
  {iata: "RBD", airport: "Redbird Airport"},
  {iata: "RBE", airport: "Ratanakiri Airport"},
  {iata: "RBF", airport: "Big Bear City Airport"},
  {iata: "RBG", airport: "Roseburg Municipal Airport"},
  {iata: "RBH", airport: "Brooks Lodge Airport"},
  {iata: "RBI", airport: "Rabi Airport"},
  {iata: "RBJ", airport: "Rebun Airport"},
  {iata: "RBK", airport: "French Valley Airport"},
  {iata: "RBL", airport: "Red Bluff FSS"},
  {iata: "RBM", airport: "Wallmuhle Airport"},
  {iata: "RBN", airport: "Fort Jefferson Airport"},
  {iata: "RBO", airport: "Robore Airport"},
  {iata: "RBP", airport: "Rabaraba Airport"},
  {iata: "RBQ", airport: "Rurrenabaque Airport"},
  {iata: "RBR", airport: "Pres. Medici Airport"},
  {iata: "RBS", airport: "Orbost Airport"},
  {iata: "RBT", airport: "Marsabit Airport"},
  {iata: "RBU", airport: "Roebourne Airport"},
  {iata: "RBV", airport: "Ramata Airport"},
  {iata: "RBW", airport: "Walterboro Municipal Airport"},
  {iata: "RBY", airport: "Ruby Airport"},
  {iata: "RCA", airport: "Ellsworth Air Force Base"},
  {iata: "RCB", airport: "Richards Bay Airport"},
  {iata: "RCE", airport: "Roche Harbor Airport"},
  {iata: "RCH", airport: "Riohacha Airport"},
  {iata: "RCK", airport: "Coffield Airport"},
  {iata: "RCL", airport: "Redcliffe Airport"},
  {iata: "RCM", airport: "Richmond Airport"},
  {iata: "RCN", airport: "American River Airport"},
  {iata: "RCO", airport: "Saint Agnant Airport"},
  {iata: "RCP", airport: "Cinder Park Airport"},
  {iata: "RCQ", airport: "Reconquista Airport"},
  {iata: "RCR", airport: "Fulton County Airport"},
  {iata: "RCS", airport: "Rochester Airport"},
  {iata: "RCT", airport: "Miller Field"},
  {iata: "RCU", airport: "Rio Cuarto Airport"},
  {iata: "RDA", airport: "Rockhampton Downs Airport"},
  {iata: "RDB", airport: "Red Dog Airport"},
  {iata: "RDC", airport: "Redencao Airport"},
  {iata: "RDD", airport: "Redding Airport"},
  {iata: "RDE", airport: "Merdey Airport"},
  {iata: "RDG", airport: "Reading Municipal Airport/Spaatz Field"},
  {iata: "RDM", airport: "Roberts Field"},
  {iata: "RDN", airport: "LTS Pulau Redang Airport"},
  {iata: "RDR", airport: "Grand Forks Air Force Base"},
  {iata: "RDS", airport: "Rincon de Los Sauces Airport"},
  {iata: "RDT", airport: "Richard Toll Airport"},
  {iata: "RDU", airport: "Raleigh/Durham Airport"},
  {iata: "RDV", airport: "Red Devil Airport"},
  {iata: "RDZ", airport: "Marcillac Airport"},
  {iata: "REA", airport: "Reao Airport"},
  {iata: "REB", airport: "Rechlin Airport"},
  {iata: "REC", airport: "Guararapes International Airport"},
  {iata: "RED", airport: "Mifflin County Airport"},
  {iata: "REE", airport: "Reese Air Force Base"},
  {iata: "REG", airport: "Tito Menniti Airport"},
  {iata: "REH", airport: "Rehoboth Beach Airport"},
  {iata: "REI", airport: "Regina Airport"},
  {iata: "REL", airport: "Trelew Airport"},
  {iata: "REN", airport: "Orenburg Airport"},
  {iata: "REO", airport: "State Airport"},
  {iata: "REP", airport: "Siem Reap Airport"},
  {iata: "RER", airport: "Base Aerea Del Sur Airport"},
  {iata: "RES", airport: "Resistencia Airport"},
  {iata: "RET", airport: "Stolport Airport"},
  {iata: "REU", airport: "Reus Airport"},
  {iata: "REW", airport: "Rewa Airport"},
  {iata: "REX", airport: "Gen Lucio Blanco Airport"},
  {iata: "REY", airport: "Reyes Airport"},
  {iata: "REZ", airport: "Resende Airport"},
  {iata: "RFA", airport: "Rafai Airport"},
  {iata: "RFD", airport: "Chicago/Rockford International Airport"},
  {iata: "RFG", airport: "Rooke Field"},
  {iata: "RFK", airport: "Rollang Field"},
  {iata: "RFN", airport: "Raufarhofn Airport"},
  {iata: "RFP", airport: "Raiatea Airport"},
  {iata: "RFR", airport: "Rio Frio Airport"},
  {iata: "RFS", airport: "Rosita Airport"},
  {iata: "RGA", airport: "Rio Grande Airport"},
  {iata: "RGE", airport: "Porgera Airport"},
  {iata: "RGH", airport: "Balurghat Airport"},
  {iata: "RGI", airport: "Rangiroa Airport"},
  {iata: "RGL", airport: "Rio Gallegos Internacional Airport"},
  {iata: "RGN", airport: "Mingaladon Airport"},
  {iata: "RGR", airport: "Ranger Municipal Airport"},
  {iata: "RGT", airport: "Japura Airport"},
  {iata: "RHA", airport: "Reykholar Airport"},
  {iata: "RHD", airport: "Rio Hondo Airport"},
  {iata: "RHE", airport: "Reims Airport"},
  {iata: "RHG", airport: "Ruhengeri Airport"},
  {iata: "RHI", airport: "Oneida County Airport"},
  {iata: "RHL", airport: "Roy Hill Airport"},
  {iata: "RHN", airport: "Rosh Pina Airport"},
  {iata: "RHO", airport: "Diagoras Airport"},
  {iata: "RHP", airport: "Ramechhap Airport"},
  {iata: "RHV", airport: "Reid-Hillview Airport"},
  {iata: "RIA", airport: "Base Aerea Airport"},
  {iata: "RIB", airport: "Gen Buech Airport"},
  {iata: "RIC", airport: "Richmond International Airport (Byrd Field)"},
  {iata: "RID", airport: "Richmond Airport"},
  {iata: "RIE", airport: "Rice Lake Airport"},
  {iata: "RIF", airport: "Reynolds Airport"},
  {iata: "RIG", airport: "Rio Grande Airport"},
  {iata: "RIJ", airport: "Rioja Airport"},
  {iata: "RIK", airport: "Carrillo Airport"},
  {iata: "RIL", airport: "Garfield County Airport"},
  {iata: "RIM", airport: "Rodriguez De Mendoza Airport"},
  {iata: "RIN", airport: "Ringi Cove Airport"},
  {iata: "RIR", airport: "Riverside Fla-Bob Airport"},
  {iata: "RIS", airport: "Rishiri Airport"},
  {iata: "RIT", airport: "Rio Tigre Airport"},
  {iata: "RIV", airport: "March Air Force Base"},
  {iata: "RIW", airport: "Riverton Airport"},
  {iata: "RIX", airport: "Riga Airport"},
  {iata: "RIY", airport: "Riyan Airport"},
  {iata: "RIZ", airport: "Rio Alzucar Airport"},
  {iata: "RJA", airport: "Rajahmundry Airport"},
  {iata: "RJB", airport: "Rajbiraj Airport"},
  {iata: "RJH", airport: "Rajshahi Airport"},
  {iata: "RJI", airport: "Rajouri Airport"},
  {iata: "RJK", airport: "Rijeka Airport"},
  {iata: "RJL", airport: "Agoncillo Airport"},
  {iata: "RJN", airport: "Rafsanjan Airport"},
  {iata: "RKC", airport: "Yreka Airport"},
  {iata: "RKD", airport: "Knox County Regional Airport"},
  {iata: "RKE", airport: "Roskilde Airport"},
  {iata: "RKH", airport: "Rock Hill Airport"},
  {iata: "RKI", airport: "Rokot Airport"},
  {iata: "RKO", airport: "Sipora Airport"},
  {iata: "RKP", airport: "Aransas County Airport"},
  {iata: "RKR", airport: "Robert S. Kerr Airport"},
  {iata: "RKS", airport: "Sweetwater County Airport"},
  {iata: "RKU", airport: "Kairuku Airport"},
  {iata: "RKV", airport: "Reykjavik Domestic Airport"},
  {iata: "RKW", airport: "Rockwood Municipal Airport"},
  {iata: "RKY", airport: "Rokeby Airport"},
  {iata: "RLA", airport: "National Airport"},
  {iata: "RLD", airport: "Richland Airport"},
  {iata: "RLG", airport: "Laage Airport"},
  {iata: "RLI", airport: "Reilly Army Heliport"},
  {iata: "RLO", airport: "Aeropuerto Internacional Valle del Mercosur S.A."},
  {iata: "RLP", airport: "Rosella Plains Airport"},
  {iata: "RLT", airport: "Arlit Airport"},
  {iata: "RMA", airport: "Roma Airport"},
  {iata: "RMC", airport: "Machesney Airport"},
  {iata: "RMD", airport: "Ramagundam Airport"},
  {iata: "RME", airport: "Griffiss Air Force Base"},
  {iata: "RMF", airport: "Marsa Alam Airport"},
  {iata: "RMG", airport: "Richard B Russell Airport"},
  {iata: "RMI", airport: "Miramare Airport"},
  {iata: "RMK", airport: "Renmark Airport"},
  {iata: "RML", airport: "Ratmalana Airport"},
  {iata: "RMN", airport: "Rumginae Airport"},
  {iata: "RMP", airport: "Rampart Airport"},
  {iata: "RMQ", airport: "Taichung Airport"},
  {iata: "RMS", airport: "Ramstein Airport"},
  {iata: "RNA", airport: "Ulawa Airport"},
  {iata: "RNB", airport: "Kallinge Airport"},
  {iata: "RNC", airport: "Warren County Airport"},
  {iata: "RND", airport: "Randolph Air Force Base"},
  {iata: "RNE", airport: "Renaison Airport"},
  {iata: "RNG", airport: "Rangely Airport"},
  {iata: "RNH", airport: "New Richmond Municipal Airport"},
  {iata: "RNI", airport: "Corn Island Airport"},
  {iata: "RNJ", airport: "Yoronjima Airport"},
  {iata: "RNL", airport: "Rennell Airport"},
  {iata: "RNN", airport: "Bornholm Airport"},
  {iata: "RNO", airport: "Reno/Tahoe International Airport"},
  {iata: "RNP", airport: "Rongelap Airport"},
  {iata: "RNR", airport: "Robinson River Airport"},
  {iata: "RNS", airport: "St Jacques Airport"},
  {iata: "RNT", airport: "Renton Airport"},
  {iata: "RNU", airport: "Ranau Airport"},
  {iata: "RNZ", airport: "Rensselaer Airport"},
  {iata: "ROA", airport: "Roanoke Regional Airport"},
  {iata: "ROB", airport: "Roberts International Airport"},
  {iata: "ROC", airport: "Greater Rochester International Airport"},
  {iata: "ROD", airport: "Robertson Airport"},
  {iata: "ROG", airport: "Rogers Airport"},
  {iata: "ROH", airport: "Robinhood Airport"},
  {iata: "ROI", airport: "Roi Et Airport"},
  {iata: "ROK", airport: "Rockhampton Airport"},
  {iata: "ROL", airport: "Roosevelt Airport"},
  {iata: "RON", airport: "Rondon Airport"},
  {iata: "ROO", airport: "Rondonopolis Airport"},
  {iata: "ROP", airport: "Rota Airport"},
  {iata: "ROR", airport: "Airai Airport"},
  {iata: "ROS", airport: "Fisherton Airport"},
  {iata: "ROT", airport: "Rotorua Airport"},
  {iata: "ROU", airport: "Rousse Airport"},
  {iata: "ROV", airport: "Rostov Airport"},
  {iata: "ROW", airport: "Industrial Airport"},
  {iata: "ROX", airport: "Roseau Municipal Airport"},
  {iata: "ROY", airport: "Rio Mayo Airport"},
  {iata: "RPA", airport: "Rolpa Airport"},
  {iata: "RPB", airport: "Roper Bar Airport"},
  {iata: "RPM", airport: "Ngukurr Airport"},
  {iata: "RPR", airport: "Raipur Airport"},
  {iata: "RPV", airport: "Roper Valley Airport"},
  {iata: "RPX", airport: "Roundup Airport"},
  {iata: "RRA", airport: "Ronda Airport"},
  {iata: "RRE", airport: "Marree Airport"},
  {iata: "RRK", airport: "Rourkela Airport"},
  {iata: "RRL", airport: "Merrill Municipal Airport"},
  {iata: "RRM", airport: "Marromeu Airport"},
  {iata: "RRN", airport: "Serra Do Norte Airport"},
  {iata: "RRO", airport: "Sorrento Airport"},
  {iata: "RRS", airport: "Roros Airport"},
  {iata: "RRT", airport: "Warroad Airport"},
  {iata: "RRV", airport: "Robinson River Airport"},
  {iata: "RSA", airport: "Santa Rosa Airport"},
  {iata: "RSB", airport: "Roseberth Airport"},
  {iata: "RSD", airport: "South Eleuthera Airport"},
  {iata: "RSE", airport: "Au-Rose Bay Airport"},
  {iata: "RSG", airport: "Serra Pelada Airport"},
  {iata: "RSH", airport: "Russian Sea Plane Base"},
  {iata: "RSI", airport: "Rio Sidra Airport"},
  {iata: "RSJ", airport: "Rosario Sea Plane Base"},
  {iata: "RSK", airport: "Ransiki Airport"},
  {iata: "RSL", airport: "Russell Airport"},
  {iata: "RSN", airport: "Ruston Airport"},
  {iata: "RSS", airport: "Roseires Airport"},
  {iata: "RST", airport: "Rochester Municipal Airport"},
  {iata: "RSU", airport: "Yeosu Airport"},
  {iata: "RSW", airport: "Southwest Florida International Airport"},
  {iata: "RSX", airport: "Rouses Point Airport"},
  {iata: "RTA", airport: "Rotuma Island Airport"},
  {iata: "RTB", airport: "Roatan Airport"},
  {iata: "RTC", airport: "Ratnagiri Airport"},
  {iata: "RTD", airport: "Rotunda Airport"},
  {iata: "RTG", airport: "Ruteng Airport"},
  {iata: "RTI", airport: "Roti Airport"},
  {iata: "RTL", airport: "Spirit Lake Airport"},
  {iata: "RTM", airport: "Rotterdam Airport"},
  {iata: "RTN", airport: "Crews Field"},
  {iata: "RTP", airport: "Rutland Plains Airport"},
  {iata: "RTS", airport: "Rottnest Island Airport"},
  {iata: "RTW", airport: "Saratov Airport"},
  {iata: "RTY", airport: "Merty Airport"},
  {iata: "RUA", airport: "Arua Airport"},
  {iata: "RUF", airport: "Yuruf, Irian Jaya Airport"},
  {iata: "RUG", airport: "Rugao Airport"},
  {iata: "RUH", airport: "King Khaled International Airport"},
  {iata: "RUI", airport: "Ruidoso Municipal Airport"},
  {iata: "RUK", airport: "Rukumkot Airport"},
  {iata: "RUM", airport: "Rumjatar Airport"},
  {iata: "RUN", airport: "Gillot Airport"},
  {iata: "RUP", airport: "Rupsi Airport"},
  {iata: "RUR", airport: "Rurutu Airport"},
  {iata: "RUS", airport: "Marau Sound Airport"},
  {iata: "RUT", airport: "Rutland Airport"},
  {iata: "RUU", airport: "Ruti Airport"},
  {iata: "RUV", airport: "Rubelsanto Airport"},
  {iata: "RUY", airport: "Copan Airport"},
  {iata: "RVA", airport: "Farafangana Airport"},
  {iata: "RVC", airport: "Rivercess Airport"},
  {iata: "RVD", airport: "Rio Verde Airport"},
  {iata: "RVE", airport: "Saravena Airport"},
  {iata: "RVH", airport: "Rzhevka Airport"},
  {iata: "RVK", airport: "Ryumsjoen Airport"},
  {iata: "RVN", airport: "Rovaniemi Airport"},
  {iata: "RVO", airport: "Reivilo Airport"},
  {iata: "RVR", airport: "Green River Airport"},
  {iata: "RVS", airport: "R. Lloyd Jones Airport"},
  {iata: "RVT", airport: "Ravensthorpe Airport"},
  {iata: "RVV", airport: "Raivavae Airport"},
  {iata: "RVY", airport: "Rivera Airport"},
  {iata: "RWF", airport: "Redwood Falls Municipal Airport"},
  {iata: "RWI", airport: "Rocky Mount-Wilson Airport"},
  {iata: "RWL", airport: "Rawlins Airport"},
  {iata: "RWN", airport: "Rovno Airport"},
  {iata: "RWS", airport: "Sumare Airport"},
  {iata: "RXA", airport: "Raudha Airport"},
  {iata: "RXS", airport: "Roxas City Airport"},
  {iata: "RYB", airport: "Rybinsk Airport"},
  {iata: "RYG", airport: "Moss-Rygge Airport"},
  {iata: "RYG", airport: "Rygge Ab"},
  {iata: "RYK", airport: "Rahim Yar Khan Airport"},
  {iata: "RYN", airport: "Medis Airport"},
  {iata: "RYO", airport: "Rio Turbio Airport"},
  {iata: "RZA", airport: "Santa Cruz Airport"},
  {iata: "RZE", airport: "Jasionka Airport"},
  {iata: "RZH", airport: "Quartz Hill Airport"},
  {iata: "RZN", airport: "Ryazan Airport"},
  {iata: "RZP", airport: "CLR Airport"},
  {iata: "RZR", airport: "Ramsar Airport"},
  {iata: "RZS", airport: "Sawan Airport"},
  {iata: "RZY", airport: "Rezayieh Airport"},
  {iata: "RZZ", airport: "Halifax County Airport"},
  {iata: "SAA", airport: "Shively Airport"},
  {iata: "SAB", airport: "J. Yrausquin Airport"},
  {iata: "SAC", airport: "Executive Airport"},
  {iata: "SAD", airport: "Safford Airport"},
  {iata: "SAE", airport: "Sangir Airport"},
  {iata: "SAF", airport: "Santa Fe Airport"},
  {iata: "SAI", airport: "San Marino Airport"},
  {iata: "SAJ", airport: "Sirajganj Airport"},
  {iata: "SAK", airport: "Saudarkrokur Airport"},
  {iata: "SAL", airport: "Comalapa International Airport"},
  {iata: "SAL", airport: "Comalapa International Airport"},
  {iata: "SAM", airport: "Salamo Airport"},
  {iata: "SAN", airport: "San Diego International Airport"},
  {iata: "SAP", airport: "Ramon Villeda Morales Airport"},
  {iata: "SAQ", airport: "San Andros Airport"},
  {iata: "SAR", airport: "Sparta Community Airport"},
  {iata: "SAS", airport: "Salton City Airport"},
  {iata: "SAT", airport: "San Antonio International Airport"},
  {iata: "SAU", airport: "Sawu Airport"},
  {iata: "SAV", airport: "Savannah/Hilton Head Airport"},
  {iata: "IAO", airport: "Siargao Airport"},
  {iata: "SAW", airport: "Sabiha Gokcen"},
  {iata: "SAX", airport: "Sambu Airport"},
  {iata: "SAY", airport: "Siena Airport"},
  {iata: "SAZ", airport: "Sasstown Airport"},
  {iata: "SBA", airport: "Santa Barbara Municipal Airport"},
  {iata: "SBB", airport: "Santa Barbara Ba Airport"},
  {iata: "SBC", airport: "Selbang Airport"},
  {iata: "SBD", airport: "Norton Air Force Base"},
  {iata: "SBE", airport: "Suabi Airport"},
  {iata: "SBF", airport: "Sardeh Band Airport"},
  {iata: "SBG", airport: "Sabang Airport"},
  {iata: "SBH", airport: "St. Barthelemy Airport"},
  {iata: "SBI", airport: "Sambailo Airport"},
  {iata: "SBJ", airport: "Sao Mateus Airport"},
  {iata: "SBK", airport: "Tremuson Airport"},
  {iata: "SBL", airport: "Yacuma Airport"},
  {iata: "SBM", airport: "Sheboygan Memorial Airport"},
  {iata: "SBN", airport: "South Bend Regional"},
  {iata: "SBO", airport: "Salina Airport"},
  {iata: "SBP", airport: "County Airport"},
  {iata: "SBQ", airport: "Sibi Airport"},
  {iata: "SBR", airport: "Saibai Island Airport"},
  {iata: "SBS", airport: "Steamboat Springs Airport"},
  {iata: "SBT", airport: "Tri-City Airport"},
  {iata: "SBU", airport: "Springbok Airport"},
  {iata: "SBV", airport: "Sabah Airport"},
  {iata: "SBW", airport: "Sibu Airport"},
  {iata: "SBX", airport: "Shelby Airport"},
  {iata: "SBY", airport: "Wicomico County Airport"},
  {iata: "SBZ", airport: "Sibiu Airport"},
  {iata: "SCA", airport: "Santa Catalina Airport"},
  {iata: "SCB", airport: "State Airport"},
  {iata: "SCC", airport: "Prudhoe Bay/Deadhorse Airport"},
  {iata: "SCD", airport: "Sulaco Airport"},
  {iata: "SCE", airport: "University Park Airport"},
  {iata: "SCF", airport: "Scottsdale Municipal Airport"},
  {iata: "SCG", airport: "Spring Creek Airport"},
  {iata: "SCH", airport: "County Airport"},
  {iata: "SCI", airport: "San Cristobal Airport"},
  {iata: "SCJ", airport: "Smith Cove Airport"},
  {iata: "SCK", airport: "Stockton Airport"},
  {iata: "SCL", airport: "Arturo Merino Benitez Airport"},
  {iata: "SCM", airport: "Scammon Bay Sea Plane Base"},
  {iata: "SCN", airport: "Ensheim Airport"},
  {iata: "SCO", airport: "Aktau Airport"},
  {iata: "SCP", airport: "Saint Crepin Airport"},
  {iata: "SCQ", airport: "Santiago De Compostela Airport"},
  {iata: "SCR", airport: "Scranton Municipal Airport"},
  {iata: "SCS", airport: "Scatsta Airport"},
  {iata: "SCT", airport: "Socotra Airport"},
  {iata: "SCU", airport: "Antonio Maceo Airport"},
  {iata: "SCV", airport: "Salcea Airport"},
  {iata: "SCW", airport: "Syktyvkar Airport"},
  {iata: "SCX", airport: "Salina Cruz Airport"},
  {iata: "SCY", airport: "San Cristobal Airport"},
  {iata: "SCZ", airport: "Santa Cruz Island Airport"},
  {iata: "SDA", airport: "Baghdad International Airport"},
  {iata: "SDB", airport: "Langebaanweg Airport"},
  {iata: "SDC", airport: "Sandcreek Airport"},
  {iata: "SDD", airport: "Lubango Airport"},
  {iata: "SDE", airport: "Santiago Del Estero Airport"},
  {iata: "SDF", airport: "Louisville International Airport"},
  {iata: "SDG", airport: "Sanandaj Airport"},
  {iata: "SDH", airport: "Santa Rosa De Copan Airport"},
  {iata: "SDI", airport: "Saidor Airport"},
  {iata: "SDJ", airport: "Sendai Airport"},
  {iata: "SDK", airport: "Sandakan Airport"},
  {iata: "SDL", airport: "Sundsvall/Harnosand Airport"},
  {iata: "SDM", airport: "Brown Field Municipal Airport"},
  {iata: "SDN", airport: "Sandane Airport"},
  {iata: "SDO", airport: "Ryotsu Sado Island Airport"},
  {iata: "SDP", airport: "Sand Point Municipal Airport"},
  {iata: "SDQ", airport: "Las Americas Airport"},
  {iata: "SDR", airport: "Santander Airport"},
  {iata: "SDS", airport: "Sado Shima Airport"},
  {iata: "SDT", airport: "Saidu Sharif Airport"},
  {iata: "SDU", airport: "Santos Dumont Airport"},
  {iata: "SDW", airport: "Sandwip Airport"},
  {iata: "SDX", airport: "Sedona Airport"},
  {iata: "SDY", airport: "Richland Municipal Airport"},
  {iata: "SEA", airport: "Seattle/Tacoma International Airport"},
  {iata: "SEB", airport: "Sebha Airport"},
  {iata: "SEC", airport: "Serre Chevalier Airport"},
  {iata: "SEE", airport: "Gillespie Field"},
  {iata: "SEF", airport: "Sebring Air Terminal"},
  {iata: "SEG", airport: "Penn Valley Airport"},
  {iata: "SEH", airport: "Senggeh Airport"},
  {iata: "SEI", airport: "Senhor Do Bonfim Airport"},
  {iata: "SEJ", airport: "Seydisfjordur Airport"},
  {iata: "SEK", airport: "Ksar Es Souk Airport"},
  {iata: "SEM", airport: "Craig Air Force Base"},
  {iata: "SEN", airport: "Southend Municipal Airport"},
  {iata: "SEP", airport: "Clark Field"},
  {iata: "SEQ", airport: "Sungaipinang Airport"},
  {iata: "SER", airport: "Freeman Municipal Airport"},
  {iata: "SES", airport: "Selfield Airport"},
  {iata: "SET", airport: "San Esteban Airport"},
  {iata: "SEU", airport: "Seronera Airport"},
  {iata: "SEV", airport: "Severodoneck Airport"},
  {iata: "SEW", airport: "Siwa Airport"},
  {iata: "SEX", airport: "Sembach Airport"},
  {iata: "SEY", airport: "Selibaby Airport"},
  {iata: "SEZ", airport: "Seychelles International Airport"},
  {iata: "SFA", airport: "Sfax El Maou Airport"},
  {iata: "SFB", airport: "Orlando Sanford International Airport"},
  {iata: "SFC", airport: "Saint Francois Airport"},
  {iata: "SFD", airport: "Las Flecheras Airport"},
  {iata: "SFE", airport: "San Fernando Airport"},
  {iata: "SFF", airport: "Felts Field"},
  {iata: "SFG", airport: "Esperance Airport"},
  {iata: "SFH", airport: "San Felipe Airport"},
  {iata: "SFI", airport: "Safi Airport"},
  {iata: "SFJ", airport: "Kangerlussuaq Airport"},
  {iata: "SFK", airport: "Soure Airport"},
  {iata: "SFL", airport: "Sao Filipe Airport"},
  {iata: "SFM", airport: "Sanford Airport"},
  {iata: "SFN", airport: "Santa Fe Airport"},
  {iata: "SFO", airport: "SFO International Airport"},
  {iata: "SFP", airport: "Surfers Paradise Airport"},
  {iata: "SFQ", airport: "Sanliurfa Airport"},
  {iata: "SFR", airport: "San Fernando Airport"},
  {iata: "SFS", airport: "Subic Bay International Airport"},
  {iata: "SFT", airport: "Skelleftea Airport"},
  {iata: "SFU", airport: "Safia Airport"},
  {iata: "SFV", airport: "Santa Fe Do Sul Airport"},
  {iata: "SFW", airport: "Santa Fe Airport"},
  {iata: "SFX", airport: "San Felix Airport"},
  {iata: "SFZ", airport: "North Central Airport"},
  {iata: "SGA", airport: "Sheghnan Airport"},
  {iata: "SGB", airport: "Singaua Airport"},
  {iata: "SGC", airport: "Surgut Airport"},
  {iata: "SGD", airport: "Sonderborg Airport"},
  {iata: "SGE", airport: "Siegerland Airport"},
  {iata: "SGF", airport: "Springfield-Branson Regional Airport"},
  {iata: "SGG", airport: "Simanggang Airport"},
  {iata: "SGH", airport: "Springfield Airport"},
  {iata: "SGI", airport: "Sargodha Airport"},
  {iata: "SGJ", airport: "Sagarai Airport"},
  {iata: "SGK", airport: "Sangapi Airport"},
  {iata: "SGL", airport: "Sangley Point NAS"},
  {iata: "SGL", airport: "Aeropuerto Los Pozos"},
  {iata: "SGM", airport: "San Ignacio Airport"},
  {iata: "SGN", airport: "Ho Chi Minh City Airport"},
  {iata: "SGO", airport: "St. George Airport"},
  {iata: "SGP", airport: "Shay Gap Airport"},
  {iata: "SGQ", airport: "Sanggata Airport"},
  {iata: "SGR", airport: "Sugar Land Municipal Airport"},
  {iata: "SGS", airport: "Sanga Sanga Airport"},
  {iata: "SGT", airport: "Stuttgart Airport"},
  {iata: "SGU", airport: "Saint George Municipal Airport"},
  {iata: "SGV", airport: "Sierra Grande Airport"},
  {iata: "SGX", airport: "Songea Airport"},
  {iata: "SGY", airport: "Skagway Municipal Airport"},
  {iata: "SGZ", airport: "Songkhla Airport"},
  {iata: "SHA", airport: "Hongqiao Airport"},
  {iata: "SHB", airport: "Nakashibetsu Airport"},
  {iata: "SHC", airport: "Indaselassie Airport"},
  {iata: "SHD", airport: "Shenandoah Valley Airport"},
  {iata: "SHE", airport: "Shenyang Airport"},
  {iata: "SHF", airport: "Shanhaiguan Airport"},
  {iata: "SHG", airport: "Shungnak Airport"},
  {iata: "SHH", airport: "Shishmaref Airport"},
  {iata: "SHI", airport: "Shimojishima Airport"},
  {iata: "SHJ", airport: "Sharjah Airport"},
  {iata: "SHK", airport: "Sehonghong Airport"},
  {iata: "SHL", airport: "Shillong Airport"},
  {iata: "SHM", airport: "Shirahama Airport"},
  {iata: "SHN", airport: "Sanderson Field"},
  {iata: "SHO", airport: "Seolak Airport"},
  {iata: "SHP", airport: "Qinhuangdao Airport"},
  {iata: "SHQ", airport: "Southport Airport"},
  {iata: "SHR", airport: "Sheridan Airport"},
  {iata: "SHS", airport: "Shashi Airport"},
  {iata: "SHT", airport: "Shepparton Airport"},
  {iata: "SHU", airport: "Smith Point Airport"},
  {iata: "SHV", airport: "Shreveport Regional Airport"},
  {iata: "SHW", airport: "Sharurah Airport"},
  {iata: "SHX", airport: "Shageluk Airport"},
  {iata: "SHY", airport: "Shinyanga Airport"},
  {iata: "SHZ", airport: "Seshutes Airport"},
  {iata: "SIA", airport: "Xiguan Airport"},
  {iata: "SIB", airport: "Sibiti Airport"},
  {iata: "SIC", airport: "Sinop Airport"},
  {iata: "SID", airport: "Amilcar Cabral International Airport"},
  {iata: "SIE", airport: "Sines Airport"},
  {iata: "SIF", airport: "Simara Airport"},
  {iata: "SIG", airport: "Isla Grande Airport"},
  {iata: "SIH", airport: "Silgarhi Doti Airport"},
  {iata: "SII", airport: "Sidi Ifni Airport"},
  {iata: "SIJ", airport: "Siglufjordur Airport"},
  {iata: "SIK", airport: "Sikeston Memorial Airport"},
  {iata: "SIL", airport: "Sila Airport"},
  {iata: "SIM", airport: "Simbai Airport"},
  {iata: "SIN", airport: "Changi Airport"},
  {iata: "SIO", airport: "Smithton Airport"},
  {iata: "SIP", airport: "Simferopol Airport"},
  {iata: "SIQ", airport: "Dabo Airport"},
  {iata: "SIR", airport: "Sion Airport"},
  {iata: "SIS", airport: "Sishen Airport"},
  {iata: "SIT", airport: "Sitka Airport"},
  {iata: "SIU", airport: "Siuna Airport"},
  {iata: "SIV", airport: "Sullivan County Airport"},
  {iata: "SIX", airport: "Singleton Airport"},
  {iata: "SIY", airport: "Siskiyou County Airport"},
  {iata: "SIZ", airport: "Sissano Airport"},
  {iata: "SJA", airport: "San Juan Airport"},
  {iata: "SJB", airport: "San Joaquin Airport"},
  {iata: "SJC", airport: "Norman Y. Mineta San Jose International Airport"},
  {iata: "SJD", airport: "Los Cabos Airport"},
  {iata: "SJE", airport: "San Jose Del Gua Airport"},
  {iata: "SJF", airport: "St. John Island Airport"},
  {iata: "SJG", airport: "San Pedro Jagua Airport"},
  {iata: "SJH", airport: "San Juan Del Cesar Airport"},
  {iata: "SJI", airport: "McGuire Field"},
  {iata: "SJJ", airport: "Butmir Airport"},
  {iata: "SJK", airport: "Sao Jose dos Campos Airport"},
  {iata: "SJL", airport: "Sao Gabriel Da Cachoeira"},
  {iata: "SJL", airport: "Da Cachoeira Airport"},
  {iata: "SJM", airport: "San Juan Airport"},
  {iata: "SJN", airport: "Saint Johns Municipal Airport"},
  {iata: "SJO", airport: "Juan Santamaria International Airport"},
  {iata: "SJP", airport: "Sao Jose Do Rio Preto Airport"},
  {iata: "SJQ", airport: "Sesheke Airport"},
  {iata: "SJR", airport: "San Juan De Uraba Airport"},
  {iata: "SJS", airport: "San Jose Airport"},
  {iata: "SJT", airport: "Mathis Field"},
  {iata: "SJV", airport: "San Javier Airport"},
  {iata: "SJW", airport: "Daguocun Airport"},
  {iata: "SJX", airport: "Sartaneja Airport"},
  {iata: "SJY", airport: "Ilmajoki Airport"},
  {iata: "SJZ", airport: "Sao Jorge Island Airport"},
  {iata: "SKA", airport: "Fairchild Air Force Base"},
  {iata: "SKB", airport: "Golden Rock Airport"},
  {iata: "SKC", airport: "Suki Airport"},
  {iata: "SKD", airport: "Samarkand Airport"},
  {iata: "SKE", airport: "Skien Airport"},
  {iata: "SKF", airport: "Kelly Air Force Base"},
  {iata: "SKG", airport: "Makedonia Airport"},
  {iata: "SKH", airport: "Surkhet Airport"},
  {iata: "SKI", airport: "Skikda Airport"},
  {iata: "SKK", airport: "Shaktoolik Airport"},
  {iata: "SKL", airport: "Broadford Airport"},
  {iata: "SKM", airport: "Skeldon Airport"},
  {iata: "SKN", airport: "Skagen Airport"},
  {iata: "SKO", airport: "Sokoto Airport"},
  {iata: "SKP", airport: "Skopje Airport"},
  {iata: "SKQ", airport: "Sekakes Airport"},
  {iata: "SKR", airport: "Shakiso Airport"},
  {iata: "SKS", airport: "Vojens Airport"},
  {iata: "SKT", airport: "Sialkot Airport"},
  {iata: "SKU", airport: "Skiros Airport"},
  {iata: "SKV", airport: "Mount Sinai Airport"},
  {iata: "SKX", airport: "Saransk Airport"},
  {iata: "SKY", airport: "Griffin Sandusky Airport"},
  {iata: "SKZ", airport: "Sukkur Airport"},
  {iata: "SLA", airport: "Gen Belgrano Airport"},
  {iata: "SLB", airport: "Storm Lake Municipal Airport"},
  {iata: "SLC", airport: "Salt Lake City International Airport"},
  {iata: "SLD", airport: "Sliac Airport"},
  {iata: "SLE", airport: "McNary Field"},
  {iata: "SLF", airport: "Sulayel Airport"},
  {iata: "SLG", airport: "Smith Field"},
  {iata: "SLH", airport: "Sola Airport"},
  {iata: "SLI", airport: "Solwezi Airport"},
  {iata: "SLJ", airport: "Stellar Air Park"},
  {iata: "SLK", airport: "Adirondack Airport"},
  {iata: "SLL", airport: "Salalah Airport"},
  {iata: "SLM", airport: "Matacan Airport"},
  {iata: "SLN", airport: "Salina Airport"},
  {iata: "SLO", airport: "Leckrone Airport"},
  {iata: "SLP", airport: "San Luis Potosi Airport"},
  {iata: "SLQ", airport: "Sleetmute Airport"},
  {iata: "SLR", airport: "Sulphur Springs Airport"},
  {iata: "SLS", airport: "Silistra Airport"},
  {iata: "SLT", airport: "Salida Airport"},
  {iata: "SLU", airport: "Vigie Field"},
  {iata: "SLV", airport: "Simla Airport"},
  {iata: "SLW", airport: "Saltillo Airport"},
  {iata: "SLX", airport: "Salt Cay Airport"},
  {iata: "SLY", airport: "Salehard Airport"},
  {iata: "SLZ", airport: "Mal. Cunha MaMalio Airport"},
  {iata: "SMA", airport: "Vila Do Porto Airport"},
  {iata: "SMB", airport: "Cerro Sombrero Airport"},
  {iata: "SMC", airport: "Santa Maria Airport"},
  {iata: "SMD", airport: "Smith Field"},
  {iata: "SME", airport: "Pulaski County Airport"},
  {iata: "SMF", airport: "Sacramento International Airport"},
  {iata: "SMG", airport: "Santa Maria Airport"},
  {iata: "SMH", airport: "Sapmanga Airport"},
  {iata: "SMI", airport: "Samos Airport"},
  {iata: "SMJ", airport: "Sim Airport"},
  {iata: "SMK", airport: "St. Michael Airport"},
  {iata: "SML", airport: "Estate Airstrip"},
  {iata: "SMM", airport: "Semporna Airport"},
  {iata: "SMN", airport: "Salmon Airport"},
  {iata: "SMO", airport: "Santa Monica Airport"},
  {iata: "SMP", airport: "Stockholm Airport"},
  {iata: "SMQ", airport: "Sampit Airport"},
  {iata: "SMR", airport: "Simon Bolivar Airport"},
  {iata: "SMS", airport: "Sainte Marie Airport"},
  {iata: "SMT", airport: "Sun Moon Lake Airport"},
  {iata: "SMV", airport: "Samedan Airport"},
  {iata: "SMW", airport: "Smara Airport"},
  {iata: "SMX", airport: "Santa Maria Public Airport"},
  {iata: "SMY", airport: "Simenti Airport"},
  {iata: "SMZ", airport: "Stoelmanseiland Airport"},
  {iata: "SNA", airport: "John Wayne Airport"},
  {iata: "SNB", airport: "Snake Bay Airport"},
  {iata: "SNC", airport: "Salinas Airport"},
  {iata: "SND", airport: "Seno Airport"},
  {iata: "SNE", airport: "Preguica Airport"},
  {iata: "SNF", airport: "San Felipe Airport"},
  {iata: "SNG", airport: "San Ignacio De Velasco Airport"},
  {iata: "SNH", airport: "Stanthorpe Airport"},
  {iata: "SNI", airport: "R. E. Murray Airport"},
  {iata: "SNJ", airport: "San Julian Airport"},
  {iata: "SNK", airport: "Winston Field"},
  {iata: "SNL", airport: "Shawnee Municipal Airport"},
  {iata: "SNM", airport: "San Ignacio De Moxos Airport"},
  {iata: "SNN", airport: "Shannon Airport"},
  {iata: "SNO", airport: "Sakon Nakhon Airport"},
  {iata: "SNP", airport: "Saint Paul Island Airport"},
  {iata: "SNQ", airport: "San Quintin Airport"},
  {iata: "SNR", airport: "Montoir Airport"},
  {iata: "SNS", airport: "Salinas Airport"},
  {iata: "SNT", airport: "Sabana De Torres Airport"},
  {iata: "SNU", airport: "Santa Clara Airport"},
  {iata: "SNV", airport: "Santa Elena Airport"},
  {iata: "SNW", airport: "Thandwe Airport"},
  {iata: "SNX", airport: "Sabana De Mar Airport"},
  {iata: "SNY", airport: "Sidney Airport"},
  {iata: "SNZ", airport: "Santa Cruz Ab"},
  {iata: "SNZ", airport: "Santa Cruz Airport"},
  {iata: "SOA", airport: "Soc Trang Airport"},
  {iata: "SOB", airport: "Saarmelleek/Balaton Airport"},
  {iata: "SOC", airport: "Adi Sumarmo Airport"},
  {iata: "SOD", airport: "Sorocaba Airport"},
  {iata: "SOE", airport: "Souanke Airport"},
  {iata: "SOF", airport: "Sofia Airport"},
  {iata: "SOG", airport: "Haukasen Airport"},
  {iata: "SOH", airport: "Solita Airport"},
  {iata: "SOI", airport: "South Molle Island Airport"},
  {iata: "SOJ", airport: "Sorkjosen Airport"},
  {iata: "SOK", airport: "Semongkong Airport"},
  {iata: "SOM", airport: "El Tigre Airport"},
  {iata: "SON", airport: "Pekoa Airport"},
  {iata: "SOO", airport: "Soderhamn Airport"},
  {iata: "SOP", airport: "Pinehurst-S. Pines Airport"},
  {iata: "SOQ", airport: "Jefman Airport"},
  {iata: "SOR", airport: "Al Thaurah Airport"},
  {iata: "SOT", airport: "Sodankyla Airport"},
  {iata: "SOU", airport: "Southampton Airport"},
  {iata: "SOV", airport: "Seldovia Airport"},
  {iata: "SOW", airport: "Show Low Airport"},
  {iata: "SOX", airport: "Sogamoso Airport"},
  {iata: "SOY", airport: "Stronsay Airport"},
  {iata: "SOZ", airport: "Solenzara Airport"},
  {iata: "SPA", airport: "Spartanburg Downtown Memorial Airport"},
  {iata: "SPB", airport: "St. Thomas Sea Plane Base"},
  {iata: "SPC", airport: "La Palma Airport"},
  {iata: "SPD", airport: "Saidpur Airport"},
  {iata: "SPE", airport: "Sepulot Airport"},
  {iata: "SPF", airport: "Black Hills Airport"},
  {iata: "SPG", airport: "Whitted Airport"},
  {iata: "SPH", airport: "Sopu Airport"},
  {iata: "SPI", airport: "Capital Airport"},
  {iata: "SPJ", airport: "Sparta Airport"},
  {iata: "SPM", airport: "Spangdahlem Ab"},
  {iata: "SPN", airport: "Saipan International Airport"},
  {iata: "SPO", airport: "San Pablo Airport"},
  {iata: "SPP", airport: "Menongue Airport"},
  {iata: "SPQ", airport: "Catalina Sea Plane Base"},
  {iata: "SPR", airport: "San Pedro Airport"},
  {iata: "SPS", airport: "Sheppard Air Force Base"},
  {iata: "SPT", airport: "Sipitang Airport"},
  {iata: "SPU", airport: "Split Airport"},
  {iata: "SPV", airport: "Sepik Plains Airport"},
  {iata: "SPW", airport: "Spencer Municipal Airport"},
  {iata: "SPX", airport: "Spaceland Airport"},
  {iata: "SPZ", airport: "Springdale Municipal Airport"},
  {iata: "SQA", airport: "Santa Ynez Airport"},
  {iata: "SQB", airport: "Santa Ana Airport"},
  {iata: "SQC", airport: "Southern Cross Airport"},
  {iata: "SQE", airport: "San Luis De Pale Airport"},
  {iata: "SQF", airport: "Solano Airport"},
  {iata: "SQG", airport: "Sintang Airport"},
  {iata: "SQH", airport: "Na-San Airport"},
  {iata: "SQI", airport: "Whiteside County Airport"},
  {iata: "SQJ", airport: "Shehdi Airport"},
  {iata: "SQK", airport: "Sidi Barani Airport"},
  {iata: "SQL", airport: "San Carlos Airport"},
  {iata: "SQM", airport: "Sao Miguel Araguaia Airport"},
  {iata: "SQN", airport: "Sanana Airport"},
  {iata: "SQO", airport: "Gunnarn Airport"},
  {iata: "SQP", airport: "Starcke Airport"},
  {iata: "SQQ", airport: "Siauliai Airport"},
  {iata: "SQR", airport: "Soroako Airport"},
  {iata: "SQS", airport: "Matthew Spain Airport"},
  {iata: "SQT", airport: "China Straits Airstrip"},
  {iata: "SQU", airport: "Saposoa Airport"},
  {iata: "SQV", airport: "Sequim Valley Airport"},
  {iata: "SQW", airport: "Skive Airport"},
  {iata: "SQX", airport: "Sao Miguel Do Oeste Airport"},
  {iata: "SQY", airport: "Sao Lourenco Do Sul Airport"},
  {iata: "SQZ", airport: "Royal Air Force Station"},
  {iata: "SRA", airport: "Santa Rosa Airport"},
  {iata: "SRB", airport: "Santa Rosa Airport"},
  {iata: "SRC", airport: "Searcy Airport"},
  {iata: "SRD", airport: "San Ramon Airport"},
  {iata: "SRE", airport: "Sucre Airport"},
  {iata: "SRF", airport: "Hamilton Field"},
  {iata: "SRG", airport: "Achmad Uani Airport"},
  {iata: "SRH", airport: "Sarh Airport"},
  {iata: "SRI", airport: "Samarinda Airport"},
  {iata: "SRJ", airport: "Capitan G Q Guardia Airport"},
  {iata: "SRK", airport: "Sierra Leone Airport"},
  {iata: "SRL", airport: "Santa Rosalia Airport"},
  {iata: "SRM", airport: "Sandringham Airport"},
  {iata: "SRN", airport: "Strahan Airport"},
  {iata: "SRO", airport: "Santana Ramos Airport"},
  {iata: "SRP", airport: "Stord Airport"},
  {iata: "SRQ", airport: "Bradenton Airport"},
  {iata: "SRS", airport: "San Marcos Airport"},
  {iata: "SRT", airport: "Soroti Airport"},
  {iata: "SRU", airport: "Santa Cruz Skypark"},
  {iata: "SRV", airport: "Stony River Airport"},
  {iata: "SRW", airport: "Rowan County Airport"},
  {iata: "SRX", airport: "Sert Airport"},
  {iata: "SRY", airport: "Dashte Naz Airport"},
  {iata: "SRZ", airport: "El Trompillo Airport"},
  {iata: "SSA", airport: "Airport Luis E. Magalhaes"},
  {iata: "SSB", airport: "St. Croix Sea Plane Base"},
  {iata: "SSC", airport: "Shaw Air Force Base"},
  {iata: "SSD", airport: "Victor Lafon"},
  {iata: "SSD", airport: "San Felipe Airport"},
  {iata: "SSE", airport: "Sholapur Airport"},
  {iata: "SSF", airport: "Stinson Municipal Airport"},
  {iata: "SSG", airport: "Santa Isabel Airport"},
  {iata: "SSH", airport: "Ophira Airport"},
  {iata: "SSI", airport: "McKinnon Airport"},
  {iata: "SSJ", airport: "Stokka Airport"},
  {iata: "SSK", airport: "Sturt Creek Airport"},
  {iata: "SSL", airport: "Santa Rosalia Airport"},
  {iata: "SSN", airport: "Seoul Ab Airport"},
  {iata: "SSO", airport: "Sao Lourenzo Airport"},
  {iata: "SSP", airport: "Silver Planes Airport"},
  {iata: "SSQ", airport: "La Sarre Airport"},
  {iata: "SSR", airport: "Sara Airport"},
  {iata: "SSS", airport: "Siassi Airport"},
  {iata: "SST", airport: "Santa Teresita Airport"},
  {iata: "SSU", airport: "Greenbrier Airport"},
  {iata: "SSV", airport: "Siasi Airport"},
  {iata: "SSW", airport: "Stuart Island Airport"},
  {iata: "SSX", airport: "Samsun Airport"},
  {iata: "SSZ", airport: "Santos Airport"},
  {iata: "STA", airport: "Stauning Airport"},
  {iata: "STB", airport: "L Delicias Airport"},
  {iata: "STC", airport: "St. Cloud Municipal Airport"},
  {iata: "STD", airport: "Mayo Guerrero Airport"},
  {iata: "STE", airport: "Stevens Point Airport"},
  {iata: "STF", airport: "Stephen Island"},
  {iata: "STG", airport: "St. George Island Airport"},
  {iata: "STH", airport: "Strathmore Airport"},
  {iata: "STI", airport: "Santiago Municipal Airport"},
  {iata: "STJ", airport: "Rosecrans Memorial Airport"},
  {iata: "STK", airport: "Crosson Field"},
  {iata: "STL", airport: "Lambert-St. Louis International Airport"},
  {iata: "STM", airport: "Eduardo Gomes Airport"},
  {iata: "STN", airport: "Stansted Airport"},
  {iata: "STP", airport: "St. Paul Downtown Airport"},
  {iata: "STQ", airport: "St. Marys Airport"},
  {iata: "STR", airport: "Echterdingen Airport"},
  {iata: "STS", airport: "Sonoma County Airport"},
  {iata: "STT", airport: "Cyril E. King Airport"},
  {iata: "STU", airport: "Santa Cruz Airport"},
  {iata: "STV", airport: "Surat Gujarat Airport"},
  {iata: "STW", airport: "Stavropol Airport"},
  {iata: "STX", airport: "Alexander Hamilton Airport"},
  {iata: "STY", airport: "Salto Airport"},
  {iata: "STZ", airport: "Confresa Airport"},
  {iata: "SUA", airport: "Witham Field"},
  {iata: "SUB", airport: "Juanda Airport"},
  {iata: "SUC", airport: "Schloredt Airport"},
  {iata: "SUD", airport: "Stroud Airport"},
  {iata: "SUE", airport: "Door County Airport"},
  {iata: "SUF", airport: "S Eufemia Airport"},
  {iata: "SUG", airport: "Surigao Airport"},
  {iata: "SUI", airport: "Babusheri Airport"},
  {iata: "SUJ", airport: "Satu Mare Airport"},
  {iata: "SUK", airport: "Samcheok Airport"},
  {iata: "SUL", airport: "Sui Airport"},
  {iata: "SUM", airport: "Sumter Municipal Airport"},
  {iata: "SUN", airport: "Sun Valley Airport"},
  {iata: "SUO", airport: "Sun River Airport"},
  {iata: "SUP", airport: "Trunojoyo Airport"},
  {iata: "SUQ", airport: "Sucua Airport"},
  {iata: "SUR", airport: "Summer Beaver Airport"},
  {iata: "SUS", airport: "Spirit of St. Louis Airport"},
  {iata: "SUT", airport: "Sumbawanga Airport"},
  {iata: "SUU", airport: "Travis Air Force Base"},
  {iata: "SUV", airport: "Nausori Airport"},
  {iata: "SUW", airport: "Richard I Bong Airport"},
  {iata: "SUX", airport: "Sioux Gateway Airport"},
  {iata: "SUY", airport: "Sudureyri Airport"},
  {iata: "SUZ", airport: "Suria Airport"},
  {iata: "SVA", airport: "Savoonga Airport"},
  {iata: "SVB", airport: "Sambava Airport"},
  {iata: "SVC", airport: "Grant County Airport"},
  {iata: "SVD", airport: "E. T. Joshua"},
  {iata: "SVE", airport: "Susanville Airport"},
  {iata: "SVF", airport: "Save Airport"},
  {iata: "SVG", airport: "Sola Airport"},
  {iata: "SVH", airport: "Statesville Municipal Airport"},
  {iata: "SVI", airport: "San Vicente Airport"},
  {iata: "SVJ", airport: "Helle Airport"},
  {iata: "SVK", airport: "Silver Creek Airport"},
  {iata: "SVL", airport: "Savonlinna Airport"},
  {iata: "SVN", airport: "Hunter Air Force Base"},
  {iata: "SVO", airport: "Sheremetyevo Airport"},
  {iata: "SVQ", airport: "Sevilla Airport"},
  {iata: "SVR", airport: "Svay Rieng Airport"},
  {iata: "SVS", airport: "Stevens Village Airport"},
  {iata: "SVT", airport: "Savuti Airport"},
  {iata: "SVU", airport: "Savusavu Airport"},
  {iata: "SVV", airport: "San Salvador De Airport"},
  {iata: "SVX", airport: "Ekaterinburg Airport"},
  {iata: "SVZ", airport: "San Antonio Airport"},
  {iata: "SWA", airport: "Shantou Airport"},
  {iata: "SWB", airport: "Shaw River Airport"},
  {iata: "SWC", airport: "Stawell Airport"},
  {iata: "SWD", airport: "Seward Airport"},
  {iata: "SWE", airport: "Siwea Airport"},
  {iata: "SWF", airport: "Stewart Airport"},
  {iata: "SWG", airport: "Satwag Airport"},
  {iata: "SWH", airport: "Swan Hill Airport"},
  {iata: "SWI", airport: "Swindon Airport"},
  {iata: "SWJ", airport: "South West Bay Airport"},
  {iata: "SWK", airport: "Segrate Airport"},
  {iata: "SWM", airport: "Suia-Missu Airport"},
  {iata: "SWN", airport: "Sahiwal Airport"},
  {iata: "SWO", airport: "Searcy Field"},
  {iata: "SWP", airport: "Swakopmund Airport"},
  {iata: "SWQ", airport: "Brang Bidji Airport"},
  {iata: "SWR", airport: "Silur Airport"},
  {iata: "SWS", airport: "Fairwood Comm Airport"},
  {iata: "SWT", airport: "Strzhewoi Airport"},
  {iata: "SWU", airport: "Suwon Airport"},
  {iata: "SWV", airport: "Shikarpur Airport"},
  {iata: "SWW", airport: "Sweetwater Airport"},
  {iata: "SWX", airport: "Shakawe Airport"},
  {iata: "SWY", airport: "Sitiawan Airport"},
  {iata: "SWZ", airport: "Sydney West Airport"},
  {iata: "SXA", airport: "Sialum Airport"},
  {iata: "SXB", airport: "Entzheim Airport"},
  {iata: "SXC", airport: "Avalon Vor/WP Airport"},
  {iata: "SXD", airport: "Sophia Antipolis Airport"},
  {iata: "SXE", airport: "Sale Airport"},
  {iata: "SXF", airport: "Schoenefeld Airport"},
  {iata: "SXG", airport: "Senanga Airport"},
  {iata: "SXH", airport: "Sehulea Airport"},
  {iata: "SXI", airport: "Sirri Island Airport"},
  {iata: "SXJ", airport: "Shanshan Airport"},
  {iata: "SXK", airport: "Saumlaki Airport"},
  {iata: "SXL", airport: "Collooney Airport"},
  {iata: "SXM", airport: "Princ. Juliana Airport"},
  {iata: "SXN", airport: "Suapan Airport"},
  {iata: "SXO", airport: "Sao Felix Do Araguaia Airport"},
  {iata: "SXP", airport: "Sheldon Sea Plane Base"},
  {iata: "SXQ", airport: "Soldotna Airport"},
  {iata: "SXR", airport: "Srinagar Airport"},
  {iata: "SXS", airport: "Sahabat 16 Airport"},
  {iata: "SXT", airport: "Taman Negara Airport"},
  {iata: "SXU", airport: "Soddu Airport"},
  {iata: "SXV", airport: "Salem Airport"},
  {iata: "SXW", airport: "Sauren Airport"},
  {iata: "SXX", airport: "Sao Felix Do Xingu Airport"},
  {iata: "SXY", airport: "Sidney Airport"},
  {iata: "SXZ", airport: "Siirt Airport"},
  {iata: "SYB", airport: "Seal Bay Airport"},
  {iata: "SYC", airport: "Shiringayoc O Hda Mejia"},
  {iata: "SYD", airport: "Kingsford Smith Airport"},
  {iata: "SYE", airport: "Sadah Airport"},
  {iata: "SYF", airport: "Silva Bay Airport"},
  {iata: "SYG", airport: "Spitsberg Airport"},
  {iata: "SYI", airport: "Bomar Field"},
  {iata: "SYJ", airport: "Sirjan Airport"},
  {iata: "SYK", airport: "Stykkisholmur Airport"},
  {iata: "SYL", airport: "Roberts Air Force Base"},
  {iata: "SYM", airport: "Simao Airport"},
  {iata: "SYN", airport: "Carleton Airport"},
  {iata: "SYO", airport: "Shonai Airport"},
  {iata: "SYP", airport: "Santiago Airport"},
  {iata: "SYQ", airport: "Tobias Bolanos International Airport"},
  {iata: "SYR", airport: "Hancock International Airport"},
  {iata: "SYS", airport: "Yeosu Airport"},
  {iata: "SYT", airport: "Charolais Bourgogne Sud Airport"},
  {iata: "SYU", airport: "Warraber Island Airport"},
  {iata: "SYV", airport: "Sylvester Airport"},
  {iata: "SYW", airport: "Sehwen Sharif Airport"},
  {iata: "SYX", airport: "Sanya Airport"},
  {iata: "SYY", airport: "Stornoway Airport"},
  {iata: "SYZ", airport: "Shiraz Airport"},
  {iata: "SZA", airport: "Soyo Airport"},
  {iata: "SZB", airport: "Sultan Abdul Aziz Shah Airport"},
  {iata: "SZC", airport: "Guanacaste Airport"},
  {iata: "SZD", airport: "Sheffield City Airport"},
  {iata: "SZE", airport: "Semera Airport"},
  {iata: "SZF", airport: "Carsamba Airport"},
  {iata: "SZG", airport: "W. A. Mozart Airport"},
  {iata: "SZH", airport: "Senipah Airport"},
  {iata: "SZI", airport: "Zaisan Airport"},
  {iata: "SZJ", airport: "Siguanea Airport"},
  {iata: "SZK", airport: "Skukuza Airport"},
  {iata: "SZL", airport: "Whiteman Air Force Base"},
  {iata: "SZM", airport: "Sesriem Airport"},
  {iata: "SZN", airport: "Santa Cruz Island Airport"},
  {iata: "SZO", airport: "Shanzhou Airport"},
  {iata: "SZP", airport: "Santa Paula Airport"},
  {iata: "SZQ", airport: "Saenz Pena Airport"},
  {iata: "SZR", airport: "Stara Zagora Airport"},
  {iata: "SZS", airport: "Stewart Island Airport"},
  {iata: "SZT", airport: "San Cristobal de las Casas Airport"},
  {iata: "SZU", airport: "Segou Airport"},
  {iata: "SZV", airport: "Suzhou Airport"},
  {iata: "SZW", airport: "Parchim Airport"},
  {iata: "SZX", airport: "Shenzhen Airport"},
  {iata: "SZY", airport: "Mazury Airport"},
  {iata: "SZZ", airport: "Goleniow Airport"},
  {iata: "TAB", airport: "Tobago Airport"},
  {iata: "TAC", airport: "D. Z. Romualdez Airport"},
  {iata: "TAD", airport: "Las Animas Airport"},
  {iata: "TAE", airport: "Daegu Airport"},
  {iata: "TAF", airport: "Tafaraoui Airport"},
  {iata: "TAG", airport: "Tagbilaran Airport"},
  {iata: "TAH", airport: "Tanna Airport"},
  {iata: "TAI", airport: "Al Janad Airport"},
  {iata: "TAJ", airport: "Tadji Airport"},
  {iata: "TAK", airport: "Takamatsu Airport"},
  {iata: "TAL", airport: "Ralph Calhoun Airport"},
  {iata: "TAM", airport: "Gen F Javier Mina Airport"},
  {iata: "TAN", airport: "Tangalooma Airport"},
  {iata: "TAO", airport: "Qingdao Airport"},
  {iata: "TAP", airport: "Tapachula International Airport"},
  {iata: "TAQ", airport: "Tarcoola Airport"},
  {iata: "TAR", airport: "M. A. Grottag Airport"},
  {iata: "TAS", airport: "Vostochny Airport"},
  {iata: "TAT", airport: "Poprad/Tatry Airport"},
  {iata: "TAU", airport: "Tauramena Airport"},
  {iata: "TAV", airport: "Tau Airport"},
  {iata: "TAW", airport: "Tacuarembo Airport"},
  {iata: "TAX", airport: "Taliabu Airport"},
  {iata: "TAY", airport: "Tartu Airport"},
  {iata: "TAZ", airport: "Dashoguz Airport"},
  {iata: "TBA", airport: "Tabibuga Airport"},
  {iata: "TBB", airport: "Tuy Hoa Airport"},
  {iata: "TBC", airport: "Tuba City Airport"},
  {iata: "TBD", airport: "Timbiqui Airport"},
  {iata: "TBE", airport: "Timbunke Airport"},
  {iata: "TBF", airport: "Tabiteuea Airport"},
  {iata: "TBG", airport: "Tabubil Airport"},
  {iata: "TBH", airport: "Tablas Airport"},
  {iata: "TBI", airport: "The Bight Airport"},
  {iata: "TBJ", airport: "Tabarka Airport"},
  {iata: "TBK", airport: "Timber Creek Airport"},
  {iata: "TBL", airport: "Tableland Airport"},
  {iata: "TBM", airport: "Tumbang Samba Airport"},
  {iata: "TBN", airport: "Forney Army Air Field"},
  {iata: "TBO", airport: "Tabora Airport"},
  {iata: "TBP", airport: "Tumbes Airport"},
  {iata: "TBR", airport: "Statesboro Municipal Airport"},
  {iata: "TBS", airport: "Novo Alexeyevka Airport"},
  {iata: "TBT", airport: "Tabatinga Internacional Airport"},
  {iata: "TBV", airport: "Tabal Airport"},
  {iata: "TBW", airport: "Tambov Airport"},
  {iata: "TBY", airport: "Tsabong Airport"},
  {iata: "TBZ", airport: "Tabriz Airport"},
  {iata: "TCA", airport: "Tennant Creek Airport"},
  {iata: "TCB", airport: "Treasure Cay Airport"},
  {iata: "TCC", airport: "Tucumcari Airport"},
  {iata: "TCD", airport: "Tarapaca Airport"},
  {iata: "TCE", airport: "Tulcea Airport"},
  {iata: "TCF", airport: "Tocoa Airport"},
  {iata: "TCG", airport: "Tacheng Airport"},
  {iata: "TCH", airport: "Tchibanga Airport"},
  {iata: "TCJ", airport: "Torembi Airport"},
  {iata: "TCK", airport: "Tinboli Airport"},
  {iata: "TCL", airport: "Van De Graaf Airport"},
  {iata: "TCM", airport: "McChord Air Force Base"},
  {iata: "TCN", airport: "Tehuacan Airport"},
  {iata: "TCO", airport: "La Florida Airport"},
  {iata: "TCP", airport: "Taba International Airport"},
  {iata: "TCQ", airport: "Tacna Airport"},
  {iata: "TCR", airport: "Tuticorin Airport"},
  {iata: "TCS", airport: "Truth Or Consequences Municipal Airport"},
  {iata: "TCT", airport: "Takotna Airport"},
  {iata: "TCU", airport: "Thaba Nchu Airport"},
  {iata: "TCV", airport: "Tete Airport"},
  {iata: "TCW", airport: "Tocumwal Airport"},
  {iata: "TCX", airport: "Tabas Airport"},
  {iata: "TCY", airport: "Terrace Bay Airport"},
  {iata: "TDA", airport: "Trinidad Airport"},
  {iata: "TDB", airport: "Tetabedi Airport"},
  {iata: "TDD", airport: "Trinidad Airport"},
  {iata: "TDG", airport: "Tandag Airport"},
  {iata: "TDJ", airport: "Tadjoura Airport"},
  {iata: "TDK", airport: "Taldy-Kurgan Airport"},
  {iata: "TDL", airport: "Tandil Airport"},
  {iata: "TDN", airport: "Theda Station Airport"},
  {iata: "TDO", airport: "Winlock Airport"},
  {iata: "TDR", airport: "Theodore Airport"},
  {iata: "TDT", airport: "Tanda Tula Airport"},
  {iata: "TDV", airport: "Tanandava Airport"},
  {iata: "TDW", airport: "Tradewind Airport"},
  {iata: "TDX", airport: "Trat Airport"},
  {iata: "TDZ", airport: "Toledo Airport"},
  {iata: "TEA", airport: "Tela Airport"},
  {iata: "TEB", airport: "Teterboro Airport"},
  {iata: "TEC", airport: "Telemaco Borba Airport"},
  {iata: "TED", airport: "Thisted Airport"},
  {iata: "TEE", airport: "Tebessa Airport"},
  {iata: "TEF", airport: "Telfer Airport"},
  {iata: "TEG", airport: "Tenkodogo Airport"},
  {iata: "TEH", airport: "Tetlin Airport"},
  {iata: "TEI", airport: "Tezu Airport"},
  {iata: "TEK", airport: "Tatitlek Airport"},
  {iata: "TEL", airport: "Telupid Airport"},
  {iata: "TEM", airport: "Temora Airport"},
  {iata: "TEN", airport: "Tongren Airport"},
  {iata: "TEO", airport: "Terapo Airport"},
  {iata: "TEP", airport: "Teptep Airport"},
  {iata: "TEQ", airport: "Corlu Airport"},
  {iata: "TER", airport: "Lajes Airport"},
  {iata: "TES", airport: "Tessenei Airport"},
  {iata: "TET", airport: "Matundo Airport"},
  {iata: "TEU", airport: "Manapouri Airport"},
  {iata: "TEW", airport: "Tohid Airport"},
  {iata: "TEX", airport: "Telluride Airport"},
  {iata: "TEY", airport: "Thingeyri Airport"},
  {iata: "TEZ", airport: "Salonibari Airport"},
  {iata: "TFB", airport: "Tifalmin Airport"},
  {iata: "TFF", airport: "Tefe Airport"},
  {iata: "TFI", airport: "Tufi Airport"},
  {iata: "TFL", airport: "Teofilo Otoni Airport"},
  {iata: "TFM", airport: "Telefomin Airport"},
  {iata: "TFN", airport: "Norte Los Rodeos Airport"},
  {iata: "TFR", airport: "Ramadan Airport"},
  {iata: "TFS", airport: "Sur Reina Sofia Airport"},
  {iata: "TFT", airport: "Taftan Airport"},
  {iata: "TFY", airport: "Tarfaya Airport"},
  {iata: "TGB", airport: "Tagbita Airport"},
  {iata: "TGD", airport: "Golubovci Airport"},
  {iata: "TGE", airport: "Sharpe Field"},
  {iata: "TGF", airport: "Tignes Airport"},
  {iata: "TGG", airport: "Sultan Mahmood Airport"},
  {iata: "TGH", airport: "Tongoa Airport"},
  {iata: "TGI", airport: "Tingo Maria Airport"},
  {iata: "TGJ", airport: "Tiga Airport"},
  {iata: "TGL", airport: "Tagula Airport"},
  {iata: "TGM", airport: "Tirgu Mures Airport"},
  {iata: "TGN", airport: "La Trobe Regional Airport"},
  {iata: "TGO", airport: "Tongliao Airport"},
  {iata: "TGQ", airport: "Tangara Da Serra Airport"},
  {iata: "TGR", airport: "Touggourt Airport"},
  {iata: "TGS", airport: "Chokwe Airport"},
  {iata: "TGT", airport: "Tanga Airport"},
  {iata: "TGU", airport: "Toncontin Airport"},
  {iata: "TGV", airport: "Targovishte Airport"},
  {iata: "TGZ", airport: "Llano San Juan Airport"},
  {iata: "THA", airport: "Northern Airport"},
  {iata: "THB", airport: "Thaba-Tseka Airport"},
  {iata: "THC", airport: "Tchien Airport"},
  {iata: "THE", airport: "Teresina Airport"},
  {iata: "THF", airport: "Tempelhof Airport"},
  {iata: "THG", airport: "Thangool Airport"},
  {iata: "THH", airport: "Taharoa Airport"},
  {iata: "THI", airport: "Tichitt Airport"},
  {iata: "THK", airport: "Thakhek Airport"},
  {iata: "THL", airport: "Tachilek Airport"},
  {iata: "THM", airport: "Thompsonfield Airport"},
  {iata: "THN", airport: "Trollhattan Airport"},
  {iata: "THO", airport: "Thorshofn Airport"},
  {iata: "THP", airport: "Hot Springs Airport"},
  {iata: "THR", airport: "Mehrabad Airport"},
  {iata: "THS", airport: "Sukhothai Airport"},
  {iata: "THT", airport: "Tamchakett Airport"},
  {iata: "THU", airport: "Pituffik Airport"},
  {iata: "THV", airport: "York Airport"},
  {iata: "THY", airport: "Thohoyandou Airport"},
  {iata: "THZ", airport: "Tahoua Airport"},
  {iata: "TIA", airport: "Rinas Airport"},
  {iata: "TIB", airport: "Tibu Airport"},
  {iata: "TIC", airport: "Tinak Airport"},
  {iata: "TID", airport: "Bouchekif Airport"},
  {iata: "TIE", airport: "Tippi Airport"},
  {iata: "TIF", airport: "Taif Airport"},
  {iata: "TIG", airport: "Tingwon Airport"},
  {iata: "TIH", airport: "Tikehau Atoll Airport"},
  {iata: "TII", airport: "Tirinkot Airport"},
  {iata: "TIJ", airport: "Rodriguez Airport"},
  {iata: "TIK", airport: "Tinker Air Force Base"},
  {iata: "TIM", airport: "Timika Airport"},
  {iata: "TIN", airport: "Tindouf Airport"},
  {iata: "TIO", airport: "Tilin Airport"},
  {iata: "TIP", airport: "Tripoli International Airport"},
  {iata: "TIQ", airport: "Tinian Airport"},
  {iata: "TIR", airport: "Tirupati Airport"},
  {iata: "TIS", airport: "Thursday Island Airport"},
  {iata: "TIU", airport: "Timaru Airport"},
  {iata: "TIV", airport: "Tivat Airport"},
  {iata: "TIW", airport: "Industrial Airport"},
  {iata: "TIX", airport: "Space Center Executive Airport"},
  {iata: "TIY", airport: "Tidjikja Airport"},
  {iata: "TIZ", airport: "Tari Airport"},
  {iata: "TJA", airport: "Tarija Airport"},
  {iata: "TJB", airport: "Tanjung Balai Airport"},
  {iata: "TJC", airport: "Ticantiki Airport"},
  {iata: "TJG", airport: "Tanjung Warukin Airport"},
  {iata: "TJH", airport: "Tajima Airport"},
  {iata: "TJI", airport: "Capiro Airport"},
  {iata: "TJK", airport: "Tokat Airport"},
  {iata: "TJM", airport: "Tyumen Airport"},
  {iata: "TJN", airport: "Takume Airport"},
  {iata: "TJQ", airport: "Bulutumbang Airport"},
  {iata: "TJS", airport: "Tanjung Selor Airport"},
  {iata: "TJV", airport: "Thanjavur Airport"},
  {iata: "TKA", airport: "Talkeetna Airport"},
  {iata: "TKB", airport: "Tekadu Airport"},
  {iata: "TKC", airport: "Tiko Airport"},
  {iata: "TKD", airport: "Takoradi Airport"},
  {iata: "TKE", airport: "Tenakee Springs Sea Plane Base"},
  {iata: "TKF", airport: "Truckee Airport"},
  {iata: "TKG", airport: "Branti Airport"},
  {iata: "TKH", airport: "Takhli Airport"},
  {iata: "TKJ", airport: "Tok Airport"},
  {iata: "TKK", airport: "Truk Airport"},
  {iata: "TKL", airport: "Taku Sea Plane Base"},
  {iata: "TKM", airport: "El Peten Airport"},
  {iata: "TKN", airport: "Tokunoshima Airport"},
  {iata: "TKO", airport: "Tlokoeng Airport"},
  {iata: "TKP", airport: "Takapoto Airport"},
  {iata: "TKQ", airport: "Kigoma Airport"},
  {iata: "TKR", airport: "Thakurgaon Airport"},
  {iata: "TKS", airport: "Tokushima Airport"},
  {iata: "TKT", airport: "Tak Airport"},
  {iata: "TKU", airport: "Turku Airport"},
  {iata: "TKV", airport: "Tuamoto Airport"},
  {iata: "TKW", airport: "Tekin Airport"},
  {iata: "TKX", airport: "Takaroa Airport"},
  {iata: "TKY", airport: "Turkey Creek Airport"},
  {iata: "TKZ", airport: "Tokoroa Airport"},
  {iata: "TLA", airport: "Teller Airport"},
  {iata: "TLB", airport: "Tarbela Airport"},
  {iata: "TLC", airport: "Toluca Airport"},
  {iata: "TLD", airport: "Limpopo Valley Airfield"},
  {iata: "TLE", airport: "Tulear Airport"},
  {iata: "TLH", airport: "Tallahassee Regional Airport"},
  {iata: "TLI", airport: "Tolitoli Airport"},
  {iata: "TLJ", airport: "Tatalina Air Force Station"},
  {iata: "TLK", airport: "Talknafjordur Airport"},
  {iata: "TLL", airport: "Ulemiste Airport"},
  {iata: "TLM", airport: "Zenata Airport"},
  {iata: "TLN", airport: "Hyeres Airport"},
  {iata: "TLO", airport: "Tol Airport"},
  {iata: "TLP", airport: "Tumolbil Airport"},
  {iata: "TLR", airport: "Tulare Airport"},
  {iata: "TLS", airport: "Blagnac Airport"},
  {iata: "TLT", airport: "Tuluksak Airport"},
  {iata: "TLU", airport: "Tolu Airport"},
  {iata: "TLW", airport: "Talasea Airport"},
  {iata: "TLX", airport: "Talca Airport"},
  {iata: "TLZ", airport: "Catalao Airport"},
  {iata: "TMA", airport: "Henry Tift Myers Airport"},
  {iata: "TMB", airport: "Tamiami Airport"},
  {iata: "TMC", airport: "Tambolaka Airport"},
  {iata: "TMD", airport: "Timbedra Airport"},
  {iata: "TME", airport: "Tame Airport"},
  {iata: "TMG", airport: "Tomanggong Airport"},
  {iata: "TMH", airport: "Tanahmerah Airport"},
  {iata: "TMI", airport: "Tumling Tar Airport"},
  {iata: "TMJ", airport: "Termez Airport"},
  {iata: "TMK", airport: "Tamky Airport"},
  {iata: "TML", airport: "Tamale Airport"},
  {iata: "TMM", airport: "Tamatave Airport"},
  {iata: "TMN", airport: "Tamana Island Airport"},
  {iata: "TMO", airport: "Tumeremo Airport"},
  {iata: "TMP", airport: "Tampere-Pirkkala Airport"},
  {iata: "TMQ", airport: "Tambao Airport"},
  {iata: "TMR", airport: "Aguemar Airport"},
  {iata: "TMS", airport: "Sao Tome Island Airport"},
  {iata: "TMT", airport: "Trombetas Airport"},
  {iata: "TMU", airport: "Tambor Airport"},
  {iata: "TMW", airport: "Tamworth Airport"},
  {iata: "TMX", airport: "Timimoun Airport"},
  {iata: "TMY", airport: "Tiom Airport"},
  {iata: "TMZ", airport: "Thames Airport"},
  {iata: "TNA", airport: "Jinan Airport"},
  {iata: "TNB", airport: "Tanahgrogot Airport"},
  {iata: "TNC", airport: "Tin City Air Force Station"},
  {iata: "TND", airport: "Trinidad Airport"},
  {iata: "TNE", airport: "Tanegashima Airport"},
  {iata: "TNF", airport: "Toussus-le-Noble Airport"},
  {iata: "TNG", airport: "Boukhalef Airport"},
  {iata: "TNH", airport: "Tonghua Liuhe Airport"},
  {iata: "TNI", airport: "Satna Airport"},
  {iata: "TNJ", airport: "Kidjang Airport"},
  {iata: "TNK", airport: "Tununak Airport"},
  {iata: "TNL", airport: "Ternopol Airport"},
  {iata: "TNN", airport: "Tainan Airport"},
  {iata: "TNO", airport: "Tamarindo Airport"},
  {iata: "TNP", airport: "Twentynine Palms Airport"},
  {iata: "TNQ", airport: "Washington Island Airport"},
  {iata: "TNR", airport: "Antananarivo Airport"},
  {iata: "TNS", airport: "Tungsten Airport"},
  {iata: "TNT", airport: "Dade Collier Airport"},
  {iata: "TNU", airport: "Newton Municipal Airport"},
  {iata: "TNV", airport: "Fanning Island Airport"},
  {iata: "TNX", airport: "Stung Treng Airport"},
  {iata: "TNZ", airport: "Tosontsengel Airport"},
  {iata: "TOA", airport: "Torrance Airport"},
  {iata: "TOB", airport: "Tobruk Airport"},
  {iata: "TOC", airport: "Toccoa Airport"},
  {iata: "TOD", airport: "Tioman Airport"},
  {iata: "TOE", airport: "Tozeur Airport"},
  {iata: "TOF", airport: "Tomsk Airport"},
  {iata: "TOG", airport: "Togiak Village Airport"},
  {iata: "TOH", airport: "Torres Airstrip"},
  {iata: "TOI", airport: "Troy Municipal Airport"},
  {iata: "TOJ", airport: "Torrejon Air Force Base"},
  {iata: "TOK", airport: "Torokina Airport"},
  {iata: "TOL", airport: "Express Airport"},
  {iata: "TOM", airport: "Tombouctou Airport"},
  {iata: "TON", airport: "Tonu Airport"},
  {iata: "TOO", airport: "San Vito Airport"},
  {iata: "TOP", airport: "Philip Billard Airport"},
  {iata: "TOQ", airport: "Barriles Airport"},
  {iata: "TOR", airport: "Torrington Municipal Airport"},
  {iata: "TOS", airport: "Tromso/Langnes Airport"},
  {iata: "TOT", airport: "Coronie Airport"},
  {iata: "TOU", airport: "Touho Airport"},
  {iata: "TOV", airport: "West End Sea Plane Base"},
  {iata: "TOW", airport: "Toledo Airport"},
  {iata: "TOX", airport: "Tobolsk Airport"},
  {iata: "TOY", airport: "Toyama Airport"},
  {iata: "TPA", airport: "Tampa International Airport"},
  {iata: "TPC", airport: "Tarapoa Airport"},
  {iata: "TPE", airport: "Taiwan Taoyuan International Airport"},
  {iata: "TPG", airport: "Taiping Airport"},
  {iata: "TPH", airport: "Tonopah Airport"},
  {iata: "TPI", airport: "Tapini Airport"},
  {iata: "TPJ", airport: "Taplejung Airport"},
  {iata: "TPK", airport: "Tapaktuan Airport"},
  {iata: "TPL", airport: "Draughon-Miller Airport"},
  {iata: "TPN", airport: "Tiputini Airport"},
  {iata: "TPP", airport: "Tarapoto Airport"},
  {iata: "TPQ", airport: "Tepic Airport"},
  {iata: "TPR", airport: "Tom Price Airport"},
  {iata: "TPS", airport: "Birgi Airport"},
  {iata: "TPT", airport: "Tapeta Airport"},
  {iata: "TPU", airport: "Tikapur Airport"},
  {iata: "TPX", airport: "Tupai Airport"},
  {iata: "TQN", airport: "Taluquan Airport"},
  {iata: "TQR", airport: "San Domino Island Airport"},
  {iata: "TQS", airport: "Tres Esquinas Airport"},
  {iata: "TRA", airport: "Tarama Airport"},
  {iata: "TRB", airport: "Gonzalo Airport"},
  {iata: "TRC", airport: "Torreon Airport"},
  {iata: "TRD", airport: "Vaernes Airport"},
  {iata: "TRE", airport: "Tiree Airport"},
  {iata: "TRF", airport: "Sandefjord Airport"},
  {iata: "TRG", airport: "Tauranga Airport"},
  {iata: "TRH", airport: "Trona Airport"},
  {iata: "TRI", airport: "Tri-Cities Regional"},
  {iata: "TRJ", airport: "Tarakbits Airport"},
  {iata: "TRK", airport: "Tarakan Airport"},
  {iata: "TRL", airport: "Terrell Field"},
  {iata: "TRM", airport: "Thermal Airport"},
  {iata: "TRN", airport: "Citta Di Torino Airport"},
  {iata: "TRO", airport: "Taree Airport"},
  {iata: "TRQ", airport: "Tarauaca Airport"},
  {iata: "TRR", airport: "China Bay Airport"},
  {iata: "TRS", airport: "Dei Legionari Airport"},
  {iata: "TRT", airport: "Tremonton Airport"},
  {iata: "TRU", airport: "Trujillo Airport"},
  {iata: "TRV", airport: "Trivandrum International Airport"},
  {iata: "TRW", airport: "Bonriki Airport"},
  {iata: "TRX", airport: "Trenton Memorial Airport"},
  {iata: "TRY", airport: "Tororo Airport"},
  {iata: "TRZ", airport: "Civil Airport"},
  {iata: "TSA", airport: "Sung Shan Airport"},
  {iata: "TSB", airport: "Tsumeb Airport"},
  {iata: "TSC", airport: "Taisha Airport"},
  {iata: "TSD", airport: "Tshipise Airport"},
  {iata: "TSE", airport: "Astana Airport"},
  {iata: "TSF", airport: "Treviso Airport"},
  {iata: "TSH", airport: "Tshikapa Airport"},
  {iata: "TSI", airport: "Tsili Tsili Airport"},
  {iata: "TSJ", airport: "Tsushima Airport"},
  {iata: "TSK", airport: "Taskul Airport"},
  {iata: "TSL", airport: "Tamuin Airport"},
  {iata: "TSM", airport: "Taos Airport"},
  {iata: "TSN", airport: "Tianjin Airport"},
  {iata: "TSO", airport: "Tresco Airport"},
  {iata: "TSP", airport: "Kern County Airport"},
  {iata: "TSQ", airport: "Torres Airport"},
  {iata: "TSR", airport: "Timisoara Airport"},
  {iata: "TSS", airport: "East 34th Street Heliport"},
  {iata: "TST", airport: "Trang Airport"},
  {iata: "TSU", airport: "Tabiteuea South Airport"},
  {iata: "TSV", airport: "Townsville Airport"},
  {iata: "TSW", airport: "Tsewi Airport"},
  {iata: "TSX", airport: "Tanjung Santan Airport"},
  {iata: "TSY", airport: "Tasikmalaya Airport"},
  {iata: "TSZ", airport: "Tsetserleg Airport"},
  {iata: "TTA", airport: "Tan Tan Airport"},
  {iata: "TTB", airport: "Arbatax Airport"},
  {iata: "TTC", airport: "Taltal Airport"},
  {iata: "TTD", airport: "Troutdale Airport"},
  {iata: "TTE", airport: "Babullah Airport"},
  {iata: "TTG", airport: "Tartagal Airport"},
  {iata: "TTI", airport: "Tetiaroa Island Airport"},
  {iata: "TTJ", airport: "Tottori Airport"},
  {iata: "TTK", airport: "Tottenham Hale Station Airport"},
  {iata: "TTL", airport: "Turtle Island Airport"},
  {iata: "TTM", airport: "Tablon De Tamara Airport"},
  {iata: "TTN", airport: "Mercer County Airport"},
  {iata: "TTO", airport: "Britton Municipal Airport"},
  {iata: "TTQ", airport: "Tortuquero Airport"},
  {iata: "TTR", airport: "Tana Toraja Airport"},
  {iata: "TTS", airport: "Tsaratanana Airport"},
  {iata: "TTT", airport: "Taitung Airport"},
  {iata: "TTU", airport: "Sania Ramel Airport"},
  {iata: "TUA", airport: "Tulcan Airport"},
  {iata: "TUB", airport: "Tubuai Island Airport"},
  {iata: "TUC", airport: "Benj Matienzo Airport"},
  {iata: "TUD", airport: "Tambacounda Airport"},
  {iata: "TUE", airport: "Tupile Airport"},
  {iata: "TUF", airport: "St Symphorien Airport"},
  {iata: "TUG", airport: "Tuguegarao Airport"},
  {iata: "TUH", airport: "Arnold Air Force Base"},
  {iata: "TUI", airport: "Turaif Airport"},
  {iata: "TUJ", airport: "Tum Airport"},
  {iata: "TUK", airport: "Turbat Airport"},
  {iata: "TUL", airport: "Tulsa International Airport"},
  {iata: "TUM", airport: "Tumut Airport"},
  {iata: "TUN", airport: "Carthage Airport"},
  {iata: "TUO", airport: "Taupo Airport"},
  {iata: "TUP", airport: "Lemons Municipal Airport"},
  {iata: "TUQ", airport: "Tougan Airport"},
  {iata: "TUR", airport: "Tucurui Airport"},
  {iata: "TUS", airport: "Tucson International Airport"},
  {iata: "TUT", airport: "Tauta Airport"},
  {iata: "TUU", airport: "Tabuk Airport"},
  {iata: "TUV", airport: "Tucupita Airport"},
  {iata: "TUW", airport: "Tubala Airport"},
  {iata: "TUX", airport: "Tumbler Ridge Airport"},
  {iata: "TUY", airport: "Tulum Airport"},
  {iata: "TUZ", airport: "Tucuma Airport"},
  {iata: "TVA", airport: "Morafenobe Airport"},
  {iata: "TVC", airport: "Traverse City Airport"},
  {iata: "TVF", airport: "Thief River Falls Regional Airport"},
  {iata: "TVI", airport: "Thomasville Municipal Airport"},
  {iata: "TVL", airport: "South Lake Tahoe Airport"},
  {iata: "TVU", airport: "Matei Airport"},
  {iata: "TVY", airport: "Dawe Airport"},
  {iata: "TWA", airport: "Twin Hills Airport"},
  {iata: "TWB", airport: "Toowoomba Airport"},
  {iata: "TWD", airport: "Port Townsend Airport"},
  {iata: "TWF", airport: "Twin Falls City County Airport"},
  {iata: "TWH", airport: "Two Harbors Airport"},
  {iata: "TWN", airport: "Tewantin Airport"},
  {iata: "TWP", airport: "Torwood Airport"},
  {iata: "TWT", airport: "Tawitawi Airport"},
  {iata: "TWU", airport: "Tawau Airport"},
  {iata: "TWY", airport: "Tawa Airport"},
  {iata: "TWZ", airport: "Pukaki/Twizel Airport"},
  {iata: "TXF", airport: "Teixeira de Freitas Airport"},
  {iata: "TXG", airport: "Taichung Airport"},
  {iata: "TXK", airport: "Texarkana Municipal Airport"},
  {iata: "TXL", airport: "Tegel Airport"},
  {iata: "TXM", airport: "Teminabuan Airport"},
  {iata: "TXN", airport: "Tunxi Airport"},
  {iata: "TXR", airport: "Tanbar Airport"},
  {iata: "TYA", airport: "Tula Airport"},
  {iata: "TYB", airport: "Tibooburra Airport"},
  {iata: "TYD", airport: "Tynda Airport"},
  {iata: "TYF", airport: "Torsby Airport"},
  {iata: "TYG", airport: "Thylungra Airport"},
  {iata: "TYL", airport: "Talara Airport"},
  {iata: "TYN", airport: "Taiyuan Airport"},
  {iata: "TYP", airport: "Tobermorey Airport"},
  {iata: "TYR", airport: "Pounds Field"},
  {iata: "TYS", airport: "Mc Ghee Tyson Airport"},
  {iata: "TYT", airport: "Treinta-y-Tres Airport"},
  {iata: "TYZ", airport: "Taylor Airport"},
  {iata: "TZA", airport: "Belize City Municipal Airport"},
  {iata: "TZL", airport: "Tuzla International Airport"},
  {iata: "TZM", airport: "Tizimin Airport"},
  {iata: "TZN", airport: "South Andros Airport"},
  {iata: "TZX", airport: "Trabzon Airport"},
  {iata: "UAB", airport: "Adana-Incirlik Airbase"},
  {iata: "UAC", airport: "San Luis Rio Colorado Airport"},
  {iata: "UAE", airport: "Mount Aue Airport"},
  {iata: "UAH", airport: "Ua Huka Airport"},
  {iata: "UAI", airport: "Suai Airport"},
  {iata: "UAK", airport: "Narsarsuaq Airport"},
  {iata: "UAM", airport: "Anderson Air Force Base"},
  {iata: "UAP", airport: "Ua Pou Airport"},
  {iata: "UAQ", airport: "San Juan Airport"},
  {iata: "UAS", airport: "Samburu Airport"},
  {iata: "UAX", airport: "Uaxactun Airport"},
  {iata: "UBA", airport: "Uberaba Airport"},
  {iata: "UBB", airport: "Mabuiag Island Airport"},
  {iata: "UBI", airport: "Buin Airport"},
  {iata: "UBJ", airport: "Ube Airport"},
  {iata: "UBP", airport: "Muang Ubon Airport"},
  {iata: "UBR", airport: "Ubrub, Irian Jaya Airport"},
  {iata: "UBS", airport: "Lowndes County Airport"},
  {iata: "UBT", airport: "Ubatuba Airport"},
  {iata: "UBU", airport: "Kalumburu Airport"},
  {iata: "UCA", airport: "Oneida County Airport"},
  {iata: "UCC", airport: "Yucca Flat Airport"},
  {iata: "UCE", airport: "Eunice Airport"},
  {iata: "UCK", airport: "Lutsk Airport"},
  {iata: "UCN", airport: "Buchanan Airport"},
  {iata: "UCT", airport: "Ukhta Airport"},
  {iata: "UCY", airport: "Everett-Stewart Airport"},
  {iata: "UDA", airport: "Undarra Airport"},
  {iata: "UDD", airport: "Bermuda Dunes Airport"},
  {iata: "UDE", airport: "Volkel Airport"},
  {iata: "UDI", airport: "Eduardo Gomes Airport"},
  {iata: "UDJ", airport: "Uzhgorod Airport"},
  {iata: "UDN", airport: "Udine Airfield"},
  {iata: "UDO", airport: "Udomxay Airport"},
  {iata: "UDR", airport: "Dabok Airport"},
  {iata: "UEE", airport: "Queenstown Airport"},
  {iata: "UEL", airport: "Quelimane Airport"},
  {iata: "UEO", airport: "Kume-jima Airport"},
  {iata: "UER", airport: "Puertollano Airport"},
  {iata: "UES", airport: "Waukesha Airport"},
  {iata: "UET", airport: "Quetta Airport"},
  {iata: "UFA", airport: "Ufa Airport"},
  {iata: "UGA", airport: "Bulgan Airport"},
  {iata: "UGB", airport: "Ugashik Bay Airport"},
  {iata: "UGC", airport: "Urgench Airport"},
  {iata: "UGI", airport: "Uganik Airport"},
  {iata: "UGN", airport: "Waukegan Memorial Airport"},
  {iata: "UGT", airport: "Umnugobitour Airport"},
  {iata: "UGU", airport: "Zugapa, Irian Jaya Airport"},
  {iata: "UHE", airport: "Uherske Hradiste Airport"},
  {iata: "UHF", airport: "Upper Heyford RAF Station"},
  {iata: "UIB", airport: "Quibdo Airport"},
  {iata: "UIH", airport: "Qui Nhon Airport"},
  {iata: "UII", airport: "Utila Airport"},
  {iata: "UIK", airport: "Ust-Ilimsk Airport"},
  {iata: "UIL", airport: "Quillayute State Airport"},
  {iata: "UIN", airport: "Quincy Municipal Airport"},
  {iata: "UIO", airport: "Mariscal Sucre Airport"},
  {iata: "UIP", airport: "Pluguffan Airport"},
  {iata: "UIQ", airport: "Quine Hill Airport"},
  {iata: "UIR", airport: "Quirindi Airport"},
  {iata: "UIZ", airport: "Berz-Macomb Airport"},
  {iata: "UJE", airport: "Ujae Island Airport"},
  {iata: "UKA", airport: "Ukunda Airport"},
  {iata: "UKB", airport: "Kobe Airport"},
  {iata: "UKI", airport: "Ukiah Airport"},
  {iata: "UKK", airport: "Ust-Kamenogorsk Airport"},
  {iata: "UKN", airport: "Waukon Municipal Airport"},
  {iata: "UKR", airport: "Mukeiras Airport"},
  {iata: "UKS", airport: "Belbek Airport"},
  {iata: "UKT", airport: "Upper Bucks Airport"},
  {iata: "UKU", airport: "Nuku Airport"},
  {iata: "UKX", airport: "Ust-Kut Airport"},
  {iata: "UKY", airport: "Kyoto Airport"},
  {iata: "ULA", airport: "San Julian Airport"},
  {iata: "ULB", airport: "Ulei Airport"},
  {iata: "ULC", airport: "Los Cerrillos Airport"},
  {iata: "ULD", airport: "Ulundi Airport"},
  {iata: "ULE", airport: "Sule Airport"},
  {iata: "ULG", airport: "Ulgit Airport"},
  {iata: "ULL", airport: "Mull Airport"},
  {iata: "ULM", airport: "New Ulm Airport"},
  {iata: "ULN", airport: "Buyant Uhaa Airport"},
  {iata: "ULO", airport: "Ulaangom Airport"},
  {iata: "ULP", airport: "Quilpie Airport"},
  {iata: "ULQ", airport: "Farfan Airport"},
  {iata: "ULS", airport: "Mulatos Airport"},
  {iata: "ULU", airport: "Gulu Airport"},
  {iata: "ULX", airport: "Ulusaba Airport"},
  {iata: "ULY", airport: "Ulyanovsk Airport"},
  {iata: "ULZ", airport: "Uliastai Airport"},
  {iata: "UMC", airport: "Umba Airport"},
  {iata: "UMD", airport: "Umanak Airport"},
  {iata: "UME", airport: "Umea Airport"},
  {iata: "UMI", airport: "Quincemil Airport"},
  {iata: "UMR", airport: "Woomera Airport"},
  {iata: "UMU", airport: "Ernesto Geisel Airport"},
  {iata: "UMY", airport: "Sumy Airport"},
  {iata: "UNA", airport: "Una Airport"},
  {iata: "UNC", airport: "Unguia Airport"},
  {iata: "UND", airport: "Kunduz Airport"},
  {iata: "UNE", airport: "Qachas Airport"},
  {iata: "UNG", airport: "Kiunga Airport"},
  {iata: "UNI", airport: "Union Island Airport"},
  {iata: "UNK", airport: "Unalakleet Airport"},
  {iata: "UNN", airport: "Ranong Airport"},
  {iata: "UNR", airport: "Underkhaan Airport"},
  {iata: "UNT", airport: "Baltasound Airport"},
  {iata: "UNU", airport: "Dodge County Airport"},
  {iata: "UNV", airport: "University Park"},
  {iata: "UOL", airport: "Buol Airport"},
  {iata: "UON", airport: "Muong Sai Airport"},
  {iata: "UOS", airport: "Franklin County Airport"},
  {iata: "UOX", airport: "University-Oxford Airport"},
  {iata: "UPA", airport: "Punta Alegre Airport"},
  {iata: "UPB", airport: "Playa Baracoa Airport"},
  {iata: "UPC", airport: "Puerto La Cruz Airport"},
  {iata: "UPF", airport: "Pforheim Airport"},
  {iata: "UPG", airport: "Hasanudin Airport"},
  {iata: "UPL", airport: "Upala Airport"},
  {iata: "UPN", airport: "Uruapan Airport"},
  {iata: "UPP", airport: "Upolu Point Airport"},
  {iata: "UPR", airport: "Upiara Airport"},
  {iata: "UPV", airport: "Upavon Airport"},
  {iata: "URA", airport: "Uralsk Airport"},
  {iata: "URB", airport: "Ernesto Pochler Airport"},
  {iata: "URC", airport: "Urumqi Airport"},
  {iata: "URD", airport: "Burg Feuerstein Airport"},
  {iata: "URE", airport: "Kuressaare Airport"},
  {iata: "URG", airport: "Ruben Berta Airport"},
  {iata: "URI", airport: "Uribe Airport"},
  {iata: "URJ", airport: "Uraj Airport"},
  {iata: "URM", airport: "Uriman Airport"},
  {iata: "URN", airport: "Urgoon Airport"},
  {iata: "URO", airport: "Boos Airport"},
  {iata: "URR", airport: "Urrao Airport"},
  {iata: "URS", airport: "Kursk Airport"},
  {iata: "URT", airport: "Surat Thani Airport"},
  {iata: "URU", airport: "Oro Province Airport"},
  {iata: "URY", airport: "Gurayat Airport"},
  {iata: "URZ", airport: "Uruzgan Airport"},
  {iata: "USH", airport: "Islas Malvinas Airport"},
  {iata: "USI", airport: "Mabaruma Airport"},
  {iata: "USK", airport: "Usinsk Airport"},
  {iata: "USL", airport: "Useless Loop Airport"},
  {iata: "USM", airport: "Koh Samui Airport"},
  {iata: "USN", airport: "Ulsan Airport"},
  {iata: "USO", airport: "Usino Airport"},
  {iata: "USQ", airport: "Usak Airport"},
  {iata: "USS", airport: "Sancti Spiritus Airport"},
  {iata: "UST", airport: "St. Augustine Airport"},
  {iata: "USU", airport: "Busuanga Airport"},
  {iata: "UTA", airport: "Mutare Airport"},
  {iata: "UTB", airport: "Muttaburra Airport"},
  {iata: "UTC", airport: "Soesterberg Airport"},
  {iata: "UTD", airport: "Nutwood Downs Airport"},
  {iata: "UTE", airport: "Butterworth Airport"},
  {iata: "UTG", airport: "Quthing Airport"},
  {iata: "UTH", airport: "Udon Thani Airport"},
  {iata: "UTI", airport: "Utti Airport"},
  {iata: "UTK", airport: "Utirik Island Airport"},
  {iata: "UTL", airport: "Torremolinos Airport"},
  {iata: "UTM", airport: "Tunica Municipal Airport"},
  {iata: "UTN", airport: "Upington Airport"},
  {iata: "UTP", airport: "Utapao Airport"},
  {iata: "UTR", airport: "Uttaradit Airport"},
  {iata: "UTT", airport: "Umtata Airport"},
  {iata: "UTU", airport: "Ustupo Airport"},
  {iata: "UTW", airport: "Queenstown Airport"},
  {iata: "UUA", airport: "Bugulma Airport"},
  {iata: "UUD", airport: "Ulan-Ude Airport"},
  {iata: "UUN", airport: "Baruun-Urt Airport"},
  {iata: "UUS", airport: "Yuzhno-Sakhalinsk Airport"},
  {iata: "UUU", airport: "Manumu Airport"},
  {iata: "UVA", airport: "Garner Field"},
  {iata: "UVE", airport: "Ouvea Airport"},
  {iata: "UVF", airport: "Hewanorra Airport"},
  {iata: "UVL", airport: "Kharga Airport"},
  {iata: "UVO", airport: "Uvol Airport"},
  {iata: "UWA", airport: "Ware Airport"},
  {iata: "UYL", airport: "Nyala Airport"},
  {iata: "UYN", airport: "Yulin Airport"},
  {iata: "UZC", airport: "Ponikve Airport"},
  {iata: "UZH", airport: "Unayzah Airport"},
  {iata: "UZU", airport: "Curuzu Cuatia Airport"},
  {iata: "VAA", airport: "Vaasa Airport"},
  {iata: "VAB", airport: "Yavarate Airport"},
  {iata: "VAC", airport: "Varrelbusch Airport"},
  {iata: "VAD", airport: "Moody Air Force Base"},
  {iata: "VAF", airport: "Chabeuil Airport"},
  {iata: "VAG", airport: "Maj. Brig. Trompowsky Airport"},
  {iata: "VAH", airport: "Vallegrande Airport"},
  {iata: "VAI", airport: "Vanimo Airport"},
  {iata: "VAK", airport: "Chevak Airport"},
  {iata: "VAL", airport: "Valenca Airport"},
  {iata: "VAN", airport: "Van Airport"},
  {iata: "VAO", airport: "Suavanao Airstrip"},
  {iata: "VAP", airport: "Valparaiso Airport"},
  {iata: "VAR", airport: "Varna Airport"},
  {iata: "VAS", airport: "Sivas Airport"},
  {iata: "VAT", airport: "Vatomandry Airport"},
  {iata: "VAU", airport: "Vatukoula Airport"},
  {iata: "VAW", airport: "Vardoe Airport"},
  {iata: "VBG", airport: "Vandenburg Air Force Base"},
  {iata: "VBS", airport: "Montichiari Airport"},
  {iata: "VBV", airport: "Vanuabalavu Airport"},
  {iata: "VBY", airport: "Visby Airport"},
  {iata: "VCA", airport: "Can Tho Airport"},
  {iata: "VCC", airport: "Limbe Airport"},
  {iata: "VCD", airport: "Victoria River Downs Airport"},
  {iata: "VCE", airport: "Marco Polo Airport"},
  {iata: "VCF", airport: "Valcheta Airport"},
  {iata: "VCH", airport: "ViMaliero Airport"},
  {iata: "VCL", airport: "Chulai Airport"},
  {iata: "VCP", airport: "Viracopos Airport"},
  {iata: "VCR", airport: "Carora Airport"},
  {iata: "VCS", airport: "Coong Airport"},
  {iata: "VCT", airport: "County-Foster Airport"},
  {iata: "VCV", airport: "George Air Force Base"},
  {iata: "VDB", airport: "Valdres Airport"},
  {iata: "VDC", airport: "Vitoria Da Conquista Airport"},
  {iata: "VDD", airport: "Vienna Danubepier Airport"},
  {iata: "VDE", airport: "Hierro Airport"},
  {iata: "VDF", airport: "Vandenberg"},
  {iata: "VDI", airport: "Vidalia Municipal Airport"},
  {iata: "VDM", airport: "Viedma Airport"},
  {iata: "VDP", airport: "Valle de la Pascua Airport"},
  {iata: "VDR", airport: "Villa Dolores Airport"},
  {iata: "VDS", airport: "Vadso Airport"},
  {iata: "VDZ", airport: "Valdez Municipal Airport"},
  {iata: "VEE", airport: "Venetie Airport"},
  {iata: "VEG", airport: "Maikwak Airport"},
  {iata: "VEJ", airport: "Vejle Airport"},
  {iata: "VEL", airport: "Vernal Airport"},
  {iata: "VER", airport: "Las Bajadas Airport"},
  {iata: "VEX", airport: "Tioga Municipal Airport"},
  {iata: "VEY", airport: "Vestmannaeyjar Airport"},
  {iata: "VFA", airport: "Victoria Falls Airport"},
  {iata: "VGA", airport: "Vijayawada Airport"},
  {iata: "VGD", airport: "Vologda Airport"},
  {iata: "VGO", airport: "Vigo Airport"},
  {iata: "VGS", airport: "General Villegas Airport"},
  {iata: "VGT", airport: "North Air Terminal"},
  {iata: "VGZ", airport: "Villagarzon Airport"},
  {iata: "VHC", airport: "Saurimo Airport"},
  {iata: "VHM", airport: "Vilhelmina Airport"},
  {iata: "VHN", airport: "Culberson County Airport"},
  {iata: "VHO", airport: "Vila Coutinho Airport"},
  {iata: "VHY", airport: "Charmeil Airport"},
  {iata: "VHZ", airport: "Vahitahi Airport"},
  {iata: "VIA", airport: "Videira Airport"},
  {iata: "VIB", airport: "Villa Constitucion Airport"},
  {iata: "VIC", airport: "Vicenza Airport"},
  {iata: "VID", airport: "Vidin Airport"},
  {iata: "VIE", airport: "Vienna International Airport"},
  {iata: "VIF", airport: "Vieste Airport"},
  {iata: "VIG", airport: "El Vigia Airport"},
  {iata: "VIH", airport: "Rolla National Airport"},
  {iata: "VII", airport: "Vinh City Airport"},
  {iata: "VIJ", airport: "Virgin Gorda Airport"},
  {iata: "VIL", airport: "Dakhla Airport"},
  {iata: "VIN", airport: "Vinnica Airport"},
  {iata: "VIQ", airport: "Viqueque Airport"},
  {iata: "VIR", airport: "Virginia Airport"},
  {iata: "VIS", airport: "Visalia Airport"},
  {iata: "VIT", airport: "Vitoria Airport"},
  {iata: "VIV", airport: "Vivigani Airport"},
  {iata: "VIX", airport: "Eurico Sales Airport"},
  {iata: "VIY", airport: "Villa Coublay Airport"},
  {iata: "VJB", airport: "Xai Xai Airport"},
  {iata: "VJI", airport: "Virginia Highlands Airport"},
  {iata: "VJQ", airport: "Gurue Airport"},
  {iata: "VKG", airport: "Rach Gia Airport"},
  {iata: "VKO", airport: "Vnukovo Airport"},
  {iata: "VKS", airport: "Vicksburg Airport"},
  {iata: "VKT", airport: "Vorkuta Airport"},
  {iata: "VLA", airport: "Vandalia Airport"},
  {iata: "VLC", airport: "Valencia Airport"},
  {iata: "VLD", airport: "Valdosta Regional Airport"},
  {iata: "VLE", airport: "J. T. Robidoux Airport"},
  {iata: "VLG", airport: "Villa Gesell Airport"},
  {iata: "VLI", airport: "Bauerfield Airport"},
  {iata: "VLK", airport: "Volgodonsk Airport"},
  {iata: "VLL", airport: "Valladolid Airport"},
  {iata: "VLM", airport: "Villamontes Airport"},
  {iata: "VLN", airport: "Valencia Airport"},
  {iata: "VLO", airport: "Stolport Airport"},
  {iata: "VLP", airport: "Vila Rica Municipal Airport"},
  {iata: "VLR", airport: "Vallenar Airport"},
  {iata: "VLS", airport: "Valesdir Airport"},
  {iata: "VLU", airport: "Velikiye Luki Airport"},
  {iata: "VLV", airport: "Carvajal Airport"},
  {iata: "VME", airport: "Villa Mercedes Airport"},
  {iata: "VMI", airport: "Vallemi Airport"},
  {iata: "VMU", airport: "Baimuru Airport"},
  {iata: "VNA", airport: "Saravane Airport"},
  {iata: "VNC", airport: "Venice Airport"},
  {iata: "VND", airport: "Vangaindrano Airport"},
  {iata: "VNE", airport: "Meucon Airport"},
  {iata: "VNG", airport: "Viengxay Airport"},
  {iata: "VNO", airport: "Vilnius Airport"},
  {iata: "VNR", airport: "Vanrook Airport"},
  {iata: "VNS", airport: "Varanasi Airport"},
  {iata: "VNX", airport: "Vilanculos Airport"},
  {iata: "GOX", airport: "Mopa International Airport"},
  {iata: "VOG", airport: "Volgograd Airport"},
  {iata: "VOH", airport: "Vohemar Airport"},
  {iata: "VOI", airport: "Voinjama Airport"},
  {iata: "VOK", airport: "Volk Field"},
  {iata: "VOL", airport: "Nea Anchialos Airport"},
  {iata: "VOT", airport: "Votuporanga Airport"},
  {iata: "VOZ", airport: "Voronezh Airport"},
  {iata: "VPE", airport: "Ongiva Airport"},
  {iata: "VPN", airport: "Vopnafjordur Airport"},
  {iata: "VPS", airport: "Ft. Walton Beach Airport"},
  {iata: "VPY", airport: "Chimoio Airport"},
  {iata: "VPZ", airport: "Porter County Airport"},
  {iata: "VQS", airport: "Vieques Airport"},
  {iata: "VRA", airport: "Juan Gualberto Gomez Airport"},
  {iata: "VRB", airport: "Vero Beach Municipal Airport"},
  {iata: "VRC", airport: "Virac Airport"},
  {iata: "VRE", airport: "Vredendal Airport"},
  {iata: "VRK", airport: "Varkaus Airport"},
  {iata: "VRL", airport: "Vila Real Airport"},
  {iata: "VRN", airport: "Verona Airport"},
  {iata: "VRO", airport: "Kawama Airport"},
  {iata: "VRS", airport: "Versailles Airport"},
  {iata: "VRU", airport: "Vryburg Airport"},
  {iata: "VRY", airport: "Stolport Airport"},
  {iata: "VSA", airport: "Capitan Carlos Perez Airport"},
  {iata: "VSE", airport: "Viseu Airport"},
  {iata: "VSF", airport: "State Airport"},
  {iata: "VSG", airport: "Lugansk Airport"},
  {iata: "VSO", airport: "Phuoc-long Airport"},
  {iata: "VST", airport: "Vasteras/Hasslo Airport"},
  {iata: "VTA", airport: "Victoria Airport"},
  {iata: "VTB", airport: "Vitebsk Airport"},
  {iata: "VTE", airport: "Wattay"},
  {iata: "VTF", airport: "Vatulele Airport"},
  {iata: "VTG", airport: "Vung Tau Airport"},
  {iata: "VTL", airport: "Vittel Airport"},
  {iata: "VTN", airport: "Miller Field"},
  {iata: "VTU", airport: "Las Tunas Airport"},
  {iata: "VTZ", airport: "Vishakhapatnam Airport"},
  {iata: "VUP", airport: "Valledupar Airport"},
  {iata: "VUS", airport: "Velikij Ustyug Airport"},
  {iata: "VUU", airport: "MVUU Camp"},
  {iata: "VVB", airport: "Mahanoro Airport"},
  {iata: "VVC", airport: "La Vanguardia Airport"},
  {iata: "VVI", airport: "Viru Viru International Airport"},
  {iata: "VVK", airport: "Vastervik Airport"},
  {iata: "VVO", airport: "Vladivostok Airport"},
  {iata: "VVZ", airport: "Illizi Airport"},
  {iata: "VXC", airport: "Lichinga Airport"},
  {iata: "VXE", airport: "San Pedro Airport"},
  {iata: "VXO", airport: "Vaxjo Airport"},
  {iata: "VYD", airport: "Vryheid Airport"},
  {iata: "VYS", airport: "Illinois Valley Regional Airport"},
  {iata: "WAA", airport: "Wales Airport"},
  {iata: "WAB", airport: "Wabag Airport"},
  {iata: "WAC", airport: "Waca Airport"},
  {iata: "WAD", airport: "Andriamena Airport"},
  {iata: "WAE", airport: "Wadi Ad Dawasir Airport"},
  {iata: "WAF", airport: "Wana Airport"},
  {iata: "WAG", airport: "Wanganui Airport"},
  {iata: "WAH", airport: "Wahpeton Airport"},
  {iata: "WAI", airport: "Antsohihy Airport"},
  {iata: "WAJ", airport: "Wawoi Falls Airport"},
  {iata: "WAK", airport: "Ankazoabo Airport"},
  {iata: "WAL", airport: "Wallops Flight Center"},
  {iata: "WAM", airport: "Ambatondrazaka Airport"},
  {iata: "WAN", airport: "Waverney Airport"},
  {iata: "WAO", airport: "Wabo Airport"},
  {iata: "WAP", airport: "Alto Palena Airport"},
  {iata: "WAQ", airport: "Antsalova Airport"},
  {iata: "WAR", airport: "Waris Airport"},
  {iata: "WAT", airport: "Waterford Airport"},
  {iata: "WAU", airport: "Wauchope Airport"},
  {iata: "WAV", airport: "Kalkgurung Airport"},
  {iata: "WAW", airport: "Frederic Chopin Airport"},
  {iata: "WAX", airport: "Zwara Airport"},
  {iata: "WAY", airport: "Green County Airport"},
  {iata: "WAZ", airport: "Warwick Airport"},
  {iata: "WBA", airport: "Wahai Airport"},
  {iata: "WBB", airport: "Stebbins Airport"},
  {iata: "WBC", airport: "Wapolu Airport"},
  {iata: "WBD", airport: "Befandriana Airport"},
  {iata: "WBE", airport: "Bealanana Airport"},
  {iata: "WBG", airport: "Schleswig Airport"},
  {iata: "WBI", airport: "Broker Inn Airport"},
  {iata: "WBM", airport: "Wapenamanda Airport"},
  {iata: "WBN", airport: "Cummings Park Airport"},
  {iata: "WBO", airport: "Beroroha Airport"},
  {iata: "WBQ", airport: "Beaver Airport"},
  {iata: "WBR", airport: "Big Rapids Airport"},
  {iata: "WBU", airport: "Boulder Municipal Airport"},
  {iata: "WBW", airport: "Wyoming Valle Airport"},
  {iata: "WCA", airport: "Gamboa Airport"},
  {iata: "WCH", airport: "Chaiten Airport"},
  {iata: "WDA", airport: "Wadi Ain Airport"},
  {iata: "WDB", airport: "Deep Bay Airport"},
  {iata: "WDG", airport: "Enid Woodring Municipal Airport"},
  {iata: "WDH", airport: "Hosea Kutako International Airport"},
  {iata: "WDI", airport: "Wondai Airport"},
  {iata: "WDN", airport: "Waldron Island Airport"},
  {iata: "WDR", airport: "Winder Airport"},
  {iata: "WEA", airport: "Parker County Airport"},
  {iata: "WED", airport: "Wedau Airport"},
  {iata: "WEF", airport: "Weifang Airport"},
  {iata: "WEH", airport: "Weihai Airport"},
  {iata: "WEI", airport: "Weipa Airport"},
  {iata: "WEL", airport: "Welkom Airport"},
  {iata: "WEM", airport: "West Malling Airport"},
  {iata: "WEP", airport: "Weam Airport"},
  {iata: "WES", airport: "Weasua Airport"},
  {iata: "WET", airport: "Wagethe Airport"},
  {iata: "WEW", airport: "Wee Waa Airport"},
  {iata: "WEX", airport: "Castlebridge Airport"},
  {iata: "WFD", airport: "Woodford Airport"},
  {iata: "WFI", airport: "Fianarantsoa Airport"},
  {iata: "WFK", airport: "Frenchville Airport"},
  {iata: "WGA", airport: "Forrest Hill Airport"},
  {iata: "WGB", airport: "Bahawalnagar Airport"},
  {iata: "WGC", airport: "Warangal Airport"},
  {iata: "WGE", airport: "Walgett Airport"},
  {iata: "WGL", airport: "Off-Line Point"},
  {iata: "WGN", airport: "Waitangi Airport"},
  {iata: "WGO", airport: "Winchester Municipal Airport"},
  {iata: "WGP", airport: "Waingapu Airport"},
  {iata: "WGT", airport: "Wangaratta Airport"},
  {iata: "WGU", airport: "Wagau Airport"},
  {iata: "WGY", airport: "Wagny Airport"},
  {iata: "WHD", airport: "Hyder Sea Plane Base"},
  {iata: "WHF", airport: "Wadi Halfa Airport"},
  {iata: "WHH", airport: "Hiltons Har H Airport"},
  {iata: "WHK", airport: "Whakatane Airport"},
  {iata: "WHL", airport: "Welshpool Airport"},
  {iata: "WHO", airport: "Franz Josef Airport"},
  {iata: "WHS", airport: "Whalsay Airport"},
  {iata: "WHT", airport: "Wharton Airport"},
  {iata: "WHU", airport: "Wuhu Airport"},
  {iata: "WIC", airport: "Wick Airport"},
  {iata: "WID", airport: "Wildenrath Airport"},
  {iata: "WIE", airport: "Wiesbaden Air Base"},
  {iata: "WIK", airport: "Surfdale Airport"},
  {iata: "WIL", airport: "Wilson Airport"},
  {iata: "WIN", airport: "Winton Airport"},
  {iata: "WIO", airport: "Wilcannia Airport"},
  {iata: "WIR", airport: "Wairoa Airport"},
  {iata: "WIT", airport: "Wittenoom Airport"},
  {iata: "WIU", airport: "Witu Airport"},
  {iata: "WJA", airport: "Woja Airport"},
  {iata: "WJF", airport: "William J Fox Airport"},
  {iata: "WJR", airport: "Wajir Airport"},
  {iata: "WJU", airport: "Wonju Airport"},
  {iata: "WKA", airport: "Wanaka Airport"},
  {iata: "WKB", airport: "Warracknabeal Airport"},
  {iata: "WKF", airport: "Waterkloof (FAWK)"},
  {iata: "WKI", airport: "Hwange Airport"},
  {iata: "WKJ", airport: "Hokkaido Airport"},
  {iata: "WKK", airport: "Aleknagik Airport"},
  {iata: "WKL", airport: "Waikoloa Airport"},
  {iata: "WKN", airport: "Wakunai Airport"},
  {iata: "WLA", airport: "Wallal Downs Airport"},
  {iata: "WLC", airport: "Walcha Airport"},
  {iata: "WLD", airport: "Arkansas City Airport"},
  {iata: "WLG", airport: "Wellington International Airport"},
  {iata: "WLH", airport: "Walaha Airport"},
  {iata: "WLK", airport: "Selawik Airport"},
  {iata: "WLL", airport: "Wollogorand Airport"},
  {iata: "WLM", airport: "Waltham Airport"},
  {iata: "WLO", airport: "Waterloo Airport"},
  {iata: "WLS", airport: "Wallis Island Airport"},
  {iata: "WLW", airport: "Glenn County Airport"},
  {iata: "WMA", airport: "Mandritsara Airport"},
  {iata: "WMB", airport: "Warrnambool Airport"},
  {iata: "WMC", airport: "Winnemucca Airport"},
  {iata: "WMD", airport: "Mandabe Airport"},
  {iata: "WME", airport: "Mount Keith Airport"},
  {iata: "WMH", airport: "Mountain Home Airport"},
  {iata: "WMK", airport: "Meyers Chuck Sea Plane Base"},
  {iata: "WML", airport: "Malaimbandy Airport"},
  {iata: "WMN", airport: "Maroantsetra Airport"},
  {iata: "WMO", airport: "White Mountain Airport"},
  {iata: "WMP", airport: "Mampikony Airport"},
  {iata: "WMR", airport: "Mananara Airport"},
  {iata: "WMV", airport: "Madirovalo Airport"},
  {iata: "WMX", airport: "Wamena Airport"},
  {iata: "WNA", airport: "Napakiak Sea Plane Base"},
  {iata: "WND", airport: "Windarra Airport"},
  {iata: "WNE", airport: "Wora Na Ye Airport"},
  {iata: "WNN", airport: "Wunnummin Lake Airport"},
  {iata: "WNP", airport: "Naga Airport"},
  {iata: "WNR", airport: "Windorah Airport"},
  {iata: "WNS", airport: "Nawabshah Airport"},
  {iata: "WNU", airport: "Wanuma Airport"},
  {iata: "WNZ", airport: "Wenzhou Airport"},
  {iata: "WOA", airport: "Wonenara Airport"},
  {iata: "WOB", airport: "Woodbridge RAF"},
  {iata: "WOE", airport: "Woensdrecht Ab Airport"},
  {iata: "WOG", airport: "Woodgreen Airport"},
  {iata: "WOI", airport: "Wologissi Airport"},
  {iata: "WOK", airport: "Wonken Airport"},
  {iata: "WOL", airport: "Wollongong Airport"},
  {iata: "WON", airport: "Wondoola Airport"},
  {iata: "WOR", airport: "Moramba Airport"},
  {iata: "WOT", airport: "Wonan Airport"},
  {iata: "WOW", airport: "Willow Airport"},
  {iata: "WPA", airport: "Puerto Aisen Airport"},
  {iata: "WPB", airport: "Port Berge Airport"},
  {iata: "WPC", airport: "Pincher Creek Airport"},
  {iata: "WPK", airport: "Wrotham Park Airport"},
  {iata: "WPL", airport: "Powell Lake Airport"},
  {iata: "WPM", airport: "Wipim Airport"},
  {iata: "WPO", airport: "North Fork Valley Airport"},
  {iata: "WPR", airport: "Porvenir Airport"},
  {iata: "WPU", airport: "Puerto Williams Airport"},
  {iata: "WRA", airport: "Warder Airport"},
  {iata: "WRB", airport: "Robins Air Force Base"},
  {iata: "WRE", airport: "Whangarei Airport"},
  {iata: "WRG", airport: "Wrangell Sea Plane Base"},
  {iata: "WRI", airport: "McGuire Air Force Base"},
  {iata: "WRL", airport: "Worland Airport"},
  {iata: "WRO", airport: "Strachowice Airport"},
  {iata: "WRW", airport: "Warrawagine Airport"},
  {iata: "WRY", airport: "Westray Airport"},
  {iata: "WRZ", airport: "Weerawila Airport"},
  {iata: "WSA", airport: "Wasua Airport"},
  {iata: "WSD", airport: "Condron Army Air Field"},
  {iata: "WSG", airport: "County Airport"},
  {iata: "WSH", airport: "Brookhaven Airport"},
  {iata: "WSN", airport: "South Naknek Airport"},
  {iata: "WSO", airport: "Washabo Airport"},
  {iata: "WSP", airport: "Waspam Airport"},
  {iata: "WSR", airport: "Wasior Airport"},
  {iata: "WST", airport: "Westerly State Airport"},
  {iata: "WSU", airport: "Wasu Airport"},
  {iata: "WSX", airport: "Westsound Airport"},
  {iata: "WSY", airport: "Whitsunday Airstrip"},
  {iata: "WSZ", airport: "Westport Airport"},
  {iata: "WTA", airport: "Tambohorano Airport"},
  {iata: "WTC", airport: "World Trade Center Airport"},
  {iata: "WTE", airport: "Wotje Airport"},
  {iata: "WTK", airport: "Noatak Airport"},
  {iata: "WTL", airport: "Tuntutuliak Airport"},
  {iata: "WTN", airport: "Royal Air Force Station"},
  {iata: "WTO", airport: "Wotho Airport"},
  {iata: "WTP", airport: "Woitape Airport"},
  {iata: "WTR", airport: "White River Airport"},
  {iata: "WTS", airport: "Tsiroanomandidy Airport"},
  {iata: "WTT", airport: "Wantoat Airport"},
  {iata: "WTZ", airport: "Whitianga Airport"},
  {iata: "WUA", airport: "Wu Hai Airport"},
  {iata: "WUD", airport: "Wudinna Airport"},
  {iata: "WUG", airport: "Wau Airport"},
  {iata: "WUH", airport: "Wuhan Airport"},
  {iata: "WUM", airport: "West New Britain Airport"},
  {iata: "WUN", airport: "Wiluna Airport"},
  {iata: "WUS", airport: "Fujian Province Airport"},
  {iata: "WUU", airport: "Wau Airport"},
  {iata: "WUV", airport: "Wuvulu Island Airport"},
  {iata: "WUX", airport: "Wuxi Airport"},
  {iata: "WUZ", airport: "Changzhoudao Airport"},
  {iata: "WVB", airport: "Rooikop Airport"},
  {iata: "WVI", airport: "Watsonville Airport"},
  {iata: "WVK", airport: "Manakara Airport"},
  {iata: "WVL", airport: "Robert Lafleur Airport"},
  {iata: "WVN", airport: "Wilhelmshaven Airport"},
  {iata: "WWA", airport: "Wasilla Airport"},
  {iata: "WWD", airport: "Cape May County Airport"},
  {iata: "WWI", airport: "Woodie Woodie Airport"},
  {iata: "WWK", airport: "Boram Airport"},
  {iata: "WWP", airport: "Whale Pass Airport"},
  {iata: "WWR", airport: "West Woodward Airport"},
  {iata: "WWT", airport: "Newtok Airport"},
  {iata: "WWY", airport: "West Wyalong Airport"},
  {iata: "WXF", airport: "Wether Field Royal Air Force"},
  {iata: "WXN", airport: "Wanxian Airport"},
  {iata: "WYA", airport: "Whyalla Airport"},
  {iata: "WYB", airport: "Yes Bay Sea Plane Base"},
  {iata: "WYE", airport: "Yengema Airport"},
  {iata: "WYN", airport: "Wyndham Airport"},
  {iata: "WYS", airport: "Yellowstone Airport"},
  {iata: "XAL", airport: "Alamos Airport"},
  {iata: "XAP", airport: "Chapeco Airport"},
  {iata: "XAR", airport: "Aribinda Airport"},
  {iata: "XAU", airport: "Saul Airport"},
  {iata: "XAY", airport: "Xayabury Airport"},
  {iata: "XBB", airport: "Blubber Bay Airport"},
  {iata: "XBE", airport: "Bearskin Lake Airport"},
  {iata: "XBG", airport: "Bogande Airport"},
  {iata: "XBJ", airport: "Birjand Airport"},
  {iata: "XBL", airport: "Buno Bedelle Airport"},
  {iata: "XBN", airport: "Biniguni Airport"},
  {iata: "XBO", airport: "Boulsa Airport"},
  {iata: "XBR", airport: "Brockville Airport"},
  {iata: "XCH", airport: "Christmas Island Airport"},
  {iata: "XCL", airport: "Cluff Lake Airport"},
  {iata: "XCM", airport: "Chatham Airport"},
  {iata: "XCN", airport: "Coron Airport"},
  {iata: "XCO", airport: "Colac Airport"},
  {iata: "XCR", airport: "Paris Vatry Airport"},
  {iata: "XDE", airport: "Diebougou Airport"},
  {iata: "XDJ", airport: "Djibo Airport"},
  {iata: "XEN", airport: "Xingcheng Airport"},
  {iata: "XEO", airport: "Oquatsut Harbour Airport"},
  {iata: "XEQ", airport: "Tasiuasaq Harbour Airport"},
  {iata: "XES", airport: "Lake Geneva Municipal Airport"},
  {iata: "XEX", airport: "Aerogare des Invalides"},
  {iata: "XFN", airport: "Xiangfan Airport"},
  {iata: "XFW", airport: "Finkenwerder Airport"},
  {iata: "XFZ", airport: "Charny Airport"},
  {iata: "XGA", airport: "Gaoua Airport"},
  {iata: "XGB", airport: "Gare Montparnasse Airport"},
  {iata: "XGG", airport: "Gorum-Gorum Airport"},
  {iata: "XGL", airport: "Granville Lake Airport"},
  {iata: "XGR", airport: "Kangiqsualujjuaq Airport"},
  {iata: "XIC", airport: "Xichang Airport"},
  {iata: "XIE", airport: "Xienglom Airport"},
  {iata: "XIG", airport: "Xinguara Municipal Airport"},
  {iata: "XIL", airport: "Xilinhot Airport"},
  {iata: "XIN", airport: "Xingning Airport"},
  {iata: "XIQ", airport: "Ilimanaq Harbour Airport"},
  {iata: "XIY", airport: "Xianyang Airport"},
  {iata: "XKA", airport: "Kantchari Airport"},
  {iata: "XKH", airport: "Xieng Khouang Airport"},
  {iata: "XKO", airport: "Kemano Airport"},
  {iata: "XKS", airport: "Kasabonika Airport"},
  {iata: "XKY", airport: "Kaya Airport"},
  {iata: "XLB", airport: "Lac Brochet Airport"},
  {iata: "XLF", airport: "Leaf Bay Airport"},
  {iata: "XLO", airport: "Long Xuyen Airport"},
  {iata: "XLS", airport: "St. Louis Airport"},
  {iata: "XLU", airport: "Leo Airport"},
  {iata: "XLW", airport: "Lemwerder Airport"},
  {iata: "XMA", airport: "Maramag Airport"},
  {iata: "XMC", airport: "Mallacoota Airport"},
  {iata: "XMD", airport: "Madison Airport"},
  {iata: "XMG", airport: "Mahendranagar Airport"},
  {iata: "XMH", airport: "Manihi Airport"},
  {iata: "XMI", airport: "Masasi Airport"},
  {iata: "XML", airport: "Minlaton Airport"},
  {iata: "XMN", airport: "Xiamen Airport"},
  {iata: "XMP", airport: "Macmillan Pass Airport"},
  {iata: "XMS", airport: "Macas Airport"},
  {iata: "XMY", airport: "Yam Island Airport"},
  {iata: "XNA", airport: "Northwest Arkansas Regional Airport"},
  {iata: "XNG", airport: "Quang Ngai Airport"},
  {iata: "XNN", airport: "Xining Airport"},
  {iata: "XNT", airport: "Xingtai Airport"},
  {iata: "XNU", airport: "Nouna Airport"},
  {iata: "XPA", airport: "Pama Airport"},
  {iata: "XPD", airport: "San Pedro"},
  {iata: "XPK", airport: "Pukatawagan Airport"},
  {iata: "XPL", airport: "Palmerola Air Base"},
  {iata: "XPP", airport: "Poplar River Airport"},
  {iata: "XPR", airport: "Pine Ridge Airport"},
  {iata: "XPZ", airport: "Saint Tropez Harbour Ferry Service"},
  {iata: "XQP", airport: "Quepos Airport"},
  {iata: "XQU", airport: "Qualicum Airport"},
  {iata: "XRH", airport: "Richmond Air Force Base"},
  {iata: "XRR", airport: "Ross River Airport"},
  {iata: "XRY", airport: "La Parra Airport"},
  {iata: "XSA", airport: "AFC Airport"},
  {iata: "XSC", airport: "South Caicos International Airport"},
  {iata: "XSD", airport: "Test Range Airport"},
  {iata: "XSE", airport: "Sebba Airport"},
  {iata: "XSI", airport: "South Indian Lake Airport"},
  {iata: "XSM", airport: "St Marys Airport"},
  {iata: "XSO", airport: "Siocon Airport"},
  {iata: "XSP", airport: "Seletar Airport"},
  {iata: "XTG", airport: "Thargomindah Airport"},
  {iata: "XTL", airport: "Tadoule Lake Airport"},
  {iata: "XTO", airport: "Taroom Airport"},
  {iata: "XTR", airport: "Tara Airport"},
  {iata: "XUZ", airport: "Xuzhou Airport"},
  {iata: "XVL", airport: "Vin Long Airport"},
  {iata: "XYA", airport: "Yandina Airport"},
  {iata: "XYE", airport: "Ye Airport"},
  {iata: "XYR", airport: "Yellow River Airport"},
  {iata: "XYT", airport: "Montaudran Airport"},
  {iata: "XZA", airport: "Zabre Airport"},
  {iata: "XZD", airport: "Kongsvinger Airport"},
  {iata: "YAA", airport: "Anahim Lake Airport"},
  {iata: "YAB", airport: "Arctic Bay Airport"},
  {iata: "YAC", airport: "Cat Lake Airport"},
  {iata: "YAD", airport: "Moose Lake Airport"},
  {iata: "YAE", airport: "Alta Lake Airport"},
  {iata: "YAF", airport: "Asbestos Hill Airport"},
  {iata: "YAG", airport: "Fort Frances Municipal Airport"},
  {iata: "YAH", airport: "Lagrande 4 Airport"},
  {iata: "YAI", airport: "Chillan Airport"},
  {iata: "YAJ", airport: "Lyall Harbour Airport"},
  {iata: "YAK", airport: "Yakutat Airport"},
  {iata: "YAL", airport: "Alert Bay Airport"},
  {iata: "YAM", airport: "Sault Ste. Marie Airport"},
  {iata: "YAN", airport: "Yangambi Airport"},
  {iata: "YAO", airport: "Yaounde Airport"},
  {iata: "YAP", airport: "Yap Airport"},
  {iata: "YAQ", airport: "Maple Bay Airport"},
  {iata: "YAR", airport: "Lagrande 3 Airport"},
  {iata: "YAS", airport: "Yasawa Island Airport"},
  {iata: "YAT", airport: "Attawapiskat Airport"},
  {iata: "YAU", airport: "Kattiniq/Donaldson Lake Airport"},
  {iata: "YAW", airport: "Shearwater Airport"},
  {iata: "YAX", airport: "Angling Lake Airport"},
  {iata: "YAY", airport: "St. Anthony Airport"},
  {iata: "YAZ", airport: "Tofino Airport"},
  {iata: "YBA", airport: "Banff Airport"},
  {iata: "YBB", airport: "Townsite Airport"},
  {iata: "YBC", airport: "Baie Comeau Airport"},
  {iata: "YBD", airport: "New Westminister Airport"},
  {iata: "YBE", airport: "Uranium City Airport"},
  {iata: "YBF", airport: "Bamfield Airport"},
  {iata: "YBG", airport: "Bagotville Airport"},
  {iata: "YBH", airport: "Bull Harbour Airport"},
  {iata: "YBI", airport: "Black Tickle Airport"},
  {iata: "YBJ", airport: "Baie Johan Beetz Airport"},
  {iata: "YBK", airport: "Baker Lake Airport"},
  {iata: "YBL", airport: "Campbell River Airport"},
  {iata: "YBM", airport: "Bronson Creek Airport"},
  {iata: "YBN", airport: "Borden Airport"},
  {iata: "YBO", airport: "Bobquinn Lake Airport"},
  {iata: "YBP", airport: "Yibin Airport"},
  {iata: "YBQ", airport: "Telegraph Harbour Airport"},
  {iata: "YBR", airport: "Brandon Airport"},
  {iata: "YBS", airport: "Musselwhite Airport"},
  {iata: "YBT", airport: "Brochet Airport"},
  {iata: "YBV", airport: "Berens River Airport"},
  {iata: "YBW", airport: "Bedwell Harbor Airport"},
  {iata: "YBX", airport: "Blanc Sablon Airport"},
  {iata: "YBY", airport: "Bonnyville Airport"},
  {iata: "YCA", airport: "Courtenay Airport"},
  {iata: "YCB", airport: "Cambridge Bay Airport"},
  {iata: "YCC", airport: "Cornwall Regional Airport"},
  {iata: "YCD", airport: "Nanaimo Airport"},
  {iata: "YCE", airport: "Centralia Airport"},
  {iata: "YCF", airport: "Cortes Bay Airport"},
  {iata: "YCG", airport: "Castlegar Airport"},
  {iata: "YCH", airport: "Miramichi Airport"},
  {iata: "YCI", airport: "Caribou Island Airport"},
  {iata: "YCJ", airport: "Cape Saint James Airport"},
  {iata: "YCK", airport: "Colville Lake Airport"},
  {iata: "YCL", airport: "Charlo Airport"},
  {iata: "YCM", airport: "St. Catharines Airport"},
  {iata: "YCN", airport: "Cochrane Airport"},
  {iata: "YCO", airport: "Kugluktuk Airport"},
  {iata: "YCP", airport: "Co-Op Point Airport"},
  {iata: "YCQ", airport: "Chetwynd Airport"},
  {iata: "YCR", airport: "Cross Lake Airport"},
  {iata: "YCS", airport: "Chesterfield Inlet Airport"},
  {iata: "YCT", airport: "Coronation Airport"},
  {iata: "YCV", airport: "Cartierville Airport"},
  {iata: "YCW", airport: "Chilliwack Airport"},
  {iata: "YCX", airport: "Gagetown Airport"},
  {iata: "YCY", airport: "Clyde River Airport"},
  {iata: "YCZ", airport: "Fairmount Springs Airport"},
  {iata: "YDA", airport: "Dawson City Airport"},
  {iata: "YDB", airport: "Burwash Landings Airport"},
  {iata: "YDC", airport: "Industrial Airport"},
  {iata: "YDE", airport: "Paradise River Airport"},
  {iata: "YDF", airport: "Deer Lake Airport"},
  {iata: "YDG", airport: "Digby Airport"},
  {iata: "YDH", airport: "Daniels Harbour Airport"},
  {iata: "YDI", airport: "Davis Inlet Airport"},
  {iata: "YDJ", airport: "Hatchet Lake Airport"},
  {iata: "YDK", airport: "Main Duck Island Airport"},
  {iata: "YDL", airport: "Dease Lake Airport"},
  {iata: "YDN", airport: "Dauphin Airport"},
  {iata: "YDO", airport: "St Methode Airport"},
  {iata: "YDP", airport: "Nain Airport"},
  {iata: "YDQ", airport: "Dawson Creek Airport"},
  {iata: "YDR", airport: "Broadview Airport"},
  {iata: "YDS", airport: "Desolation Sound Airport"},
  {iata: "YDT", airport: "Boundary Bay Airport"},
  {iata: "YDU", airport: "Kasba Lake Airport"},
  {iata: "YDV", airport: "Bloodvein Airport"},
  {iata: "YDW", airport: "Obre Lake Airport"},
  {iata: "YDX", airport: "Doc Creek Airport"},
  {iata: "YEC", airport: "Yecheon Airport"},
  {iata: "YED", airport: "Namao Field"},
  {iata: "YEG", airport: "Edmonton International Airport"},
  {iata: "YEI", airport: "Yenisehir Airport"},
  {iata: "YEK", airport: "Arviat Airport"},
  {iata: "YEL", airport: "Elliot Lake Airport"},
  {iata: "YEM", airport: "East Manitoulin Airport"},
  {iata: "YEN", airport: "Estevan Airport"},
  {iata: "YEO", airport: "Yeovilton Airport"},
  {iata: "YEP", airport: "Estevan Point Airport"},
  {iata: "YEQ", airport: "Yenkis Airport"},
  {iata: "YER", airport: "Fort Severn Airport"},
  {iata: "YES", airport: "Yasouj Airport"},
  {iata: "YET", airport: "Edson Airport"},
  {iata: "YEU", airport: "Eureka Airport"},
  {iata: "YEV", airport: "Inuvik/Mike Zubko Airport"},
  {iata: "YEY", airport: "Amos Airport"},
  {iata: "YFA", airport: "Fort Albany Airport"},
  {iata: "YFB", airport: "Iqaluit Airport"},
  {iata: "YFC", airport: "Fredericton Airport"},
  {iata: "YFE", airport: "Forestville Airport"},
  {iata: "YFG", airport: "Fontanges Airport"},
  {iata: "YFH", airport: "Fort Hope Airport"},
  {iata: "YFJ", airport: "Snare Lake Airport"},
  {iata: "YFK", airport: "Kitchener/Waterloo Regional Airport"},
  {iata: "YFL", airport: "Fort Reliance Airport"},
  {iata: "YFO", airport: "Flin Flon Airport"},
  {iata: "YFR", airport: "Fort Resolution Airport"},
  {iata: "YFS", airport: "Fort Simpson Airport"},
  {iata: "YFX", airport: "Fox Harbour Airport"},
  {iata: "YGA", airport: "Gagnon Airport"},
  {iata: "YGB", airport: "Gillies Bay Airport"},
  {iata: "YGC", airport: "Grande Cache Airport"},
  {iata: "YGE", airport: "Gorge Harbor Airport"},
  {iata: "YGG", airport: "Ganges Harbor Airport"},
  {iata: "YGH", airport: "Fort Good Hope Airport"},
  {iata: "YGJ", airport: "Miho Airport"},
  {iata: "YGK", airport: "Kingston Airport"},
  {iata: "YGL", airport: "La Grande Airport"},
  {iata: "YGM", airport: "Gimli Airport"},
  {iata: "YGN", airport: "Greenway Sound Airport"},
  {iata: "YGO", airport: "Gods Narrows Airport"},
  {iata: "YGP", airport: "Metropolitan Area Airport"},
  {iata: "YGQ", airport: "Geraldton Airport"},
  {iata: "YGR", airport: "Iles De La Madeleine Airport"},
  {iata: "YGS", airport: "Germansen Airport"},
  {iata: "YGT", airport: "Igloolik Airport"},
  {iata: "YGV", airport: "Havre St. Pierre Airport"},
  {iata: "YGW", airport: "Kuujjuarapik Airport"},
  {iata: "YGX", airport: "Gillam Airport"},
  {iata: "YGY", airport: "Deception Bay Airport"},
  {iata: "YGZ", airport: "Grise Fiord Airport"},
  {iata: "YHA", airport: "Port Hope Simpson Airport"},
  {iata: "YHB", airport: "Hudson Bay Airport"},
  {iata: "YHC", airport: "Hakai Pass Airport"},
  {iata: "YHD", airport: "Dryden Municipal Airport"},
  {iata: "YHE", airport: "Hope Airport"},
  {iata: "YHF", airport: "Hearst Airport"},
  {iata: "YHG", airport: "Charlottetown Airport"},
  {iata: "YHH", airport: "Harbor Sea Plane Base"},
  {iata: "YHI", airport: "Holman Airport"},
  {iata: "YHK", airport: "Gjoa Haven Airport"},
  {iata: "YHM", airport: "Hamilton Airport"},
  {iata: "YHN", airport: "Hornepayne Airport"},
  {iata: "YHO", airport: "Hopedale Airport"},
  {iata: "YHP", airport: "Poplar Hill Airport"},
  {iata: "YHR", airport: "Chevery Airport"},
  {iata: "YHS", airport: "Sechelt Airport"},
  {iata: "YHT", airport: "Haines Junction Airport"},
  {iata: "YHU", airport: "St. Hubert Airport"},
  {iata: "YHY", airport: "Hay River Airport"},
  {iata: "YHZ", airport: "Halifax International Airport"},
  {iata: "YIB", airport: "Atikokan Airport"},
  {iata: "YIF", airport: "Pakuashipi Airport"},
  {iata: "YIG", airport: "Big Bay Marina Airport"},
  {iata: "YIH", airport: "Yichang Airport"},
  {iata: "YIK", airport: "Ivujivik Airport"},
  {iata: "YIN", airport: "Yining Airport"},
  {iata: "YIO", airport: "Pond Inlet Airport"},
  {iata: "YIP", airport: "Willow Run Airport"},
  {iata: "YIV", airport: "Island Lake/Garden Hill Airport"},
  {iata: "YIW", airport: "Yiwu Airport"},
  {iata: "YJA", airport: "Metropolitan Area Airport"},
  {iata: "YJF", airport: "Fort Liard Airport"},
  {iata: "YJN", airport: "Saint Jean Airport"},
  {iata: "YJO", airport: "Johnny Mountain Airport"},
  {iata: "YJP", airport: "Jasper-Hinton Airport"},
  {iata: "YJT", airport: "Stephenville Airport"},
  {iata: "YKA", airport: "Kamloops Airport"},
  {iata: "YKC", airport: "Collins Bay Airport"},
  {iata: "YKD", airport: "Township Airport"},
  {iata: "YKE", airport: "Knee Lake Airport"},
  {iata: "YKF", airport: "Kitchener-Waterloo Regional Airport"},
  {iata: "YKG", airport: "Kangirsuk Airport"},
  {iata: "YKJ", airport: "Key Lake Airport"},
  {iata: "YKK", airport: "Kitkatla Airport"},
  {iata: "YKL", airport: "Schefferville Airport"},
  {iata: "YKM", airport: "Yakima Air Terminal"},
  {iata: "YKN", airport: "Chan Gurney Airport"},
  {iata: "YKQ", airport: "Waskaganish Airport"},
  {iata: "YKS", airport: "Yakutsk Airport"},
  {iata: "YKT", airport: "Klemtu Airport"},
  {iata: "YKU", airport: "Chisasibi Airport"},
  {iata: "YKX", airport: "Kirkland Lake Airport"},
  {iata: "YKY", airport: "Kindersley Airport"},
  {iata: "YKZ", airport: "Buttonville Airport"},
  {iata: "YLA", airport: "Langara Airport"},
  {iata: "YLB", airport: "Lac Biche Airport"},
  {iata: "YLC", airport: "Kimmirut Airport"},
  {iata: "YLD", airport: "Chapleau Airport"},
  {iata: "YLE", airport: "Wha Ti Airport"},
  {iata: "YLF", airport: "Laforges Airport"},
  {iata: "YLG", airport: "Yalgoo Airport"},
  {iata: "YLH", airport: "Lansdowne House Airport"},
  {iata: "YLI", airport: "Ylivieska Airport"},
  {iata: "YLJ", airport: "Meadow Lake Airport"},
  {iata: "YLL", airport: "Lloydminster Airport"},
  {iata: "YLM", airport: "Clinton Creek Airport"},
  {iata: "YLN", airport: "Yilan Airport"},
  {iata: "YLO", airport: "Shilo Airport"},
  {iata: "YLP", airport: "Mingan Airport"},
  {iata: "YLQ", airport: "La Tuque Airport"},
  {iata: "YLR", airport: "Leaf Rapids Airport"},
  {iata: "YLS", airport: "Lebel-Sur-Quevillon Airport"},
  {iata: "YLT", airport: "Alert Airport"},
  {iata: "YLW", airport: "Kelowna Airport"},
  {iata: "YLY", airport: "Langley Regional Airport"},
  {iata: "YMA", airport: "Mayo Airport"},
  {iata: "YMB", airport: "Merritt Airport"},
  {iata: "YMC", airport: "Maricourt Airstrip"},
  {iata: "YMD", airport: "Mould Bay Airport"},
  {iata: "YME", airport: "Matane Airport"},
  {iata: "YMF", airport: "Montagne Harbor Airport"},
  {iata: "YMG", airport: "Manitouwadge Airport"},
  {iata: "YMI", airport: "Minaki Airport"},
  {iata: "YMJ", airport: "Moose Jaw Airport"},
  {iata: "YML", airport: "Charlevoix Airport"},
  {iata: "YMM", airport: "Fort McMurray Airport"},
  {iata: "YMN", airport: "Makkovik Airport"},
  {iata: "YMO", airport: "Moosonee Airport"},
  {iata: "YMP", airport: "Port McNeil Airport"},
  {iata: "YMR", airport: "Merry Island Airport"},
  {iata: "YMS", airport: "Yurimaguas Airport"},
  {iata: "YMT", airport: "Chibougamau Airport"},
  {iata: "YMW", airport: "Maniwaki Airport"},
  {iata: "YMX", airport: "Mirabel International Airport"},
  {iata: "YNA", airport: "Natashquan Airport"},
  {iata: "YNB", airport: "Yanbu Airport"},
  {iata: "YNC", airport: "Wemindji Airport"},
  {iata: "YND", airport: "Gatineau Airport"},
  {iata: "YNE", airport: "Norway House Airport"},
  {iata: "YNF", airport: "Deer Lake/Stephenville Airport"},
  {iata: "YNG", airport: "Youngstown Airport"},
  {iata: "YNI", airport: "Nitchequon Airport"},
  {iata: "YNJ", airport: "Yanji Airport"},
  {iata: "YNK", airport: "Nootka Sound Airport"},
  {iata: "YNL", airport: "Points North Landing Airport"},
  {iata: "YNM", airport: "Matagami Airport"},
  {iata: "YNN", airport: "Yandi Airport"},
  {iata: "YNO", airport: "North Spirit Lake Airport"},
  {iata: "YNP", airport: "Natuashish Airport"},
  {iata: "YNR", airport: "Arnes Airport"},
  {iata: "YNS", airport: "Nemiscau Airport"},
  {iata: "YNT", airport: "Laishan Airport"},
  {iata: "YNY", airport: "Yangyang Airport"},
  {iata: "YNZ", airport: "Yancheng Airport"},
  {iata: "YOA", airport: "Ekati Airport"},
  {iata: "YOC", airport: "Old Crow Airport"},
  {iata: "YOD", airport: "Cold Lake Airport"},
  {iata: "YOE", airport: "Falher Airport"},
  {iata: "YOG", airport: "Ogoki Airport"},
  {iata: "YOH", airport: "Oxford House Airport"},
  {iata: "YOJ", airport: "Footner Lake Airport"},
  {iata: "YOK", airport: "Yokohoma Airport"},
  {iata: "YOL", airport: "Yola Airport"},
  {iata: "YOO", airport: "Oshawa Municipal Airport"},
  {iata: "YOP", airport: "Rainbow Lake Airport"},
  {iata: "YOS", airport: "Billy Bishop Regional Airport"},
  {iata: "YOW", airport: "Ottawa/Macdonald-Cartier International Airport"},
  {iata: "YOY", airport: "Valcartier Airport"},
  {iata: "YPA", airport: "Prince Albert Airport"},
  {iata: "YPB", airport: "Port Alberni Airport"},
  {iata: "YPC", airport: "Paulatuk Airport"},
  {iata: "YPD", airport: "Parry Sound Airport"},
  {iata: "YPE", airport: "Peace River Airport"},
  {iata: "YPF", airport: "Esquimalt Airport"},
  {iata: "YPG", airport: "Portage La Prarie Airport"},
  {iata: "YPH", airport: "Inukjuak Airport"},
  {iata: "YPI", airport: "Port Simpson Airport"},
  {iata: "YPJ", airport: "Aupaluk Airport"},
  {iata: "YPL", airport: "Pickle Lake Airport"},
  {iata: "YPM", airport: "Pikangikum Airport"},
  {iata: "YPN", airport: "Port Menier Airport"},
  {iata: "YPO", airport: "Peawanuk Airport"},
  {iata: "YPP", airport: "Pine Point Airport"},
  {iata: "YPQ", airport: "Peterborough Airport"},
  {iata: "YPR", airport: "Digby Island Airport"},
  {iata: "YPS", airport: "Port Hawkesbury Airport"},
  {iata: "YPT", airport: "Pender Harbor Airport"},
  {iata: "YPW", airport: "Powell River Airport"},
  {iata: "YPX", airport: "Puvirnituq Airport"},
  {iata: "YPY", airport: "Fort Chipewyan Airport"},
  {iata: "YPZ", airport: "Burns Lake Airport"},
  {iata: "YQA", airport: "Muskoka Airport"},
  {iata: "YQB", airport: "Quebec Airport"},
  {iata: "YQC", airport: "Quaqtaq Airport"},
  {iata: "YQD", airport: "The Pas Airport"},
  {iata: "YQE", airport: "Kimberley Airport"},
  {iata: "YQF", airport: "Red Deer Airport"},
  {iata: "YQG", airport: "Windsor Airport"},
  {iata: "YQH", airport: "Watson Lake Airport"},
  {iata: "YQI", airport: "Yarmouth Airport"},
  {iata: "YQK", airport: "Kenora Airport"},
  {iata: "YQL", airport: "Lethbridge Airport"},
  {iata: "YQM", airport: "Metropolitan Area"},
  {iata: "YQN", airport: "Nakina Airport"},
  {iata: "YQQ", airport: "Comox Airport"},
  {iata: "YQR", airport: "Regina Airport"},
  {iata: "YQS", airport: "Pembroke Area Municipal Airport"},
  {iata: "YQT", airport: "Thunder Bay Airport"},
  {iata: "YQU", airport: "Grande Prairie Airport"},
  {iata: "YQV", airport: "Yorkton Airport"},
  {iata: "YQW", airport: "North Battleford Airport"},
  {iata: "YQX", airport: "Gander Airport"},
  {iata: "YQY", airport: "Sydney Airport"},
  {iata: "YQZ", airport: "Quesnel Airport"},
  {iata: "YRA", airport: "Rae Lakes Airport"},
  {iata: "YRB", airport: "Resolute Airport"},
  {iata: "YRD", airport: "Dean River Airport"},
  {iata: "YRE", airport: "Resolution Island Airport"},
  {iata: "YRF", airport: "Cartwright Airport"},
  {iata: "YRG", airport: "Rigolet Airport"},
  {iata: "YRI", airport: "Riviere-du-Loup Airport"},
  {iata: "YRJ", airport: "Roberval Airport"},
  {iata: "YRL", airport: "Red Lake Airport"},
  {iata: "YRM", airport: "Rocky Mountain House Airport"},
  {iata: "YRN", airport: "Rivers Inlet Airport"},
  {iata: "YRO", airport: "Rockcliffe St. Airport"},
  {iata: "YRQ", airport: "Trois-Rivieres Airport"},
  {iata: "YRR", airport: "Stuart Island Airport"},
  {iata: "YRS", airport: "Red Sucker Lake Airport"},
  {iata: "YRT", airport: "Rankin Inlet Airport"},
  {iata: "YRV", airport: "Revelstoke Airport"},
  {iata: "YSA", airport: "Sable Island Airport"},
  {iata: "YSB", airport: "Sudbury Airport"},
  {iata: "YSC", airport: "Sherbrooke Airport"},
  {iata: "YSD", airport: "Suffield Airport"},
  {iata: "YSE", airport: "Squamish Airport"},
  {iata: "YSF", airport: "Stony Rapids Airport"},
  {iata: "YSG", airport: "Lutselke Airport"},
  {iata: "YSH", airport: "Smith Falls Airport"},
  {iata: "YSI", airport: "Sans Souci Airport"},
  {iata: "YSJ", airport: "Saint John Airport"},
  {iata: "YSK", airport: "Sanikiluaq Airport"},
  {iata: "YSL", airport: "Edmunston Airport"},
  {iata: "YSM", airport: "Fort Smith Airport"},
  {iata: "YSN", airport: "Salmon Arm Airport"},
  {iata: "YSO", airport: "Postville Airport"},
  {iata: "YSP", airport: "Marathon Airport"},
  {iata: "YSR", airport: "Nanisivik Airport"},
  {iata: "YST", airport: "Ste. Therese Point Airport"},
  {iata: "YSU", airport: "Summerside Airport"},
  {iata: "YSV", airport: "Saglek Airport"},
  {iata: "YSX", airport: "Shearwater Airport"},
  {iata: "YSY", airport: "Sachs Harbour Airport"},
  {iata: "YSZ", airport: "Squirrel Cove Airport"},
  {iata: "YTA", airport: "Pembroke And Area Airport"},
  {iata: "YTB", airport: "Hartley Bay Airport"},
  {iata: "YTC", airport: "Sturdee Airport"},
  {iata: "YTD", airport: "Thicket Portage Airport"},
  {iata: "YTE", airport: "Cape Dorset Airport"},
  {iata: "YTF", airport: "Alma Airport"},
  {iata: "YTG", airport: "Sullivan Bay Airport"},
  {iata: "YTH", airport: "Thompson Airport"},
  {iata: "YTJ", airport: "Terrace Bay Airport"},
  {iata: "YTK", airport: "Tulugak Airport"},
  {iata: "YTL", airport: "Big Trout Airport"},
  {iata: "YTM", airport: "La Macaza Airport"},
  {iata: "YTN", airport: "Riviere Au Tonnerre Airport"},
  {iata: "YTP", airport: "Tofino Sea Plane Base"},
  {iata: "YTQ", airport: "Tasiujuaq Airport"},
  {iata: "YTR", airport: "Trenton Airport"},
  {iata: "YTS", airport: "Timmins Airport"},
  {iata: "YTT", airport: "Tisdale Airport"},
  {iata: "YTU", airport: "Tasu Airport"},
  {iata: "YTX", airport: "Telegraph Creek Airport"},
  {iata: "YTZ", airport: "Toronto City Centre Airport"},
  {iata: "YUA", airport: "Yuanmou Airport"},
  {iata: "YUB", airport: "Tuktoyaktuk Airport"},
  {iata: "YUD", airport: "Umiujag Airport"},
  {iata: "YUE", airport: "Yuendumu Airport"},
  {iata: "YUF", airport: "Dewline Site Airport"},
  {iata: "YUL", airport: "Pierre Elliott Trudeau International Airport"},
  {iata: "YUT", airport: "Repulse Bay Airport"},
  {iata: "YUX", airport: "Hall Beach Airport"},
  {iata: "YUY", airport: "Rouyn Airport"},
  {iata: "YVA", airport: "Iconi Airport"},
  {iata: "YVB", airport: "Bonaventure Airport"},
  {iata: "YVC", airport: "La Ronge Airport"},
  {iata: "YVD", airport: "Yeva Airport"},
  {iata: "YVE", airport: "Vernon Airport"},
  {iata: "YVG", airport: "Vermilion Airport"},
  {iata: "YVM", airport: "Broughton Island Airport"},
  {iata: "YVP", airport: "Kuujjuaq Airport"},
  {iata: "YVQ", airport: "Norman Wells Airport"},
  {iata: "YVR", airport: "Vancouver International Airport"},
  {iata: "YVT", airport: "Buffalo Narrows Airport"},
  {iata: "YVV", airport: "Wiarton Airport"},
  {iata: "YVZ", airport: "Deer Lake Airport"},
  {iata: "YWA", airport: "Petawawa Airport"},
  {iata: "YWB", airport: "Kangiqsujuaq Airport"},
  {iata: "YWF", airport: "Halifax Downtown Waterfront Heliport"},
  {iata: "YWG", airport: "Winnipeg James Armstrong Richardson International Airport"},
  {iata: "YWH", airport: "Inner Harbour Airport"},
  {iata: "YWJ", airport: "Deline Airport"},
  {iata: "YWK", airport: "Wabush Airport"},
  {iata: "YWL", airport: "Williams Lake Airport"},
  {iata: "YWM", airport: "Williams Harbour Airport"},
  {iata: "YWN", airport: "Winisk Airport"},
  {iata: "YWO", airport: "Lupin Airport"},
  {iata: "YWP", airport: "Webequie Airport"},
  {iata: "YWQ", airport: "Chute-Des-Passes Airport"},
  {iata: "YWR", airport: "White River Airport"},
  {iata: "YWS", airport: "Whistler Airport"},
  {iata: "YWY", airport: "Wrigley Airport"},
  {iata: "YXC", airport: "Cranbrook Airport"},
  {iata: "YXD", airport: "Edmonton Municipal Airport"},
  {iata: "YXE", airport: "Saskatoon Airport"},
  {iata: "YXF", airport: "Snake River Airport"},
  {iata: "YXH", airport: "Medicine Hat Airport"},
  {iata: "YXI", airport: "Killaloe Airport"},
  {iata: "YXJ", airport: "Fort St. John Airport"},
  {iata: "YXK", airport: "Rimouski Airport"},
  {iata: "YXL", airport: "Sioux Lookout Airport"},
  {iata: "YXN", airport: "Whale Cove Airport"},
  {iata: "YXP", airport: "Pangnirtung Airport"},
  {iata: "YXQ", airport: "Beaver Creek Airport"},
  {iata: "YXR", airport: "Earlton Airport"},
  {iata: "YXS", airport: "Prince George Airport"},
  {iata: "YXT", airport: "Terrace Airport"},
  {iata: "YXU", airport: "Metropolitan Area Airport"},
  {iata: "YXX", airport: "Abbotsford Airport"},
  {iata: "YXY", airport: "Whitehorse Airport"},
  {iata: "YXZ", airport: "Wawa Airport"},
  {iata: "YYA", airport: "Big Bay Yacht Club Airport"},
  {iata: "YYB", airport: "North Bay Airport"},
  {iata: "YYC", airport: "Calgary International Airport"},
  {iata: "YYD", airport: "Smithers Airport"},
  {iata: "YYE", airport: "Fort Nelson Airport"},
  {iata: "YYF", airport: "Penticton Airport"},
  {iata: "YYG", airport: "Charlottetown Airport"},
  {iata: "YYH", airport: "Taloyoak Airport"},
  {iata: "YYI", airport: "Rivers Airport"},
  {iata: "YYJ", airport: "Victoria International Airport"},
  {iata: "YYL", airport: "Lynn Lake Airport"},
  {iata: "YYM", airport: "Cowley Airport"},
  {iata: "YYN", airport: "Swift Current Airport"},
  {iata: "YYQ", airport: "Metropolitan Area Airport"},
  {iata: "YYR", airport: "Goose Bay Airport"},
  {iata: "YYU", airport: "Kapuskasing Airport"},
  {iata: "YYW", airport: "Armstrong Airport"},
  {iata: "YYY", airport: "Mont Joli Airport"},
  {iata: "YYZ", airport: "Pearson International Airport"},
  {iata: "YZA", airport: "Ashcroft Airport"},
  {iata: "YZC", airport: "Beatton River Airport"},
  {iata: "YZE", airport: "Gore Bay Airport"},
  {iata: "YZF", airport: "Yellowknife Airport"},
  {iata: "YZG", airport: "Salluit Airport"},
  {iata: "YZH", airport: "Slave Lake Airport"},
  {iata: "YZM", airport: "Buchans Airport"},
  {iata: "YZP", airport: "Sandspit Airport"},
  {iata: "YZR", airport: "Sarnia Airport"},
  {iata: "YZS", airport: "Coral Harbour Airport"},
  {iata: "YZT", airport: "Port Hardy Airport"},
  {iata: "YZU", airport: "Whitecourt Airport"},
  {iata: "YZV", airport: "Sept-Iles Airport"},
  {iata: "YZW", airport: "Teslin Airport"},
  {iata: "YZX", airport: "Greenwood Airport"},
  {iata: "ZAA", airport: "Alice Arm Airport"},
  {iata: "ZAC", airport: "York Landing Airport"},
  {iata: "ZAD", airport: "Zadar Airport"},
  {iata: "ZAG", airport: "Pleso Airport"},
  {iata: "ZAH", airport: "Zahedan Airport"},
  {iata: "ZAJ", airport: "Zaranj Airport"},
  {iata: "ZAL", airport: "Pichoy Airport"},
  {iata: "ZAM", airport: "Zamboanga Airport"},
  {iata: "ZAO", airport: "Laberandie Airport"},
  {iata: "ZAR", airport: "Zaria Airport"},
  {iata: "ZAT", airport: "Zhaotong Airport"},
  {iata: "ZAZ", airport: "Zaragoza Airport"},
  {iata: "ZBE", airport: "Dolni Benesov Airport"},
  {iata: "ZBF", airport: "Bathurst Airport"},
  {iata: "ZBK", airport: "Zabljak Airport"},
  {iata: "ZBL", airport: "Biloela Airport"},
  {iata: "ZBM", airport: "Bromont Airport"},
  {iata: "ZBO", airport: "Bowen Airport"},
  {iata: "ZBR", airport: "Chah-Bahar Airport"},
  {iata: "ZBY", airport: "Sayaboury Airport"},
  {iata: "ZCL", airport: "La Calera Airport"},
  {iata: "ZCO", airport: "Temuco Airport"},
  {iata: "ZDN", airport: "Brno Bus Service"},
  {iata: "ZEC", airport: "Secunda Airport"},
  {iata: "ZEG", airport: "Senggo Airport"},
  {iata: "ZEL", airport: "Bella Bella Airport"},
  {iata: "ZEM", airport: "East Main Airport"},
  {iata: "ZEN", airport: "Zenag Airport"},
  {iata: "ZER", airport: "Zero Airport"},
  {iata: "ZFA", airport: "Faro Airport"},
  {iata: "ZFB", airport: "Old Fort Bay Airport"},
  {iata: "ZFD", airport: "Fond Du Lac Airport"},
  {iata: "ZFL", airport: "South Trout Lake Airport"},
  {iata: "ZFM", airport: "Fort Mcpherson Airport"},
  {iata: "ZFN", airport: "Tulita Airport"},
  {iata: "ZFV", airport: "Philadelphia Rail"},
  {iata: "ZFW", airport: "Fairview Airport"},
  {iata: "ZGC", airport: "Zhongchuan Airport"},
  {iata: "ZGF", airport: "Grand Forks Airport"},
  {iata: "ZGI", airport: "Gods River Airport"},
  {iata: "ZGL", airport: "South Galway Airport"},
  {iata: "ZGM", airport: "Ngoma Airport"},
  {iata: "ZGR", airport: "Little Grand Rapids Airport"},
  {iata: "ZGS", airport: "Gethsemani Airport"},
  {iata: "ZGU", airport: "Gaua Airport"},
  {iata: "ZHA", airport: "Zhanjiang Airport"},
  {iata: "ZHM", airport: "Shamshernagar Airport"},
  {iata: "ZHP", airport: "High Prairie Airport"},
  {iata: "ZIC", airport: "Victoria Airport"},
  {iata: "ZIG", airport: "Ziguinchor Airport"},
  {iata: "ZIH", airport: "Ixtapa/Zihuatanejo Internacional Airport"},
  {iata: "ZJG", airport: "Jenpeg Airport"},
  {iata: "ZJN", airport: "Swan River Airport"},
  {iata: "ZKB", airport: "Kasaba Bay Airport"},
  {iata: "ZKE", airport: "Kaschechewan Airport"},
  {iata: "ZKG", airport: "Kegaska Airport"},
  {iata: "ZKL", airport: "Steenkool Airport"},
  {iata: "ZKM", airport: "Sette Cama Airport"},
  {iata: "ZKP", airport: "Kasompe Airport"},
  {iata: "ZLG", airport: "El Gouera Airport"},
  {iata: "ZLO", airport: "Manzanillo Airport"},
  {iata: "ZLR", airport: "Linares"},
  {iata: "ZLT", airport: "La Tabatiere Airport"},
  {iata: "ZMD", airport: "Sena Madureira Airport"},
  {iata: "ZMH", airport: "108 Mile Ranch Airport"},
  {iata: "ZMM", airport: "Zamora Airport"},
  {iata: "ZMT", airport: "Masset Airport"},
  {iata: "ZNA", airport: "Harbour Airport"},
  {iata: "ZND", airport: "Zinder Airport"},
  {iata: "ZNE", airport: "Newman Airport"},
  {iata: "ZNG", airport: "Negginan Airport"},
  {iata: "ZNU", airport: "Namu Airport"},
  {iata: "ZNZ", airport: "Kisauni Airport"},
  {iata: "ZOF", airport: "Ocean Falls Airport"},
  {iata: "ZOS", airport: "Canal Balo Airport"},
  {iata: "ZPB", airport: "Sachigo Lake Airport"},
  {iata: "ZPC", airport: "Pucon Airport"},
  {iata: "ZPH", airport: "Zephyrhills Airport"},
  {iata: "ZPO", airport: "Pine House Airport"},
  {iata: "ZQN", airport: "Frankton Airport"},
  {iata: "ZQS", airport: "Queen Charlotte Island Airport"},
  {iata: "ZRH", airport: "Zurich Airport"},
  {iata: "ZRI", airport: "Serui Airport"},
  {iata: "ZRJ", airport: "Round Lake Airport"},
  {iata: "ZRM", airport: "Sarmi Airport"},
  {iata: "ZSA", airport: "San Salvador Airport"},
  {iata: "ZSE", airport: "St. Pierre de la Reunion Airport"},
  {iata: "ZSJ", airport: "Sandy Lake Airport"},
  {iata: "ZSP", airport: "St. Paul Airport"},
  {iata: "ZST", airport: "Stewart Airport"},
  {iata: "ZSW", airport: "Seal Cove Airport"},
  {iata: "ZTA", airport: "Tureira Airport"},
  {iata: "ZTB", airport: "Tete-A-La Baleine Airport"},
  {iata: "ZTH", airport: "Zakinthos Airport"},
  {iata: "ZTM", airport: "Shamattawa Airport"},
  {iata: "ZTR", airport: "Zhitomir Airport"},
  {iata: "ZTS", airport: "Tahsis Airport"},
  {iata: "ZUC", airport: "High Prairie Airport"},
  {iata: "ZUD", airport: "Ancud Airport"},
  {iata: "ZUH", airport: "Zhuhai Airport"},
  {iata: "ZUL", airport: "Zilfi Airport"},
  {iata: "ZUM", airport: "Churchill Falls Airport"},
  {iata: "ZVA", airport: "Miandrivazo Airport"},
  {iata: "ZVG", airport: "Springvale Airport"},
  {iata: "ZVK", airport: "Savannakhet Airport"},
  {iata: "ZWA", airport: "Andapa Airport"},
  {iata: "ZWL", airport: "Wollaston Lake Airport"},
  {iata: "ZWN", airport: "Wittenberge Railway Service"},
  {iata: "ZXQ", airport: "Solstad Airport"},
  {iata: "ZXT", airport: "Zabrat Airport"},
  {iata: "ZYI", airport: "Zunyi Airport"},
  {iata: "ZYL", airport: "Civil Airport"},
  {iata: "ZYR", airport: "Brussels Midi"},
  {iata: "ZZU", airport: "Mzuzu Airport"},
  {iata: "ZZV", airport: "Zanesville Airport"},
  {iata: "DWC", airport: "Al Maktoum International Airport"},
  {iata: "ORD", airport: "Chicago OHare International"},
  {iata: "XNB", airport: "United Arab Emirates - Bus Station"},
  {iata: "BH1", airport: "Isa AB"},
  {iata: "MRU", airport: "Mauritius"},
  {iata: "ABJ", airport: "Abidjan"},
  {iata: "HBH", airport: "Alexandria - Borg el Arab Airport"},
  {iata: "QNB", airport: "Anand"},
  {iata: "EAP", airport: "Basel/Mulhouse"},
  {iata: "BUG", airport: "Bengueka"},
  {iata: "BER", airport: "Berlin"},
  {iata: "ZDJ", airport: "Berne - Railway Service"},
  {iata: "BYK", airport: "Bouake"},
  {iata: "BUH", airport: "Bucharest"},
  {iata: "BUE", airport: "Buenos Aires"},
  {iata: "QCB", airport: "Chiba City"},
  {iata: "CHI", airport: "Chicago - IL"},
  {iata: "DJO", airport: "Daloa"},
  {iata: "HAG", airport: "Den Haag (The Hague)"},
  {iata: "DTT", airport: "Detroit - MI - Metropolitan Area"},
  {iata: "DCS", airport: "Doncaster - Robin Hood International Ai"},
  {iata: "YEA", airport: "Edmonton"},
  {iata: "VDA", airport: "Elat - Ovula"},
  {iata: "GHB", airport: "Govenors Harbour"},
  {iata: "GBI", airport: "Gulbarga"},
  {iata: "GSI", airport: "Guadalcanal"},
  {iata: "HMH", airport: "Home Hill"},
  {iata: "ZJK", airport: "Hong Kong - Chek Lap Kok"},
  {iata: "LSG", airport: "Ishigaki"},
  {iata: "IZM", airport: "Izmir"},
  {iata: "JKT", airport: "Jakarta - Metropolitan Area"},
  {iata: "UIT", airport: "Jaluit Island"},
  {iata: "JMB", airport: "Jamba"},
  {iata: "KNC", airport: "Ji'An"},
  {iata: "FCA", airport: "Kalispell - MT"},
  {iata: "QJU", airport: "Kanpur"},
  {iata: "ZNS", airport: "Kempten"},
  {iata: "FIH", airport: "Kinshasa - Djili"},
  {iata: "HGO", airport: "Korhogo"},
  {iata: "KUB", airport: "Kuala Belait"},
  {iata: "WLB", airport: "Labouchere Bay - AK"},
  {iata: "LQE", airport: "Land's End"},
  {iata: "QLI", airport: "Limassol"},
  {iata: "LIJ", airport: "Long Island - AK"},
  {iata: "MMA", airport: "Malmo (Malmoe)"},
  {iata: "MJC", airport: "Man"},
  {iata: "MVY", airport: "Martha's Vineyard - MA"},
  {iata: "MIL", airport: "Milan"},
  {iata: "QML", airport: "Mirpur"},
  {iata: "YMQ", airport: "Montreal"},
  {iata: "MOW", airport: "Moscow - Metropolitan Area"},
  {iata: "MCL", airport: "Mt. McKinley - AK"},
  // {iata: "NYC", airport: "New York - NY"},
  {iata: "NCE", airport: "Nice - Cote DAzur"},
  {iata: "QND", airport: "Novi Sad"},
  {iata: "TBU", airport: "Nuku'alofa - Fua'Amotu International"},
  {iata: "OSA", airport: "Osaka - Metropolitan Area"},
  {iata: "FBU", airport: "Oslo - Fornebu"},
  {iata: "RKT", airport: "Ras al Khaymah (Ras al Khaimah)"},
  {iata: "RWP", airport: "Rawalpindi"},
  {iata: "REK", airport: "Reykjavik - Metropolitan Area"},
  {iata: "RIO", airport: "Rio de Janeiro"},
  {iata: "RRG", airport: "Rodrigues Island"},
  {iata: "ROM", airport: "Rome"},
  {iata: "SJU", airport: "San Juan"},
  {iata: "SPY", airport: "San Pedro"},
  {iata: "SAH", airport: "Sanaa (Sana'a) - Sana'a International"},
  {iata: "SAO", airport: "Sao Paulo"},
  {iata: "SPK", airport: "Sapporo"},
  {iata: "ZSS", airport: "Sassandra"},
  {iata: "SEL", airport: "Seoul - Kimpo"},
  {iata: "DCS", airport: "Sheffield - Doncaster - Robin Hood Int"},
  {iata: "QPG", airport: "Singapore - Paya Lebar"},
  {iata: "YYT", airport: "St. John's"},
  {iata: "STO", airport: "Stockholm Metropolitan Area"},
  {iata: "TLV", airport: "Tel Aviv - Ben Gurion International"},
  {iata: "TCI", airport: "Tenerife"},
  // {iata: "TYO", airport: "Tokyo"},
  {iata: "YTO", airport: "Toronto"},
  {iata: "UGO", airport: "Uige"},
  {iata: "YVO", airport: "Val d'Or"},
  {iata: "WAS", airport: "Washington DC"},
  {iata: "WHM", airport: "Wickham"},
  {iata: "ISL", airport: "Williston - ND"},
  {iata: "ASK", airport: "Yamoussoukro"},
  {iata: "YUM", airport: "Yuma - AZ"},
  {iata: "ROM", airport: "Rom"},
  {iata: "ISU", airport: "Sulaymaniyah"},
  {iata: "EBL", airport: "Arbil"},
  {iata: "NJF", airport: "Al Najaf"},
  {iata: "SAG", airport: "Shirdi"},
  {iata: "VDY", airport: "Bellary"},
  {iata: "DSS", airport: "Blaise Diagne International Airport"},
  {iata: "KQH", airport: "Rajasthan"},
  {iata: "JRG", airport: "Jharsuguda Airport"},
  {iata: "RDP", airport: "Kazi Nazrul Islam Airport"},
  {iata: "IXX", airport: "Bidar Airport"},
  {iata: "PKX", airport: "Beijing Daxing International Airport"},
  {iata: "HMB", airport: "Sohag International Airport"},
  {iata: "DBR", airport: "Dharbhanga Airport"},
  {iata: "PYG", airport: "Pakyong Airport"},
  {iata: "KBK", airport: "Kushinagar International Airport"},
  {iata: "DGH", airport: "Deoghar Airport"},
  {iata: "AYJ", airport: "Maharishi Valmiki International Airport"},
  {iata: "RQY", airport: "Shivamogga Airport"},
  {iata: "HSR", airport: "Rajkot Greenfield International Airport"},
  {iata: "HGI", airport: "Hollongi Airport India"}
]



// WEBPACK FOOTER //
// ./src/data/airports.js